import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /**
   * The `Date` scalar type represents a Date
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  Date: any;
  /**
   * The `DateTime` scalar type represents a DateTime
   * value as specified by
   * [iso8601](https://en.wikipedia.org/wiki/ISO_8601).
   */
  DateTime: any;
  /**
   * Leverages the internal Python implementation of UUID (uuid.UUID) to provide native UUID objects
   * in fields, resolvers and input.
   */
  UUID: any;
};

export type AgendaType = {
  __typename?: 'AgendaType';
  createdBy?: Maybe<UserType>;
  dateOfInterview?: Maybe<Scalars['DateTime']>;
  desc?: Maybe<Scalars['String']>;
  employerCandidate?: Maybe<EmployerCandidateType>;
  end?: Maybe<Scalars['DateTime']>;
  interviewId?: Maybe<Scalars['ID']>;
  interviewRequester?: Maybe<EmployerProfileType>;
  interviewType?: Maybe<Scalars['String']>;
  interviewUuid?: Maybe<Scalars['String']>;
  location?: Maybe<Array<Maybe<Scalars['String']>>>;
  locationOfInterview?: Maybe<LocationType>;
  meetingUrl?: Maybe<Scalars['String']>;
  participants?: Maybe<Array<Maybe<Scalars['String']>>>;
  phoneNumber?: Maybe<Scalars['String']>;
  position?: Maybe<Array<Maybe<Scalars['String']>>>;
  positionOfInterview?: Maybe<PositionType>;
  start?: Maybe<Scalars['DateTime']>;
  title?: Maybe<Scalars['String']>;
};

export type AnswerInput = {
  answer: Scalars['String'];
  option?: InputMaybe<Scalars['ID']>;
  question: Scalars['ID'];
};

export type AnswerLocationQuestions = {
  __typename?: 'AnswerLocationQuestions';
  location?: Maybe<LocationType>;
};

export type AnswerQuestionsInputType = {
  employerCandidateQuestionnaireId: Scalars['ID'];
  questionsAnswered: Array<InputMaybe<QuestionAnswerInputType>>;
};

export type AnswerQuestionsMutation = {
  __typename?: 'AnswerQuestionsMutation';
  answersDetail?: Maybe<Array<Maybe<UploadUrlType>>>;
};

/** An enumeration. */
export enum ApiInterviewStatusChoices {
  /** Accepted */
  Accepted = 'ACCEPTED',
  /** Canceled */
  Canceled = 'CANCELED',
  /** Declined */
  Declined = 'DECLINED',
  /** Expired */
  Expired = 'EXPIRED',
  /** No Show */
  NoShow = 'NO_SHOW',
  /** Pending */
  Pending = 'PENDING',
  /** Scheduled */
  Scheduled = 'SCHEDULED',
  /** Unscheduled */
  Unscheduled = 'UNSCHEDULED'
}

export type BulkMessageMutation = {
  __typename?: 'BulkMessageMutation';
  ok?: Maybe<Scalars['String']>;
};

export type BulkMoveEmployerCandidateMutation = {
  __typename?: 'BulkMoveEmployerCandidateMutation';
  candidateName?: Maybe<Scalars['String']>;
  moved?: Maybe<Scalars['Boolean']>;
  movedCandidatesCount?: Maybe<Scalars['Int']>;
  stageName?: Maybe<Scalars['String']>;
};

export type CalculatePriceType = {
  __typename?: 'CalculatePriceType';
  annualPayAsYouGo?: Maybe<PriceDisplayType>;
  annualUnlimited?: Maybe<PriceDisplayType>;
  monthlyPayAsYouGo?: Maybe<PriceDisplayType>;
  monthlyUnlimited?: Maybe<PriceDisplayType>;
};

export type CampaignEstimationType = {
  __typename?: 'CampaignEstimationType';
  message?: Maybe<Scalars['String']>;
};

export type CampaignMutationInput = {
  /** price in cents */
  amount?: InputMaybe<Scalars['Int']>;
  campaignEndedOn?: InputMaybe<Scalars['DateTime']>;
  campaignWillEndOn?: InputMaybe<Scalars['DateTime']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  /** Undefined, Null, or missing fields will not update when set to true. */
  partialUpdate?: InputMaybe<Scalars['Boolean']>;
  positionId?: InputMaybe<Scalars['String']>;
  willStartOn?: InputMaybe<Scalars['DateTime']>;
};

/** Mutation to create or update employer campaign. */
export type CampaignMutationPayload = {
  __typename?: 'CampaignMutationPayload';
  campaignType?: Maybe<JobBoardCampaignType>;
  clientMutationId?: Maybe<Scalars['String']>;
  /** May contain more than one error for same field. */
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type CampaignPredictionType = {
  __typename?: 'CampaignPredictionType';
  budget?: Maybe<Scalars['String']>;
  clicks?: Maybe<Scalars['String']>;
  currencyCode?: Maybe<Scalars['String']>;
  days?: Maybe<Scalars['String']>;
};

export type CancellationReasonMutationInput = {
  cancellationReasonOther?: InputMaybe<Scalars['String']>;
  cancelledBy?: InputMaybe<Scalars['ID']>;
  candidatesUnresponsive?: InputMaybe<Scalars['Boolean']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  hiredFohandboh?: InputMaybe<Scalars['Boolean']>;
  hiredOther?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  /** Location cancelled, or every position on a PAYG subscription was cancelled at once */
  location: Scalars['ID'];
  needsChange?: InputMaybe<Scalars['Boolean']>;
  other?: InputMaybe<Scalars['Boolean']>;
  /** Undefined, Null, or missing fields will not update when set to true. */
  partialUpdate?: InputMaybe<Scalars['Boolean']>;
  /** Pay as you go position that was removed from a subscription */
  position?: InputMaybe<Scalars['ID']>;
  tooFewApplicants?: InputMaybe<Scalars['Boolean']>;
};

export type CancellationReasonMutationPayload = {
  __typename?: 'CancellationReasonMutationPayload';
  cancellationReason?: Maybe<CancellationReasonType>;
  clientMutationId?: Maybe<Scalars['String']>;
  /** May contain more than one error for same field. */
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type CancellationReasonType = Node & {
  __typename?: 'CancellationReasonType';
  /** Deprecated Field */
  cancellationReason?: Maybe<PaymentCancellationReasonCancellationReasonChoices>;
  cancellationReasonOther?: Maybe<Scalars['String']>;
  cancelledBy?: Maybe<UserType>;
  candidatesUnresponsive: Scalars['Boolean'];
  createdAt?: Maybe<Scalars['DateTime']>;
  employerProfile?: Maybe<EmployerProfileType>;
  hiredFohandboh: Scalars['Boolean'];
  hiredOther: Scalars['Boolean'];
  /** The ID of the object */
  id: Scalars['ID'];
  /** Location cancelled, or every position on a PAYG subscription was cancelled at once */
  location: LocationType;
  needsChange: Scalars['Boolean'];
  other: Scalars['Boolean'];
  payment?: Maybe<PaymentType>;
  /** Pay as you go position that was removed from a subscription */
  position?: Maybe<PositionType>;
  rowId?: Maybe<Scalars['Int']>;
  tooFewApplicants: Scalars['Boolean'];
};

export type CancellationReasonTypeConnection = {
  __typename?: 'CancellationReasonTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CancellationReasonTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CancellationReasonType` and its cursor. */
export type CancellationReasonTypeEdge = {
  __typename?: 'CancellationReasonTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CancellationReasonType>;
};

export type CandidateProfileMutationInput = {
  additionalTraining?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  addressCity?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressPostalCode?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressStreet1?: InputMaybe<Scalars['String']>;
  addressStreet2?: InputMaybe<Scalars['String']>;
  availabilityFriday?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilityMonday?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilitySaturday?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilitySunday?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilityThursday?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilityTuesday?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilityWednesday?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  canHaveDressCode?: InputMaybe<Scalars['Boolean']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  commutePreference?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  employmentPreferenceOtherDescription?: InputMaybe<Scalars['String']>;
  employmentPreferences?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  firstName?: InputMaybe<Scalars['String']>;
  handle?: InputMaybe<Scalars['String']>;
  hasCompletedOnboarding?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  isBenefitsRequired?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  newPassword?: InputMaybe<Scalars['String']>;
  oldPassword?: InputMaybe<Scalars['String']>;
  /** Undefined, Null, or missing fields will not update when set to true. */
  partialUpdate?: InputMaybe<Scalars['Boolean']>;
  personalSummary?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  positions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  private?: InputMaybe<Scalars['Boolean']>;
  profileImageId?: InputMaybe<Scalars['ID']>;
  profileVideoId?: InputMaybe<Scalars['ID']>;
  restaurantTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  resume?: InputMaybe<Scalars['String']>;
  resumeFileName?: InputMaybe<Scalars['String']>;
  resumeFileType?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  statusEmoji?: InputMaybe<Scalars['String']>;
  terms?: InputMaybe<Scalars['Boolean']>;
  yearsExperience?: InputMaybe<Scalars['String']>;
};

export type CandidateProfileMutationPayload = {
  __typename?: 'CandidateProfileMutationPayload';
  candidateProfile?: Maybe<CandidateProfileType>;
  clientMutationId?: Maybe<Scalars['String']>;
  /** May contain more than one error for same field. */
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  followedToolTip?: Maybe<Scalars['String']>;
  interviewStatus?: Maybe<Scalars['String']>;
  profileImage?: Maybe<Scalars['String']>;
  profileVideo?: Maybe<Scalars['String']>;
  resumeUploadUrl?: Maybe<Scalars['String']>;
};

export type CandidateProfileType = Node & {
  __typename?: 'CandidateProfileType';
  additionalTraining?: Maybe<Array<Maybe<Scalars['String']>>>;
  addressCity?: Maybe<Scalars['String']>;
  addressCountry?: Maybe<Scalars['String']>;
  addressPostalCode?: Maybe<Scalars['String']>;
  addressState?: Maybe<Scalars['String']>;
  addressStreet1?: Maybe<Scalars['String']>;
  addressStreet2?: Maybe<Scalars['String']>;
  applications: PositionTypeConnection;
  applicationsForEmployer?: Maybe<PositionApplicationTypeConnection>;
  /** Setting this field deactivates the CandidateProfile User. Set this to any date instead of deleting. */
  archivedAt?: Maybe<Scalars['DateTime']>;
  availabilityFriday?: Maybe<Array<Maybe<Scalars['String']>>>;
  availabilityMonday?: Maybe<Array<Maybe<Scalars['String']>>>;
  availabilitySaturday?: Maybe<Array<Maybe<Scalars['String']>>>;
  availabilitySunday?: Maybe<Array<Maybe<Scalars['String']>>>;
  availabilityThursday?: Maybe<Array<Maybe<Scalars['String']>>>;
  availabilityTuesday?: Maybe<Array<Maybe<Scalars['String']>>>;
  availabilityWednesday?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Is candidate ok with having a dress code? */
  canHaveDressCode?: Maybe<Scalars['Boolean']>;
  candidateprofileSet: CandidateProfileTypeConnection;
  /** The maximum distance willing to commute, expressed in time */
  commutePreference: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deactivatedAt?: Maybe<Scalars['DateTime']>;
  employerCandidate?: Maybe<EmployerCandidateType>;
  employercandidateSet: EmployerCandidateTypeConnection;
  employmentPreferenceOtherDescription?: Maybe<Scalars['String']>;
  employmentPreferences?: Maybe<Array<Maybe<Scalars['String']>>>;
  employmentdocumentSet: EmploymentDocumentTypeConnection;
  endorsementSet: EndorsementTypeConnection;
  endorsements?: Maybe<EndorsementTypeConnection>;
  favoriteLocations: LocationTypeConnection;
  favoritedlocationSet: FavoritedLocationTypeConnection;
  handle?: Maybe<Scalars['String']>;
  hasAppliedToEmployer?: Maybe<Scalars['Boolean']>;
  hasAppliedToPosition?: Maybe<Scalars['Boolean']>;
  hasContactInformation?: Maybe<Scalars['Boolean']>;
  hasEndorsements?: Maybe<Scalars['Boolean']>;
  hasResume?: Maybe<Scalars['Boolean']>;
  hiddenLocations: LocationTypeConnection;
  hiddenlocationSet: HiddenLocationTypeConnection;
  /** The ID of the object */
  id: Scalars['ID'];
  incompleteSections?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Are benefits a must-have for a candidate? */
  isBenefitsRequired?: Maybe<Scalars['Boolean']>;
  isFavorited?: Maybe<Scalars['Boolean']>;
  isFollowingLocations?: Maybe<Scalars['Boolean']>;
  /** Whether the candidate is included in the candidate feed and postion notification emails */
  isVisible: Scalars['Boolean'];
  lastInterview?: Maybe<InterviewType>;
  /** The last date matches were created specifically for this candidate */
  lastMatchCreation?: Maybe<Scalars['DateTime']>;
  lastPositionApplication?: Maybe<PositionApplicationType>;
  latitude?: Maybe<Scalars['Float']>;
  longitude?: Maybe<Scalars['Float']>;
  /** Points to add to any match score for this candidate */
  matchBonus: Scalars['Int'];
  matchSet: MatchTypeConnection;
  /** The maximum distance willing to commute, expressed in coordinate points (for geometric distance math) */
  maxCommuteCoordinates?: Maybe<Scalars['Float']>;
  onboardingCompletedAt?: Maybe<Scalars['DateTime']>;
  personalSummary: Scalars['String'];
  positionapplicationSet: PositionApplicationTypeConnection;
  positions?: Maybe<Array<Maybe<Scalars['String']>>>;
  preferredCategories: Array<TagType>;
  private: Scalars['Boolean'];
  profileCompleteness?: Maybe<Scalars['Int']>;
  profileVideo?: Maybe<Scalars['String']>;
  redirectTo?: Maybe<CandidateProfileType>;
  restaurantTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  resume?: Maybe<Scalars['String']>;
  resumeUploadDate?: Maybe<Scalars['DateTime']>;
  rowId?: Maybe<Scalars['Int']>;
  status?: Maybe<Scalars['String']>;
  statusEmoji?: Maybe<Scalars['String']>;
  terms: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
  url?: Maybe<Scalars['String']>;
  user: UserType;
  workHistory: CandidateWorkHistoryTypeConnection;
  yearsExperience: Scalars['String'];
};


export type CandidateProfileTypeApplicationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  archivedAt_Isnull?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  canHaveDressCode?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  hiring?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  isBenefitsRequired?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['ID']>;
  location_In?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  offset?: InputMaybe<Scalars['Int']>;
  positionName_Icontains?: InputMaybe<Scalars['String']>;
};


export type CandidateProfileTypeApplicationsForEmployerArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type CandidateProfileTypeCandidateprofileSetArgs = {
  additionalTraining_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  after?: InputMaybe<Scalars['String']>;
  availabilityFriday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilityMonday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilitySaturday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilitySunday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilityThursday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilityTuesday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilityWednesday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  before?: InputMaybe<Scalars['String']>;
  employmentPreferences_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  positions_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  restaurantTypes_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Scalars['String']>;
  yearsExperience?: InputMaybe<Scalars['String']>;
};


export type CandidateProfileTypeEmployercandidateSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  stageUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  stageUpdatedAt_Gte?: InputMaybe<Scalars['DateTime']>;
  stageUpdatedAt_Lte?: InputMaybe<Scalars['DateTime']>;
};


export type CandidateProfileTypeEmploymentdocumentSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  candidate?: InputMaybe<Scalars['ID']>;
  documentType_Icontains?: InputMaybe<EmployersEmploymentDocumentDocumentTypeChoices>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type CandidateProfileTypeEndorsementSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type CandidateProfileTypeEndorsementsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type CandidateProfileTypeFavoriteLocationsArgs = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCity_Icontains?: InputMaybe<Scalars['String']>;
  addressCity_Istartswith?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressCountry_Icontains?: InputMaybe<Scalars['String']>;
  addressCountry_Istartswith?: InputMaybe<Scalars['String']>;
  addressPostalCode?: InputMaybe<Scalars['String']>;
  addressPostalCode_Icontains?: InputMaybe<Scalars['String']>;
  addressPostalCode_Istartswith?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressState_Icontains?: InputMaybe<Scalars['String']>;
  addressState_Istartswith?: InputMaybe<Scalars['String']>;
  addressStreet1?: InputMaybe<Scalars['String']>;
  addressStreet1_Icontains?: InputMaybe<Scalars['String']>;
  addressStreet1_Istartswith?: InputMaybe<Scalars['String']>;
  addressStreet2?: InputMaybe<Scalars['String']>;
  addressStreet2_Icontains?: InputMaybe<Scalars['String']>;
  addressStreet2_Istartswith?: InputMaybe<Scalars['String']>;
  addressStreet3?: InputMaybe<Scalars['String']>;
  addressStreet3_Icontains?: InputMaybe<Scalars['String']>;
  addressStreet3_Istartswith?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employerProfile?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_Icontains?: InputMaybe<Scalars['String']>;
  name_Istartswith?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  positions?: InputMaybe<Scalars['ID']>;
};


export type CandidateProfileTypeFavoritedlocationSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type CandidateProfileTypeHiddenLocationsArgs = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCity_Icontains?: InputMaybe<Scalars['String']>;
  addressCity_Istartswith?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressCountry_Icontains?: InputMaybe<Scalars['String']>;
  addressCountry_Istartswith?: InputMaybe<Scalars['String']>;
  addressPostalCode?: InputMaybe<Scalars['String']>;
  addressPostalCode_Icontains?: InputMaybe<Scalars['String']>;
  addressPostalCode_Istartswith?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressState_Icontains?: InputMaybe<Scalars['String']>;
  addressState_Istartswith?: InputMaybe<Scalars['String']>;
  addressStreet1?: InputMaybe<Scalars['String']>;
  addressStreet1_Icontains?: InputMaybe<Scalars['String']>;
  addressStreet1_Istartswith?: InputMaybe<Scalars['String']>;
  addressStreet2?: InputMaybe<Scalars['String']>;
  addressStreet2_Icontains?: InputMaybe<Scalars['String']>;
  addressStreet2_Istartswith?: InputMaybe<Scalars['String']>;
  addressStreet3?: InputMaybe<Scalars['String']>;
  addressStreet3_Icontains?: InputMaybe<Scalars['String']>;
  addressStreet3_Istartswith?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employerProfile?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_Icontains?: InputMaybe<Scalars['String']>;
  name_Istartswith?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  positions?: InputMaybe<Scalars['ID']>;
};


export type CandidateProfileTypeHiddenlocationSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type CandidateProfileTypeIsFollowingLocationsArgs = {
  locations?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type CandidateProfileTypeMatchSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type CandidateProfileTypePositionapplicationSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type CandidateProfileTypeWorkHistoryArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type CandidateProfileTypeConnection = {
  __typename?: 'CandidateProfileTypeConnection';
  edgeCount?: Maybe<Scalars['Int']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CandidateProfileTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `CandidateProfileType` and its cursor. */
export type CandidateProfileTypeEdge = {
  __typename?: 'CandidateProfileTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CandidateProfileType>;
};

export enum CandidateSortByEnum {
  LastActive = 'LAST_ACTIVE',
  MostExperienced = 'MOST_EXPERIENCED',
  Nearest = 'NEAREST'
}

export type CandidateWorkHistoryMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  employerName: Scalars['String'];
  end?: InputMaybe<Scalars['Date']>;
  hideProfile?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  location?: InputMaybe<Scalars['ID']>;
  /** Undefined, Null, or missing fields will not update when set to true. */
  partialUpdate?: InputMaybe<Scalars['Boolean']>;
  position?: InputMaybe<Scalars['String']>;
  /** This field represents if the candidate is still employed by this employer. */
  present?: InputMaybe<Scalars['Boolean']>;
  responsibilities?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Date']>;
};

export type CandidateWorkHistoryMutationPayload = {
  __typename?: 'CandidateWorkHistoryMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  endDisplay?: Maybe<Scalars['String']>;
  /** May contain more than one error for same field. */
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  startDisplay?: Maybe<Scalars['String']>;
  workHistory?: Maybe<CandidateWorkHistoryType>;
};

export type CandidateWorkHistoryType = Node & {
  __typename?: 'CandidateWorkHistoryType';
  createdAt: Scalars['DateTime'];
  employerName: Scalars['String'];
  end?: Maybe<Scalars['Date']>;
  hideProfile: Scalars['Boolean'];
  /** The ID of the object */
  id: Scalars['ID'];
  location?: Maybe<LocationType>;
  position?: Maybe<Scalars['String']>;
  /** This field represents if the candidate is still employed by this employer. */
  present: Scalars['Boolean'];
  profile: CandidateProfileType;
  responsibilities?: Maybe<Scalars['String']>;
  start?: Maybe<Scalars['Date']>;
  updatedAt: Scalars['DateTime'];
};

export type CandidateWorkHistoryTypeConnection = {
  __typename?: 'CandidateWorkHistoryTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CandidateWorkHistoryTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CandidateWorkHistoryType` and its cursor. */
export type CandidateWorkHistoryTypeEdge = {
  __typename?: 'CandidateWorkHistoryTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CandidateWorkHistoryType>;
};

export type CareerPageAnswerInputType = {
  option?: InputMaybe<Scalars['ID']>;
  question: Scalars['ID'];
  response: Scalars['String'];
};

/** Mutation for update CareerPage Questions. */
export type CareerPageAnswerMutation = {
  __typename?: 'CareerPageAnswerMutation';
  answers?: Maybe<Array<Maybe<CareerPageAnswerType>>>;
};

export type CareerPageAnswerQuestionsInputType = {
  careerPage: Scalars['ID'];
  responses: Array<InputMaybe<CareerPageAnswerInputType>>;
};

export type CareerPageAnswerType = Node & {
  __typename?: 'CareerPageAnswerType';
  /** The ID of the object */
  id: Scalars['ID'];
  option?: Maybe<QuestionOptionType>;
  question: QuestionType;
  /** Either the answer input by the user, or the label of the option they selected */
  response: Scalars['String'];
};

export type CareerPageAnswerTypeConnection = {
  __typename?: 'CareerPageAnswerTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CareerPageAnswerTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CareerPageAnswerType` and its cursor. */
export type CareerPageAnswerTypeEdge = {
  __typename?: 'CareerPageAnswerTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CareerPageAnswerType>;
};

/** Mutation to delete career page. */
export type CareerPageDeleteMutation = {
  __typename?: 'CareerPageDeleteMutation';
  deleted?: Maybe<Scalars['Boolean']>;
};

/** The CareerPage Gallery input */
export type CareerPageGalleriesInputType = {
  careerPage: Scalars['ID'];
  galleries: Array<InputMaybe<CareerPageGalleryCategories>>;
};

/** The CareerPage Gallery Categories */
export type CareerPageGalleryCategories = {
  category: Scalars['String'];
  fileName: Scalars['String'];
  fileType: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
};

/** The CareerPage Gallery AWS S3 signed info */
export type CareerPageGallerySignedUrl = {
  __typename?: 'CareerPageGallerySignedUrl';
  fileName?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  signedS3Url?: Maybe<Scalars['String']>;
};

/** CareerPage Gallery */
export type CareerPageGalleryType = Node & {
  __typename?: 'CareerPageGalleryType';
  category?: Maybe<Scalars['String']>;
  getUploadFileExtension?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  uploadFile?: Maybe<Scalars['String']>;
};

export type CareerPageGalleryTypeConnection = {
  __typename?: 'CareerPageGalleryTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CareerPageGalleryTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `CareerPageGalleryType` and its cursor. */
export type CareerPageGalleryTypeEdge = {
  __typename?: 'CareerPageGalleryTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CareerPageGalleryType>;
};

/** Career Page message Mutaton */
export type CareerPageLocationMessageMutation = {
  __typename?: 'CareerPageLocationMessageMutation';
  response?: Maybe<Scalars['String']>;
};

export type CareerPageMutationInput = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressPostalCode?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressStreet1?: InputMaybe<Scalars['String']>;
  addressStreet2?: InputMaybe<Scalars['String']>;
  /** Brand color of the CareerPage */
  brandColor?: InputMaybe<Scalars['String']>;
  /** Page background color of the CareerPage */
  brandPageColor?: InputMaybe<Scalars['String']>;
  /** Table background color of the CareerPage */
  brandTableColor?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Cover color of the CareerPage */
  coverColor?: InputMaybe<Scalars['String']>;
  /** Description of the CareerPage */
  description?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  /** Font color of the CareerPage */
  fontColor?: InputMaybe<Scalars['String']>;
  /** Font Family of the CareerPage */
  fontFamily?: InputMaybe<Scalars['String']>;
  /** Undefined, Null, or missing fields will not update when set to true. */
  partialUpdate?: InputMaybe<Scalars['Boolean']>;
  selectedLocations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug: Scalars['String'];
  /** Title of the CareerPage */
  title?: InputMaybe<Scalars['String']>;
};

/** Mutation for update CareerPage. */
export type CareerPageMutationPayload = {
  __typename?: 'CareerPageMutationPayload';
  careerPageType?: Maybe<CareerPageType>;
  clientMutationId?: Maybe<Scalars['String']>;
  coverImageUploadUrl?: Maybe<Scalars['String']>;
  /** May contain more than one error for same field. */
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

/** Career Page */
export type CareerPageType = Node & {
  __typename?: 'CareerPageType';
  addressCity?: Maybe<Scalars['String']>;
  addressCountry?: Maybe<Scalars['String']>;
  addressPostalCode?: Maybe<Scalars['String']>;
  addressState?: Maybe<Scalars['String']>;
  addressStreet1?: Maybe<Scalars['String']>;
  addressStreet2?: Maybe<Scalars['String']>;
  answers: CareerPageAnswerTypeConnection;
  /** Setting this field deactivates the Career Page. Set this to any date instead of deleting. */
  archivedAt?: Maybe<Scalars['DateTime']>;
  /** Brand color of the CareerPage */
  brandColor?: Maybe<Scalars['String']>;
  /** Page background color of the CareerPage */
  brandPageColor?: Maybe<Scalars['String']>;
  /** Table background color of the CareerPage */
  brandTableColor?: Maybe<Scalars['String']>;
  canManage?: Maybe<Scalars['Boolean']>;
  cover?: Maybe<Scalars['String']>;
  /** Cover color of the CareerPage */
  coverColor?: Maybe<Scalars['String']>;
  coverImage?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  /** Description of the CareerPage */
  description?: Maybe<Scalars['String']>;
  employerProfile: EmployerProfileType;
  /** Font color of the CareerPage */
  fontColor?: Maybe<Scalars['String']>;
  /** Font Family of the CareerPage */
  fontFamily?: Maybe<Scalars['String']>;
  formattedAddress?: Maybe<Scalars['String']>;
  /** Career page which belongs to this gallery item. */
  galleries: CareerPageGalleryTypeConnection;
  /** The ID of the object */
  id: Scalars['ID'];
  locations: LocationTypeConnection;
  pageLocations?: Maybe<Array<Maybe<LocationType>>>;
  selectedLocations?: Maybe<Array<Maybe<Scalars['ID']>>>;
  slug: Scalars['String'];
  /** Title of the CareerPage */
  title?: Maybe<Scalars['String']>;
  totalPositions?: Maybe<Scalars['Int']>;
};


/** Career Page */
export type CareerPageTypeAnswersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** Career Page */
export type CareerPageTypeGalleriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


/** Career Page */
export type CareerPageTypeLocationsArgs = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCity_Icontains?: InputMaybe<Scalars['String']>;
  addressCity_Istartswith?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressCountry_Icontains?: InputMaybe<Scalars['String']>;
  addressCountry_Istartswith?: InputMaybe<Scalars['String']>;
  addressPostalCode?: InputMaybe<Scalars['String']>;
  addressPostalCode_Icontains?: InputMaybe<Scalars['String']>;
  addressPostalCode_Istartswith?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressState_Icontains?: InputMaybe<Scalars['String']>;
  addressState_Istartswith?: InputMaybe<Scalars['String']>;
  addressStreet1?: InputMaybe<Scalars['String']>;
  addressStreet1_Icontains?: InputMaybe<Scalars['String']>;
  addressStreet1_Istartswith?: InputMaybe<Scalars['String']>;
  addressStreet2?: InputMaybe<Scalars['String']>;
  addressStreet2_Icontains?: InputMaybe<Scalars['String']>;
  addressStreet2_Istartswith?: InputMaybe<Scalars['String']>;
  addressStreet3?: InputMaybe<Scalars['String']>;
  addressStreet3_Icontains?: InputMaybe<Scalars['String']>;
  addressStreet3_Istartswith?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employerProfile?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_Icontains?: InputMaybe<Scalars['String']>;
  name_Istartswith?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  positions?: InputMaybe<Scalars['ID']>;
};

export type CareerPageTypeConnection = {
  __typename?: 'CareerPageTypeConnection';
  edgeCount?: Maybe<Scalars['Int']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<CareerPageTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `CareerPageType` and its cursor. */
export type CareerPageTypeEdge = {
  __typename?: 'CareerPageTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<CareerPageType>;
};

export type ChannelType = Node & {
  __typename?: 'ChannelType';
  /** Set when a candidate replies "STOP" via SMS */
  candidateOptoutAt?: Maybe<Scalars['DateTime']>;
  candidateUser?: Maybe<UserType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdUser?: Maybe<UserType>;
  /** This is deprecated in new chat. This will be removed soon. */
  employerUser?: Maybe<UserType>;
  employerUsers: UserTypeConnection;
  /** The ID of the object */
  id: Scalars['ID'];
  /** the current application to show on a conversation */
  lastApplication?: Maybe<PositionApplicationType>;
  /** the current interview to show on a conversation */
  lastInterview?: Maybe<InterviewType>;
  /** This is deprecated in new chat. This will be removed soon. */
  lastLocation?: Maybe<LocationType>;
  /** This is deprecated in new chat. This will be removed soon. */
  lastPosition?: Maybe<PositionType>;
  /** one location per conversation */
  location?: Maybe<LocationType>;
  /** The sendbird id of the channel */
  sendbirdChannelId: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type ChannelTypeEmployerUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['UUID']>;
};

export type ChannelTypeConnection = {
  __typename?: 'ChannelTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ChannelTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ChannelType` and its cursor. */
export type ChannelTypeEdge = {
  __typename?: 'ChannelTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ChannelType>;
};

export type ChannelsCountType = {
  __typename?: 'ChannelsCountType';
  hidden?: Maybe<Scalars['Int']>;
  unhidden?: Maybe<Scalars['Int']>;
};

export type ClaimTokenSignInMutation = {
  __typename?: 'ClaimTokenSignInMutation';
  authorization?: Maybe<Scalars['String']>;
  me?: Maybe<UserType>;
};

export type CreateCampaign = {
  __typename?: 'CreateCampaign';
  campaign?: Maybe<JobBoardCampaignType>;
};

/** Career page gallery items. */
export type CreateCareerPageGalleryMutation = {
  __typename?: 'CreateCareerPageGalleryMutation';
  urls?: Maybe<Array<Maybe<CareerPageGallerySignedUrl>>>;
};

export type CreateCareerPageMutationInput = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressPostalCode?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressStreet1?: InputMaybe<Scalars['String']>;
  addressStreet2?: InputMaybe<Scalars['String']>;
  /** Brand color of the CareerPage */
  brandColor?: InputMaybe<Scalars['String']>;
  /** Page background color of the CareerPage */
  brandPageColor?: InputMaybe<Scalars['String']>;
  /** Table background color of the CareerPage */
  brandTableColor?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Cover color of the CareerPage */
  coverColor?: InputMaybe<Scalars['String']>;
  /** Description of the CareerPage */
  description?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  /** Font color of the CareerPage */
  fontColor?: InputMaybe<Scalars['String']>;
  /** Font Family of the CareerPage */
  fontFamily?: InputMaybe<Scalars['String']>;
  /** Undefined, Null, or missing fields will not update when set to true. */
  partialUpdate?: InputMaybe<Scalars['Boolean']>;
  selectedLocations?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  slug: Scalars['String'];
  /** Title of the CareerPage */
  title?: InputMaybe<Scalars['String']>;
};

/** Mutation for Create CareerPage. */
export type CreateCareerPageMutationPayload = {
  __typename?: 'CreateCareerPageMutationPayload';
  careerPageType?: Maybe<CareerPageType>;
  clientMutationId?: Maybe<Scalars['String']>;
  coverImageUploadUrl?: Maybe<Scalars['String']>;
  /** May contain more than one error for same field. */
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type CreateEmployerCandidatesMutation = {
  __typename?: 'CreateEmployerCandidatesMutation';
  created?: Maybe<Scalars['Boolean']>;
  employerCandidates?: Maybe<Array<Maybe<EmployerCandidateType>>>;
};

export type CreateScreeningQuestionMutation = {
  __typename?: 'CreateScreeningQuestionMutation';
  screeningQuestion?: Maybe<ScreeningQuestionType>;
};

/** Mutation to create the screening Questionnaire. */
export type CreateScreeningQuestionnaireMutation = {
  __typename?: 'CreateScreeningQuestionnaireMutation';
  screeningQuestionnaire?: Maybe<ScreeningQuestionnaireType>;
};

export type CreateStripePaymentIntent = {
  __typename?: 'CreateStripePaymentIntent';
  clientSecret?: Maybe<Scalars['String']>;
  paymentIntent?: Maybe<Scalars['String']>;
};

export type DashboardCountType = {
  __typename?: 'DashboardCountType';
  new?: Maybe<Scalars['Int']>;
  total?: Maybe<Scalars['Int']>;
};

export type DashboardCountsType = {
  __typename?: 'DashboardCountsType';
  applicants?: Maybe<DashboardCountType>;
  candidates?: Maybe<DashboardCountType>;
  chat?: Maybe<DashboardCountType>;
  interviews?: Maybe<InterviewCountType>;
};

export type DeactivateSubscriptionMutation = {
  __typename?: 'DeactivateSubscriptionMutation';
  locations?: Maybe<Array<Maybe<LocationType>>>;
  payment?: Maybe<PaymentType>;
  positions?: Maybe<Array<Maybe<PositionType>>>;
};

export type DebugSentryMutation = {
  __typename?: 'DebugSentryMutation';
  nothing?: Maybe<Scalars['String']>;
};

export type DeleteCandidateWorkHistoryMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type DeleteCandidateWorkHistoryMutationPayload = {
  __typename?: 'DeleteCandidateWorkHistoryMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  message?: Maybe<Scalars['String']>;
};

export type DeleteInterviewScheduleRangeMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type DeleteInterviewScheduleRangeMutationPayload = {
  __typename?: 'DeleteInterviewScheduleRangeMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  message?: Maybe<Scalars['String']>;
};

/** Mutation to delete message template file. */
export type DeleteMessageTemplateFile = {
  __typename?: 'DeleteMessageTemplateFile';
  deleted?: Maybe<Scalars['Boolean']>;
};

export type DeleteMyResumeMutation = {
  __typename?: 'DeleteMyResumeMutation';
  candidateProfile?: Maybe<CandidateProfileType>;
};

export type DeletePositionMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type DeletePositionMutationPayload = {
  __typename?: 'DeletePositionMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  message?: Maybe<Scalars['String']>;
};

export type DismissNotification = {
  __typename?: 'DismissNotification';
  notification?: Maybe<EmployerCandidateNotificationType>;
};

/** Debugging information for the current query. */
export type DjangoDebug = {
  __typename?: 'DjangoDebug';
  /** Raise exceptions for this API query. */
  exceptions?: Maybe<Array<Maybe<DjangoDebugException>>>;
  /** Executed SQL queries for this API query. */
  sql?: Maybe<Array<Maybe<DjangoDebugSql>>>;
};

/** Represents a single exception raised. */
export type DjangoDebugException = {
  __typename?: 'DjangoDebugException';
  /** The class of the exception */
  excType: Scalars['String'];
  /** The message of the exception */
  message: Scalars['String'];
  /** The stack trace */
  stack: Scalars['String'];
};

/** Represents a single database query made to a Django managed DB. */
export type DjangoDebugSql = {
  __typename?: 'DjangoDebugSQL';
  /** The Django database alias (e.g. 'default'). */
  alias: Scalars['String'];
  /** Duration of this database query in seconds. */
  duration: Scalars['Float'];
  /** Postgres connection encoding if available. */
  encoding?: Maybe<Scalars['String']>;
  /** Whether this database query was a SELECT. */
  isSelect: Scalars['Boolean'];
  /** Whether this database query took more than 10 seconds. */
  isSlow: Scalars['Boolean'];
  /** Postgres isolation level if available. */
  isoLevel?: Maybe<Scalars['String']>;
  /** JSON encoded database query parameters. */
  params: Scalars['String'];
  /** The raw SQL of this query, without params. */
  rawSql: Scalars['String'];
  /** The actual SQL sent to this database. */
  sql?: Maybe<Scalars['String']>;
  /** Start time of this database query. */
  startTime: Scalars['Float'];
  /** Stop time of this database query. */
  stopTime: Scalars['Float'];
  /** Postgres transaction ID if available. */
  transId?: Maybe<Scalars['String']>;
  /** Postgres transaction status if available. */
  transStatus?: Maybe<Scalars['String']>;
  /** The type of database being used (e.g. postrgesql, mysql, sqlite). */
  vendor: Scalars['String'];
};

export type EmployerCandidateDetailsViewType = Node & {
  __typename?: 'EmployerCandidateDetailsViewType';
  email: Scalars['String'];
  employerCandidateId?: Maybe<Scalars['ID']>;
  employerProfileId: Scalars['Int'];
  firstName: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  isArchived?: Maybe<Scalars['Boolean']>;
  isSelectable?: Maybe<Scalars['Boolean']>;
  lastActivityAt: Scalars['DateTime'];
  lastName: Scalars['String'];
  locationId?: Maybe<Scalars['ID']>;
  locationName: Scalars['String'];
  positionId?: Maybe<Scalars['ID']>;
  positionName: Scalars['String'];
  stageId?: Maybe<Scalars['ID']>;
  userId?: Maybe<Scalars['ID']>;
};

export type EmployerCandidateDetailsViewTypeConnection = {
  __typename?: 'EmployerCandidateDetailsViewTypeConnection';
  edgeCount?: Maybe<Scalars['Int']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EmployerCandidateDetailsViewTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `EmployerCandidateDetailsViewType` and its cursor. */
export type EmployerCandidateDetailsViewTypeEdge = {
  __typename?: 'EmployerCandidateDetailsViewTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<EmployerCandidateDetailsViewType>;
};

export type EmployerCandidateNoteMutationInput = {
  archivedAt?: InputMaybe<Scalars['DateTime']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['ID']>;
  employerCandidate?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  /** Undefined, Null, or missing fields will not update when set to true. */
  partialUpdate?: InputMaybe<Scalars['Boolean']>;
  text?: InputMaybe<Scalars['String']>;
  updatedBy?: InputMaybe<Scalars['ID']>;
};

/** Mutation to create or update employer candidate note. */
export type EmployerCandidateNoteMutationPayload = {
  __typename?: 'EmployerCandidateNoteMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  employerCandidateNoteType?: Maybe<EmployerCandidateNoteType>;
  /** May contain more than one error for same field. */
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type EmployerCandidateNoteType = Node & {
  __typename?: 'EmployerCandidateNoteType';
  archivedAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: UserType;
  employerCandidate: EmployerCandidateType;
  /** The ID of the object */
  id: Scalars['ID'];
  text?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  updatedBy: UserType;
};

export type EmployerCandidateNoteTypeConnection = {
  __typename?: 'EmployerCandidateNoteTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EmployerCandidateNoteTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `EmployerCandidateNoteType` and its cursor. */
export type EmployerCandidateNoteTypeEdge = {
  __typename?: 'EmployerCandidateNoteTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<EmployerCandidateNoteType>;
};

export type EmployerCandidateNotificationType = Node & {
  __typename?: 'EmployerCandidateNotificationType';
  actions?: Maybe<Array<Maybe<Scalars['String']>>>;
  color?: Maybe<Scalars['String']>;
  /** null means "active"/"show it" */
  dismissedAt?: Maybe<Scalars['DateTime']>;
  icon?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  message?: Maybe<Scalars['String']>;
  notificationType: EmployersEmployerCandidateNotificationNotificationTypeChoices;
  rowId?: Maybe<Scalars['Int']>;
  status: EmployersEmployerCandidateNotificationStatusChoices;
};

export type EmployerCandidateNotificationTypeConnection = {
  __typename?: 'EmployerCandidateNotificationTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EmployerCandidateNotificationTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `EmployerCandidateNotificationType` and its cursor. */
export type EmployerCandidateNotificationTypeEdge = {
  __typename?: 'EmployerCandidateNotificationTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<EmployerCandidateNotificationType>;
};

export type EmployerCandidateQuestionnaireType = Node & {
  __typename?: 'EmployerCandidateQuestionnaireType';
  candidateUrl?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  employerCandidate?: Maybe<EmployerCandidateType>;
  /** The ID of the object */
  id: Scalars['ID'];
  position?: Maybe<PositionType>;
  screeningAnswer: ScreeningAnswerTypeConnection;
  screeningQuestionnaire?: Maybe<ScreeningQuestionnaireType>;
  sentAt?: Maybe<Scalars['DateTime']>;
  submittedAt?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
};


export type EmployerCandidateQuestionnaireTypeScreeningAnswerArgs = {
  after?: InputMaybe<Scalars['String']>;
  answer?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employerCandidateQuestionnaire?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  questionText?: InputMaybe<Scalars['String']>;
  screeningQuestion?: InputMaybe<Scalars['ID']>;
};

export type EmployerCandidateQuestionnaireTypeConnection = {
  __typename?: 'EmployerCandidateQuestionnaireTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EmployerCandidateQuestionnaireTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `EmployerCandidateQuestionnaireType` and its cursor. */
export type EmployerCandidateQuestionnaireTypeEdge = {
  __typename?: 'EmployerCandidateQuestionnaireTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<EmployerCandidateQuestionnaireType>;
};

export enum EmployerCandidateSortByEnum {
  CreatedAt = 'CREATED_AT',
  LastUpdated = 'LAST_UPDATED'
}

export type EmployerCandidateType = Node & {
  __typename?: 'EmployerCandidateType';
  candidateProfile: CandidateProfileType;
  chatNotification?: Maybe<EmployerCandidateNotificationType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  employerProfile: EmployerProfileType;
  employercandidateNotes: EmployerCandidateNoteTypeConnection;
  employercandidateNotifications: EmployerCandidateNotificationTypeConnection;
  employercandidatequestionnaireSet: EmployerCandidateQuestionnaireTypeConnection;
  hasNote?: Maybe<Scalars['Boolean']>;
  /** The ID of the object */
  id: Scalars['ID'];
  lastActivityAt: Scalars['DateTime'];
  matches: MatchTypeConnection;
  preferredMatch?: Maybe<MatchType>;
  rejectionReasons: EmployerRejectionReasonTypeConnection;
  /** The Company ID of the employee in 7Shifts */
  sevenshiftsCompanyId?: Maybe<Scalars['String']>;
  /** The ID of the employee in 7Shifts */
  sevenshiftsId?: Maybe<Scalars['String']>;
  sevenshiftsUrl?: Maybe<Scalars['String']>;
  stage?: Maybe<EmployerStageType>;
  stageUpdatedAt: Scalars['DateTime'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type EmployerCandidateTypeEmployercandidateNotesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employerCandidate?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type EmployerCandidateTypeEmployercandidateNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  notificationType?: InputMaybe<EmployersEmployerCandidateNotificationNotificationTypeChoices>;
  offset?: InputMaybe<Scalars['Int']>;
  stage?: InputMaybe<Scalars['ID']>;
};


export type EmployerCandidateTypeEmployercandidatequestionnaireSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  candidateUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  employerCandidate?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  position?: InputMaybe<Scalars['ID']>;
  screeningQuestionnaire?: InputMaybe<Scalars['ID']>;
  sentAt?: InputMaybe<Scalars['DateTime']>;
  submittedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  uuid?: InputMaybe<Scalars['UUID']>;
};


export type EmployerCandidateTypeMatchesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type EmployerCandidateTypeRejectionReasonsArgs = {
  after?: InputMaybe<Scalars['String']>;
  archivedAt_Isnull?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type EmployerCandidateTypeConnection = {
  __typename?: 'EmployerCandidateTypeConnection';
  edgeCount?: Maybe<Scalars['Int']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EmployerCandidateTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `EmployerCandidateType` and its cursor. */
export type EmployerCandidateTypeEdge = {
  __typename?: 'EmployerCandidateTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<EmployerCandidateType>;
};

export type EmployerMessageTemplateCountType = {
  __typename?: 'EmployerMessageTemplateCountType';
  applicants?: Maybe<Scalars['Int']>;
  hired?: Maybe<Scalars['Int']>;
  interview?: Maybe<Scalars['Int']>;
  offer?: Maybe<Scalars['Int']>;
  other?: Maybe<Scalars['Int']>;
  screening?: Maybe<Scalars['Int']>;
};

/** Mutation to delete employee message template. */
export type EmployerMessageTemplateDeleteMutation = {
  __typename?: 'EmployerMessageTemplateDeleteMutation';
  deleted?: Maybe<Scalars['Boolean']>;
};

export type EmployerMessageTemplateFileType = Node & {
  __typename?: 'EmployerMessageTemplateFileType';
  attachment?: Maybe<Scalars['String']>;
  employerMessageTemplate: EmployerMessageTemplateType;
  fileName?: Maybe<Scalars['String']>;
  fileType?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type EmployerMessageTemplateFileTypeConnection = {
  __typename?: 'EmployerMessageTemplateFileTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EmployerMessageTemplateFileTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `EmployerMessageTemplateFileType` and its cursor. */
export type EmployerMessageTemplateFileTypeEdge = {
  __typename?: 'EmployerMessageTemplateFileTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<EmployerMessageTemplateFileType>;
};

export type EmployerMessageTemplateMutationInput = {
  /** Action's for employer message template */
  action?: InputMaybe<Scalars['String']>;
  /** Setting this field deactivates the employer message template. Set this to any date instead of deleting. */
  archivedAt?: InputMaybe<Scalars['DateTime']>;
  /** Category for employer message template */
  category?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['ID']>;
  defaultCompensation?: InputMaybe<Scalars['Float']>;
  defaultCompensationUnits?: InputMaybe<Scalars['String']>;
  employerProfile?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  messageContent?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  /** Undefined, Null, or missing fields will not update when set to true. */
  partialUpdate?: InputMaybe<Scalars['Boolean']>;
  screeningQuestionList?: InputMaybe<Array<InputMaybe<ScreeningQuestionSerializerInput>>>;
  /** Type for employer candidate template */
  templateType?: InputMaybe<Scalars['String']>;
};

/** Mutation to create or update employer message template. */
export type EmployerMessageTemplateMutationPayload = {
  __typename?: 'EmployerMessageTemplateMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  employerMessageTemplate?: Maybe<EmployerMessageTemplateType>;
  /** May contain more than one error for same field. */
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  fileUploadUrl?: Maybe<Scalars['String']>;
};

export type EmployerMessageTemplateType = Node & {
  __typename?: 'EmployerMessageTemplateType';
  action?: Maybe<Scalars['String']>;
  /** Setting this field deactivates the employer message template. Set this to any date instead of deleting. */
  archivedAt?: Maybe<Scalars['DateTime']>;
  /** Category for employer message template */
  category?: Maybe<EmployersEmployerMessageTemplateCategoryChoices>;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  defaultCompensation?: Maybe<Scalars['Float']>;
  defaultCompensationUnits?: Maybe<EmployersEmployerMessageTemplateDefaultCompensationUnitsChoices>;
  employerMessageTemplateFile: EmployerMessageTemplateFileTypeConnection;
  employerProfile: EmployerProfileType;
  fileUploadUrl?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  isDefault: Scalars['Boolean'];
  messageContent?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  screeningQuestionnaire: ScreeningQuestionnaireTypeConnection;
  /** Type for employer candidate template */
  templateType?: Maybe<EmployersEmployerMessageTemplateTemplateTypeChoices>;
};


export type EmployerMessageTemplateTypeEmployerMessageTemplateFileArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type EmployerMessageTemplateTypeScreeningQuestionnaireArgs = {
  after?: InputMaybe<Scalars['String']>;
  archivedAt?: InputMaybe<Scalars['DateTime']>;
  before?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  employerProfile?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name_Icontains?: InputMaybe<Scalars['String']>;
  name_Iexact?: InputMaybe<Scalars['String']>;
  name_Istartswith?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  questionnaireType?: InputMaybe<ScreeningScreeningQuestionnaireQuestionnaireTypeChoices>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type EmployerMessageTemplateTypeConnection = {
  __typename?: 'EmployerMessageTemplateTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EmployerMessageTemplateTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `EmployerMessageTemplateType` and its cursor. */
export type EmployerMessageTemplateTypeEdge = {
  __typename?: 'EmployerMessageTemplateTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<EmployerMessageTemplateType>;
};

export type EmployerProfileMutationInput = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressPostalCode?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressStreet1?: InputMaybe<Scalars['String']>;
  addressStreet2?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  /** Undefined, Null, or missing fields will not update when set to true. */
  partialUpdate?: InputMaybe<Scalars['Boolean']>;
  phone?: InputMaybe<Scalars['String']>;
  /** Sales status of the employer account */
  status?: InputMaybe<Scalars['String']>;
  terms?: InputMaybe<Scalars['Boolean']>;
};

export type EmployerProfileMutationPayload = {
  __typename?: 'EmployerProfileMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  employerProfile?: Maybe<EmployerProfileType>;
  /** May contain more than one error for same field. */
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type EmployerProfileType = Node & {
  __typename?: 'EmployerProfileType';
  addressCity?: Maybe<Scalars['String']>;
  addressCountry: Scalars['String'];
  addressPostalCode?: Maybe<Scalars['String']>;
  addressState?: Maybe<Scalars['String']>;
  addressStreet1?: Maybe<Scalars['String']>;
  addressStreet2?: Maybe<Scalars['String']>;
  answers: LocationAnswerTypeConnection;
  cancellationreasonSet: CancellationReasonTypeConnection;
  careerPage: CareerPageTypeConnection;
  companyName?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  employerStages: EmployerStageTypeConnection;
  employercandidateSet: EmployerCandidateTypeConnection;
  employermessagetemplateSet: EmployerMessageTemplateTypeConnection;
  employerprofileuserSet: EmployerProfileUserTypeConnection;
  employerrejectionreasonSet: EmployerRejectionReasonTypeConnection;
  employmentdocumentSet: EmploymentDocumentTypeConnection;
  featureFlags: FeatureFlagTypeConnection;
  /** The ID of the object */
  id: Scalars['ID'];
  /** Toggles whether to include physical address in the interview notification email */
  includeAddressInNotification: Scalars['Boolean'];
  indeedoauthtokenSet: IndeedCompanyTypeConnection;
  integrationidentifierSet: IntegrationIdentifierTypeConnection;
  interviews: InterviewTypeConnection;
  jobBoardCampaign: JobBoardCampaignTypeConnection;
  lastCandidateCheck?: Maybe<Scalars['DateTime']>;
  lastMatchNotificationCheck?: Maybe<Scalars['DateTime']>;
  locations: LocationTypeConnection;
  payment: PaymentTypeConnection;
  rowId?: Maybe<Scalars['Int']>;
  screeningQuestionnaire: ScreeningQuestionnaireTypeConnection;
  segment?: Maybe<EmployersEmployerProfileSegmentChoices>;
  sevenshiftsguidSet: SevenShiftsGuidTypeConnection;
  /** Sales status of the employer account */
  status: EmployersEmployerProfileStatusChoices;
  subscribed?: Maybe<Scalars['Boolean']>;
  /** Like 'verified', if this field is unset the employer cannot interact with candidates. However, this field can be automatically set (by Stripe payments or expirations), or set manually (i.e. a free trial, complimentary subscription, or to bypass a billing error) */
  subscribedAt?: Maybe<Scalars['DateTime']>;
  terms: Scalars['Boolean'];
  updatedAt: Scalars['DateTime'];
  users: UserTypeConnection;
  /** Uncheck (set to False) to prevent users from canceling their plan on the billing page */
  usersCanCancel: Scalars['Boolean'];
  /** Internal kill switch, defaults to True. If this is unchecked, the employer cannot interact with candidates. */
  verified: Scalars['Boolean'];
  /** The main URL for the company */
  website?: Maybe<Scalars['String']>;
};


export type EmployerProfileTypeAnswersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type EmployerProfileTypeCancellationreasonSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['ID']>;
  offset?: InputMaybe<Scalars['Int']>;
  position?: InputMaybe<Scalars['ID']>;
};


export type EmployerProfileTypeCareerPageArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employerProfile?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type EmployerProfileTypeEmployerStagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employerProfile?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type EmployerProfileTypeEmployercandidateSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  stageUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  stageUpdatedAt_Gte?: InputMaybe<Scalars['DateTime']>;
  stageUpdatedAt_Lte?: InputMaybe<Scalars['DateTime']>;
};


export type EmployerProfileTypeEmployermessagetemplateSetArgs = {
  action_Iexact?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  archivedAt?: InputMaybe<Scalars['DateTime']>;
  before?: InputMaybe<Scalars['String']>;
  category_Icontains?: InputMaybe<EmployersEmployerMessageTemplateCategoryChoices>;
  category_Iexact?: InputMaybe<EmployersEmployerMessageTemplateCategoryChoices>;
  category_Istartswith?: InputMaybe<EmployersEmployerMessageTemplateCategoryChoices>;
  employerProfile?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  messageContent_Icontains?: InputMaybe<Scalars['String']>;
  messageContent_Iexact?: InputMaybe<Scalars['String']>;
  messageContent_Istartswith?: InputMaybe<Scalars['String']>;
  name_Icontains?: InputMaybe<Scalars['String']>;
  name_Iexact?: InputMaybe<Scalars['String']>;
  name_Istartswith?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type EmployerProfileTypeEmployerprofileuserSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type EmployerProfileTypeEmployerrejectionreasonSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  archivedAt_Isnull?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type EmployerProfileTypeEmploymentdocumentSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  candidate?: InputMaybe<Scalars['ID']>;
  documentType_Icontains?: InputMaybe<EmployersEmploymentDocumentDocumentTypeChoices>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type EmployerProfileTypeFeatureFlagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  feature?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  on?: InputMaybe<Scalars['Boolean']>;
};


export type EmployerProfileTypeIndeedoauthtokenSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type EmployerProfileTypeIntegrationidentifierSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type EmployerProfileTypeInterviewsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type EmployerProfileTypeJobBoardCampaignArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employer?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<PaymentJobBoardCampaignPlatformChoices>;
  position?: InputMaybe<Scalars['ID']>;
  stripeCustomer?: InputMaybe<Scalars['String']>;
};


export type EmployerProfileTypeLocationsArgs = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCity_Icontains?: InputMaybe<Scalars['String']>;
  addressCity_Istartswith?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressCountry_Icontains?: InputMaybe<Scalars['String']>;
  addressCountry_Istartswith?: InputMaybe<Scalars['String']>;
  addressPostalCode?: InputMaybe<Scalars['String']>;
  addressPostalCode_Icontains?: InputMaybe<Scalars['String']>;
  addressPostalCode_Istartswith?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressState_Icontains?: InputMaybe<Scalars['String']>;
  addressState_Istartswith?: InputMaybe<Scalars['String']>;
  addressStreet1?: InputMaybe<Scalars['String']>;
  addressStreet1_Icontains?: InputMaybe<Scalars['String']>;
  addressStreet1_Istartswith?: InputMaybe<Scalars['String']>;
  addressStreet2?: InputMaybe<Scalars['String']>;
  addressStreet2_Icontains?: InputMaybe<Scalars['String']>;
  addressStreet2_Istartswith?: InputMaybe<Scalars['String']>;
  addressStreet3?: InputMaybe<Scalars['String']>;
  addressStreet3_Icontains?: InputMaybe<Scalars['String']>;
  addressStreet3_Istartswith?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employerProfile?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_Icontains?: InputMaybe<Scalars['String']>;
  name_Istartswith?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  positions?: InputMaybe<Scalars['ID']>;
};


export type EmployerProfileTypePaymentArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['ID']>;
  offset?: InputMaybe<Scalars['Int']>;
  position?: InputMaybe<Scalars['ID']>;
};


export type EmployerProfileTypeScreeningQuestionnaireArgs = {
  after?: InputMaybe<Scalars['String']>;
  archivedAt?: InputMaybe<Scalars['DateTime']>;
  before?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  employerProfile?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name_Icontains?: InputMaybe<Scalars['String']>;
  name_Iexact?: InputMaybe<Scalars['String']>;
  name_Istartswith?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  questionnaireType?: InputMaybe<ScreeningScreeningQuestionnaireQuestionnaireTypeChoices>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};


export type EmployerProfileTypeSevenshiftsguidSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type EmployerProfileTypeUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['UUID']>;
};

export type EmployerProfileTypeConnection = {
  __typename?: 'EmployerProfileTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EmployerProfileTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `EmployerProfileType` and its cursor. */
export type EmployerProfileTypeEdge = {
  __typename?: 'EmployerProfileTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<EmployerProfileType>;
};

/** Employer Notification preference Mutation. */
export type EmployerProfileUserNotificationPreferenceMutation = {
  __typename?: 'EmployerProfileUserNotificationPreferenceMutation';
  employerProfileUser?: Maybe<EmployerProfileUserType>;
  id?: Maybe<Scalars['ID']>;
  notifications?: Maybe<NotificationPreferenceSubType>;
};

export type EmployerProfileUserNotificationPreferenceType = Node & {
  __typename?: 'EmployerProfileUserNotificationPreferenceType';
  chatMessageEmail: Scalars['Boolean'];
  chatMessageSms: Scalars['Boolean'];
  dailyDigestEmail: Scalars['Boolean'];
  employerProfileUser?: Maybe<EmployerProfileUserType>;
  /** The ID of the object */
  id: Scalars['ID'];
  interviewResponseEmail: Scalars['Boolean'];
  interviewResponseSms: Scalars['Boolean'];
  notifications?: Maybe<NotificationPreferenceSubType>;
  pk?: Maybe<Scalars['Int']>;
};

export type EmployerProfileUserType = Node & {
  __typename?: 'EmployerProfileUserType';
  createdAt: Scalars['DateTime'];
  employerProfile: EmployerProfileType;
  /** The ID of the object */
  id: Scalars['ID'];
  locations: LocationTypeConnection;
  /** "Admin" users will have access to all locations and settings. "User" users only have access to the specified locations. "Interviewer" users can access all feed functions but cannot manage locations/positions/billing */
  role: EmployersEmployerProfileUserRoleChoices;
  user: UserType;
};


export type EmployerProfileUserTypeLocationsArgs = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCity_Icontains?: InputMaybe<Scalars['String']>;
  addressCity_Istartswith?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressCountry_Icontains?: InputMaybe<Scalars['String']>;
  addressCountry_Istartswith?: InputMaybe<Scalars['String']>;
  addressPostalCode?: InputMaybe<Scalars['String']>;
  addressPostalCode_Icontains?: InputMaybe<Scalars['String']>;
  addressPostalCode_Istartswith?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressState_Icontains?: InputMaybe<Scalars['String']>;
  addressState_Istartswith?: InputMaybe<Scalars['String']>;
  addressStreet1?: InputMaybe<Scalars['String']>;
  addressStreet1_Icontains?: InputMaybe<Scalars['String']>;
  addressStreet1_Istartswith?: InputMaybe<Scalars['String']>;
  addressStreet2?: InputMaybe<Scalars['String']>;
  addressStreet2_Icontains?: InputMaybe<Scalars['String']>;
  addressStreet2_Istartswith?: InputMaybe<Scalars['String']>;
  addressStreet3?: InputMaybe<Scalars['String']>;
  addressStreet3_Icontains?: InputMaybe<Scalars['String']>;
  addressStreet3_Istartswith?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employerProfile?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_Icontains?: InputMaybe<Scalars['String']>;
  name_Istartswith?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  positions?: InputMaybe<Scalars['ID']>;
};

export type EmployerProfileUserTypeConnection = {
  __typename?: 'EmployerProfileUserTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EmployerProfileUserTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `EmployerProfileUserType` and its cursor. */
export type EmployerProfileUserTypeEdge = {
  __typename?: 'EmployerProfileUserTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<EmployerProfileUserType>;
};

export type EmployerRejectionReasonMutationInput = {
  /** Setting this field deactivates the rejection reason everywhere in the site, including in the employers view. Set this to any date instead of deleting. */
  archivedAt?: InputMaybe<Scalars['DateTime']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  employerProfile?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  /** Reasons appear in ascending order in FE */
  order?: InputMaybe<Scalars['Int']>;
  /** Undefined, Null, or missing fields will not update when set to true. */
  partialUpdate?: InputMaybe<Scalars['Boolean']>;
};

/** Mutation to create or update employer rejection reason. */
export type EmployerRejectionReasonMutationPayload = {
  __typename?: 'EmployerRejectionReasonMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  employerRejectionReason?: Maybe<EmployerRejectionReasonType>;
  /** May contain more than one error for same field. */
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  name?: Maybe<Scalars['String']>;
  order?: Maybe<Scalars['Int']>;
};

export type EmployerRejectionReasonType = Node & {
  __typename?: 'EmployerRejectionReasonType';
  /** Setting this field deactivates the rejection reason everywhere in the site, including in the employers view. Set this to any date instead of deleting. */
  archivedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  employerProfile: EmployerProfileType;
  employercandidateSet: EmployerCandidateTypeConnection;
  /** The ID of the object */
  id: Scalars['ID'];
  name: Scalars['String'];
  /** Reasons appear in ascending order in FE */
  order?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};


export type EmployerRejectionReasonTypeEmployercandidateSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  stageUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  stageUpdatedAt_Gte?: InputMaybe<Scalars['DateTime']>;
  stageUpdatedAt_Lte?: InputMaybe<Scalars['DateTime']>;
};

export type EmployerRejectionReasonTypeConnection = {
  __typename?: 'EmployerRejectionReasonTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EmployerRejectionReasonTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `EmployerRejectionReasonType` and its cursor. */
export type EmployerRejectionReasonTypeEdge = {
  __typename?: 'EmployerRejectionReasonTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<EmployerRejectionReasonType>;
};

export type EmployerStageType = Node & {
  __typename?: 'EmployerStageType';
  employerCandidateCount?: Maybe<Scalars['Int']>;
  employerProfile?: Maybe<EmployerProfileType>;
  hasNotification?: Maybe<Scalars['Boolean']>;
  /** The ID of the object */
  id: Scalars['ID'];
  name: Scalars['String'];
  ordering: Scalars['Int'];
  refreshNotificationCount?: Maybe<Scalars['Int']>;
  rowId?: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
  stageType: EmployersEmployerStageStageTypeChoices;
};


export type EmployerStageTypeEmployerCandidateCountArgs = {
  locations?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  positions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  profileDetailFilters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  stageUpdatedAtGte?: InputMaybe<Scalars['DateTime']>;
  stageUpdatedAtLte?: InputMaybe<Scalars['DateTime']>;
};


export type EmployerStageTypeHasNotificationArgs = {
  locations?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  positions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type EmployerStageTypeConnection = {
  __typename?: 'EmployerStageTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EmployerStageTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `EmployerStageType` and its cursor. */
export type EmployerStageTypeEdge = {
  __typename?: 'EmployerStageTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<EmployerStageType>;
};

export type EmployerUserMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  lastName?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  role?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type EmployerUserMutationPayload = {
  __typename?: 'EmployerUserMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  employerUser?: Maybe<EmployerProfileUserType>;
};

/** An enumeration. */
export enum EmployersEmployerCandidateNotificationNotificationTypeChoices {
  /** Chat Notification */
  Chat = 'CHAT',
  /** Hired Notification */
  Hired = 'HIRED',
  /** Offered Notification */
  Offered = 'OFFERED',
  /** Schedule Notification */
  Schedule = 'SCHEDULE',
  /** Screening Notification */
  Screening = 'SCREENING'
}

/** An enumeration. */
export enum EmployersEmployerCandidateNotificationStatusChoices {
  /** Declined */
  Declined = 'DECLINED',
  /** Done */
  Done = 'DONE',
  /** Pending */
  Pending = 'PENDING',
  /** ToDo */
  Todo = 'TODO',
  /** Unscheduled */
  Unscheduled = 'UNSCHEDULED'
}

/** An enumeration. */
export enum EmployersEmployerMessageTemplateCategoryChoices {
  /** Applicants */
  Applicants = 'APPLICANTS',
  /** Hired */
  Hired = 'HIRED',
  /** Interviews */
  Interview = 'INTERVIEW',
  /** Offers */
  Offer = 'OFFER',
  /** Others */
  Other = 'OTHER',
  /** Screening */
  Screening = 'SCREENING'
}

/** An enumeration. */
export enum EmployersEmployerMessageTemplateDefaultCompensationUnitsChoices {
  /** Hourly */
  Hour = 'HOUR',
  /** Hourly with tips */
  HourlyTips = 'HOURLY_TIPS',
  /** Annually */
  Year = 'YEAR'
}

/** An enumeration. */
export enum EmployersEmployerMessageTemplateTemplateTypeChoices {
  /** Global */
  Global = 'GLOBAL',
  /** Personal */
  Personal = 'PERSONAL'
}

/** An enumeration. */
export enum EmployersEmployerProfileSegmentChoices {
  /** Fraud */
  Fraud = 'FRAUD',
  /** ICP Large (26+) */
  IcpLarge = 'ICP_LARGE',
  /** ICP Medium (8-25) */
  IcpMedium = 'ICP_MEDIUM',
  /** ICP Small (5-7) */
  IcpSmall = 'ICP_SMALL',
  /** Land & Expand */
  LandAndExpand = 'LAND_AND_EXPAND',
  /** Tiny */
  Tiny = 'TINY'
}

/** An enumeration. */
export enum EmployersEmployerProfileStatusChoices {
  /** Cancelled */
  Cancelled = 'CANCELLED',
  /** Fraud */
  Fraud = 'FRAUD',
  /** Paused */
  Paused = 'PAUSED',
  /** Pending */
  Pending = 'PENDING',
  /** Registered */
  Registered = 'REGISTERED',
  /** Subscribed */
  Subscribed = 'SUBSCRIBED'
}

/** An enumeration. */
export enum EmployersEmployerProfileUserRoleChoices {
  /** Admin */
  Admin = 'ADMIN',
  /** Interviewer */
  Interviewer = 'INTERVIEWER',
  /** User */
  User = 'USER'
}

/** An enumeration. */
export enum EmployersEmployerStageStageTypeChoices {
  /** Applicants */
  Applicants = 'APPLICANTS',
  /** Hired */
  Hired = 'HIRED',
  /** Interviews */
  Interviews = 'INTERVIEWS',
  /** Offered */
  Offered = 'OFFERED',
  /** Candidates */
  PassiveCandidates = 'PASSIVE_CANDIDATES',
  /** Rejected */
  Rejected = 'REJECTED',
  /** Screening */
  Screening = 'SCREENING'
}

/** An enumeration. */
export enum EmployersEmploymentDocumentBaseSalaryUnitTextChoices {
  /** Hourly */
  Hour = 'HOUR',
  /** Hourly with tips */
  HourlyTips = 'HOURLY_TIPS',
  /** Annually */
  Year = 'YEAR'
}

/** An enumeration. */
export enum EmployersEmploymentDocumentDocumentTypeChoices {
  /** Hired */
  Hired = 'HIRED',
  /** Offer */
  Offer = 'OFFER',
  /** Onboarding */
  Onboarding = 'ONBOARDING'
}

/** An enumeration. */
export enum EmployersEmploymentDocumentStatusChoices {
  /** Accepted */
  Accepted = 'ACCEPTED',
  /** Declined */
  Declined = 'DECLINED',
  /** Sent */
  Sent = 'SENT'
}

/** An enumeration. */
export enum EmployersInterviewMessagingInterviewAcceptedTypeChoices {
  /** Custom */
  Custom = 'CUSTOM',
  /** Default */
  Default = 'DEFAULT'
}

/** An enumeration. */
export enum EmployersInterviewMessagingInterviewRequestTypeChoices {
  /** Custom */
  Custom = 'CUSTOM',
  /** Default */
  Default = 'DEFAULT'
}

/** An enumeration. */
export enum EmployersInterviewScheduleDurationMinutesChoices {
  /** 15 minutes */
  A_15 = 'A_15',
  /** 30 minutes */
  A_30 = 'A_30',
  /** 45 minutes */
  A_45 = 'A_45',
  /** 60 minutes */
  A_60 = 'A_60'
}

/** An enumeration. */
export enum EmployersInterviewScheduleLocationChoices {
  /** In Person */
  Inperson = 'INPERSON',
  /** Phone */
  Phone = 'PHONE',
  /** Remote */
  Remote = 'REMOTE'
}

/** An enumeration. */
export enum EmployersInterviewScheduleRangeDayChoices {
  /** Monday */
  A_0 = 'A_0',
  /** Tuesday */
  A_1 = 'A_1',
  /** Wednesday */
  A_2 = 'A_2',
  /** Thursday */
  A_3 = 'A_3',
  /** Friday */
  A_4 = 'A_4',
  /** Saturday */
  A_5 = 'A_5',
  /** Sunday */
  A_6 = 'A_6'
}

/** An enumeration. */
export enum EmployersLocationPaymentStatusChoices {
  /** Paused */
  Paused = 'PAUSED',
  /** Subscribed */
  Subscribed = 'SUBSCRIBED'
}

/** An enumeration. */
export enum EmployersPositionApplicationStatusChoices {
  /** Expired */
  Expired = 'EXPIRED',
  /** Interview Requested */
  InterviewRequested = 'INTERVIEW_REQUESTED',
  /** Pending */
  Pending = 'PENDING',
  /** Under Review */
  UnderReview = 'UNDER_REVIEW'
}

/** An enumeration. */
export enum EmployersPositionMatchVersionChoices {
  /** 1 */
  A_1 = 'A_1',
  /** 2 */
  A_2 = 'A_2'
}

/** An enumeration. */
export enum EmployersPositionPaymentStatusChoices {
  /** Paused */
  Paused = 'PAUSED',
  /** Subscribed */
  Subscribed = 'SUBSCRIBED'
}

/** An enumeration. */
export enum EmployersTagTagTypeChoices {
  /** Category */
  Category = 'CATEGORY',
  /** Cuisine */
  Cuisine = 'CUISINE',
  /** Neighborhood */
  Neighborhood = 'NEIGHBORHOOD'
}

export type EmploymentDocumentFileInput = {
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type EmploymentDocumentFileType = Node & {
  __typename?: 'EmploymentDocumentFileType';
  attachment?: Maybe<Scalars['String']>;
  employmentDocument: EmploymentDocumentType;
  fileName?: Maybe<Scalars['String']>;
  fileType?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  size?: Maybe<Scalars['String']>;
  url?: Maybe<Scalars['String']>;
};

export type EmploymentDocumentFileTypeConnection = {
  __typename?: 'EmploymentDocumentFileTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EmploymentDocumentFileTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `EmploymentDocumentFileType` and its cursor. */
export type EmploymentDocumentFileTypeEdge = {
  __typename?: 'EmploymentDocumentFileTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<EmploymentDocumentFileType>;
};

export type EmploymentDocumentMutationInput = {
  acceptedDeclinedAt?: InputMaybe<Scalars['DateTime']>;
  baseSalaryUnitText?: InputMaybe<Scalars['String']>;
  baseSalaryValue?: InputMaybe<Scalars['Float']>;
  candidate?: InputMaybe<Scalars['ID']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  contactName?: InputMaybe<Scalars['String']>;
  contactPhone?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Scalars['String']>;
  employerProfile?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  messageContent?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  /** Undefined, Null, or missing fields will not update when set to true. */
  partialUpdate?: InputMaybe<Scalars['Boolean']>;
  position?: InputMaybe<Scalars['ID']>;
  startingAt?: InputMaybe<Scalars['DateTime']>;
  status?: InputMaybe<Scalars['String']>;
};

/** Mutation to create or update employer document. */
export type EmploymentDocumentMutationPayload = {
  __typename?: 'EmploymentDocumentMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  employmentDocumentType?: Maybe<EmploymentDocumentType>;
  /** May contain more than one error for same field. */
  errors?: Maybe<Array<Maybe<ErrorType>>>;
};

export type EmploymentDocumentType = Node & {
  __typename?: 'EmploymentDocumentType';
  acceptedDeclinedAt?: Maybe<Scalars['DateTime']>;
  baseSalaryUnitText?: Maybe<EmployersEmploymentDocumentBaseSalaryUnitTextChoices>;
  baseSalaryValue?: Maybe<Scalars['Float']>;
  candidate: CandidateProfileType;
  contactName?: Maybe<Scalars['String']>;
  contactPhone?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  documentType?: Maybe<EmployersEmploymentDocumentDocumentTypeChoices>;
  employerProfile?: Maybe<EmployerProfileType>;
  employmentdocumentfileSet: EmploymentDocumentFileTypeConnection;
  /** The ID of the object */
  id: Scalars['ID'];
  note?: Maybe<Scalars['String']>;
  position: PositionType;
  startingAt?: Maybe<Scalars['DateTime']>;
  status?: Maybe<EmployersEmploymentDocumentStatusChoices>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};


export type EmploymentDocumentTypeEmploymentdocumentfileSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type EmploymentDocumentTypeConnection = {
  __typename?: 'EmploymentDocumentTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EmploymentDocumentTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `EmploymentDocumentType` and its cursor. */
export type EmploymentDocumentTypeEdge = {
  __typename?: 'EmploymentDocumentTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<EmploymentDocumentType>;
};

export type EndCampaign = {
  __typename?: 'EndCampaign';
  ended?: Maybe<Scalars['Boolean']>;
};

export type EndorsementType = Node & {
  __typename?: 'EndorsementType';
  body: Scalars['String'];
  candidate: CandidateProfileType;
  createdAt: Scalars['DateTime'];
  employerName?: Maybe<Scalars['String']>;
  endorser?: Maybe<UserType>;
  /** The ID of the object */
  id: Scalars['ID'];
  rowId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
};

export type EndorsementTypeConnection = {
  __typename?: 'EndorsementTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<EndorsementTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `EndorsementType` and its cursor. */
export type EndorsementTypeEdge = {
  __typename?: 'EndorsementTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<EndorsementType>;
};

export type ErrorType = {
  __typename?: 'ErrorType';
  field: Scalars['String'];
  messages: Array<Scalars['String']>;
};

export type FavoritedLocationType = Node & {
  __typename?: 'FavoritedLocationType';
  candidateProfile: CandidateProfileType;
  createdAt: Scalars['DateTime'];
  /** The ID of the object */
  id: Scalars['ID'];
  location: LocationType;
  locationIsHiring?: Maybe<Scalars['Boolean']>;
  matchSet: MatchTypeConnection;
};


export type FavoritedLocationTypeMatchSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type FavoritedLocationTypeConnection = {
  __typename?: 'FavoritedLocationTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FavoritedLocationTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `FavoritedLocationType` and its cursor. */
export type FavoritedLocationTypeEdge = {
  __typename?: 'FavoritedLocationTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<FavoritedLocationType>;
};

export type FeatureFlagType = Node & {
  __typename?: 'FeatureFlagType';
  createdAt?: Maybe<Scalars['DateTime']>;
  employerProfile?: Maybe<EmployerProfileType>;
  feature?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  /** Turn on this feature */
  on: Scalars['Boolean'];
  updatedAt?: Maybe<Scalars['DateTime']>;
  user?: Maybe<UserType>;
};

export type FeatureFlagTypeConnection = {
  __typename?: 'FeatureFlagTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<FeatureFlagTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `FeatureFlagType` and its cursor. */
export type FeatureFlagTypeEdge = {
  __typename?: 'FeatureFlagTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<FeatureFlagType>;
};

/** For users to get a sendbird access token */
export type GenerteSendBirdUserToken = {
  __typename?: 'GenerteSendBirdUserToken';
  me?: Maybe<UserType>;
};

/** Get or create a channel with a user */
export type GetOrCreateSendBirdChannelWith = {
  __typename?: 'GetOrCreateSendBirdChannelWith';
  me?: Maybe<UserType>;
  sendbirdChannel?: Maybe<Scalars['String']>;
};

export type GoogleOAuthMutation = {
  __typename?: 'GoogleOAuthMutation';
  existingLocation?: Maybe<Scalars['String']>;
  invitedBy?: Maybe<Scalars['String']>;
  invitedLocation?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type HelpRequestsAttachmentInputType = {
  fileString: Scalars['String'];
  fileType: Scalars['String'];
};

export type HiddenLocationType = Node & {
  __typename?: 'HiddenLocationType';
  candidateProfile: CandidateProfileType;
  createdAt: Scalars['DateTime'];
  /** The ID of the object */
  id: Scalars['ID'];
  location: LocationType;
};

export type HiddenLocationTypeConnection = {
  __typename?: 'HiddenLocationTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<HiddenLocationTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `HiddenLocationType` and its cursor. */
export type HiddenLocationTypeEdge = {
  __typename?: 'HiddenLocationTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<HiddenLocationType>;
};

export type HideMatchMutation = {
  __typename?: 'HideMatchMutation';
  match?: Maybe<MatchType>;
};

export type IndeedBillingActive = {
  __typename?: 'IndeedBillingActive';
  isBillingConfirmed?: Maybe<Scalars['Boolean']>;
};

export type IndeedCompanyType = Node & {
  __typename?: 'IndeedCompanyType';
  createdAt?: Maybe<Scalars['DateTime']>;
  employerProfile?: Maybe<EmployerProfileType>;
  hasActiveCampaign?: Maybe<Scalars['Boolean']>;
  /** The ID of the object */
  id: Scalars['ID'];
  /** The name of the "company" at Indeed associated with this token */
  indeedCompany?: Maybe<Scalars['String']>;
  /** The name of the "contact" at Indeed associated with this token */
  indeedContact?: Maybe<Scalars['String']>;
  /** The email address of the Indeed account associated with this token */
  indeedEmail?: Maybe<Scalars['String']>;
};

export type IndeedCompanyTypeConnection = {
  __typename?: 'IndeedCompanyTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<IndeedCompanyTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `IndeedCompanyType` and its cursor. */
export type IndeedCompanyTypeEdge = {
  __typename?: 'IndeedCompanyTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IndeedCompanyType>;
};

export type IndeedOAuthDetails = {
  __typename?: 'IndeedOAuthDetails';
  clientId?: Maybe<Scalars['String']>;
  redirectUri?: Maybe<Scalars['String']>;
};

export type IndeedOAuthTokenDeleteMutation = {
  __typename?: 'IndeedOAuthTokenDeleteMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type IndeedRequestOAuthToken = {
  __typename?: 'IndeedRequestOAuthToken';
  ok?: Maybe<Scalars['Boolean']>;
};

export type IntegrationIdentifierCreateUpdateMutation = {
  __typename?: 'IntegrationIdentifierCreateUpdateMutation';
  identifier: Scalars['String'];
  integration: Scalars['String'];
};

export type IntegrationIdentifierDeleteMutation = {
  __typename?: 'IntegrationIdentifierDeleteMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type IntegrationIdentifierType = Node & {
  __typename?: 'IntegrationIdentifierType';
  createdAt?: Maybe<Scalars['DateTime']>;
  employerProfile: EmployerProfileType;
  /** The ID of the object */
  id: Scalars['ID'];
  identifier: Scalars['String'];
  integration: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type IntegrationIdentifierTypeConnection = {
  __typename?: 'IntegrationIdentifierTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<IntegrationIdentifierTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `IntegrationIdentifierType` and its cursor. */
export type IntegrationIdentifierTypeEdge = {
  __typename?: 'IntegrationIdentifierTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<IntegrationIdentifierType>;
};

export type InterviewAttendeeSerializerInput = {
  role: Scalars['String'];
  userId: Scalars['String'];
};

export type InterviewAttendeeType = {
  __typename?: 'InterviewAttendeeType';
  role?: Maybe<Scalars['String']>;
  user?: Maybe<UserType>;
};

export type InterviewCountType = {
  __typename?: 'InterviewCountType';
  accepted?: Maybe<DashboardCountType>;
  completed?: Maybe<DashboardCountType>;
  pending?: Maybe<DashboardCountType>;
};

export type InterviewMessagingMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The URL for the interviewer's next steps */
  furtherProcessUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  /** Message to the candidate that has accepted or scheduled an interview */
  interviewAcceptedMessaging?: InputMaybe<Scalars['String']>;
  /** The type of message to use when a candidate has accepted or scheduled an interview */
  interviewAcceptedType?: InputMaybe<Scalars['String']>;
  /** Message to the candidate you are requesting */
  interviewRequestMessaging?: InputMaybe<Scalars['String']>;
  /** The type of message to use when requesting a candidate interview */
  interviewRequestType?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['ID']>;
  /** Undefined, Null, or missing fields will not update when set to true. */
  partialUpdate?: InputMaybe<Scalars['Boolean']>;
};

export type InterviewMessagingMutationPayload = {
  __typename?: 'InterviewMessagingMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** May contain more than one error for same field. */
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  interviewMessaging?: Maybe<InterviewMessagingType>;
};

export type InterviewMessagingType = Node & {
  __typename?: 'InterviewMessagingType';
  /** The URL for the interviewer's next steps */
  furtherProcessUrl?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  /** Message to the candidate that has accepted or scheduled an interview */
  interviewAcceptedMessaging?: Maybe<Scalars['String']>;
  /** The type of message to use when a candidate has accepted or scheduled an interview */
  interviewAcceptedType: EmployersInterviewMessagingInterviewAcceptedTypeChoices;
  /** Message to the candidate you are requesting */
  interviewRequestMessaging?: Maybe<Scalars['String']>;
  /** The type of message to use when requesting a candidate interview */
  interviewRequestType: EmployersInterviewMessagingInterviewRequestTypeChoices;
  location?: Maybe<LocationType>;
  rowId?: Maybe<Scalars['Int']>;
};

export type InterviewMutationInput = {
  candidate?: InputMaybe<Scalars['ID']>;
  candidateMessage?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  createdBy?: InputMaybe<Scalars['ID']>;
  /** Length of the actual interview plus any buffer */
  duration?: InputMaybe<Scalars['String']>;
  employerProfile?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  interviewAttendees?: InputMaybe<Array<InputMaybe<InterviewAttendeeSerializerInput>>>;
  /** Where or how the interview will be conducted */
  interviewType?: InputMaybe<Scalars['String']>;
  /** The URL for the interviewer's Zoom, Webex, Google Hangout, etc. */
  meetingUrl?: InputMaybe<Scalars['String']>;
  messageContent?: InputMaybe<Scalars['String']>;
  /** Undefined, Null, or missing fields will not update when set to true. */
  partialUpdate?: InputMaybe<Scalars['Boolean']>;
  /** The number the interviewer will be calling from */
  phoneNumber?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['ID']>;
  scheduledFor?: InputMaybe<Scalars['DateTime']>;
  setViewedAt?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  /** Datetime denoting when a candidate first views a employer's interview request. */
  viewedAt?: InputMaybe<Scalars['DateTime']>;
};

export type InterviewMutationPayload = {
  __typename?: 'InterviewMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** May contain more than one error for same field. */
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  interview?: Maybe<InterviewType>;
};

export type InterviewScheduleDayType = {
  __typename?: 'InterviewScheduleDayType';
  day?: Maybe<Scalars['Date']>;
  slots?: Maybe<Array<Maybe<InterviewScheduleSlotType>>>;
};

export type InterviewScheduleMutationInput = {
  /** If checked, multiple candidates will be able to book the same interview time slot. */
  allowOverbooking?: InputMaybe<Scalars['Boolean']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  durationMinutes?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  location?: InputMaybe<Scalars['String']>;
  /** The number the interviewer will be calling from */
  locationPhone?: InputMaybe<Scalars['String']>;
  /** The URL for the interviewer's Zoom, Webex, Google Hangout, etc. */
  locationUrl?: InputMaybe<Scalars['String']>;
  maxWeeksOut?: InputMaybe<Scalars['Int']>;
  /** Undefined, Null, or missing fields will not update when set to true. */
  partialUpdate?: InputMaybe<Scalars['Boolean']>;
};

export type InterviewScheduleMutationPayload = {
  __typename?: 'InterviewScheduleMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** May contain more than one error for same field. */
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  interviewSchedule?: Maybe<InterviewScheduleType>;
};

export type InterviewScheduleRangeMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  day?: InputMaybe<Scalars['Int']>;
  endHour?: InputMaybe<Scalars['Int']>;
  endMinute?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  /** Undefined, Null, or missing fields will not update when set to true. */
  partialUpdate?: InputMaybe<Scalars['Boolean']>;
  schedule?: InputMaybe<Scalars['ID']>;
  startHour?: InputMaybe<Scalars['Int']>;
  startMinute?: InputMaybe<Scalars['Int']>;
};

export type InterviewScheduleRangeMutationPayload = {
  __typename?: 'InterviewScheduleRangeMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** May contain more than one error for same field. */
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  interviewScheduleRange?: Maybe<InterviewScheduleRangeType>;
};

export type InterviewScheduleRangeType = Node & {
  __typename?: 'InterviewScheduleRangeType';
  day: EmployersInterviewScheduleRangeDayChoices;
  endHour?: Maybe<Scalars['Int']>;
  endMinute?: Maybe<Scalars['Int']>;
  /** The ID of the object */
  id: Scalars['ID'];
  schedule: InterviewScheduleType;
  startHour?: Maybe<Scalars['Int']>;
  startMinute?: Maybe<Scalars['Int']>;
};

export type InterviewScheduleRangeTypeConnection = {
  __typename?: 'InterviewScheduleRangeTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InterviewScheduleRangeTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `InterviewScheduleRangeType` and its cursor. */
export type InterviewScheduleRangeTypeEdge = {
  __typename?: 'InterviewScheduleRangeTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<InterviewScheduleRangeType>;
};

export type InterviewScheduleSlotType = {
  __typename?: 'InterviewScheduleSlotType';
  available?: Maybe<Scalars['Boolean']>;
  start?: Maybe<Scalars['DateTime']>;
};

export type InterviewScheduleType = Node & {
  __typename?: 'InterviewScheduleType';
  /** If checked, multiple candidates will be able to book the same interview time slot. */
  allowOverbooking: Scalars['Boolean'];
  /** Length of the actual interview plus any buffer */
  durationMinutes: EmployersInterviewScheduleDurationMinutesChoices;
  /** The ID of the object */
  id: Scalars['ID'];
  interviewScheduleRanges?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Where or how the interview will be conducted */
  location: EmployersInterviewScheduleLocationChoices;
  /** The number the interviewer will be calling from */
  locationPhone?: Maybe<Scalars['String']>;
  /** The URL for the interviewer's Zoom, Webex, Google Hangout, etc. */
  locationUrl?: Maybe<Scalars['String']>;
  /** Number of weeks out a candidate can schedule an interview */
  maxWeeksOut: Scalars['Int'];
  ranges: InterviewScheduleRangeTypeConnection;
  user: UserType;
};


export type InterviewScheduleTypeRangesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export enum InterviewStatusFilter {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Pending = 'PENDING',
  PostInterview = 'POST_INTERVIEW',
  Scheduled = 'SCHEDULED',
  Unscheduled = 'UNSCHEDULED'
}

export type InterviewType = Node & {
  __typename?: 'InterviewType';
  /** Deprecated: The id of a calendar event in Nylas. */
  calendarEventId?: Maybe<Scalars['String']>;
  candidate?: Maybe<UserType>;
  /** the current interview to show on a conversation */
  channelSet: ChannelTypeConnection;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  duration?: Maybe<Scalars['String']>;
  employerInterview: MatchTypeConnection;
  employerProfile?: Maybe<EmployerProfileType>;
  followUpSent?: Maybe<Scalars['DateTime']>;
  ics?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  interviewAttendees?: Maybe<Array<Maybe<InterviewAttendeeType>>>;
  /** Link sent to candidates to accept or schedule the interview */
  interviewRequestUrl?: Maybe<Scalars['String']>;
  interviewScheduleSlots?: Maybe<Array<Maybe<InterviewScheduleDayType>>>;
  interviewType?: Maybe<Scalars['String']>;
  interviewer?: Maybe<InterviewAttendeeType>;
  location?: Maybe<LocationType>;
  match?: Maybe<MatchType>;
  maxWeeksOut?: Maybe<Scalars['Int']>;
  meetingUrl?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  position?: Maybe<PositionType>;
  positionInterview: MatchTypeConnection;
  requestEmailSent?: Maybe<Scalars['DateTime']>;
  rowId?: Maybe<Scalars['Int']>;
  scheduledFor?: Maybe<Scalars['DateTime']>;
  /** The shortened version of Interview Request URL */
  shortUrl?: Maybe<Scalars['String']>;
  status: ApiInterviewStatusChoices;
  token?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  uuid?: Maybe<Scalars['String']>;
  /** Datetime denoting when a candidate first views a employer's interview request. */
  viewedAt?: Maybe<Scalars['DateTime']>;
};


export type InterviewTypeChannelSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sendbirdChannelId?: InputMaybe<Scalars['String']>;
};


export type InterviewTypeEmployerInterviewArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type InterviewTypeInterviewScheduleSlotsArgs = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
};


export type InterviewTypePositionInterviewArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type InterviewTypeConnection = {
  __typename?: 'InterviewTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<InterviewTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `InterviewType` and its cursor. */
export type InterviewTypeEdge = {
  __typename?: 'InterviewTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<InterviewType>;
};

export type InviteToApplyMutation = {
  __typename?: 'InviteToApplyMutation';
  created?: Maybe<Scalars['Boolean']>;
};

export type JobBoardCampaignType = Node & {
  __typename?: 'JobBoardCampaignType';
  active?: Maybe<Scalars['Boolean']>;
  /** price in cents */
  amount?: Maybe<Scalars['Int']>;
  applicationsCount?: Maybe<Scalars['Int']>;
  archivedAt?: Maybe<Scalars['DateTime']>;
  /** Stored in US cents */
  avgCpa: Scalars['Int'];
  campaignEndedOn?: Maybe<Scalars['DateTime']>;
  campaignWillEndOn?: Maybe<Scalars['DateTime']>;
  clicks: Scalars['Int'];
  employer: EmployerProfileType;
  /** The ID of the object */
  id: Scalars['ID'];
  /** The identifier for the campaign at Indeed */
  indeedId?: Maybe<Scalars['String']>;
  indeedToken?: Maybe<IndeedCompanyType>;
  isDraft: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  numApplies: Scalars['Int'];
  platform: PaymentJobBoardCampaignPlatformChoices;
  position?: Maybe<PositionType>;
  positions: PositionTypeConnection;
  rowId?: Maybe<Scalars['Int']>;
  /** Spend to date */
  spent: Scalars['Int'];
  startedOn?: Maybe<Scalars['DateTime']>;
  statsUpdatedAt?: Maybe<Scalars['DateTime']>;
  status: PaymentJobBoardCampaignStatusChoices;
  /** cus_someid, from stripe */
  stripeCustomer?: Maybe<Scalars['String']>;
  /** ch_someid, from stripe */
  stripePaymentIntent?: Maybe<Scalars['String']>;
  willStartOn?: Maybe<Scalars['DateTime']>;
};


export type JobBoardCampaignTypePositionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  archivedAt_Isnull?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  canHaveDressCode?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  hiring?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  isBenefitsRequired?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['ID']>;
  location_In?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  offset?: InputMaybe<Scalars['Int']>;
  positionName_Icontains?: InputMaybe<Scalars['String']>;
};

export type JobBoardCampaignTypeConnection = {
  __typename?: 'JobBoardCampaignTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<JobBoardCampaignTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `JobBoardCampaignType` and its cursor. */
export type JobBoardCampaignTypeEdge = {
  __typename?: 'JobBoardCampaignTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<JobBoardCampaignType>;
};

export type LocationAnswerInput = {
  employerProfile?: InputMaybe<Scalars['ID']>;
  location?: InputMaybe<Scalars['ID']>;
  responses?: InputMaybe<Array<InputMaybe<AnswerInput>>>;
};

export type LocationAnswerType = Node & {
  __typename?: 'LocationAnswerType';
  displayIcon?: Maybe<Scalars['String']>;
  displayLabel?: Maybe<Scalars['String']>;
  employerProfile?: Maybe<EmployerProfileType>;
  /** The ID of the object */
  id: Scalars['ID'];
  location?: Maybe<LocationType>;
  option?: Maybe<QuestionOptionType>;
  question: QuestionType;
  /** Either the answer input by the user, or the label of the option they selected */
  response: Scalars['String'];
};

export type LocationAnswerTypeConnection = {
  __typename?: 'LocationAnswerTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LocationAnswerTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `LocationAnswerType` and its cursor. */
export type LocationAnswerTypeEdge = {
  __typename?: 'LocationAnswerTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<LocationAnswerType>;
};

export type LocationImageMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  fileType: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  location: Scalars['ID'];
  /** Undefined, Null, or missing fields will not update when set to true. */
  partialUpdate?: InputMaybe<Scalars['Boolean']>;
};

export type LocationImageMutationPayload = {
  __typename?: 'LocationImageMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** May contain more than one error for same field. */
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  imageUploadUrl?: Maybe<Scalars['String']>;
  location?: Maybe<LocationType>;
  locationImage?: Maybe<LocationImageType>;
};

export type LocationImageType = Node & {
  __typename?: 'LocationImageType';
  createdAt: Scalars['DateTime'];
  /** The ID of the object */
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  imageHeight?: Maybe<Scalars['String']>;
  imageUploadUrl?: Maybe<Scalars['String']>;
  imageWidth?: Maybe<Scalars['String']>;
  location?: Maybe<LocationType>;
  updatedAt: Scalars['DateTime'];
};

export type LocationMutationInput = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressPostalCode?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressStreet1?: InputMaybe<Scalars['String']>;
  addressStreet2?: InputMaybe<Scalars['String']>;
  addressStreet3?: InputMaybe<Scalars['String']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  indeedEasyapplyOptoutDefault?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  /** Undefined, Null, or missing fields will not update when set to true. */
  partialUpdate?: InputMaybe<Scalars['Boolean']>;
  summary?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type LocationMutationPayload = {
  __typename?: 'LocationMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** May contain more than one error for same field. */
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  location?: Maybe<LocationType>;
};

export type LocationType = Node & {
  __typename?: 'LocationType';
  addressCity: Scalars['String'];
  addressCountry: Scalars['String'];
  addressPostalCode: Scalars['String'];
  addressState: Scalars['String'];
  addressStreet1: Scalars['String'];
  addressStreet2?: Maybe<Scalars['String']>;
  addressStreet3?: Maybe<Scalars['String']>;
  allPositionsCount?: Maybe<Scalars['Int']>;
  answers: LocationAnswerTypeConnection;
  canManage?: Maybe<Scalars['Boolean']>;
  /** Location cancelled, or every position on a PAYG subscription was cancelled at once */
  cancellationReason: CancellationReasonTypeConnection;
  candidateworkhistorySet: CandidateWorkHistoryTypeConnection;
  careerpageSet: CareerPageTypeConnection;
  /** This is deprecated in new chat. This will be removed soon. */
  channelSet: ChannelTypeConnection;
  createdAt: Scalars['DateTime'];
  displayName?: Maybe<Scalars['String']>;
  employerProfile?: Maybe<EmployerProfileType>;
  employerprofileuserSet: EmployerProfileUserTypeConnection;
  favorited: CandidateProfileTypeConnection;
  favoritedlocationSet: FavoritedLocationTypeConnection;
  /** Featured locations are shown more prominently in search results and maps */
  featured: Scalars['Boolean'];
  followerCount?: Maybe<Scalars['Int']>;
  formattedAddress?: Maybe<Scalars['String']>;
  hasJobMatch?: Maybe<Scalars['Boolean']>;
  hasPositions?: Maybe<Scalars['Boolean']>;
  hidden: CandidateProfileTypeConnection;
  hiddenlocationSet: HiddenLocationTypeConnection;
  hiringPositionCount?: Maybe<Scalars['Int']>;
  /** The ID of the object */
  id: Scalars['ID'];
  image?: Maybe<Scalars['String']>;
  indeedEasyapplyOptoutDefault: Scalars['Boolean'];
  interviewMessaging?: Maybe<InterviewMessagingType>;
  interviewSet: InterviewTypeConnection;
  isFavorited?: Maybe<Scalars['Boolean']>;
  isHidden?: Maybe<Scalars['Boolean']>;
  isHiring?: Maybe<Scalars['Boolean']>;
  latitude?: Maybe<Scalars['Float']>;
  /** one location per conversation */
  locationChannels: ChannelTypeConnection;
  locationPhoneNumber?: Maybe<Scalars['String']>;
  longitude?: Maybe<Scalars['Float']>;
  name: Scalars['String'];
  nextBillingDate?: Maybe<Scalars['Int']>;
  payment?: Maybe<PaymentType>;
  paymentStatus?: Maybe<EmployersLocationPaymentStatusChoices>;
  positions?: Maybe<PositionTypeConnection>;
  rowId?: Maybe<Scalars['Int']>;
  slug: Scalars['String'];
  /** An external identifier for the location, i.e. store number */
  storeId?: Maybe<Scalars['String']>;
  summary?: Maybe<Scalars['String']>;
  tags: Array<TagType>;
  updatedAt: Scalars['DateTime'];
  uuid: Scalars['UUID'];
  website?: Maybe<Scalars['String']>;
  yelpId?: Maybe<Scalars['String']>;
};


export type LocationTypeAnswersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type LocationTypeCancellationReasonArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['ID']>;
  offset?: InputMaybe<Scalars['Int']>;
  position?: InputMaybe<Scalars['ID']>;
};


export type LocationTypeCandidateworkhistorySetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type LocationTypeCareerpageSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employerProfile?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type LocationTypeChannelSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sendbirdChannelId?: InputMaybe<Scalars['String']>;
};


export type LocationTypeEmployerprofileuserSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type LocationTypeFavoritedArgs = {
  additionalTraining_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  after?: InputMaybe<Scalars['String']>;
  availabilityFriday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilityMonday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilitySaturday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilitySunday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilityThursday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilityTuesday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilityWednesday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  before?: InputMaybe<Scalars['String']>;
  employmentPreferences_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  positions_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  restaurantTypes_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Scalars['String']>;
  yearsExperience?: InputMaybe<Scalars['String']>;
};


export type LocationTypeFavoritedlocationSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type LocationTypeHiddenArgs = {
  additionalTraining_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  after?: InputMaybe<Scalars['String']>;
  availabilityFriday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilityMonday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilitySaturday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilitySunday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilityThursday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilityTuesday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilityWednesday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  before?: InputMaybe<Scalars['String']>;
  employmentPreferences_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  positions_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  restaurantTypes_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Scalars['String']>;
  yearsExperience?: InputMaybe<Scalars['String']>;
};


export type LocationTypeHiddenlocationSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type LocationTypeInterviewSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type LocationTypeLocationChannelsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sendbirdChannelId?: InputMaybe<Scalars['String']>;
};


export type LocationTypePositionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  archivedAt_Isnull?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  canHaveDressCode?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  hiring?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  isBenefitsRequired?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['ID']>;
  location_In?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  offset?: InputMaybe<Scalars['Int']>;
  positionName_Icontains?: InputMaybe<Scalars['String']>;
};

export type LocationTypeConnection = {
  __typename?: 'LocationTypeConnection';
  centerLat?: Maybe<Scalars['Float']>;
  centerLng?: Maybe<Scalars['Float']>;
  edgeCount?: Maybe<Scalars['Int']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<LocationTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `LocationType` and its cursor. */
export type LocationTypeEdge = {
  __typename?: 'LocationTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<LocationType>;
};

export type LocationsCountType = {
  __typename?: 'LocationsCountType';
  applicants?: Maybe<Scalars['Int']>;
  chats?: Maybe<Scalars['Int']>;
  interviewsAccepted?: Maybe<Scalars['Int']>;
  matches?: Maybe<Scalars['Int']>;
};

export type MatchFilterCountsType = {
  __typename?: 'MatchFilterCountsType';
  acceptedCount?: Maybe<Scalars['Int']>;
  appliedCount?: Maybe<Scalars['Int']>;
  bestMatchCount?: Maybe<Scalars['Int']>;
  declinedCount?: Maybe<Scalars['Int']>;
  followerCount?: Maybe<Scalars['Int']>;
  pendingCount?: Maybe<Scalars['Int']>;
  postInterviewCount?: Maybe<Scalars['Int']>;
  scheduledCount?: Maybe<Scalars['Int']>;
};

export type MatchType = Node & {
  __typename?: 'MatchType';
  application?: Maybe<PositionApplicationType>;
  candidateProfile: CandidateProfileType;
  candidateScore: Scalars['Int'];
  candidateStatus?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  employerCandidate?: Maybe<EmployerCandidateType>;
  employercandidateSet: EmployerCandidateTypeConnection;
  favorite?: Maybe<FavoritedLocationType>;
  firstViewedAt?: Maybe<Scalars['DateTime']>;
  hasAppliedToPosition?: Maybe<Scalars['Boolean']>;
  hiddenAt?: Maybe<Scalars['DateTime']>;
  /** The ID of the object */
  id: Scalars['ID'];
  isFavorited?: Maybe<Scalars['Boolean']>;
  lastEmployerInterview?: Maybe<InterviewType>;
  lastInterview?: Maybe<InterviewType>;
  /** Indicates whether a match meets the basic matching criteria. Set as False when matches are manually created for things like following a location. */
  meetsCriteria: Scalars['Boolean'];
  position: PositionType;
  score: Scalars['Int'];
  stage?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};


export type MatchTypeEmployercandidateSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  stageUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  stageUpdatedAt_Gte?: InputMaybe<Scalars['DateTime']>;
  stageUpdatedAt_Lte?: InputMaybe<Scalars['DateTime']>;
};

export type MatchTypeConnection = {
  __typename?: 'MatchTypeConnection';
  edgeCount?: Maybe<Scalars['Int']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<MatchTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `MatchType` and its cursor. */
export type MatchTypeEdge = {
  __typename?: 'MatchTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<MatchType>;
};

/** For candidates that have already signed up, and also apply through indeed later */
export type MergeCandidatesMutation = {
  __typename?: 'MergeCandidatesMutation';
  authorization?: Maybe<Scalars['String']>;
  me?: Maybe<UserType>;
};

export type MessageTemplateFileInput = {
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  url?: InputMaybe<Scalars['String']>;
};

export type MessageTemplateFileUrlType = {
  __typename?: 'MessageTemplateFileUrlType';
  link?: Maybe<Scalars['String']>;
  presignedUrl?: Maybe<Scalars['String']>;
};

export type MessageType = {
  __typename?: 'MessageType';
  createdAt?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type MutateEmployerUserArchivedAt = {
  __typename?: 'MutateEmployerUserArchivedAt';
  isSuccess?: Maybe<Scalars['Boolean']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  answerLocationQuestions?: Maybe<AnswerLocationQuestions>;
  bulkMoveEmployerCandidatesToStage?: Maybe<BulkMoveEmployerCandidateMutation>;
  claimTokenSignInMutation?: Maybe<ClaimTokenSignInMutation>;
  /** Mutation for Create CareerPage. */
  createCareerPageMutation?: Maybe<CreateCareerPageMutationPayload>;
  createEmployerCandidates?: Maybe<CreateEmployerCandidatesMutation>;
  createJobBoardCampaign?: Maybe<CreateCampaign>;
  createScreeningAnswer?: Maybe<AnswerQuestionsMutation>;
  /** Mutation to create the screening Questionnaire. */
  createScreeningQuestionnaire?: Maybe<CreateScreeningQuestionnaireMutation>;
  createStripePaymentIntent?: Maybe<CreateStripePaymentIntent>;
  createUpdateIntegrationIdentifier?: Maybe<IntegrationIdentifierCreateUpdateMutation>;
  deactivateSubscription?: Maybe<DeactivateSubscriptionMutation>;
  debugSentry?: Maybe<DebugSentryMutation>;
  /** Mutation to delete career page. */
  deleteCareerPage?: Maybe<CareerPageDeleteMutation>;
  /** Mutation to delete message template file. */
  deleteEmployerMessageTemplateFile?: Maybe<DeleteMessageTemplateFile>;
  deleteIndeedToken?: Maybe<IndeedOAuthTokenDeleteMutation>;
  deleteIntegrationIdentifier?: Maybe<IntegrationIdentifierDeleteMutation>;
  deleteInterviewScheduleRange?: Maybe<DeleteInterviewScheduleRangeMutationPayload>;
  deleteMyResume?: Maybe<DeleteMyResumeMutation>;
  deletePosition?: Maybe<DeletePositionMutationPayload>;
  deleteWorkHistory?: Maybe<DeleteCandidateWorkHistoryMutationPayload>;
  dismissNotification?: Maybe<DismissNotification>;
  endCampaign?: Maybe<EndCampaign>;
  /** For users to get a sendbird access token */
  generateSendbirdUserToken?: Maybe<GenerteSendBirdUserToken>;
  /** Get or create a channel with a user */
  getOrCreateSendbirdChannelWith?: Maybe<GetOrCreateSendBirdChannelWith>;
  googleOauth?: Maybe<GoogleOAuthMutation>;
  indeedRequestOauthToken?: Maybe<IndeedRequestOAuthToken>;
  inviteToApply?: Maybe<InviteToApplyMutation>;
  /** For candidates that have already signed up, and also apply through indeed later */
  mergeCandidatesMutation?: Maybe<MergeCandidatesMutation>;
  mutateBulkMessage?: Maybe<BulkMessageMutation>;
  mutateCancellationReason?: Maybe<CancellationReasonMutationPayload>;
  mutateCandidate?: Maybe<CandidateProfileMutationPayload>;
  /** Mutation for update CareerPage. */
  mutateCareerPage?: Maybe<CareerPageMutationPayload>;
  /** Mutation for update CareerPage Questions. */
  mutateCareerPageAnswer?: Maybe<CareerPageAnswerMutation>;
  /** Career Page message Mutaton */
  mutateCareerPageLocationMessage?: Maybe<CareerPageLocationMessageMutation>;
  /** Career page gallery items. */
  mutateCreateCareerPageGallery?: Maybe<CreateCareerPageGalleryMutation>;
  /** Mutation to delete employee message template. */
  mutateDeleteMessageTemplate?: Maybe<EmployerMessageTemplateDeleteMutation>;
  /** Mutation to create or update employer candidate note. */
  mutateEmployerCandidateNote?: Maybe<EmployerCandidateNoteMutationPayload>;
  /** Mutation to create or update employer message template. */
  mutateEmployerMessageTemplate?: Maybe<EmployerMessageTemplateMutationPayload>;
  /** Mutation to upload message template files. */
  mutateEmployerMessageTemplateFile?: Maybe<UploadMessageTemplateFileMutation>;
  /** Employer Notification preference Mutation. */
  mutateEmployerNotificationPreference?: Maybe<EmployerProfileUserNotificationPreferenceMutation>;
  /** Mutation to create or update employer rejection reason. */
  mutateEmployerRejectionReason?: Maybe<EmployerRejectionReasonMutationPayload>;
  mutateEmployerUser?: Maybe<EmployerUserMutationPayload>;
  mutateEmployerUserChannelHideOrUnhide?: Maybe<MutateEmployerUserArchivedAt>;
  /** Mutation to create or update employer document. */
  mutateEmploymentDocument?: Maybe<EmploymentDocumentMutationPayload>;
  mutateInterview?: Maybe<InterviewMutationPayload>;
  mutateInterviewMessaging?: Maybe<InterviewMessagingMutationPayload>;
  mutateInterviewSchedule?: Maybe<InterviewScheduleMutationPayload>;
  mutateInterviewScheduleRange?: Maybe<InterviewScheduleRangeMutationPayload>;
  /** Mutation to create or update employer campaign. */
  mutateJobBoardCampaign?: Maybe<CampaignMutationPayload>;
  mutateLocation?: Maybe<LocationMutationPayload>;
  mutateLocationImage?: Maybe<LocationImageMutationPayload>;
  mutatePosition?: Maybe<PositionMutationPayload>;
  mutatePositionApplication?: Maybe<PositionApplicationMutationPayload>;
  mutateProfileImage?: Maybe<ProfileImageMutationPayload>;
  mutateScreeningQuestion?: Maybe<CreateScreeningQuestionMutation>;
  mutateUser?: Maybe<UserMutationPayload>;
  mutateWorkHistory?: Maybe<CandidateWorkHistoryMutationPayload>;
  reactivateSubscription?: Maybe<ReactivateSubscriptionMutation>;
  /** For users to get a sendbird access token */
  refreshSendbirdUser?: Maybe<RefreshSendBirdUser>;
  refundAndEndCampaign?: Maybe<RefundAndEndCampaign>;
  rejectCandidates?: Maybe<RejectCandidates>;
  removeEmployerUser?: Maybe<RemoveEmployerUserPayload>;
  resendEmployerUserInvite?: Maybe<ResendEmployerUserInvitePayload>;
  sendBatchInterviews?: Maybe<RequestAllCandidatesMutation>;
  sendHelpRequest?: Maybe<SendHelpRequestMutation>;
  sendQuestionnaire?: Maybe<SendQuestionnaireMutation>;
  setPreferredMatchForPosition?: Maybe<SetPreferredMatchForPosition>;
  sevenshiftsCreateGuid?: Maybe<SevenShiftsCreateGuidMutation>;
  sevenshiftsCreateUser?: Maybe<SevenShiftsCreateUserMutation>;
  sevenshiftsDeleteGuid?: Maybe<SevenShiftsDeleteGuidMutation>;
  signInInterviewMutation?: Maybe<SignInInterviewMutation>;
  softDeleteCandidateUser?: Maybe<SoftDeleteCandidateUser>;
  softDeleteJobBoardCampaign?: Maybe<SoftDeleteJobBoardCampaign>;
  syncCampaign?: Maybe<SyncCampaign>;
  syncCampaigns?: Maybe<SyncCampaigns>;
  toggleFavoriteLocation?: Maybe<ToggleFavoriteLocationMutationPayload>;
  toggleHideLocation?: Maybe<ToggleHideFromLocationMutationPayload>;
  toggleHideMatch?: Maybe<HideMatchMutation>;
  unrejectCandidates?: Maybe<UnrejectCandidates>;
  updateEmployerProfile?: Maybe<EmployerProfileMutationPayload>;
  /** Mutation to update the screening Question. */
  updateScreeningQuestion?: Maybe<UpdateScreeningQuestionMutation>;
  /** Mutation to update the screening Questionnaire. */
  updateScreeningQuestionnaire?: Maybe<UpdateScreeningQutestionnaireMutation>;
  /** Mutation to upload employer document files. */
  uploadEmploymentDocument?: Maybe<UploadEmploymentDocumentFileMutation>;
};


export type MutationAnswerLocationQuestionsArgs = {
  input: LocationAnswerInput;
};


export type MutationBulkMoveEmployerCandidatesToStageArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
  employerCandidateIds: Array<InputMaybe<Scalars['ID']>>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  newStage: Scalars['ID'];
  notificationStatusToUpdate?: InputMaybe<Scalars['String']>;
  notificationStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notificationType?: InputMaybe<Scalars['String']>;
  oldStage?: InputMaybe<Scalars['ID']>;
  positions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type MutationClaimTokenSignInMutationArgs = {
  claimToken: Scalars['String'];
  uid: Scalars['String'];
};


export type MutationCreateCareerPageMutationArgs = {
  input: CreateCareerPageMutationInput;
};


export type MutationCreateEmployerCandidatesArgs = {
  candidateHandles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  moveToStageId?: InputMaybe<Scalars['ID']>;
  positionId?: InputMaybe<Scalars['ID']>;
};


export type MutationCreateJobBoardCampaignArgs = {
  name: Scalars['String'];
  platform: Scalars['String'];
  positionId: Scalars['ID'];
};


export type MutationCreateScreeningAnswerArgs = {
  input: AnswerQuestionsInputType;
};


export type MutationCreateScreeningQuestionnaireArgs = {
  name?: InputMaybe<Scalars['String']>;
  questionnaireType?: InputMaybe<Scalars['String']>;
  questions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type MutationCreateStripePaymentIntentArgs = {
  amount?: InputMaybe<Scalars['Int']>;
  positionId: Scalars['ID'];
};


export type MutationCreateUpdateIntegrationIdentifierArgs = {
  identifier: Scalars['String'];
  integration: Scalars['String'];
};


export type MutationDeactivateSubscriptionArgs = {
  position?: InputMaybe<Scalars['ID']>;
  stripeSubscription: Scalars['String'];
};


export type MutationDeleteCareerPageArgs = {
  careerPageId?: InputMaybe<Scalars['ID']>;
};


export type MutationDeleteEmployerMessageTemplateFileArgs = {
  messageTemplateFileId: Scalars['ID'];
};


export type MutationDeleteIndeedTokenArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteIntegrationIdentifierArgs = {
  integration: Scalars['String'];
};


export type MutationDeleteInterviewScheduleRangeArgs = {
  input: DeleteInterviewScheduleRangeMutationInput;
};


export type MutationDeletePositionArgs = {
  input: DeletePositionMutationInput;
};


export type MutationDeleteWorkHistoryArgs = {
  input: DeleteCandidateWorkHistoryMutationInput;
};


export type MutationDismissNotificationArgs = {
  notification?: InputMaybe<Scalars['ID']>;
};


export type MutationEndCampaignArgs = {
  campaignId: Scalars['String'];
};


export type MutationGetOrCreateSendbirdChannelWithArgs = {
  application?: InputMaybe<Scalars['ID']>;
  interview?: InputMaybe<Scalars['ID']>;
  location?: InputMaybe<Scalars['ID']>;
  position?: InputMaybe<Scalars['ID']>;
  userUuids: Array<InputMaybe<Scalars['String']>>;
};


export type MutationGoogleOauthArgs = {
  authCode: Scalars['String'];
  authType: Scalars['String'];
  userGroup?: InputMaybe<Scalars['String']>;
};


export type MutationIndeedRequestOauthTokenArgs = {
  code: Scalars['String'];
  employerId?: InputMaybe<Scalars['String']>;
};


export type MutationInviteToApplyArgs = {
  candidateHandles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  locationId?: InputMaybe<Scalars['ID']>;
  message?: InputMaybe<Scalars['String']>;
  positionId?: InputMaybe<Scalars['ID']>;
};


export type MutationMergeCandidatesMutationArgs = {
  indeedEmail: Scalars['String'];
};


export type MutationMutateBulkMessageArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
  employerCandidates?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  location: Scalars['ID'];
  locationFilters?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  message: Scalars['String'];
  notificationStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notificationType?: InputMaybe<Scalars['String']>;
  position: Scalars['ID'];
  positionFilters?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  stage?: InputMaybe<Scalars['ID']>;
};


export type MutationMutateCancellationReasonArgs = {
  input: CancellationReasonMutationInput;
};


export type MutationMutateCandidateArgs = {
  input: CandidateProfileMutationInput;
};


export type MutationMutateCareerPageArgs = {
  input: CareerPageMutationInput;
};


export type MutationMutateCareerPageAnswerArgs = {
  input: CareerPageAnswerQuestionsInputType;
};


export type MutationMutateCareerPageLocationMessageArgs = {
  locationId?: InputMaybe<Scalars['ID']>;
  message?: InputMaybe<Scalars['String']>;
};


export type MutationMutateCreateCareerPageGalleryArgs = {
  input: CareerPageGalleriesInputType;
};


export type MutationMutateDeleteMessageTemplateArgs = {
  templateId?: InputMaybe<Scalars['ID']>;
};


export type MutationMutateEmployerCandidateNoteArgs = {
  input: EmployerCandidateNoteMutationInput;
};


export type MutationMutateEmployerMessageTemplateArgs = {
  input: EmployerMessageTemplateMutationInput;
};


export type MutationMutateEmployerMessageTemplateFileArgs = {
  employerMessageTemplateId: Scalars['ID'];
  templateFiles?: InputMaybe<Array<InputMaybe<MessageTemplateFileInput>>>;
};


export type MutationMutateEmployerNotificationPreferenceArgs = {
  chatMessageEmail?: InputMaybe<Scalars['Boolean']>;
  chatMessageSms?: InputMaybe<Scalars['Boolean']>;
  dailyDigestEmail?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  interviewResponseEmail?: InputMaybe<Scalars['Boolean']>;
  interviewResponseSms?: InputMaybe<Scalars['Boolean']>;
};


export type MutationMutateEmployerRejectionReasonArgs = {
  input: EmployerRejectionReasonMutationInput;
};


export type MutationMutateEmployerUserArgs = {
  input: EmployerUserMutationInput;
};


export type MutationMutateEmployerUserChannelHideOrUnhideArgs = {
  archive: Scalars['Boolean'];
  channelUrl: Scalars['String'];
};


export type MutationMutateEmploymentDocumentArgs = {
  input: EmploymentDocumentMutationInput;
};


export type MutationMutateInterviewArgs = {
  input: InterviewMutationInput;
};


export type MutationMutateInterviewMessagingArgs = {
  input: InterviewMessagingMutationInput;
};


export type MutationMutateInterviewScheduleArgs = {
  input: InterviewScheduleMutationInput;
};


export type MutationMutateInterviewScheduleRangeArgs = {
  input: InterviewScheduleRangeMutationInput;
};


export type MutationMutateJobBoardCampaignArgs = {
  input: CampaignMutationInput;
};


export type MutationMutateLocationArgs = {
  input: LocationMutationInput;
};


export type MutationMutateLocationImageArgs = {
  input: LocationImageMutationInput;
};


export type MutationMutatePositionArgs = {
  input: PositionMutationInput;
};


export type MutationMutatePositionApplicationArgs = {
  input: PositionApplicationMutationInput;
};


export type MutationMutateProfileImageArgs = {
  input: ProfileImageMutationInput;
};


export type MutationMutateScreeningQuestionArgs = {
  question?: InputMaybe<Scalars['String']>;
  screeningQuestionnaireId?: InputMaybe<Scalars['ID']>;
};


export type MutationMutateUserArgs = {
  input: UserMutationInput;
};


export type MutationMutateWorkHistoryArgs = {
  input: CandidateWorkHistoryMutationInput;
};


export type MutationReactivateSubscriptionArgs = {
  positions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  stripeSubscription: Scalars['String'];
};


export type MutationRefundAndEndCampaignArgs = {
  jobBoardCampaignId: Scalars['ID'];
};


export type MutationRejectCandidatesArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
  employerCandidates?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  positions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  rejectReasons?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  search?: InputMaybe<Scalars['String']>;
  stage: Scalars['ID'];
};


export type MutationRemoveEmployerUserArgs = {
  input: RemoveEmployerUserInput;
};


export type MutationResendEmployerUserInviteArgs = {
  input: ResendEmployerUserInviteInput;
};


export type MutationSendBatchInterviewsArgs = {
  filter?: InputMaybe<RequestInterviewFilter>;
  positionId: Scalars['ID'];
};


export type MutationSendHelpRequestArgs = {
  attachments?: InputMaybe<Array<InputMaybe<HelpRequestsAttachmentInputType>>>;
  email: Scalars['String'];
  employerName: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  message: Scalars['String'];
};


export type MutationSendQuestionnaireArgs = {
  employerCandidate: Scalars['ID'];
  messageContent?: InputMaybe<Scalars['String']>;
  position: Scalars['ID'];
  screeningQuestionnaire: Scalars['ID'];
};


export type MutationSetPreferredMatchForPositionArgs = {
  employerCandidateId?: InputMaybe<Scalars['ID']>;
  positionId?: InputMaybe<Scalars['ID']>;
};


export type MutationSevenshiftsCreateGuidArgs = {
  companyId: Scalars['String'];
  guid: Scalars['String'];
};


export type MutationSevenshiftsCreateUserArgs = {
  companyId: Scalars['Int'];
  departmentId: Scalars['Int'];
  employerCandidate: Scalars['ID'];
  hireDate?: InputMaybe<Scalars['Date']>;
  inviteUser?: InputMaybe<Scalars['Boolean']>;
  locationId: Scalars['Int'];
  roleId?: InputMaybe<Scalars['Int']>;
};


export type MutationSevenshiftsDeleteGuidArgs = {
  id: Scalars['ID'];
};


export type MutationSignInInterviewMutationArgs = {
  interviewToken: Scalars['String'];
  uuid: Scalars['String'];
};


export type MutationSoftDeleteCandidateUserArgs = {
  userId: Scalars['String'];
};


export type MutationSoftDeleteJobBoardCampaignArgs = {
  campaignId: Scalars['String'];
};


export type MutationSyncCampaignArgs = {
  campaignId: Scalars['String'];
};


export type MutationSyncCampaignsArgs = {
  employerId: Scalars['String'];
};


export type MutationToggleFavoriteLocationArgs = {
  input: ToggleFavoriteLocationMutationInput;
};


export type MutationToggleHideLocationArgs = {
  input: ToggleHideFromLocationMutationInput;
};


export type MutationToggleHideMatchArgs = {
  match: Scalars['ID'];
};


export type MutationUnrejectCandidatesArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
  employerCandidates: Array<InputMaybe<Scalars['ID']>>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  positions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type MutationUpdateEmployerProfileArgs = {
  input: EmployerProfileMutationInput;
};


export type MutationUpdateScreeningQuestionArgs = {
  archivedAt?: InputMaybe<Scalars['DateTime']>;
  question?: InputMaybe<Scalars['String']>;
  screeningQuestionId?: InputMaybe<Scalars['ID']>;
};


export type MutationUpdateScreeningQuestionnaireArgs = {
  archivedAt?: InputMaybe<Scalars['DateTime']>;
  name?: InputMaybe<Scalars['String']>;
  screeningQuestionnaireId?: InputMaybe<Scalars['ID']>;
};


export type MutationUploadEmploymentDocumentArgs = {
  documentFiles?: InputMaybe<Array<InputMaybe<EmploymentDocumentFileInput>>>;
  employmentDocumentId: Scalars['ID'];
};

/** An object with an ID */
export type Node = {
  /** The ID of the object */
  id: Scalars['ID'];
};

export enum NotificationCategoryEnum {
  InterviewRequest = 'INTERVIEW_REQUEST'
}

export type NotificationPreferenceResponse = {
  __typename?: 'NotificationPreferenceResponse';
  email?: Maybe<Scalars['Boolean']>;
  sms?: Maybe<Scalars['Boolean']>;
};

export type NotificationPreferenceSubType = {
  __typename?: 'NotificationPreferenceSubType';
  chatMessage?: Maybe<NotificationPreferenceResponse>;
  dailyDigest?: Maybe<NotificationPreferenceResponse>;
  interviewResponse?: Maybe<NotificationPreferenceResponse>;
};

export type NotificationType = {
  __typename?: 'NotificationType';
  category?: Maybe<NotificationCategoryEnum>;
  message?: Maybe<Scalars['String']>;
  uri?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum OnboardingQuestionCategoryChoices {
  /** Career Page */
  CareerPage = 'CAREER_PAGE',
  /** Location */
  Location = 'LOCATION',
  /** Qualifying */
  Qualifying = 'QUALIFYING'
}

/** An enumeration. */
export enum OnboardingQuestionQuestionTypeChoices {
  /** Options */
  Options = 'OPTIONS',
  /** Options with "Other" */
  OptionsWithOther = 'OPTIONS_WITH_OTHER',
  /** Text */
  Text = 'TEXT'
}

/** The Relay compliant `PageInfo` type, containing data necessary to paginate this connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** An enumeration. */
export enum PaymentCancellationReasonCancellationReasonChoices {
  /** Our candidates were unresponsive */
  CandidatesUnresponsive = 'CANDIDATES_UNRESPONSIVE',
  /** We hired somone on foh&boh */
  HiredFohandboh = 'HIRED_FOHANDBOH',
  /** We hired someone on another platform */
  HiredOther = 'HIRED_OTHER',
  /** Our needs have changed */
  NeedsChange = 'NEEDS_CHANGE',
  /** Other */
  Other = 'OTHER',
  /** We got too few applicants */
  TooFewApplicants = 'TOO_FEW_APPLICANTS'
}

export enum PaymentCycleEnum {
  Annual = 'annual',
  Monthly = 'monthly'
}

/** An enumeration. */
export enum PaymentJobBoardCampaignPlatformChoices {
  /** Indeed */
  Indeed = 'INDEED',
  /** ZipRecruiter */
  Ziprecruiter = 'ZIPRECRUITER'
}

/** An enumeration. */
export enum PaymentJobBoardCampaignStatusChoices {
  /** Fail */
  Fail = 'FAIL',
  /** Initial */
  Initial = 'INITIAL',
  /** Progress */
  Progress = 'PROGRESS',
  /** Success */
  Success = 'SUCCESS'
}

/** An enumeration. */
export enum PaymentPaymentPlanNameChoices {
  /** Enterprise */
  Enterprise = 'ENTERPRISE',
  /** Pay as you go */
  Payasyougo = 'PAYASYOUGO',
  /** Unlimited hiring */
  Unlimited = 'UNLIMITED'
}

export enum PaymentStatusEnum {
  Notsubscribed = 'notsubscribed',
  Paused = 'paused',
  Subscribed = 'subscribed'
}

export type PaymentType = Node & {
  __typename?: 'PaymentType';
  /** Deprecated, cancellation reason has its own model now */
  cancellationReason?: Maybe<Scalars['String']>;
  cancellationreasonSet: CancellationReasonTypeConnection;
  /** Deprecated, cancellation reason has its own model now */
  cancelledBy?: Maybe<UserType>;
  employer: EmployerProfileType;
  /** The ID of the object */
  id: Scalars['ID'];
  lastFour?: Maybe<Scalars['String']>;
  locationSet: LocationTypeConnection;
  /** foh&boh's internal plan name */
  planName?: Maybe<PaymentPaymentPlanNameChoices>;
  positionSet: PositionTypeConnection;
  rowId?: Maybe<Scalars['Int']>;
  startedOn?: Maybe<Scalars['DateTime']>;
  stripeCustomer: Scalars['String'];
  /** "Plan" is deprecated by Stripe */
  stripePlan?: Maybe<Scalars['String']>;
  stripeSubscription: Scalars['String'];
  subscription?: Maybe<SubscriptionType>;
  subscriptionEndedOn?: Maybe<Scalars['DateTime']>;
  subscriptionWillEndOn?: Maybe<Scalars['DateTime']>;
};


export type PaymentTypeCancellationreasonSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['ID']>;
  offset?: InputMaybe<Scalars['Int']>;
  position?: InputMaybe<Scalars['ID']>;
};


export type PaymentTypeLocationSetArgs = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCity_Icontains?: InputMaybe<Scalars['String']>;
  addressCity_Istartswith?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressCountry_Icontains?: InputMaybe<Scalars['String']>;
  addressCountry_Istartswith?: InputMaybe<Scalars['String']>;
  addressPostalCode?: InputMaybe<Scalars['String']>;
  addressPostalCode_Icontains?: InputMaybe<Scalars['String']>;
  addressPostalCode_Istartswith?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressState_Icontains?: InputMaybe<Scalars['String']>;
  addressState_Istartswith?: InputMaybe<Scalars['String']>;
  addressStreet1?: InputMaybe<Scalars['String']>;
  addressStreet1_Icontains?: InputMaybe<Scalars['String']>;
  addressStreet1_Istartswith?: InputMaybe<Scalars['String']>;
  addressStreet2?: InputMaybe<Scalars['String']>;
  addressStreet2_Icontains?: InputMaybe<Scalars['String']>;
  addressStreet2_Istartswith?: InputMaybe<Scalars['String']>;
  addressStreet3?: InputMaybe<Scalars['String']>;
  addressStreet3_Icontains?: InputMaybe<Scalars['String']>;
  addressStreet3_Istartswith?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employerProfile?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_Icontains?: InputMaybe<Scalars['String']>;
  name_Istartswith?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  positions?: InputMaybe<Scalars['ID']>;
};


export type PaymentTypePositionSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  archivedAt_Isnull?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  canHaveDressCode?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  hiring?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  isBenefitsRequired?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['ID']>;
  location_In?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  offset?: InputMaybe<Scalars['Int']>;
  positionName_Icontains?: InputMaybe<Scalars['String']>;
};

export type PaymentTypeConnection = {
  __typename?: 'PaymentTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PaymentTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `PaymentType` and its cursor. */
export type PaymentTypeEdge = {
  __typename?: 'PaymentTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<PaymentType>;
};

export type PositionApplicationMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  initialMessage?: InputMaybe<Scalars['String']>;
  /** Undefined, Null, or missing fields will not update when set to true. */
  partialUpdate?: InputMaybe<Scalars['Boolean']>;
  platform?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['ID']>;
  setViewedAt?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Scalars['String']>;
  /** Datetime denoting when an employer first views a candidate's profile that has applied. */
  viewedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PositionApplicationMutationPayload = {
  __typename?: 'PositionApplicationMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** May contain more than one error for same field. */
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  positionApplication?: Maybe<PositionApplicationType>;
};

export type PositionApplicationType = Node & {
  __typename?: 'PositionApplicationType';
  candidateProfile: CandidateProfileType;
  /** the current application to show on a conversation */
  channelSet: ChannelTypeConnection;
  createdAt: Scalars['DateTime'];
  /** The ID of the object */
  id: Scalars['ID'];
  matchSet: MatchTypeConnection;
  /** When we sent the application email to the employer. */
  notificationSentAt?: Maybe<Scalars['DateTime']>;
  platform?: Maybe<Scalars['String']>;
  platformApplyId?: Maybe<Scalars['String']>;
  platformAttribution?: Maybe<Scalars['String']>;
  position: PositionType;
  status: EmployersPositionApplicationStatusChoices;
  updatedAt: Scalars['DateTime'];
  /** Datetime denoting when an employer first views a candidate's profile that has applied. */
  viewedAt?: Maybe<Scalars['DateTime']>;
};


export type PositionApplicationTypeChannelSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sendbirdChannelId?: InputMaybe<Scalars['String']>;
};


export type PositionApplicationTypeMatchSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PositionApplicationTypeConnection = {
  __typename?: 'PositionApplicationTypeConnection';
  edgeCount?: Maybe<Scalars['Int']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PositionApplicationTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `PositionApplicationType` and its cursor. */
export type PositionApplicationTypeEdge = {
  __typename?: 'PositionApplicationTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<PositionApplicationType>;
};

export type PositionMutationInput = {
  availabilityFriday?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilityMonday?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilitySaturday?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilitySunday?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilityThursday?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilityTuesday?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilityWednesday?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  baseSalaryMax?: InputMaybe<Scalars['Float']>;
  baseSalaryMin?: InputMaybe<Scalars['Float']>;
  baseSalaryUnitText?: InputMaybe<Scalars['String']>;
  /** Is candidate ok with having a dress code? */
  canHaveDressCode?: InputMaybe<Scalars['Boolean']>;
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Identifier for this position from an external system */
  externalId?: InputMaybe<Scalars['String']>;
  /** Whether to mark this company as "hiring" in our UI and publish the job posting to Google, et al */
  hiring?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  /** If True, do not include the easyapply node in the Indeed XML feed. */
  indeedEasyapplyOptout?: InputMaybe<Scalars['Boolean']>;
  /** Are benefits a must-have for a candidate? */
  isBenefitsRequired?: InputMaybe<Scalars['Boolean']>;
  /** Supports a subset of Markdown */
  jobDescription?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['ID']>;
  /** Undefined, Null, or missing fields will not update when set to true. */
  partialUpdate?: InputMaybe<Scalars['Boolean']>;
  positionName?: InputMaybe<Scalars['String']>;
  positionType?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  preferredExperience?: InputMaybe<Scalars['String']>;
  preferredTraining?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Whether to send notifications of new matches */
  sendNotifications?: InputMaybe<Scalars['Boolean']>;
  shortUrl?: InputMaybe<Scalars['String']>;
};

export type PositionMutationPayload = {
  __typename?: 'PositionMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** May contain more than one error for same field. */
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  position?: Maybe<PositionType>;
};

export type PositionType = Node & {
  __typename?: 'PositionType';
  allowIndexing?: Maybe<Scalars['Boolean']>;
  applicants: CandidateProfileTypeConnection;
  appliedAt?: Maybe<Scalars['String']>;
  /** Setting this field deactivates the position everywhere in the site, including in the employers view. Set this to any date instead of deleting. */
  archivedAt?: Maybe<Scalars['DateTime']>;
  availabilityFriday?: Maybe<Array<Maybe<Scalars['String']>>>;
  availabilityMonday?: Maybe<Array<Maybe<Scalars['String']>>>;
  availabilitySaturday?: Maybe<Array<Maybe<Scalars['String']>>>;
  availabilitySunday?: Maybe<Array<Maybe<Scalars['String']>>>;
  availabilityThursday?: Maybe<Array<Maybe<Scalars['String']>>>;
  availabilityTuesday?: Maybe<Array<Maybe<Scalars['String']>>>;
  availabilityWednesday?: Maybe<Array<Maybe<Scalars['String']>>>;
  baseSalaryMax?: Maybe<Scalars['Float']>;
  baseSalaryMin?: Maybe<Scalars['Float']>;
  baseSalaryUnitText?: Maybe<Scalars['String']>;
  /** Is candidate ok with having a dress code? */
  canHaveDressCode?: Maybe<Scalars['Boolean']>;
  /** Pay as you go position that was removed from a subscription */
  cancellationReason: CancellationReasonTypeConnection;
  /** This is deprecated in new chat. This will be removed soon. */
  channelSet: ChannelTypeConnection;
  createdAt: Scalars['DateTime'];
  createdBy?: Maybe<UserType>;
  dashboardCounts?: Maybe<DashboardCountsType>;
  employerProfile?: Maybe<EmployerProfileType>;
  employercandidatequestionnaireSet: EmployerCandidateQuestionnaireTypeConnection;
  employmentdocumentSet: EmploymentDocumentTypeConnection;
  /** The URL for the application process outside fohandboh.com. Bypasses fohandboh.com completely for external applications. */
  externalApplyUrl?: Maybe<Scalars['String']>;
  /** Identifier for this position from an external system */
  externalId?: Maybe<Scalars['String']>;
  hasApplied?: Maybe<Scalars['Boolean']>;
  /** Whether to mark this company as "hiring" in our UI and publish the job posting to Google, et al */
  hiring: Scalars['Boolean'];
  hiringStatus?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  /** If True, do not include the easyapply node in the Indeed XML feed. */
  indeedEasyapplyOptout: Scalars['Boolean'];
  indeedLastPostedAt?: Maybe<Scalars['DateTime']>;
  indexable?: Maybe<Scalars['Boolean']>;
  interviews: InterviewTypeConnection;
  /** Are benefits a must-have for a candidate? */
  isBenefitsRequired?: Maybe<Scalars['Boolean']>;
  isMatch?: Maybe<Scalars['Boolean']>;
  isNonPartner?: Maybe<Scalars['Boolean']>;
  jobBoardCampaign: JobBoardCampaignTypeConnection;
  jobDescription?: Maybe<Scalars['String']>;
  jobDescriptionType?: Maybe<Scalars['String']>;
  jobPostingBodyHtml: Scalars['String'];
  jobPostingBodyPlaintext: Scalars['String'];
  jobboardcampaignSet: JobBoardCampaignTypeConnection;
  /** Time of last Google Indexing API call (sent from Google server) */
  lastIndexing?: Maybe<Scalars['DateTime']>;
  /** Status code from Google of last index request (200 means OK) */
  lastIndexingStatusCode?: Maybe<Scalars['Int']>;
  /** The last time `create_matches` was run for this position */
  lastMatchCreation?: Maybe<Scalars['DateTime']>;
  location: LocationType;
  matchSet: MatchTypeConnection;
  /** The version of the match algorithm to use for this position */
  matchVersion: EmployersPositionMatchVersionChoices;
  myInterview?: Maybe<InterviewType>;
  /** Google Indexing API will be called within 5 minutes of this future date. Set to a time in the past to call immediately. Clear (set to None) to cancel indexing. */
  nextIndexing?: Maybe<Scalars['DateTime']>;
  payment?: Maybe<PaymentType>;
  paymentStatus?: Maybe<EmployersPositionPaymentStatusChoices>;
  positionName: Scalars['String'];
  positionType?: Maybe<Array<Maybe<Scalars['String']>>>;
  positionapplicationSet: PositionApplicationTypeConnection;
  /** The date for posting the job to Google, etc. Defaults to the date the Position was created. */
  posted: Scalars['DateTime'];
  preferredExperience?: Maybe<Scalars['String']>;
  preferredTraining?: Maybe<Array<Maybe<Scalars['String']>>>;
  requirements?: Maybe<Scalars['String']>;
  responsibilities?: Maybe<Scalars['String']>;
  rowId?: Maybe<Scalars['Int']>;
  /** Whether to send notifications of new matches */
  sendNotifications: Scalars['Boolean'];
  shortUrl?: Maybe<Scalars['String']>;
  slug: Scalars['String'];
  syndicationId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  /** Value for <cpc> in ziprecruiter.xml. Bid for clicks. */
  ziprecruiterBid: Scalars['Float'];
};


export type PositionTypeApplicantsArgs = {
  additionalTraining_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  after?: InputMaybe<Scalars['String']>;
  availabilityFriday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilityMonday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilitySaturday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilitySunday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilityThursday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilityTuesday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilityWednesday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  before?: InputMaybe<Scalars['String']>;
  employmentPreferences_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  positions_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  restaurantTypes_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Scalars['String']>;
  yearsExperience?: InputMaybe<Scalars['String']>;
};


export type PositionTypeCancellationReasonArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['ID']>;
  offset?: InputMaybe<Scalars['Int']>;
  position?: InputMaybe<Scalars['ID']>;
};


export type PositionTypeChannelSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sendbirdChannelId?: InputMaybe<Scalars['String']>;
};


export type PositionTypeEmployercandidatequestionnaireSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  candidateUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  employerCandidate?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  position?: InputMaybe<Scalars['ID']>;
  screeningQuestionnaire?: InputMaybe<Scalars['ID']>;
  sentAt?: InputMaybe<Scalars['DateTime']>;
  submittedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  uuid?: InputMaybe<Scalars['UUID']>;
};


export type PositionTypeEmploymentdocumentSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  candidate?: InputMaybe<Scalars['ID']>;
  documentType_Icontains?: InputMaybe<EmployersEmploymentDocumentDocumentTypeChoices>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type PositionTypeInterviewsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type PositionTypeJobBoardCampaignArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employer?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<PaymentJobBoardCampaignPlatformChoices>;
  position?: InputMaybe<Scalars['ID']>;
  stripeCustomer?: InputMaybe<Scalars['String']>;
};


export type PositionTypeJobboardcampaignSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employer?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<PaymentJobBoardCampaignPlatformChoices>;
  position?: InputMaybe<Scalars['ID']>;
  stripeCustomer?: InputMaybe<Scalars['String']>;
};


export type PositionTypeMatchSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type PositionTypePositionapplicationSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type PositionTypeConnection = {
  __typename?: 'PositionTypeConnection';
  edgeCount?: Maybe<Scalars['Int']>;
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<PositionTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

/** A Relay edge containing a `PositionType` and its cursor. */
export type PositionTypeEdge = {
  __typename?: 'PositionTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<PositionType>;
};

export type PriceDisplayType = {
  __typename?: 'PriceDisplayType';
  displayPerMonth?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['String']>;
};

export type ProfileCountType = {
  __typename?: 'ProfileCountType';
  count?: Maybe<Scalars['Int']>;
};

export type ProfileFilterGroupType = {
  __typename?: 'ProfileFilterGroupType';
  filterItems?: Maybe<Array<Maybe<Scalars['String']>>>;
  name?: Maybe<Scalars['String']>;
  operator?: Maybe<Scalars['String']>;
};

export type ProfileImageMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  fileName: Scalars['String'];
  fileType: Scalars['String'];
  id?: InputMaybe<Scalars['Int']>;
  /** Undefined, Null, or missing fields will not update when set to true. */
  partialUpdate?: InputMaybe<Scalars['Boolean']>;
};

export type ProfileImageMutationPayload = {
  __typename?: 'ProfileImageMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  /** May contain more than one error for same field. */
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  imageUploadUrl?: Maybe<Scalars['String']>;
  profileImage?: Maybe<ProfileImageType>;
};

export type ProfileImageType = Node & {
  __typename?: 'ProfileImageType';
  createdAt: Scalars['DateTime'];
  /** The ID of the object */
  id: Scalars['ID'];
  profileImage?: Maybe<Scalars['String']>;
  profileImageHeight?: Maybe<Scalars['String']>;
  profileImageWidth?: Maybe<Scalars['String']>;
  rowId?: Maybe<Scalars['Int']>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<UserType>;
};

export type ProfileImageTypeConnection = {
  __typename?: 'ProfileImageTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProfileImageTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ProfileImageType` and its cursor. */
export type ProfileImageTypeEdge = {
  __typename?: 'ProfileImageTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ProfileImageType>;
};

export type ProfileVideoType = Node & {
  __typename?: 'ProfileVideoType';
  createdAt: Scalars['DateTime'];
  /** The ID of the object */
  id: Scalars['ID'];
  profile?: Maybe<CandidateProfileType>;
  profileVideo?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user: UserType;
};

export type ProfileVideoTypeConnection = {
  __typename?: 'ProfileVideoTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ProfileVideoTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ProfileVideoType` and its cursor. */
export type ProfileVideoTypeEdge = {
  __typename?: 'ProfileVideoTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ProfileVideoType>;
};

export type Query = {
  __typename?: 'Query';
  _debug?: Maybe<DjangoDebug>;
  agendaEvents?: Maybe<Array<Maybe<AgendaType>>>;
  calculatePrice?: Maybe<CalculatePriceType>;
  campaignEstimation?: Maybe<CampaignEstimationType>;
  campaignPrediction?: Maybe<CampaignPredictionType>;
  campaignsByPosition?: Maybe<Array<Maybe<JobBoardCampaignType>>>;
  cancellationChoices?: Maybe<Array<Maybe<Scalars['String']>>>;
  candidateSearchFilterGroups?: Maybe<Array<Maybe<ProfileFilterGroupType>>>;
  candidateSearchSortByOptions?: Maybe<Array<Maybe<CandidateSortByEnum>>>;
  careerPageBySlug?: Maybe<CareerPageTypeConnection>;
  careerPageEditAccess?: Maybe<CareerPageType>;
  channel?: Maybe<ChannelType>;
  channels?: Maybe<ChannelTypeConnection>;
  channelsCount?: Maybe<ChannelsCountType>;
  employerCandidate?: Maybe<EmployerCandidateType>;
  employerCandidateNote?: Maybe<EmployerCandidateNoteType>;
  employerCandidateQuestionnaire?: Maybe<EmployerCandidateQuestionnaireType>;
  employerCandidateQuestionnaires?: Maybe<EmployerCandidateQuestionnaireTypeConnection>;
  employerCandidates?: Maybe<EmployerCandidateTypeConnection>;
  employerCareerPages?: Maybe<CareerPageTypeConnection>;
  employerMessageTemplate?: Maybe<EmployerMessageTemplateTypeConnection>;
  employerMessageTemplateCounts?: Maybe<EmployerMessageTemplateCountType>;
  employerMessageTemplates?: Maybe<EmployerMessageTemplateTypeConnection>;
  employerNotificationPreference?: Maybe<EmployerProfileUserNotificationPreferenceType>;
  employerRejectionReasons?: Maybe<EmployerRejectionReasonTypeConnection>;
  employerStage?: Maybe<EmployerStageType>;
  employerStages?: Maybe<EmployerStageTypeConnection>;
  employerUsers?: Maybe<EmployerProfileUserTypeConnection>;
  getEmployerDocument?: Maybe<EmploymentDocumentType>;
  getEmployerDocuments?: Maybe<EmploymentDocumentTypeConnection>;
  getIndeedBillingStatus?: Maybe<IndeedBillingActive>;
  getObjectByShortUrl?: Maybe<ShortUrlQueryType>;
  indeedCompanies?: Maybe<Array<Maybe<IndeedCompanyType>>>;
  indeedOauthDetails?: Maybe<IndeedOAuthDetails>;
  integrationIdentifiers?: Maybe<Array<Maybe<IntegrationIdentifierType>>>;
  interview?: Maybe<InterviewType>;
  interviewMessaging?: Maybe<InterviewMessagingType>;
  jobBoardCampaign?: Maybe<JobBoardCampaignType>;
  jobBoardCampaigns?: Maybe<JobBoardCampaignTypeConnection>;
  jobDescriptionForPositionType?: Maybe<Scalars['String']>;
  location?: Maybe<LocationType>;
  locationById?: Maybe<LocationType>;
  locations?: Maybe<LocationTypeConnection>;
  match?: Maybe<MatchType>;
  matchFilterCounts?: Maybe<MatchFilterCountsType>;
  matches?: Maybe<MatchTypeConnection>;
  me?: Maybe<UserType>;
  myApplications?: Maybe<PositionApplicationTypeConnection>;
  myMatches?: Maybe<MatchTypeConnection>;
  myPositions?: Maybe<PositionTypeConnection>;
  position?: Maybe<PositionType>;
  positionById?: Maybe<PositionType>;
  positions?: Maybe<PositionTypeConnection>;
  profile?: Maybe<CandidateProfileType>;
  profileImages?: Maybe<ProfileImageTypeConnection>;
  profileVideos?: Maybe<ProfileVideoTypeConnection>;
  questionnaire?: Maybe<ScreeningQuestionnaireType>;
  questionnaires?: Maybe<ScreeningQuestionnaireTypeConnection>;
  questions?: Maybe<QuestionTypeConnection>;
  scheduleSlots?: Maybe<Array<Maybe<InterviewScheduleDayType>>>;
  searchAhead?: Maybe<SearchAheadGroupsType>;
  searchAheadNetwork?: Maybe<SearchAheadGroupsType>;
  searchEmployerCandidates?: Maybe<EmployerCandidateDetailsViewTypeConnection>;
  searchProfiles?: Maybe<CandidateProfileTypeConnection>;
  searchProfilesCount?: Maybe<ProfileCountType>;
  sendbirdUsers?: Maybe<UserTypeConnection>;
  sevenshiftsCompanies?: Maybe<Array<Maybe<SevenShiftsGuidType>>>;
  sevenshiftsDepartments?: Maybe<Array<Maybe<SevenShiftsDepartmentType>>>;
  sevenshiftsLocations?: Maybe<Array<Maybe<SevenShiftsLocationType>>>;
  sevenshiftsRoles?: Maybe<Array<Maybe<SevenShiftsRoleType>>>;
  shouldRefreshFeed?: Maybe<ShouldRefreshFeedResponseType>;
  stageNotifications?: Maybe<EmployerCandidateNotificationTypeConnection>;
  userInterviewSchedule?: Maybe<InterviewScheduleType>;
  waffleFlags?: Maybe<Array<Maybe<WaffleFlagType>>>;
  workHistory?: Maybe<CandidateWorkHistoryTypeConnection>;
  zipcodeForCoordinates?: Maybe<ZipcodeType>;
};


export type QueryAgendaEventsArgs = {
  endTime?: InputMaybe<Scalars['DateTime']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  positions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  startTime?: InputMaybe<Scalars['DateTime']>;
};


export type QueryCalculatePriceArgs = {
  location?: InputMaybe<Scalars['ID']>;
  paymentStatus?: InputMaybe<PaymentStatusEnum>;
  singleposition?: InputMaybe<Scalars['Boolean']>;
};


export type QueryCampaignEstimationArgs = {
  budget?: InputMaybe<Scalars['Float']>;
  campaignId?: InputMaybe<Scalars['ID']>;
  endDate?: InputMaybe<Scalars['Date']>;
  startDate?: InputMaybe<Scalars['Date']>;
};


export type QueryCampaignPredictionArgs = {
  campaignId?: InputMaybe<Scalars['ID']>;
};


export type QueryCampaignsByPositionArgs = {
  position?: InputMaybe<Scalars['ID']>;
};


export type QueryCareerPageBySlugArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employerProfile?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryCareerPageEditAccessArgs = {
  id: Scalars['ID'];
};


export type QueryChannelArgs = {
  sendbirdChannelId?: InputMaybe<Scalars['String']>;
};


export type QueryChannelsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  positionId?: InputMaybe<Scalars['String']>;
  sendbirdChannelId?: InputMaybe<Scalars['String']>;
};


export type QueryChannelsCountArgs = {
  locationId?: InputMaybe<Scalars['String']>;
  positionId?: InputMaybe<Scalars['String']>;
};


export type QueryEmployerCandidateArgs = {
  id: Scalars['ID'];
};


export type QueryEmployerCandidateNoteArgs = {
  employerCandidate: Scalars['ID'];
};


export type QueryEmployerCandidateQuestionnaireArgs = {
  uuid?: InputMaybe<Scalars['UUID']>;
};


export type QueryEmployerCandidateQuestionnairesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  candidateUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  employerCandidate?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  position?: InputMaybe<Scalars['ID']>;
  screeningQuestionnaire?: InputMaybe<Scalars['ID']>;
  sentAt?: InputMaybe<Scalars['DateTime']>;
  submittedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  uuid?: InputMaybe<Scalars['UUID']>;
};


export type QueryEmployerCandidatesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employerCandidateId?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  idIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  last?: InputMaybe<Scalars['Int']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  notificationStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  notificationType?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  positions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  profileDetailFilters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  search?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<EmployerCandidateSortByEnum>;
  stageId?: InputMaybe<Scalars['ID']>;
  stageUpdatedAt?: InputMaybe<Scalars['DateTime']>;
  stageUpdatedAt_Gte?: InputMaybe<Scalars['DateTime']>;
  stageUpdatedAt_Lte?: InputMaybe<Scalars['DateTime']>;
};


export type QueryEmployerCareerPagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employerProfile?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryEmployerMessageTemplateArgs = {
  action_Iexact?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  archivedAt?: InputMaybe<Scalars['DateTime']>;
  before?: InputMaybe<Scalars['String']>;
  category_Icontains?: InputMaybe<EmployersEmployerMessageTemplateCategoryChoices>;
  category_Iexact?: InputMaybe<EmployersEmployerMessageTemplateCategoryChoices>;
  category_Istartswith?: InputMaybe<EmployersEmployerMessageTemplateCategoryChoices>;
  employerProfile?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  messageContent_Icontains?: InputMaybe<Scalars['String']>;
  messageContent_Iexact?: InputMaybe<Scalars['String']>;
  messageContent_Istartswith?: InputMaybe<Scalars['String']>;
  name_Icontains?: InputMaybe<Scalars['String']>;
  name_Iexact?: InputMaybe<Scalars['String']>;
  name_Istartswith?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  templateId: Scalars['ID'];
};


export type QueryEmployerMessageTemplatesArgs = {
  action_Iexact?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  archivedAt?: InputMaybe<Scalars['DateTime']>;
  before?: InputMaybe<Scalars['String']>;
  category_Icontains?: InputMaybe<EmployersEmployerMessageTemplateCategoryChoices>;
  category_Iexact?: InputMaybe<EmployersEmployerMessageTemplateCategoryChoices>;
  category_Istartswith?: InputMaybe<EmployersEmployerMessageTemplateCategoryChoices>;
  employerProfile?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  isSimpleOnly?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  messageContent_Icontains?: InputMaybe<Scalars['String']>;
  messageContent_Iexact?: InputMaybe<Scalars['String']>;
  messageContent_Istartswith?: InputMaybe<Scalars['String']>;
  name_Icontains?: InputMaybe<Scalars['String']>;
  name_Iexact?: InputMaybe<Scalars['String']>;
  name_Istartswith?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryEmployerNotificationPreferenceArgs = {
  employerProfileUserId?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
};


export type QueryEmployerRejectionReasonsArgs = {
  after?: InputMaybe<Scalars['String']>;
  archivedAt_Isnull?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryEmployerStageArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryEmployerStagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employerProfile?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryEmployerUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryGetEmployerDocumentArgs = {
  id: Scalars['ID'];
};


export type QueryGetEmployerDocumentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  candidate?: InputMaybe<Scalars['ID']>;
  documentType_Icontains?: InputMaybe<EmployersEmploymentDocumentDocumentTypeChoices>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryGetObjectByShortUrlArgs = {
  shortUrl?: InputMaybe<Scalars['String']>;
};


export type QueryIntegrationIdentifiersArgs = {
  integration?: InputMaybe<Scalars['String']>;
};


export type QueryInterviewArgs = {
  id?: InputMaybe<Scalars['String']>;
  shortUrl?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
};


export type QueryInterviewMessagingArgs = {
  location: Scalars['ID'];
};


export type QueryJobBoardCampaignArgs = {
  campaignId: Scalars['ID'];
};


export type QueryJobBoardCampaignsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employer?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Scalars['String']>;
  platform?: InputMaybe<PaymentJobBoardCampaignPlatformChoices>;
  position?: InputMaybe<Scalars['ID']>;
  stripeCustomer?: InputMaybe<Scalars['String']>;
};


export type QueryJobDescriptionForPositionTypeArgs = {
  positionType?: InputMaybe<Scalars['String']>;
};


export type QueryLocationArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryLocationByIdArgs = {
  id: Scalars['ID'];
};


export type QueryLocationsArgs = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCity_Icontains?: InputMaybe<Scalars['String']>;
  addressCity_Istartswith?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressCountry_Icontains?: InputMaybe<Scalars['String']>;
  addressCountry_Istartswith?: InputMaybe<Scalars['String']>;
  addressPostalCode?: InputMaybe<Scalars['String']>;
  addressPostalCode_Icontains?: InputMaybe<Scalars['String']>;
  addressPostalCode_Istartswith?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressState_Icontains?: InputMaybe<Scalars['String']>;
  addressState_Istartswith?: InputMaybe<Scalars['String']>;
  addressStreet1?: InputMaybe<Scalars['String']>;
  addressStreet1_Icontains?: InputMaybe<Scalars['String']>;
  addressStreet1_Istartswith?: InputMaybe<Scalars['String']>;
  addressStreet2?: InputMaybe<Scalars['String']>;
  addressStreet2_Icontains?: InputMaybe<Scalars['String']>;
  addressStreet2_Istartswith?: InputMaybe<Scalars['String']>;
  addressStreet3?: InputMaybe<Scalars['String']>;
  addressStreet3_Icontains?: InputMaybe<Scalars['String']>;
  addressStreet3_Istartswith?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  claimed?: InputMaybe<Scalars['Boolean']>;
  dressCode?: InputMaybe<Scalars['Boolean']>;
  employerProfile?: InputMaybe<Scalars['ID']>;
  featured?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  following?: InputMaybe<Scalars['Boolean']>;
  healthInsurance?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  last?: InputMaybe<Scalars['Int']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  name?: InputMaybe<Scalars['String']>;
  name_Icontains?: InputMaybe<Scalars['String']>;
  name_Istartswith?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  positionTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  positions?: InputMaybe<Scalars['ID']>;
  restaurantTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  search?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};


export type QueryMatchArgs = {
  handle: Scalars['String'];
  position: Scalars['ID'];
};


export type QueryMatchFilterCountsArgs = {
  position?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
};


export type QueryMatchesArgs = {
  after?: InputMaybe<Scalars['String']>;
  applied?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  followingLocation?: InputMaybe<Scalars['ID']>;
  id?: InputMaybe<Scalars['ID']>;
  interviewStatus?: InputMaybe<InterviewStatusFilter>;
  last?: InputMaybe<Scalars['Int']>;
  newApplications?: InputMaybe<Scalars['Boolean']>;
  newChats?: InputMaybe<Scalars['Boolean']>;
  newMatches?: InputMaybe<Scalars['Boolean']>;
  newlyAcceptedInterviews?: InputMaybe<Scalars['Boolean']>;
  offset?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  position?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  sendbird?: InputMaybe<Scalars['Boolean']>;
  sort?: InputMaybe<Scalars['String']>;
};


export type QueryMyApplicationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  searchTerms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};


export type QueryMyMatchesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryMyPositionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  archivedAt_Isnull?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  canHaveDressCode?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  hiring?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  isBenefitsRequired?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['ID']>;
  location_In?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  offset?: InputMaybe<Scalars['Int']>;
  positionName_Icontains?: InputMaybe<Scalars['String']>;
};


export type QueryPositionArgs = {
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryPositionByIdArgs = {
  id: Scalars['ID'];
};


export type QueryPositionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  archivedAt_Isnull?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  canHaveDressCode?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  hasApplied?: InputMaybe<Scalars['Boolean']>;
  hasInterview?: InputMaybe<Scalars['Boolean']>;
  hiring?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  interviewStatus?: InputMaybe<Scalars['String']>;
  isBenefitsRequired?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['ID']>;
  location_In?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  offset?: InputMaybe<Scalars['Int']>;
  positionName_Icontains?: InputMaybe<Scalars['String']>;
  searchTerms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  showBestMatch?: InputMaybe<Scalars['Boolean']>;
  sortBy?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};


export type QueryProfileArgs = {
  handle?: InputMaybe<Scalars['String']>;
};


export type QueryProfileImagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryProfileVideosArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryQuestionnaireArgs = {
  screeningQuestionnaireId?: InputMaybe<Scalars['ID']>;
};


export type QueryQuestionnairesArgs = {
  after?: InputMaybe<Scalars['String']>;
  archivedAt?: InputMaybe<Scalars['DateTime']>;
  before?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  employerProfile?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  name_Icontains?: InputMaybe<Scalars['String']>;
  name_Iexact?: InputMaybe<Scalars['String']>;
  name_Istartswith?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  questionnaireType?: InputMaybe<ScreeningScreeningQuestionnaireQuestionnaireTypeChoices>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};


export type QueryQuestionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<OnboardingQuestionCategoryChoices>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryScheduleSlotsArgs = {
  endDate: Scalars['DateTime'];
  startDate: Scalars['DateTime'];
  userId: Scalars['ID'];
};


export type QuerySearchAheadArgs = {
  search?: InputMaybe<Scalars['String']>;
};


export type QuerySearchAheadNetworkArgs = {
  search?: InputMaybe<Scalars['String']>;
};


export type QuerySearchEmployerCandidatesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  search: Scalars['String'];
};


export type QuerySearchProfilesArgs = {
  additionalTraining_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  addressPostalCode?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  availabilityFriday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilityMonday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilitySaturday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilitySunday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilityThursday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilityTuesday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilityWednesday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  before?: InputMaybe<Scalars['String']>;
  count?: InputMaybe<Scalars['Boolean']>;
  employmentPreferences_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  first?: InputMaybe<Scalars['Int']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  last?: InputMaybe<Scalars['Int']>;
  milesFromCenterZip?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  positions_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  profileDetailFilters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  restaurantTypes_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchTerms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sortBy?: InputMaybe<CandidateSortByEnum>;
  status?: InputMaybe<Scalars['String']>;
  yearsExperience?: InputMaybe<Scalars['String']>;
};


export type QuerySearchProfilesCountArgs = {
  addressPostalCode?: InputMaybe<Scalars['String']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  milesFromCenterZip?: InputMaybe<Scalars['Int']>;
  profileDetailFilters?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  searchTerms?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sortBy?: InputMaybe<CandidateSortByEnum>;
};


export type QuerySendbirdUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  uuid?: InputMaybe<Scalars['UUID']>;
};


export type QuerySevenshiftsDepartmentsArgs = {
  companyId: Scalars['Int'];
  locationId?: InputMaybe<Scalars['Int']>;
};


export type QuerySevenshiftsLocationsArgs = {
  companyId: Scalars['Int'];
};


export type QuerySevenshiftsRolesArgs = {
  companyId: Scalars['Int'];
  departmentId?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<Scalars['Int']>;
};


export type QueryShouldRefreshFeedArgs = {
  lastChecked: Scalars['DateTime'];
};


export type QueryStageNotificationsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  offset?: InputMaybe<Scalars['Int']>;
  positions?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};


export type QueryUserInterviewScheduleArgs = {
  userId?: InputMaybe<Scalars['ID']>;
};


export type QueryWorkHistoryArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QueryZipcodeForCoordinatesArgs = {
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type QuestionAnswerInputType = {
  answer: Scalars['String'];
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  questionId: Scalars['ID'];
  questionText?: InputMaybe<Scalars['String']>;
};

export type QuestionOptionType = Node & {
  __typename?: 'QuestionOptionType';
  careerpageanswerSet: CareerPageAnswerTypeConnection;
  /** The icon to show for this answer on this profile */
  displayIcon?: Maybe<Scalars['String']>;
  /** The text to show for this answer on the profile */
  displayLabel?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  /** The visible response to a question */
  label: Scalars['String'];
  locationanswerSet: LocationAnswerTypeConnection;
  /** The order the options will be displayed in */
  ordering: Scalars['Int'];
  question: QuestionType;
  /** The stored version of the answer */
  value: Scalars['String'];
};


export type QuestionOptionTypeCareerpageanswerSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type QuestionOptionTypeLocationanswerSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type QuestionType = Node & {
  __typename?: 'QuestionType';
  category: OnboardingQuestionCategoryChoices;
  icon?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  options?: Maybe<Array<Maybe<QuestionOptionType>>>;
  /** Used either in the text field or "Other" field */
  placeholder?: Maybe<Scalars['String']>;
  questionType: OnboardingQuestionQuestionTypeChoices;
  /** Whether to mark the question as required in the UI */
  required: Scalars['Boolean'];
  /** The actual text of the question */
  title: Scalars['String'];
};

export type QuestionTypeConnection = {
  __typename?: 'QuestionTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<QuestionTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `QuestionType` and its cursor. */
export type QuestionTypeEdge = {
  __typename?: 'QuestionTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<QuestionType>;
};

export type ReactivateSubscriptionMutation = {
  __typename?: 'ReactivateSubscriptionMutation';
  locations?: Maybe<Array<Maybe<LocationType>>>;
  payment?: Maybe<PaymentType>;
  positions?: Maybe<Array<Maybe<PositionType>>>;
};

/** For users to get a sendbird access token */
export type RefreshSendBirdUser = {
  __typename?: 'RefreshSendBirdUser';
  me?: Maybe<UserType>;
};

export type RefundAndEndCampaign = {
  __typename?: 'RefundAndEndCampaign';
  jobBoardCampaign?: Maybe<JobBoardCampaignType>;
};

export type RejectCandidates = {
  __typename?: 'RejectCandidates';
  employerCandidates?: Maybe<Array<Maybe<EmployerCandidateType>>>;
};

export type RemoveEmployerUserInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type RemoveEmployerUserPayload = {
  __typename?: 'RemoveEmployerUserPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type RequestAllCandidatesMutation = {
  __typename?: 'RequestAllCandidatesMutation';
  /** May contain more than one error for same field. */
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  matches?: Maybe<Array<Maybe<MatchType>>>;
};

export enum RequestInterviewFilter {
  AllApplicants = 'ALL_APPLICANTS',
  AllMatches = 'ALL_MATCHES',
  NewApplicants = 'NEW_APPLICANTS',
  NewMatches = 'NEW_MATCHES'
}

export type ResendEmployerUserInviteInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type ResendEmployerUserInvitePayload = {
  __typename?: 'ResendEmployerUserInvitePayload';
  clientMutationId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
};

export type ScreeningAnswerType = Node & {
  __typename?: 'ScreeningAnswerType';
  answer?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  employerCandidateQuestionnaire?: Maybe<EmployerCandidateQuestionnaireType>;
  /** The ID of the object */
  id: Scalars['ID'];
  /** The text of the question at the time the candidate answered it */
  questionText: Scalars['String'];
  screeningAnswerVideo?: Maybe<Scalars['String']>;
  screeningQuestion?: Maybe<ScreeningQuestionType>;
  updatedAt: Scalars['DateTime'];
};

export type ScreeningAnswerTypeConnection = {
  __typename?: 'ScreeningAnswerTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ScreeningAnswerTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ScreeningAnswerType` and its cursor. */
export type ScreeningAnswerTypeEdge = {
  __typename?: 'ScreeningAnswerTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ScreeningAnswerType>;
};

export type ScreeningQuestionSerializerInput = {
  deleteQuestion?: InputMaybe<Scalars['Boolean']>;
  question?: InputMaybe<Scalars['String']>;
  questionId?: InputMaybe<Scalars['String']>;
};

export type ScreeningQuestionType = Node & {
  __typename?: 'ScreeningQuestionType';
  answers?: Maybe<Array<Maybe<ScreeningAnswerType>>>;
  /** DateTime set on delete */
  archivedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  /** Question ID from external source (ex: Jobget) */
  externalId?: Maybe<Scalars['String']>;
  /** The ID of the object */
  id: Scalars['ID'];
  question: Scalars['String'];
  questionType?: Maybe<ScreeningScreeningQuestionQuestionTypeChoices>;
  screeningQuestionnaire?: Maybe<ScreeningQuestionnaireType>;
  screeninganswerSet: ScreeningAnswerTypeConnection;
  updatedAt: Scalars['DateTime'];
};


export type ScreeningQuestionTypeScreeninganswerSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  answer?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employerCandidateQuestionnaire?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  questionText?: InputMaybe<Scalars['String']>;
  screeningQuestion?: InputMaybe<Scalars['ID']>;
};

export type ScreeningQuestionTypeConnection = {
  __typename?: 'ScreeningQuestionTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ScreeningQuestionTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ScreeningQuestionType` and its cursor. */
export type ScreeningQuestionTypeEdge = {
  __typename?: 'ScreeningQuestionTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ScreeningQuestionType>;
};

export type ScreeningQuestionnaireType = Node & {
  __typename?: 'ScreeningQuestionnaireType';
  /** DateTime set on delete */
  archivedAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  employerMessageTemplate?: Maybe<EmployerMessageTemplateType>;
  employerProfile?: Maybe<EmployerProfileType>;
  employercandidatequestionnaireSet: EmployerCandidateQuestionnaireTypeConnection;
  /** The ID of the object */
  id: Scalars['ID'];
  name: Scalars['String'];
  questionnaireType?: Maybe<ScreeningScreeningQuestionnaireQuestionnaireTypeChoices>;
  screeningQuestion: ScreeningQuestionTypeConnection;
  updatedAt: Scalars['DateTime'];
};


export type ScreeningQuestionnaireTypeEmployercandidatequestionnaireSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  candidateUrl?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  employerCandidate?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  position?: InputMaybe<Scalars['ID']>;
  screeningQuestionnaire?: InputMaybe<Scalars['ID']>;
  sentAt?: InputMaybe<Scalars['DateTime']>;
  submittedAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  uuid?: InputMaybe<Scalars['UUID']>;
};


export type ScreeningQuestionnaireTypeScreeningQuestionArgs = {
  after?: InputMaybe<Scalars['String']>;
  archivedAt?: InputMaybe<Scalars['DateTime']>;
  before?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  externalId?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  question?: InputMaybe<Scalars['String']>;
  questionType?: InputMaybe<ScreeningScreeningQuestionQuestionTypeChoices>;
  screeningQuestionnaire?: InputMaybe<Scalars['ID']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ScreeningQuestionnaireTypeConnection = {
  __typename?: 'ScreeningQuestionnaireTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<ScreeningQuestionnaireTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `ScreeningQuestionnaireType` and its cursor. */
export type ScreeningQuestionnaireTypeEdge = {
  __typename?: 'ScreeningQuestionnaireTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<ScreeningQuestionnaireType>;
};

/** An enumeration. */
export enum ScreeningScreeningQuestionQuestionTypeChoices {
  /** Multi Select */
  Multiselect = 'MULTISELECT',
  /** Select */
  Select = 'SELECT',
  /** Text */
  Text = 'TEXT',
  /** Text Area */
  Textarea = 'TEXTAREA'
}

/** An enumeration. */
export enum ScreeningScreeningQuestionnaireQuestionnaireTypeChoices {
  /** Demographic */
  Demographic = 'DEMOGRAPHIC',
  /** Pre-screen */
  Prescreen = 'PRESCREEN',
  /** Text */
  Text = 'TEXT',
  /** Video */
  Video = 'VIDEO'
}

export type SearchAheadGroupType = {
  __typename?: 'SearchAheadGroupType';
  group?: Maybe<Scalars['String']>;
  values?: Maybe<Array<Maybe<SearchAheadType>>>;
};

export type SearchAheadGroupsType = {
  __typename?: 'SearchAheadGroupsType';
  groups?: Maybe<Array<Maybe<SearchAheadGroupType>>>;
};

export type SearchAheadType = {
  __typename?: 'SearchAheadType';
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type SendBirdUserType = {
  __typename?: 'SendBirdUserType';
  nickname?: Maybe<Scalars['String']>;
  profileUrl?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type SendHelpRequestMutation = {
  __typename?: 'SendHelpRequestMutation';
  success?: Maybe<Scalars['Boolean']>;
};

export type SendQuestionnaireMutation = {
  __typename?: 'SendQuestionnaireMutation';
  id?: Maybe<Scalars['ID']>;
};

export type SetPreferredMatchForPosition = {
  __typename?: 'SetPreferredMatchForPosition';
  channel?: Maybe<ChannelType>;
  employerCandidate?: Maybe<EmployerCandidateType>;
};

export type SevenShiftsCreateGuidMutation = {
  __typename?: 'SevenShiftsCreateGuidMutation';
  guid?: Maybe<SevenShiftsGuidType>;
};

export type SevenShiftsCreateUserMutation = {
  __typename?: 'SevenShiftsCreateUserMutation';
  employerCandidate?: Maybe<EmployerCandidateType>;
  sevenshiftsId?: Maybe<Scalars['Int']>;
  sevenshiftsUrl?: Maybe<Scalars['String']>;
};

export type SevenShiftsDeleteGuidMutation = {
  __typename?: 'SevenShiftsDeleteGuidMutation';
  ok?: Maybe<Scalars['Boolean']>;
};

export type SevenShiftsDepartmentType = {
  __typename?: 'SevenShiftsDepartmentType';
  id?: Maybe<Scalars['Int']>;
  locationId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type SevenShiftsGuidType = Node & {
  __typename?: 'SevenShiftsGuidType';
  /** Company ID provided by 7Shifts */
  companyId: Scalars['String'];
  /** The name of the company as stored at 7Shifts */
  companyName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  createdBy: UserType;
  employerProfile: EmployerProfileType;
  /** GUID provided by 7Shifts */
  guid: Scalars['String'];
  /** The ID of the object */
  id: Scalars['ID'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type SevenShiftsGuidTypeConnection = {
  __typename?: 'SevenShiftsGuidTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<SevenShiftsGuidTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `SevenShiftsGuidType` and its cursor. */
export type SevenShiftsGuidTypeEdge = {
  __typename?: 'SevenShiftsGuidTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<SevenShiftsGuidType>;
};

export type SevenShiftsLocationType = {
  __typename?: 'SevenShiftsLocationType';
  address?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type SevenShiftsRoleType = {
  __typename?: 'SevenShiftsRoleType';
  departmentId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  locationId?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
};

export type ShortUrlQueryType = {
  __typename?: 'ShortUrlQueryType';
  interview?: Maybe<InterviewType>;
  objectType?: Maybe<Scalars['String']>;
};

export type ShouldRefreshFeedResponseType = {
  __typename?: 'ShouldRefreshFeedResponseType';
  message?: Maybe<Scalars['String']>;
  refresh?: Maybe<Scalars['Boolean']>;
};

export type SignInInterviewMutation = {
  __typename?: 'SignInInterviewMutation';
  authorization?: Maybe<Scalars['String']>;
};

export type SoftDeleteCandidateUser = {
  __typename?: 'SoftDeleteCandidateUser';
  deleted?: Maybe<Scalars['String']>;
};

export type SoftDeleteJobBoardCampaign = {
  __typename?: 'SoftDeleteJobBoardCampaign';
  deleted?: Maybe<Scalars['Boolean']>;
};

export type SubscriptionType = {
  __typename?: 'SubscriptionType';
  currentPeriodEnd?: Maybe<Scalars['Int']>;
  cycle?: Maybe<PaymentCycleEnum>;
  displayChargeAmount?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type SyncCampaign = {
  __typename?: 'SyncCampaign';
  campaign?: Maybe<JobBoardCampaignType>;
};

export type SyncCampaigns = {
  __typename?: 'SyncCampaigns';
  updated?: Maybe<Scalars['Boolean']>;
};

export type TagType = {
  __typename?: 'TagType';
  candidateprofileSet: CandidateProfileTypeConnection;
  createdAt: Scalars['DateTime'];
  /** Show this tag when displaying tags as options */
  default: Scalars['Boolean'];
  id: Scalars['ID'];
  locations: LocationTypeConnection;
  name: Scalars['String'];
  slug: Scalars['String'];
  tagType?: Maybe<EmployersTagTagTypeChoices>;
  updatedAt: Scalars['DateTime'];
};


export type TagTypeCandidateprofileSetArgs = {
  additionalTraining_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  after?: InputMaybe<Scalars['String']>;
  availabilityFriday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilityMonday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilitySaturday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilitySunday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilityThursday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilityTuesday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  availabilityWednesday_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  before?: InputMaybe<Scalars['String']>;
  employmentPreferences_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  positions_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  restaurantTypes_Icontains?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  status?: InputMaybe<Scalars['String']>;
  yearsExperience?: InputMaybe<Scalars['String']>;
};


export type TagTypeLocationsArgs = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCity_Icontains?: InputMaybe<Scalars['String']>;
  addressCity_Istartswith?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressCountry_Icontains?: InputMaybe<Scalars['String']>;
  addressCountry_Istartswith?: InputMaybe<Scalars['String']>;
  addressPostalCode?: InputMaybe<Scalars['String']>;
  addressPostalCode_Icontains?: InputMaybe<Scalars['String']>;
  addressPostalCode_Istartswith?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressState_Icontains?: InputMaybe<Scalars['String']>;
  addressState_Istartswith?: InputMaybe<Scalars['String']>;
  addressStreet1?: InputMaybe<Scalars['String']>;
  addressStreet1_Icontains?: InputMaybe<Scalars['String']>;
  addressStreet1_Istartswith?: InputMaybe<Scalars['String']>;
  addressStreet2?: InputMaybe<Scalars['String']>;
  addressStreet2_Icontains?: InputMaybe<Scalars['String']>;
  addressStreet2_Istartswith?: InputMaybe<Scalars['String']>;
  addressStreet3?: InputMaybe<Scalars['String']>;
  addressStreet3_Icontains?: InputMaybe<Scalars['String']>;
  addressStreet3_Istartswith?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employerProfile?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_Icontains?: InputMaybe<Scalars['String']>;
  name_Istartswith?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  positions?: InputMaybe<Scalars['ID']>;
};

export type ToggleFavoriteLocationMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type ToggleFavoriteLocationMutationPayload = {
  __typename?: 'ToggleFavoriteLocationMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  location?: Maybe<LocationType>;
};

export type ToggleHideFromLocationMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
};

export type ToggleHideFromLocationMutationPayload = {
  __typename?: 'ToggleHideFromLocationMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  location?: Maybe<LocationType>;
};

export type UnrejectCandidates = {
  __typename?: 'UnrejectCandidates';
  employerCandidates?: Maybe<Array<Maybe<EmployerCandidateType>>>;
  toStage?: Maybe<EmployerStageType>;
};

/** Mutation to update the screening Question. */
export type UpdateScreeningQuestionMutation = {
  __typename?: 'UpdateScreeningQuestionMutation';
  screeningQuestion?: Maybe<ScreeningQuestionType>;
};

/** Mutation to update the screening Questionnaire. */
export type UpdateScreeningQutestionnaireMutation = {
  __typename?: 'UpdateScreeningQutestionnaireMutation';
  screeningQuestionnaire?: Maybe<ScreeningQuestionnaireType>;
};

/** Mutation to upload employer document files. */
export type UploadEmploymentDocumentFileMutation = {
  __typename?: 'UploadEmploymentDocumentFileMutation';
  employmentDocument?: Maybe<EmploymentDocumentType>;
  urls?: Maybe<Array<Maybe<UploadedSignedUrl>>>;
};

/** Mutation to upload message template files. */
export type UploadMessageTemplateFileMutation = {
  __typename?: 'UploadMessageTemplateFileMutation';
  messageTemplate?: Maybe<EmployerMessageTemplateType>;
  urls?: Maybe<Array<Maybe<MessageTemplateFileUrlType>>>;
};

export type UploadUrlType = {
  __typename?: 'UploadUrlType';
  question?: Maybe<ScreeningAnswerType>;
  signedS3Url?: Maybe<Scalars['String']>;
};

export type UploadedSignedUrl = {
  __typename?: 'UploadedSignedUrl';
  fileName?: Maybe<Scalars['String']>;
  fileUrl?: Maybe<Scalars['String']>;
  link?: Maybe<Scalars['String']>;
  signedS3Url?: Maybe<Scalars['String']>;
  templateFileId?: Maybe<Scalars['ID']>;
};

export type UserMutationInput = {
  clientMutationId?: InputMaybe<Scalars['String']>;
  confirmPassword?: InputMaybe<Scalars['String']>;
  dateJoined?: InputMaybe<Scalars['DateTime']>;
  email?: InputMaybe<Scalars['String']>;
  emailVerifiedAt?: InputMaybe<Scalars['DateTime']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  lastName?: InputMaybe<Scalars['String']>;
  notifyViaEmail?: InputMaybe<Scalars['Boolean']>;
  notifyViaSms?: InputMaybe<Scalars['Boolean']>;
  /** Undefined, Null, or missing fields will not update when set to true. */
  partialUpdate?: InputMaybe<Scalars['Boolean']>;
  password?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  preferredLanguage?: InputMaybe<Scalars['String']>;
  profileImageId?: InputMaybe<Scalars['ID']>;
  smsVerifiedAt?: InputMaybe<Scalars['DateTime']>;
  terms?: InputMaybe<Scalars['Boolean']>;
  timezone?: InputMaybe<Scalars['String']>;
};

export type UserMutationPayload = {
  __typename?: 'UserMutationPayload';
  clientMutationId?: Maybe<Scalars['String']>;
  employerProfile?: Maybe<EmployerProfileType>;
  /** May contain more than one error for same field. */
  errors?: Maybe<Array<Maybe<ErrorType>>>;
  me?: Maybe<UserType>;
  name?: Maybe<Scalars['String']>;
};

export type UserType = Node & {
  __typename?: 'UserType';
  allLocationUpdateCounts?: Maybe<LocationsCountType>;
  authorization?: Maybe<Scalars['String']>;
  cancellationreasonSet: CancellationReasonTypeConnection;
  candidateProfile?: Maybe<CandidateProfileType>;
  candidateUserChannels: ChannelTypeConnection;
  careerPage: CareerPageTypeConnection;
  channelSet: ChannelTypeConnection;
  dateJoined: Scalars['DateTime'];
  email?: Maybe<Scalars['String']>;
  emailVerifiedAt?: Maybe<Scalars['DateTime']>;
  employerProfile?: Maybe<EmployerProfileType>;
  employerProfileUser?: Maybe<EmployerProfileUserType>;
  /** This is deprecated in new chat. This will be removed soon. */
  employerUserChannels: ChannelTypeConnection;
  employermessagetemplateSet: EmployerMessageTemplateTypeConnection;
  employerprofileSet: EmployerProfileTypeConnection;
  employerprofileuserSet: EmployerProfileUserTypeConnection;
  endorsementSet: EndorsementTypeConnection;
  featureFlags?: Maybe<FeatureFlagTypeConnection>;
  featureflagSet: FeatureFlagTypeConnection;
  firstName: Scalars['String'];
  hasSchedule?: Maybe<Scalars['Boolean']>;
  /** The ID of the object */
  id: Scalars['ID'];
  indeedoauthtokenSet: IndeedCompanyTypeConnection;
  integrations?: Maybe<Array<Maybe<Scalars['String']>>>;
  interviewOffers?: Maybe<InterviewTypeConnection>;
  interviews: InterviewTypeConnection;
  interviewschedule?: Maybe<InterviewScheduleType>;
  invitees: EmployerProfileUserTypeConnection;
  inviteesChannels: ChannelTypeConnection;
  /** Designates whether this user should be treated as active. Unselect this instead of deleting accounts. */
  isActive: Scalars['Boolean'];
  /** Designates whether the user can log into this admin site. */
  isStaff: Scalars['Boolean'];
  /** Designates that this user has all permissions without explicitly assigning them. */
  isSuperuser: Scalars['Boolean'];
  /** Set to false to restrict users from automatically joining sendbird channels on creation */
  joinSendbirdChannels: Scalars['Boolean'];
  lastLogin?: Maybe<Scalars['DateTime']>;
  lastMessage?: Maybe<MessageType>;
  lastName: Scalars['String'];
  myLocations?: Maybe<LocationTypeConnection>;
  noteCreatedBy: EmployerCandidateNoteTypeConnection;
  noteUpdatedBy: EmployerCandidateNoteTypeConnection;
  notifications?: Maybe<Array<Maybe<NotificationType>>>;
  notifyViaEmail: Scalars['Boolean'];
  notifyViaSms: Scalars['Boolean'];
  password: Scalars['String'];
  /** Deprecated, cancellation reason has its own model now */
  paymentSet: PaymentTypeConnection;
  phone?: Maybe<Scalars['String']>;
  positionMatches?: Maybe<MatchTypeConnection>;
  positionSet: PositionTypeConnection;
  preferredLanguage: Scalars['String'];
  profileImage?: Maybe<Scalars['String']>;
  profileVideos: ProfileVideoTypeConnection;
  rowId?: Maybe<Scalars['Int']>;
  /** The ID of the segment regulation associated with gdpr delete */
  segmentRegulationId?: Maybe<Scalars['String']>;
  /** The users token for using the SendBird chat platform */
  sendbirdAccessToken?: Maybe<Scalars['String']>;
  sendbirdUser?: Maybe<SendBirdUserType>;
  sevenshiftsguidSet: SevenShiftsGuidTypeConnection;
  smsVerifiedAt?: Maybe<Scalars['DateTime']>;
  timezone: Scalars['String'];
  unclaimed?: Maybe<Scalars['Boolean']>;
  updatedAt: Scalars['DateTime'];
  /** Required. 150 characters or fewer. Letters, digits and @/./+/-/_ only. */
  username: Scalars['String'];
  uuid: Scalars['UUID'];
};


export type UserTypeCancellationreasonSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['ID']>;
  offset?: InputMaybe<Scalars['Int']>;
  position?: InputMaybe<Scalars['ID']>;
};


export type UserTypeCandidateUserChannelsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sendbirdChannelId?: InputMaybe<Scalars['String']>;
};


export type UserTypeCareerPageArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employerProfile?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type UserTypeChannelSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sendbirdChannelId?: InputMaybe<Scalars['String']>;
};


export type UserTypeEmployerUserChannelsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sendbirdChannelId?: InputMaybe<Scalars['String']>;
};


export type UserTypeEmployermessagetemplateSetArgs = {
  action_Iexact?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  archivedAt?: InputMaybe<Scalars['DateTime']>;
  before?: InputMaybe<Scalars['String']>;
  category_Icontains?: InputMaybe<EmployersEmployerMessageTemplateCategoryChoices>;
  category_Iexact?: InputMaybe<EmployersEmployerMessageTemplateCategoryChoices>;
  category_Istartswith?: InputMaybe<EmployersEmployerMessageTemplateCategoryChoices>;
  employerProfile?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  messageContent_Icontains?: InputMaybe<Scalars['String']>;
  messageContent_Iexact?: InputMaybe<Scalars['String']>;
  messageContent_Istartswith?: InputMaybe<Scalars['String']>;
  name_Icontains?: InputMaybe<Scalars['String']>;
  name_Iexact?: InputMaybe<Scalars['String']>;
  name_Istartswith?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type UserTypeEmployerprofileSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type UserTypeEmployerprofileuserSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type UserTypeEndorsementSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type UserTypeFeatureFlagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  feature?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  on?: InputMaybe<Scalars['Boolean']>;
};


export type UserTypeFeatureflagSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  feature?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  on?: InputMaybe<Scalars['Boolean']>;
};


export type UserTypeIndeedoauthtokenSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type UserTypeInterviewOffersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type UserTypeInterviewsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type UserTypeInviteesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type UserTypeInviteesChannelsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  sendbirdChannelId?: InputMaybe<Scalars['String']>;
};


export type UserTypeLastMessageArgs = {
  locationId?: InputMaybe<Scalars['ID']>;
};


export type UserTypeMyLocationsArgs = {
  addressCity?: InputMaybe<Scalars['String']>;
  addressCity_Icontains?: InputMaybe<Scalars['String']>;
  addressCity_Istartswith?: InputMaybe<Scalars['String']>;
  addressCountry?: InputMaybe<Scalars['String']>;
  addressCountry_Icontains?: InputMaybe<Scalars['String']>;
  addressCountry_Istartswith?: InputMaybe<Scalars['String']>;
  addressPostalCode?: InputMaybe<Scalars['String']>;
  addressPostalCode_Icontains?: InputMaybe<Scalars['String']>;
  addressPostalCode_Istartswith?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressState_Icontains?: InputMaybe<Scalars['String']>;
  addressState_Istartswith?: InputMaybe<Scalars['String']>;
  addressStreet1?: InputMaybe<Scalars['String']>;
  addressStreet1_Icontains?: InputMaybe<Scalars['String']>;
  addressStreet1_Istartswith?: InputMaybe<Scalars['String']>;
  addressStreet2?: InputMaybe<Scalars['String']>;
  addressStreet2_Icontains?: InputMaybe<Scalars['String']>;
  addressStreet2_Istartswith?: InputMaybe<Scalars['String']>;
  addressStreet3?: InputMaybe<Scalars['String']>;
  addressStreet3_Icontains?: InputMaybe<Scalars['String']>;
  addressStreet3_Istartswith?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employerProfile?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  id_In?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  last?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  name_Icontains?: InputMaybe<Scalars['String']>;
  name_Istartswith?: InputMaybe<Scalars['String']>;
  offset?: InputMaybe<Scalars['Int']>;
  positions?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
  sortBy?: InputMaybe<Scalars['String']>;
};


export type UserTypeNoteCreatedByArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employerCandidate?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type UserTypeNoteUpdatedByArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employerCandidate?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type UserTypePaymentSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['ID']>;
  offset?: InputMaybe<Scalars['Int']>;
  position?: InputMaybe<Scalars['ID']>;
};


export type UserTypePositionMatchesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  employerUuid?: InputMaybe<Scalars['UUID']>;
  first?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type UserTypePositionSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  archivedAt_Isnull?: InputMaybe<Scalars['Boolean']>;
  before?: InputMaybe<Scalars['String']>;
  canHaveDressCode?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  hiring?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['ID']>;
  isBenefitsRequired?: InputMaybe<Scalars['Boolean']>;
  last?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['ID']>;
  location_In?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  offset?: InputMaybe<Scalars['Int']>;
  positionName_Icontains?: InputMaybe<Scalars['String']>;
};


export type UserTypeProfileImageArgs = {
  height?: InputMaybe<Scalars['Int']>;
  width?: InputMaybe<Scalars['Int']>;
};


export type UserTypeProfileVideosArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};


export type UserTypeSevenshiftsguidSetArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
};

export type UserTypeConnection = {
  __typename?: 'UserTypeConnection';
  /** Contains the nodes in this connection. */
  edges: Array<Maybe<UserTypeEdge>>;
  /** Pagination data for this connection. */
  pageInfo: PageInfo;
};

/** A Relay edge containing a `UserType` and its cursor. */
export type UserTypeEdge = {
  __typename?: 'UserTypeEdge';
  /** A cursor for use in pagination */
  cursor: Scalars['String'];
  /** The item at the end of the edge */
  node?: Maybe<UserType>;
};

export type WaffleFlagType = {
  __typename?: 'WaffleFlagType';
  feature?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  on?: Maybe<Scalars['Boolean']>;
};

export type ZipcodeType = {
  __typename?: 'ZipcodeType';
  zipcode?: Maybe<Scalars['String']>;
};

export type CalculatePriceQueryVariables = Exact<{
  location?: InputMaybe<Scalars['ID']>;
  paymentStatus?: InputMaybe<PaymentStatusEnum>;
  singleposition?: InputMaybe<Scalars['Boolean']>;
}>;


export type CalculatePriceQuery = { __typename?: 'Query', calculatePrice?: { __typename?: 'CalculatePriceType', monthlyPayAsYouGo?: { __typename?: 'PriceDisplayType', total?: string | null, displayPerMonth?: string | null } | null, annualPayAsYouGo?: { __typename?: 'PriceDisplayType', total?: string | null, displayPerMonth?: string | null } | null, monthlyUnlimited?: { __typename?: 'PriceDisplayType', total?: string | null, displayPerMonth?: string | null } | null, annualUnlimited?: { __typename?: 'PriceDisplayType', total?: string | null, displayPerMonth?: string | null } | null } | null };

export type CancellationReasonMutationVariables = Exact<{
  position?: InputMaybe<Scalars['ID']>;
  location: Scalars['ID'];
  cancellationReasonOther?: InputMaybe<Scalars['String']>;
  hiredFohandboh?: InputMaybe<Scalars['Boolean']>;
  hiredOther?: InputMaybe<Scalars['Boolean']>;
  tooFewApplicants?: InputMaybe<Scalars['Boolean']>;
  candidatesUnresponsive?: InputMaybe<Scalars['Boolean']>;
  needsChange?: InputMaybe<Scalars['Boolean']>;
  other?: InputMaybe<Scalars['Boolean']>;
}>;


export type CancellationReasonMutation = { __typename?: 'Mutation', mutateCancellationReason?: { __typename?: 'CancellationReasonMutationPayload', cancellationReason?: { __typename?: 'CancellationReasonType', id: string, cancellationReasonOther?: string | null, hiredFohandboh: boolean, hiredOther: boolean, tooFewApplicants: boolean, candidatesUnresponsive: boolean, needsChange: boolean, other: boolean } | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type CreatePaymentIntentMutationVariables = Exact<{
  positionId: Scalars['ID'];
  amount: Scalars['Int'];
}>;


export type CreatePaymentIntentMutation = { __typename?: 'Mutation', createStripePaymentIntent?: { __typename?: 'CreateStripePaymentIntent', clientSecret?: string | null, paymentIntent?: string | null } | null };

export type DeactivateSubscriptionMutateMutationVariables = Exact<{
  stripeSubscription: Scalars['String'];
  position?: InputMaybe<Scalars['ID']>;
}>;


export type DeactivateSubscriptionMutateMutation = { __typename?: 'Mutation', deactivateSubscription?: { __typename?: 'DeactivateSubscriptionMutation', positions?: Array<{ __typename?: 'PositionType', id: string, hiring: boolean, paymentStatus?: EmployersPositionPaymentStatusChoices | null } | null> | null, payment?: { __typename?: 'PaymentType', id: string, startedOn?: any | null, subscriptionWillEndOn?: any | null, subscriptionEndedOn?: any | null, subscription?: { __typename?: 'SubscriptionType', id?: string | null, currentPeriodEnd?: number | null, displayChargeAmount?: string | null } | null } | null } | null };

export type GetCancelReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCancelReasonsQuery = { __typename?: 'Query', cancellationChoices?: Array<string | null> | null };

export type GetCurrentPlanQueryVariables = Exact<{
  location: Scalars['ID'];
}>;


export type GetCurrentPlanQuery = { __typename?: 'Query', locationById?: { __typename?: 'LocationType', id: string, rowId?: number | null, paymentStatus?: EmployersLocationPaymentStatusChoices | null, employerProfile?: { __typename?: 'EmployerProfileType', id: string, status: EmployersEmployerProfileStatusChoices, usersCanCancel: boolean } | null, payment?: { __typename?: 'PaymentType', id: string, planName?: PaymentPaymentPlanNameChoices | null, startedOn?: any | null, subscriptionWillEndOn?: any | null, subscriptionEndedOn?: any | null, subscription?: { __typename?: 'SubscriptionType', id?: string | null, cycle?: PaymentCycleEnum | null, currentPeriodEnd?: number | null, displayChargeAmount?: string | null } | null } | null } | null };

export type GetMyPositionsPlanQueryVariables = Exact<{
  location?: InputMaybe<Scalars['ID']>;
}>;


export type GetMyPositionsPlanQuery = { __typename?: 'Query', myPositions?: { __typename?: 'PositionTypeConnection', edges: Array<{ __typename?: 'PositionTypeEdge', node?: { __typename?: 'PositionType', id: string, rowId?: number | null, slug: string, positionName: string, hiring: boolean, positionType?: Array<string | null> | null, createdAt: any, paymentStatus?: EmployersPositionPaymentStatusChoices | null, hiringStatus?: string | null, location: { __typename?: 'LocationType', id: string, paymentStatus?: EmployersLocationPaymentStatusChoices | null }, payment?: { __typename?: 'PaymentType', id: string, planName?: PaymentPaymentPlanNameChoices | null, startedOn?: any | null, stripeSubscription: string, stripeCustomer: string, subscriptionWillEndOn?: any | null, subscriptionEndedOn?: any | null, subscription?: { __typename?: 'SubscriptionType', id?: string | null, cycle?: PaymentCycleEnum | null, currentPeriodEnd?: number | null, displayChargeAmount?: string | null } | null } | null } | null } | null> } | null };

export type GetPositionToPayForQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetPositionToPayForQuery = { __typename?: 'Query', positionById?: { __typename?: 'PositionType', id: string, slug: string, rowId?: number | null, positionName: string, positionType?: Array<string | null> | null, paymentStatus?: EmployersPositionPaymentStatusChoices | null, location: { __typename?: 'LocationType', id: string, rowId?: number | null }, payment?: { __typename?: 'PaymentType', id: string, startedOn?: any | null, subscriptionWillEndOn?: any | null, subscriptionEndedOn?: any | null, subscription?: { __typename?: 'SubscriptionType', id?: string | null, currentPeriodEnd?: number | null, displayChargeAmount?: string | null } | null } | null } | null };

export type ReactivateSubscriptionMutationMutationVariables = Exact<{
  stripeSubscription: Scalars['String'];
  positions?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type ReactivateSubscriptionMutationMutation = { __typename?: 'Mutation', reactivateSubscription?: { __typename?: 'ReactivateSubscriptionMutation', positions?: Array<{ __typename?: 'PositionType', id: string, hiring: boolean, paymentStatus?: EmployersPositionPaymentStatusChoices | null } | null> | null, payment?: { __typename?: 'PaymentType', id: string, startedOn?: any | null, subscriptionWillEndOn?: any | null, subscriptionEndedOn?: any | null, subscription?: { __typename?: 'SubscriptionType', id?: string | null, currentPeriodEnd?: number | null, displayChargeAmount?: string | null } | null } | null } | null };

export type MutateEndCampaignMutationVariables = Exact<{
  campaignId: Scalars['String'];
}>;


export type MutateEndCampaignMutation = { __typename?: 'Mutation', endCampaign?: { __typename?: 'EndCampaign', ended?: boolean | null } | null };

export type GetCampaignsDataQueryVariables = Exact<{
  employer?: InputMaybe<Scalars['ID']>;
  position?: InputMaybe<Scalars['ID']>;
  stripeCustomer?: InputMaybe<Scalars['String']>;
  orderBy?: InputMaybe<Scalars['String']>;
}>;


export type GetCampaignsDataQuery = { __typename?: 'Query', jobBoardCampaigns?: { __typename?: 'JobBoardCampaignTypeConnection', edges: Array<{ __typename?: 'JobBoardCampaignTypeEdge', node?: { __typename?: 'JobBoardCampaignType', id: string, name?: string | null, platform: PaymentJobBoardCampaignPlatformChoices, amount?: number | null, stripeCustomer?: string | null, stripePaymentIntent?: string | null, startedOn?: any | null, willStartOn?: any | null, campaignEndedOn?: any | null, campaignWillEndOn?: any | null, clicks: number, numApplies: number, avgCpa: number, spent: number, active?: boolean | null, applicationsCount?: number | null, isDraft: boolean, statsUpdatedAt?: any | null, status: PaymentJobBoardCampaignStatusChoices, positions: { __typename?: 'PositionTypeConnection', edges: Array<{ __typename?: 'PositionTypeEdge', node?: { __typename?: 'PositionType', positionName: string, location: { __typename?: 'LocationType', displayName?: string | null } } | null } | null> } } | null } | null> } | null };

export type CampaignEstimationQueryVariables = Exact<{
  campaignId?: InputMaybe<Scalars['ID']>;
  startDate?: InputMaybe<Scalars['Date']>;
  endDate?: InputMaybe<Scalars['Date']>;
  budget?: InputMaybe<Scalars['Float']>;
}>;


export type CampaignEstimationQuery = { __typename?: 'Query', campaignEstimation?: { __typename?: 'CampaignEstimationType', message?: string | null } | null };

export type CampaignPredictionQueryVariables = Exact<{
  campaignId: Scalars['ID'];
}>;


export type CampaignPredictionQuery = { __typename?: 'Query', campaignPrediction?: { __typename?: 'CampaignPredictionType', budget?: string | null, clicks?: string | null, days?: string | null, currencyCode?: string | null } | null };

export type CreateJobBoardCampaignMutationVariables = Exact<{
  name: Scalars['String'];
  positionId: Scalars['ID'];
  platform: Scalars['String'];
}>;


export type CreateJobBoardCampaignMutation = { __typename?: 'Mutation', createJobBoardCampaign?: { __typename?: 'CreateCampaign', campaign?: { __typename?: 'JobBoardCampaignType', id: string, name?: string | null, platform: PaymentJobBoardCampaignPlatformChoices } | null } | null };

export type SoftDeleteJobBoardCampaignMutationVariables = Exact<{
  campaignId: Scalars['String'];
}>;


export type SoftDeleteJobBoardCampaignMutation = { __typename?: 'Mutation', softDeleteJobBoardCampaign?: { __typename?: 'SoftDeleteJobBoardCampaign', deleted?: boolean | null } | null };

export type GetCampaignQueryVariables = Exact<{
  campaignId: Scalars['ID'];
}>;


export type GetCampaignQuery = { __typename?: 'Query', jobBoardCampaign?: { __typename?: 'JobBoardCampaignType', id: string, name?: string | null, platform: PaymentJobBoardCampaignPlatformChoices, stripeCustomer?: string | null, amount?: number | null, spent: number, clicks: number, numApplies: number, avgCpa: number, willStartOn?: any | null, campaignWillEndOn?: any | null, startedOn?: any | null, campaignEndedOn?: any | null, isDraft: boolean, employer: { __typename?: 'EmployerProfileType', id: string }, positions: { __typename?: 'PositionTypeConnection', edges: Array<{ __typename?: 'PositionTypeEdge', node?: { __typename?: 'PositionType', id: string, positionName: string, rowId?: number | null, location: { __typename?: 'LocationType', id: string, displayName?: string | null, formattedAddress?: string | null } } | null } | null> } } | null };

export type GetIndeedBillingStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIndeedBillingStatusQuery = { __typename?: 'Query', getIndeedBillingStatus?: { __typename?: 'IndeedBillingActive', isBillingConfirmed?: boolean | null } | null };

export type MutateJobBoardCampaignMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  positionId?: InputMaybe<Scalars['String']>;
  willStartOn?: InputMaybe<Scalars['DateTime']>;
  campaignWillEndOn?: InputMaybe<Scalars['DateTime']>;
  campaignEndedOn?: InputMaybe<Scalars['DateTime']>;
  amount?: InputMaybe<Scalars['Int']>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
}>;


export type MutateJobBoardCampaignMutation = { __typename?: 'Mutation', mutateJobBoardCampaign?: { __typename?: 'CampaignMutationPayload', campaignType?: { __typename?: 'JobBoardCampaignType', id: string, name?: string | null } | null } | null };

export type SyncCampaignMutationVariables = Exact<{
  campaignId: Scalars['String'];
}>;


export type SyncCampaignMutation = { __typename?: 'Mutation', syncCampaign?: { __typename?: 'SyncCampaign', campaign?: { __typename?: 'JobBoardCampaignType', id: string, name?: string | null, platform: PaymentJobBoardCampaignPlatformChoices } | null } | null };

export type SyncCampaignsMutationVariables = Exact<{
  employerId: Scalars['String'];
}>;


export type SyncCampaignsMutation = { __typename?: 'Mutation', syncCampaigns?: { __typename?: 'SyncCampaigns', updated?: boolean | null } | null };

export type GetCandidateNameQueryVariables = Exact<{
  handle?: InputMaybe<Scalars['String']>;
}>;


export type GetCandidateNameQuery = { __typename?: 'Query', profile?: { __typename?: 'CandidateProfileType', id: string, rowId?: number | null, handle?: string | null, lastInterview?: { __typename?: 'InterviewType', id: string, status: ApiInterviewStatusChoices } | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string } } | null };

export type GetCandidateQueryVariables = Exact<{
  handle?: InputMaybe<Scalars['String']>;
}>;


export type GetCandidateQuery = { __typename?: 'Query', profile?: { __typename?: 'CandidateProfileType', id: string, rowId?: number | null, resume?: string | null, resumeUploadDate?: any | null, profileVideo?: string | null, personalSummary: string, yearsExperience: string, handle?: string | null, positions?: Array<string | null> | null, canHaveDressCode?: boolean | null, isBenefitsRequired?: boolean | null, additionalTraining?: Array<string | null> | null, status?: string | null, availabilityMonday?: Array<string | null> | null, availabilityTuesday?: Array<string | null> | null, availabilityWednesday?: Array<string | null> | null, availabilityThursday?: Array<string | null> | null, availabilityFriday?: Array<string | null> | null, availabilitySaturday?: Array<string | null> | null, availabilitySunday?: Array<string | null> | null, addressPostalCode?: string | null, commutePreference: string, employmentPreferences?: Array<string | null> | null, hasAppliedToEmployer?: boolean | null, user: { __typename?: 'UserType', id: string, rowId?: number | null, uuid: any, firstName: string, lastName: string, profileImage?: string | null, phone?: string | null, email?: string | null }, lastInterview?: { __typename?: 'InterviewType', id: string, status: ApiInterviewStatusChoices, scheduledFor?: any | null, ics?: string | null, interviewType?: string | null, location?: { __typename?: 'LocationType', id: string, name: string } | null, position?: { __typename?: 'PositionType', id: string, positionName: string } | null } | null, lastPositionApplication?: { __typename?: 'PositionApplicationType', id: string, createdAt: any, position: { __typename?: 'PositionType', id: string, positionName: string, slug: string, location: { __typename?: 'LocationType', id: string, name: string, formattedAddress?: string | null, image?: string | null } } } | null, endorsements?: { __typename?: 'EndorsementTypeConnection', edges: Array<{ __typename?: 'EndorsementTypeEdge', node?: { __typename?: 'EndorsementType', id: string, employerName?: string | null, body: string, createdAt: any, endorser?: { __typename?: 'UserType', id: string, firstName: string } | null } | null } | null> } | null, workHistory: { __typename?: 'CandidateWorkHistoryTypeConnection', edges: Array<{ __typename?: 'CandidateWorkHistoryTypeEdge', node?: { __typename?: 'CandidateWorkHistoryType', id: string, position?: string | null, responsibilities?: string | null, employerName: string, start?: any | null, end?: any | null, present: boolean, location?: { __typename?: 'LocationType', id: string, slug: string, image?: string | null } | null } | null } | null> } } | null };

export type GetCandidateWithApplicantsQueryVariables = Exact<{
  handle?: InputMaybe<Scalars['String']>;
}>;


export type GetCandidateWithApplicantsQuery = { __typename?: 'Query', profile?: { __typename?: 'CandidateProfileType', id: string, rowId?: number | null, resume?: string | null, resumeUploadDate?: any | null, profileVideo?: string | null, personalSummary: string, yearsExperience: string, handle?: string | null, positions?: Array<string | null> | null, canHaveDressCode?: boolean | null, isBenefitsRequired?: boolean | null, additionalTraining?: Array<string | null> | null, status?: string | null, availabilityMonday?: Array<string | null> | null, availabilityTuesday?: Array<string | null> | null, availabilityWednesday?: Array<string | null> | null, availabilityThursday?: Array<string | null> | null, availabilityFriday?: Array<string | null> | null, availabilitySaturday?: Array<string | null> | null, availabilitySunday?: Array<string | null> | null, addressPostalCode?: string | null, commutePreference: string, employmentPreferences?: Array<string | null> | null, hasAppliedToEmployer?: boolean | null, user: { __typename?: 'UserType', id: string, rowId?: number | null, uuid: any, firstName: string, lastName: string, profileImage?: string | null, phone?: string | null, email?: string | null }, lastInterview?: { __typename?: 'InterviewType', id: string, status: ApiInterviewStatusChoices, scheduledFor?: any | null, ics?: string | null, interviewType?: string | null, phoneNumber?: string | null, meetingUrl?: string | null, interviewer?: { __typename?: 'InterviewAttendeeType', user?: { __typename?: 'UserType', firstName: string, lastName: string, email?: string | null } | null } | null, location?: { __typename?: 'LocationType', id: string, name: string, displayName?: string | null, formattedAddress?: string | null } | null, position?: { __typename?: 'PositionType', id: string, positionName: string } | null } | null, lastPositionApplication?: { __typename?: 'PositionApplicationType', id: string, platform?: string | null, platformAttribution?: string | null, createdAt: any, position: { __typename?: 'PositionType', id: string, positionName: string, slug: string, location: { __typename?: 'LocationType', id: string, name: string, formattedAddress?: string | null, displayName?: string | null, image?: string | null } } } | null, endorsements?: { __typename?: 'EndorsementTypeConnection', edges: Array<{ __typename?: 'EndorsementTypeEdge', node?: { __typename?: 'EndorsementType', id: string, employerName?: string | null, body: string, createdAt: any, endorser?: { __typename?: 'UserType', id: string, firstName: string } | null } | null } | null> } | null, workHistory: { __typename?: 'CandidateWorkHistoryTypeConnection', edges: Array<{ __typename?: 'CandidateWorkHistoryTypeEdge', node?: { __typename?: 'CandidateWorkHistoryType', id: string, position?: string | null, responsibilities?: string | null, employerName: string, start?: any | null, end?: any | null, present: boolean, location?: { __typename?: 'LocationType', id: string, slug: string, image?: string | null } | null } | null } | null> }, applicationsForEmployer?: { __typename?: 'PositionApplicationTypeConnection', edges: Array<{ __typename?: 'PositionApplicationTypeEdge', node?: { __typename?: 'PositionApplicationType', id: string, createdAt: any, viewedAt?: any | null, position: { __typename?: 'PositionType', id: string, positionName: string, slug: string, location: { __typename?: 'LocationType', id: string, name: string, displayName?: string | null, formattedAddress?: string | null, image?: string | null } } } | null } | null> } | null } | null };

export type GetMatchQueryVariables = Exact<{
  position: Scalars['ID'];
  handle: Scalars['String'];
}>;


export type GetMatchQuery = { __typename?: 'Query', match?: { __typename?: 'MatchType', id: string, hiddenAt?: any | null, candidateStatus?: string | null, application?: { __typename?: 'PositionApplicationType', id: string, createdAt: any, viewedAt?: any | null, position: { __typename?: 'PositionType', id: string, positionName: string, location: { __typename?: 'LocationType', id: string, name: string } } } | null, lastEmployerInterview?: { __typename?: 'InterviewType', id: string, status: ApiInterviewStatusChoices, scheduledFor?: any | null, location?: { __typename?: 'LocationType', id: string, name: string, formattedAddress?: string | null } | null, position?: { __typename?: 'PositionType', id: string, positionName: string } | null } | null } | null };

export type PositionApplicationMutationVariables = Exact<{
  id: Scalars['ID'];
  status?: InputMaybe<Scalars['String']>;
  setViewedAt?: InputMaybe<Scalars['Boolean']>;
}>;


export type PositionApplicationMutation = { __typename?: 'Mutation', mutatePositionApplication?: { __typename?: 'PositionApplicationMutationPayload', positionApplication?: { __typename?: 'PositionApplicationType', id: string, status: EmployersPositionApplicationStatusChoices, viewedAt?: any | null } | null } | null };

export type EmployerRejectionReasonMutationVariables = Exact<{
  employerProfile?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
}>;


export type EmployerRejectionReasonMutation = { __typename?: 'Mutation', mutateEmployerRejectionReason?: { __typename?: 'EmployerRejectionReasonMutationPayload', employerRejectionReason?: { __typename?: 'EmployerRejectionReasonType', name: string, employerProfile: { __typename?: 'EmployerProfileType', id: string } } | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type MutateBulkMoveEmployerCandidateMutationVariables = Exact<{
  oldStage?: InputMaybe<Scalars['ID']>;
  newStage: Scalars['ID'];
  all?: InputMaybe<Scalars['Boolean']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  positions?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  employerCandidateIds: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
  notificationStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  notificationType?: InputMaybe<Scalars['String']>;
  notificationStatusToUpdate?: InputMaybe<Scalars['String']>;
}>;


export type MutateBulkMoveEmployerCandidateMutation = { __typename?: 'Mutation', bulkMoveEmployerCandidatesToStage?: { __typename?: 'BulkMoveEmployerCandidateMutation', moved?: boolean | null, movedCandidatesCount?: number | null, stageName?: string | null, candidateName?: string | null } | null };

export type MatchCountQueryQueryVariables = Exact<{
  position?: InputMaybe<Scalars['ID']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type MatchCountQueryQuery = { __typename?: 'Query', matchFilterCounts?: { __typename?: 'MatchFilterCountsType', bestMatchCount?: number | null, appliedCount?: number | null, pendingCount?: number | null, acceptedCount?: number | null, declinedCount?: number | null, scheduledCount?: number | null, followerCount?: number | null, postInterviewCount?: number | null } | null };

export type EmployerCandidateNoteQueryVariables = Exact<{
  employerCandidate: Scalars['ID'];
}>;


export type EmployerCandidateNoteQuery = { __typename?: 'Query', employerCandidateNote?: { __typename?: 'EmployerCandidateNoteType', id: string, text?: string | null, createdAt?: any | null, updatedAt?: any | null, archivedAt?: any | null, createdBy: { __typename?: 'UserType', id: string }, updatedBy: { __typename?: 'UserType', id: string } } | null };

export type MutateCreateEmployerCandidateMutationVariables = Exact<{
  employerCandidate?: InputMaybe<Scalars['ID']>;
  text?: InputMaybe<Scalars['String']>;
}>;


export type MutateCreateEmployerCandidateMutation = { __typename?: 'Mutation', mutateEmployerCandidateNote?: { __typename?: 'EmployerCandidateNoteMutationPayload', employerCandidateNoteType?: { __typename?: 'EmployerCandidateNoteType', id: string, text?: string | null, createdAt?: any | null, updatedAt?: any | null, archivedAt?: any | null, createdBy: { __typename?: 'UserType', id: string }, updatedBy: { __typename?: 'UserType', id: string } } | null } | null };

export type DismissNotificationMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
}>;


export type DismissNotificationMutation = { __typename?: 'Mutation', dismissNotification?: { __typename?: 'DismissNotification', notification?: { __typename?: 'EmployerCandidateNotificationType', id: string, dismissedAt?: any | null } | null } | null };

export type EmployerCandidatesQueryVariables = Exact<{
  employerCandidateId?: InputMaybe<Scalars['ID']>;
  stageId?: InputMaybe<Scalars['ID']>;
  positions?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  notificationType?: InputMaybe<Scalars['String']>;
  notificationStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  profileDetailFilters?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  sortBy?: InputMaybe<EmployerCandidateSortByEnum>;
}>;


export type EmployerCandidatesQuery = { __typename?: 'Query', employerCandidates?: { __typename?: 'EmployerCandidateTypeConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'EmployerCandidateTypeEdge', node?: { __typename?: 'EmployerCandidateType', id: string, createdAt?: any | null, updatedAt?: any | null, sevenshiftsId?: string | null, hasNote?: boolean | null, preferredMatch?: { __typename?: 'MatchType', id: string, position: { __typename?: 'PositionType', id: string, positionName: string, location: { __typename?: 'LocationType', id: string, name: string } } } | null, candidateProfile: { __typename?: 'CandidateProfileType', id: string, handle?: string | null, positions?: Array<string | null> | null, user: { __typename?: 'UserType', id: string, uuid: any, firstName: string, lastName: string, profileImage?: string | null, email?: string | null, phone?: string | null } }, employercandidateNotifications: { __typename?: 'EmployerCandidateNotificationTypeConnection', edges: Array<{ __typename?: 'EmployerCandidateNotificationTypeEdge', node?: { __typename?: 'EmployerCandidateNotificationType', id: string, notificationType: EmployersEmployerCandidateNotificationNotificationTypeChoices, dismissedAt?: any | null, rowId?: number | null, message?: string | null, status: EmployersEmployerCandidateNotificationStatusChoices, color?: string | null, actions?: Array<string | null> | null } | null } | null> }, chatNotification?: { __typename?: 'EmployerCandidateNotificationType', id: string, notificationType: EmployersEmployerCandidateNotificationNotificationTypeChoices, dismissedAt?: any | null, rowId?: number | null, message?: string | null, status: EmployersEmployerCandidateNotificationStatusChoices, color?: string | null, actions?: Array<string | null> | null } | null, rejectionReasons: { __typename?: 'EmployerRejectionReasonTypeConnection', edges: Array<{ __typename?: 'EmployerRejectionReasonTypeEdge', node?: { __typename?: 'EmployerRejectionReasonType', id: string, name: string } | null } | null> } } | null } | null> } | null };

export type EmployerCandidateNotificationsQueryVariables = Exact<{
  employerCandidateIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  stageId?: InputMaybe<Scalars['ID']>;
  positions?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type EmployerCandidateNotificationsQuery = { __typename?: 'Query', employerCandidates?: { __typename?: 'EmployerCandidateTypeConnection', edges: Array<{ __typename?: 'EmployerCandidateTypeEdge', node?: { __typename?: 'EmployerCandidateType', id: string, createdAt?: any | null, updatedAt?: any | null, sevenshiftsId?: string | null, sevenshiftsUrl?: string | null, candidateProfile: { __typename?: 'CandidateProfileType', id: string, handle?: string | null, positions?: Array<string | null> | null, user: { __typename?: 'UserType', id: string, uuid: any, firstName: string, lastName: string, profileImage?: string | null, email?: string | null, phone?: string | null } }, employercandidateNotifications: { __typename?: 'EmployerCandidateNotificationTypeConnection', edges: Array<{ __typename?: 'EmployerCandidateNotificationTypeEdge', node?: { __typename?: 'EmployerCandidateNotificationType', id: string, notificationType: EmployersEmployerCandidateNotificationNotificationTypeChoices, dismissedAt?: any | null, rowId?: number | null, message?: string | null, status: EmployersEmployerCandidateNotificationStatusChoices, color?: string | null, actions?: Array<string | null> | null } | null } | null> }, rejectionReasons: { __typename?: 'EmployerRejectionReasonTypeConnection', edges: Array<{ __typename?: 'EmployerRejectionReasonTypeEdge', node?: { __typename?: 'EmployerRejectionReasonType', id: string, name: string } | null } | null> } } | null } | null> } | null };

export type EmployerStagesQueryVariables = Exact<{
  locations?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  positions?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  profileDetailFilters?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  stageUpdatedAtLte?: InputMaybe<Scalars['DateTime']>;
  stageUpdatedAtGte?: InputMaybe<Scalars['DateTime']>;
}>;


export type EmployerStagesQuery = { __typename?: 'Query', employerStages?: { __typename?: 'EmployerStageTypeConnection', edges: Array<{ __typename?: 'EmployerStageTypeEdge', node?: { __typename?: 'EmployerStageType', id: string, name: string, ordering: number, stageType: EmployersEmployerStageStageTypeChoices, slug: string, employerCandidateCount?: number | null, hasNotification?: boolean | null, refreshNotificationCount?: number | null } | null } | null> } | null };

export type AgendaEventsQueryVariables = Exact<{
  startTime?: InputMaybe<Scalars['DateTime']>;
  endTime?: InputMaybe<Scalars['DateTime']>;
  positions?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type AgendaEventsQuery = { __typename?: 'Query', agendaEvents?: Array<{ __typename?: 'AgendaType', title?: string | null, desc?: string | null, participants?: Array<string | null> | null, start?: any | null, end?: any | null, dateOfInterview?: any | null, interviewId?: string | null, interviewUuid?: string | null, interviewType?: string | null, meetingUrl?: string | null, phoneNumber?: string | null, locationOfInterview?: { __typename?: 'LocationType', id: string, name: string, formattedAddress?: string | null } | null, positionOfInterview?: { __typename?: 'PositionType', id: string, positionName: string } | null, interviewRequester?: { __typename?: 'EmployerProfileType', id: string } | null, createdBy?: { __typename?: 'UserType', firstName: string, lastName: string } | null, employerCandidate?: { __typename?: 'EmployerCandidateType', id: string, candidateProfile: { __typename?: 'CandidateProfileType', handle?: string | null, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string, profileImage?: string | null } }, stage?: { __typename?: 'EmployerStageType', id: string, name: string } | null, preferredMatch?: { __typename?: 'MatchType', id: string, position: { __typename?: 'PositionType', id: string, location: { __typename?: 'LocationType', id: string } } } | null } | null } | null> | null };

export type GetEmployerDocumentsQueryVariables = Exact<{
  document_type?: InputMaybe<EmployersEmploymentDocumentDocumentTypeChoices>;
  candidate?: InputMaybe<Scalars['ID']>;
}>;


export type GetEmployerDocumentsQuery = { __typename?: 'Query', getEmployerDocuments?: { __typename?: 'EmploymentDocumentTypeConnection', edges: Array<{ __typename?: 'EmploymentDocumentTypeEdge', node?: { __typename?: 'EmploymentDocumentType', id: string, documentType?: EmployersEmploymentDocumentDocumentTypeChoices | null, baseSalaryValue?: number | null, baseSalaryUnitText?: EmployersEmploymentDocumentBaseSalaryUnitTextChoices | null, status?: EmployersEmploymentDocumentStatusChoices | null, acceptedDeclinedAt?: any | null, contactName?: string | null, contactPhone?: string | null, startingAt?: any | null, note?: string | null, position: { __typename?: 'PositionType', id: string, positionName: string }, employmentdocumentfileSet: { __typename?: 'EmploymentDocumentFileTypeConnection', edges: Array<{ __typename?: 'EmploymentDocumentFileTypeEdge', node?: { __typename?: 'EmploymentDocumentFileType', id: string, name?: string | null, attachment?: string | null, size?: string | null, url?: string | null } | null } | null> } } | null } | null> } | null };

export type RejectCandidatesMutationVariables = Exact<{
  employerCandidates?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  all?: InputMaybe<Scalars['Boolean']>;
  positions?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  stage: Scalars['ID'];
  rejectReasons?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type RejectCandidatesMutation = { __typename?: 'Mutation', rejectCandidates?: { __typename?: 'RejectCandidates', employerCandidates?: Array<{ __typename?: 'EmployerCandidateType', id: string, rejectionReasons: { __typename?: 'EmployerRejectionReasonTypeConnection', edges: Array<{ __typename?: 'EmployerRejectionReasonTypeEdge', node?: { __typename?: 'EmployerRejectionReasonType', name: string } | null } | null> } } | null> | null } | null };

export type SearchEmployerCandidatesQueryVariables = Exact<{
  search: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type SearchEmployerCandidatesQuery = { __typename?: 'Query', searchEmployerCandidates?: { __typename?: 'EmployerCandidateDetailsViewTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'EmployerCandidateDetailsViewTypeEdge', node?: { __typename?: 'EmployerCandidateDetailsViewType', employerCandidateId?: string | null, userId?: string | null, firstName: string, lastName: string, email: string, positionId?: string | null, positionName: string, locationId?: string | null, locationName: string, stageId?: string | null, isSelectable?: boolean | null, isArchived?: boolean | null } | null } | null>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null } } | null };

export type SelectedEmployerCandidatesQueryVariables = Exact<{
  employerCandidateIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  stageId?: InputMaybe<Scalars['ID']>;
  positions?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type SelectedEmployerCandidatesQuery = { __typename?: 'Query', employerCandidates?: { __typename?: 'EmployerCandidateTypeConnection', edges: Array<{ __typename?: 'EmployerCandidateTypeEdge', node?: { __typename?: 'EmployerCandidateType', id: string, candidateProfile: { __typename?: 'CandidateProfileType', id: string, handle?: string | null, positions?: Array<string | null> | null, addressPostalCode?: string | null, personalSummary: string, resume?: string | null, user: { __typename?: 'UserType', id: string, email?: string | null, phone?: string | null, firstName: string, lastName: string, profileImage?: string | null } } } | null } | null> } | null };

export type UnrejectCandidatesMutationVariables = Exact<{
  employerCandidates: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  positions?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  all?: InputMaybe<Scalars['Boolean']>;
}>;


export type UnrejectCandidatesMutation = { __typename?: 'Mutation', unrejectCandidates?: { __typename?: 'UnrejectCandidates', toStage?: { __typename?: 'EmployerStageType', id: string } | null } | null };

export type MutateUpdateEmployerCandidateMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  text?: InputMaybe<Scalars['String']>;
}>;


export type MutateUpdateEmployerCandidateMutation = { __typename?: 'Mutation', mutateEmployerCandidateNote?: { __typename?: 'EmployerCandidateNoteMutationPayload', employerCandidateNoteType?: { __typename?: 'EmployerCandidateNoteType', id: string, text?: string | null, createdAt?: any | null, updatedAt?: any | null, archivedAt?: any | null, createdBy: { __typename?: 'UserType', id: string }, updatedBy: { __typename?: 'UserType', id: string } } | null } | null };

export type GetMyMatchesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetMyMatchesQuery = { __typename?: 'Query', myMatches?: { __typename?: 'MatchTypeConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'MatchTypeEdge', node?: { __typename?: 'MatchType', id: string, position: { __typename?: 'PositionType', id: string, rowId?: number | null, slug: string, positionName: string, updatedAt: any, hasApplied?: boolean | null, positionType?: Array<string | null> | null, createdAt: any, baseSalaryMin?: number | null, baseSalaryMax?: number | null, baseSalaryUnitText?: string | null, isNonPartner?: boolean | null, externalApplyUrl?: string | null, createdBy?: { __typename?: 'UserType', id: string, profileImage?: string | null, firstName: string } | null, location: { __typename?: 'LocationType', id: string, name: string, slug: string, image?: string | null } } } | null } | null> } | null };

export type SearchInterviewPositionsQueryVariables = Exact<{
  searchTerms?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
  hasApplied?: InputMaybe<Scalars['Boolean']>;
  hasInterview?: InputMaybe<Scalars['Boolean']>;
  interviewStatus?: InputMaybe<Scalars['String']>;
  canHaveDressCode?: InputMaybe<Scalars['Boolean']>;
  isBenefitsRequired?: InputMaybe<Scalars['Boolean']>;
}>;


export type SearchInterviewPositionsQuery = { __typename?: 'Query', positions?: { __typename?: 'PositionTypeConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'PositionTypeEdge', node?: { __typename?: 'PositionType', id: string, rowId?: number | null, slug: string, positionName: string, positionType?: Array<string | null> | null, updatedAt: any, hasApplied?: boolean | null, appliedAt?: string | null, baseSalaryMin?: number | null, baseSalaryMax?: number | null, baseSalaryUnitText?: string | null, myInterview?: { __typename?: 'InterviewType', id: string, uuid?: string | null, scheduledFor?: any | null, status: ApiInterviewStatusChoices, createdAt: any, interviewType?: string | null, phoneNumber?: string | null, meetingUrl?: string | null, createdBy?: { __typename?: 'UserType', id: string, uuid: any, profileImage?: string | null, firstName: string, hasSchedule?: boolean | null } | null } | null, createdBy?: { __typename?: 'UserType', id: string, profileImage?: string | null, firstName: string } | null, location: { __typename?: 'LocationType', id: string, name: string, slug: string, image?: string | null, formattedAddress?: string | null } } | null } | null> } | null };

export type SearchPositionsQueryVariables = Exact<{
  searchTerms?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
  hasApplied?: InputMaybe<Scalars['Boolean']>;
  hasInterview?: InputMaybe<Scalars['Boolean']>;
  canHaveDressCode?: InputMaybe<Scalars['Boolean']>;
  isBenefitsRequired?: InputMaybe<Scalars['Boolean']>;
  hiring?: InputMaybe<Scalars['Boolean']>;
  showBestMatch?: InputMaybe<Scalars['Boolean']>;
  sortBy?: InputMaybe<Scalars['String']>;
}>;


export type SearchPositionsQuery = { __typename?: 'Query', positions?: { __typename?: 'PositionTypeConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'PositionTypeEdge', node?: { __typename?: 'PositionType', id: string, slug: string, positionName: string, positionType?: Array<string | null> | null, updatedAt: any, hasApplied?: boolean | null, appliedAt?: string | null, baseSalaryMin?: number | null, baseSalaryMax?: number | null, baseSalaryUnitText?: string | null, isNonPartner?: boolean | null, posted: any, externalApplyUrl?: string | null, isMatch?: boolean | null, positionapplicationSet: { __typename?: 'PositionApplicationTypeConnection', edges: Array<{ __typename?: 'PositionApplicationTypeEdge', node?: { __typename?: 'PositionApplicationType', id: string, status: EmployersPositionApplicationStatusChoices } | null } | null> }, createdBy?: { __typename?: 'UserType', id: string, uuid: any, profileImage?: string | null, firstName: string } | null, location: { __typename?: 'LocationType', id: string, name: string, slug: string, image?: string | null } } | null } | null> } | null };

export type TypeAheadSearchQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type TypeAheadSearchQuery = { __typename?: 'Query', searchAhead?: { __typename?: 'SearchAheadGroupsType', groups?: Array<{ __typename?: 'SearchAheadGroupType', group?: string | null, values?: Array<{ __typename?: 'SearchAheadType', value?: string | null, label?: string | null } | null> | null } | null> | null } | null };

export type SortByOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type SortByOptionsQuery = { __typename?: 'Query', candidateSearchSortByOptions?: Array<CandidateSortByEnum | null> | null };

export type MutateCreateEmployerCandidatesMutationVariables = Exact<{
  candidateHandles?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  positionId?: InputMaybe<Scalars['ID']>;
  moveToStageId?: InputMaybe<Scalars['ID']>;
}>;


export type MutateCreateEmployerCandidatesMutation = { __typename?: 'Mutation', createEmployerCandidates?: { __typename?: 'CreateEmployerCandidatesMutation', created?: boolean | null, employerCandidates?: Array<{ __typename?: 'EmployerCandidateType', id: string, stage?: { __typename?: 'EmployerStageType', id: string, name: string } | null, candidateProfile: { __typename?: 'CandidateProfileType', id: string, handle?: string | null } } | null> | null } | null };

export type GetZipcodeForLatLngQueryVariables = Exact<{
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
}>;


export type GetZipcodeForLatLngQuery = { __typename?: 'Query', zipcodeForCoordinates?: { __typename?: 'ZipcodeType', zipcode?: string | null } | null };

export type MutateInviteToApplyMutationVariables = Exact<{
  candidateHandles?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  positionId?: InputMaybe<Scalars['ID']>;
  locationId?: InputMaybe<Scalars['ID']>;
  message?: InputMaybe<Scalars['String']>;
}>;


export type MutateInviteToApplyMutation = { __typename?: 'Mutation', inviteToApply?: { __typename?: 'InviteToApplyMutation', created?: boolean | null } | null };

export type SearchAheadNetworkQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type SearchAheadNetworkQuery = { __typename?: 'Query', searchAheadNetwork?: { __typename?: 'SearchAheadGroupsType', groups?: Array<{ __typename?: 'SearchAheadGroupType', group?: string | null, values?: Array<{ __typename?: 'SearchAheadType', label?: string | null, value?: string | null } | null> | null } | null> | null } | null };

export type CandidateSearchFilterGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type CandidateSearchFilterGroupsQuery = { __typename?: 'Query', candidateSearchFilterGroups?: Array<{ __typename?: 'ProfileFilterGroupType', name?: string | null, operator?: string | null, filterItems?: Array<string | null> | null } | null> | null };

export type SearchFilterGroupsQueryVariables = Exact<{ [key: string]: never; }>;


export type SearchFilterGroupsQuery = { __typename?: 'Query', candidateSearchFilterGroups?: Array<{ __typename?: 'ProfileFilterGroupType', name?: string | null, operator?: string | null, filterItems?: Array<string | null> | null } | null> | null };

export type SearchProfilesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  searchTerms?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  profileDetailFilters?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  addressPostalCode?: InputMaybe<Scalars['String']>;
  milesFromCenterZip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<CandidateSortByEnum>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type SearchProfilesQuery = { __typename?: 'Query', searchProfiles?: { __typename?: 'CandidateProfileTypeConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'CandidateProfileTypeEdge', node?: { __typename?: 'CandidateProfileType', id: string, positions?: Array<string | null> | null, canHaveDressCode?: boolean | null, isBenefitsRequired?: boolean | null, employmentPreferences?: Array<string | null> | null, personalSummary: string, profileVideo?: string | null, status?: string | null, hasResume?: boolean | null, hasEndorsements?: boolean | null, hasContactInformation?: boolean | null, handle?: string | null, addressPostalCode?: string | null, yearsExperience: string, resume?: string | null, resumeUploadDate?: any | null, employerCandidate?: { __typename?: 'EmployerCandidateType', id: string } | null, user: { __typename?: 'UserType', id: string, uuid: any, profileImage?: string | null, firstName: string, lastName: string }, workHistory: { __typename?: 'CandidateWorkHistoryTypeConnection', edges: Array<{ __typename?: 'CandidateWorkHistoryTypeEdge', node?: { __typename?: 'CandidateWorkHistoryType', id: string, position?: string | null, location?: { __typename?: 'LocationType', id: string, name: string, addressCity: string, addressPostalCode: string } | null } | null } | null> } } | null } | null> } | null };

export type SearchProfilesCountQueryVariables = Exact<{
  searchTerms?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  profileDetailFilters?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  addressPostalCode?: InputMaybe<Scalars['String']>;
  milesFromCenterZip?: InputMaybe<Scalars['Int']>;
  sortBy?: InputMaybe<CandidateSortByEnum>;
}>;


export type SearchProfilesCountQuery = { __typename?: 'Query', searchProfilesCount?: { __typename?: 'ProfileCountType', count?: number | null } | null };

export type UpdateCandidateProfileImageMutationVariables = Exact<{
  id: Scalars['ID'];
  profileImageId?: InputMaybe<Scalars['ID']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  addressPostalCode?: InputMaybe<Scalars['String']>;
  commutePreference?: InputMaybe<Scalars['String']>;
}>;


export type UpdateCandidateProfileImageMutation = { __typename?: 'Mutation', mutateCandidate?: { __typename?: 'CandidateProfileMutationPayload', errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, candidateProfile?: { __typename?: 'CandidateProfileType', id: string, profileVideo?: string | null, addressPostalCode?: string | null, profileCompleteness?: number | null, incompleteSections?: Array<string | null> | null, commutePreference: string, user: { __typename?: 'UserType', id: string, email?: string | null, phone?: string | null, firstName: string, lastName: string, profileImage?: string | null } } | null } | null };

export type UpdateCandidateMutationVariables = Exact<{
  id: Scalars['ID'];
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  hasCompletedOnboarding?: InputMaybe<Scalars['Boolean']>;
  profileVideoId?: InputMaybe<Scalars['ID']>;
  positions?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  availabilityMonday?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  availabilityTuesday?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  availabilityWednesday?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  availabilityThursday?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  availabilityFriday?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  availabilitySaturday?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  availabilitySunday?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  personalSummary?: InputMaybe<Scalars['String']>;
  restaurantTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  additionalTraining?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  yearsExperience?: InputMaybe<Scalars['String']>;
  employmentPreferences?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  addressPostalCode?: InputMaybe<Scalars['String']>;
  commutePreference?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  canHaveDressCode?: InputMaybe<Scalars['Boolean']>;
  isBenefitsRequired?: InputMaybe<Scalars['Boolean']>;
}>;


export type UpdateCandidateMutation = { __typename?: 'Mutation', mutateCandidate?: { __typename?: 'CandidateProfileMutationPayload', errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, candidateProfile?: { __typename?: 'CandidateProfileType', id: string, profileVideo?: string | null, addressPostalCode?: string | null, positions?: Array<string | null> | null, availabilityMonday?: Array<string | null> | null, availabilityTuesday?: Array<string | null> | null, availabilityWednesday?: Array<string | null> | null, availabilityThursday?: Array<string | null> | null, availabilityFriday?: Array<string | null> | null, availabilitySaturday?: Array<string | null> | null, availabilitySunday?: Array<string | null> | null, personalSummary: string, restaurantTypes?: Array<string | null> | null, additionalTraining?: Array<string | null> | null, yearsExperience: string, employmentPreferences?: Array<string | null> | null, commutePreference: string, onboardingCompletedAt?: any | null, isBenefitsRequired?: boolean | null, canHaveDressCode?: boolean | null, status?: string | null, profileCompleteness?: number | null, incompleteSections?: Array<string | null> | null, lastMatchCreation?: any | null, user: { __typename?: 'UserType', id: string, email?: string | null, phone?: string | null, firstName: string, lastName: string } } | null } | null };

export type SoftDeleteCandidateUserMutationVariables = Exact<{
  userId: Scalars['String'];
}>;


export type SoftDeleteCandidateUserMutation = { __typename?: 'Mutation', softDeleteCandidateUser?: { __typename?: 'SoftDeleteCandidateUser', deleted?: string | null } | null };

export type MutateDeleteMyResumeMutationVariables = Exact<{ [key: string]: never; }>;


export type MutateDeleteMyResumeMutation = { __typename?: 'Mutation', deleteMyResume?: { __typename?: 'DeleteMyResumeMutation', candidateProfile?: { __typename?: 'CandidateProfileType', id: string, resume?: string | null, profileCompleteness?: number | null, incompleteSections?: Array<string | null> | null } | null } | null };

export type DeleteWorkHistoryMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;


export type DeleteWorkHistoryMutation = { __typename?: 'Mutation', deleteWorkHistory?: { __typename?: 'DeleteCandidateWorkHistoryMutationPayload', id?: string | null, message?: string | null } | null };

export type GetEmployerCandidateForHandleQueryVariables = Exact<{
  handle?: InputMaybe<Scalars['String']>;
}>;


export type GetEmployerCandidateForHandleQuery = { __typename?: 'Query', profile?: { __typename?: 'CandidateProfileType', id: string, handle?: string | null, employerCandidate?: { __typename?: 'EmployerCandidateType', id: string, createdAt?: any | null, updatedAt?: any | null, sevenshiftsId?: string | null, hasNote?: boolean | null, preferredMatch?: { __typename?: 'MatchType', id: string, position: { __typename?: 'PositionType', id: string, positionName: string, location: { __typename?: 'LocationType', id: string, name: string } } } | null, stage?: { __typename?: 'EmployerStageType', id: string, name: string } | null, candidateProfile: { __typename?: 'CandidateProfileType', id: string, handle?: string | null, positions?: Array<string | null> | null, user: { __typename?: 'UserType', id: string, uuid: any, firstName: string, lastName: string, profileImage?: string | null, email?: string | null, phone?: string | null } }, chatNotification?: { __typename?: 'EmployerCandidateNotificationType', id: string, notificationType: EmployersEmployerCandidateNotificationNotificationTypeChoices, dismissedAt?: any | null, rowId?: number | null, message?: string | null, status: EmployersEmployerCandidateNotificationStatusChoices, color?: string | null, actions?: Array<string | null> | null } | null, employercandidateNotifications: { __typename?: 'EmployerCandidateNotificationTypeConnection', edges: Array<{ __typename?: 'EmployerCandidateNotificationTypeEdge', node?: { __typename?: 'EmployerCandidateNotificationType', id: string, notificationType: EmployersEmployerCandidateNotificationNotificationTypeChoices, dismissedAt?: any | null, rowId?: number | null, message?: string | null, status: EmployersEmployerCandidateNotificationStatusChoices, color?: string | null, actions?: Array<string | null> | null } | null } | null> }, rejectionReasons: { __typename?: 'EmployerRejectionReasonTypeConnection', edges: Array<{ __typename?: 'EmployerRejectionReasonTypeEdge', node?: { __typename?: 'EmployerRejectionReasonType', id: string, name: string } | null } | null> } } | null } | null };

export type GetIsFollowingLocationsQueryVariables = Exact<{
  handle?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
}>;


export type GetIsFollowingLocationsQuery = { __typename?: 'Query', profile?: { __typename?: 'CandidateProfileType', id: string, isFollowingLocations?: boolean | null } | null };

export type GetMyProfileCompletenessQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyProfileCompletenessQuery = { __typename?: 'Query', me?: { __typename?: 'UserType', id: string, candidateProfile?: { __typename?: 'CandidateProfileType', id: string, handle?: string | null, profileCompleteness?: number | null, incompleteSections?: Array<string | null> | null } | null } | null };

export type GetMyWorkHistoryDetailQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyWorkHistoryDetailQuery = { __typename?: 'Query', me?: { __typename?: 'UserType', id: string, candidateProfile?: { __typename?: 'CandidateProfileType', id: string, workHistory: { __typename: 'CandidateWorkHistoryTypeConnection', edges: Array<{ __typename?: 'CandidateWorkHistoryTypeEdge', node?: { __typename: 'CandidateWorkHistoryType', id: string, employerName: string, responsibilities?: string | null, position?: string | null, start?: any | null, end?: any | null, present: boolean, location?: { __typename?: 'LocationType', id: string, slug: string, name: string, formattedAddress?: string | null, image?: string | null } | null } | null } | null> } } | null } | null };

export type MutateCandidateResumeMutationVariables = Exact<{
  id: Scalars['ID'];
  resumeFileName?: InputMaybe<Scalars['String']>;
  resumeFileType?: InputMaybe<Scalars['String']>;
}>;


export type MutateCandidateResumeMutation = { __typename?: 'Mutation', mutateCandidate?: { __typename?: 'CandidateProfileMutationPayload', resumeUploadUrl?: string | null, candidateProfile?: { __typename?: 'CandidateProfileType', id: string, resume?: string | null, resumeUploadDate?: any | null, profileCompleteness?: number | null, incompleteSections?: Array<string | null> | null } | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type MutateWorkHistoryMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  employerName: Scalars['String'];
  location?: InputMaybe<Scalars['ID']>;
  position?: InputMaybe<Scalars['String']>;
  present?: InputMaybe<Scalars['Boolean']>;
  responsibilities?: InputMaybe<Scalars['String']>;
  start?: InputMaybe<Scalars['Date']>;
  end?: InputMaybe<Scalars['Date']>;
}>;


export type MutateWorkHistoryMutation = { __typename?: 'Mutation', mutateWorkHistory?: { __typename?: 'CandidateWorkHistoryMutationPayload', workHistory?: { __typename: 'CandidateWorkHistoryType', id: string, employerName: string, responsibilities?: string | null, position?: string | null, start?: any | null, end?: any | null, present: boolean, location?: { __typename?: 'LocationType', id: string, slug: string, name: string, formattedAddress?: string | null, image?: string | null } | null } | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type CreateCareerPageMutationVariables = Exact<{
  slug: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
  selectedLocations?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type CreateCareerPageMutation = { __typename?: 'Mutation', createCareerPageMutation?: { __typename?: 'CreateCareerPageMutationPayload', careerPageType?: { __typename?: 'CareerPageType', title?: string | null, slug: string, createdBy?: { __typename?: 'UserType', id: string } | null } | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type MutateDeleteCareerPageMutationVariables = Exact<{
  careerPageId?: InputMaybe<Scalars['ID']>;
}>;


export type MutateDeleteCareerPageMutation = { __typename?: 'Mutation', deleteCareerPage?: { __typename?: 'CareerPageDeleteMutation', deleted?: boolean | null } | null };

export type GetCareerPageAnswersDisplayQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type GetCareerPageAnswersDisplayQuery = { __typename?: 'Query', careerPageBySlug?: { __typename?: 'CareerPageTypeConnection', edges: Array<{ __typename?: 'CareerPageTypeEdge', node?: { __typename?: 'CareerPageType', id: string, answers: { __typename?: 'CareerPageAnswerTypeConnection', edges: Array<{ __typename?: 'CareerPageAnswerTypeEdge', node?: { __typename?: 'CareerPageAnswerType', response: string, question: { __typename?: 'QuestionType', icon?: string | null }, option?: { __typename?: 'QuestionOptionType', displayLabel?: string | null } | null } | null } | null> } } | null } | null> } | null };

export type GetCareerPageAnswersQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type GetCareerPageAnswersQuery = { __typename?: 'Query', careerPageBySlug?: { __typename?: 'CareerPageTypeConnection', edges: Array<{ __typename?: 'CareerPageTypeEdge', node?: { __typename?: 'CareerPageType', id: string, answers: { __typename?: 'CareerPageAnswerTypeConnection', edges: Array<{ __typename?: 'CareerPageAnswerTypeEdge', node?: { __typename?: 'CareerPageAnswerType', id: string, response: string, question: { __typename?: 'QuestionType', id: string, title: string, required: boolean, placeholder?: string | null, category: OnboardingQuestionCategoryChoices, questionType: OnboardingQuestionQuestionTypeChoices, icon?: string | null, options?: Array<{ __typename?: 'QuestionOptionType', id: string, label: string, value: string, ordering: number, displayLabel?: string | null } | null> | null }, option?: { __typename?: 'QuestionOptionType', id: string, label: string, value: string, ordering: number, displayLabel?: string | null } | null } | null } | null> } } | null } | null> } | null };

export type EditCareerPageMutationVariables = Exact<{
  addressCity?: InputMaybe<Scalars['String']>;
  addressPostalCode?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressStreet1?: InputMaybe<Scalars['String']>;
  addressStreet2?: InputMaybe<Scalars['String']>;
  brandColor?: InputMaybe<Scalars['String']>;
  brandPageColor?: InputMaybe<Scalars['String']>;
  brandTableColor?: InputMaybe<Scalars['String']>;
  coverColor?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  fontColor?: InputMaybe<Scalars['String']>;
  fontFamily?: InputMaybe<Scalars['String']>;
  selectedLocations?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  slug: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
}>;


export type EditCareerPageMutation = { __typename?: 'Mutation', mutateCareerPage?: { __typename?: 'CareerPageMutationPayload', coverImageUploadUrl?: string | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type UpdateCareerPageAnswersMutationVariables = Exact<{
  careerPage: Scalars['ID'];
  responses: Array<InputMaybe<CareerPageAnswerInputType>> | InputMaybe<CareerPageAnswerInputType>;
}>;


export type UpdateCareerPageAnswersMutation = { __typename?: 'Mutation', mutateCareerPageAnswer?: { __typename: 'CareerPageAnswerMutation' } | null };

export type MutateCareerPageLocationChatMutationVariables = Exact<{
  locationId?: InputMaybe<Scalars['ID']>;
  message?: InputMaybe<Scalars['String']>;
}>;


export type MutateCareerPageLocationChatMutation = { __typename?: 'Mutation', mutateCareerPageLocationMessage?: { __typename?: 'CareerPageLocationMessageMutation', response?: string | null } | null };

export type EditCareerPageWithCoverMutationVariables = Exact<{
  addressCity?: InputMaybe<Scalars['String']>;
  addressPostalCode?: InputMaybe<Scalars['String']>;
  addressState?: InputMaybe<Scalars['String']>;
  addressStreet1?: InputMaybe<Scalars['String']>;
  addressStreet2?: InputMaybe<Scalars['String']>;
  brandColor?: InputMaybe<Scalars['String']>;
  brandPageColor?: InputMaybe<Scalars['String']>;
  brandTableColor?: InputMaybe<Scalars['String']>;
  coverColor?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  fileName?: InputMaybe<Scalars['String']>;
  fileType?: InputMaybe<Scalars['String']>;
  fontColor?: InputMaybe<Scalars['String']>;
  fontFamily?: InputMaybe<Scalars['String']>;
  selectedLocations?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  slug: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
}>;


export type EditCareerPageWithCoverMutation = { __typename?: 'Mutation', mutateCareerPage?: { __typename?: 'CareerPageMutationPayload', coverImageUploadUrl?: string | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type EditCareerPageGalleryMutationVariables = Exact<{
  careerPage: Scalars['ID'];
  galleries: Array<InputMaybe<CareerPageGalleryCategories>> | InputMaybe<CareerPageGalleryCategories>;
}>;


export type EditCareerPageGalleryMutation = { __typename?: 'Mutation', mutateCreateCareerPageGallery?: { __typename?: 'CreateCareerPageGalleryMutation', urls?: Array<{ __typename?: 'CareerPageGallerySignedUrl', signedS3Url?: string | null, fileName?: string | null, link?: string | null } | null> | null } | null };

export type GetCareerPageDataQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type GetCareerPageDataQuery = { __typename?: 'Query', careerPageBySlug?: { __typename?: 'CareerPageTypeConnection', edges: Array<{ __typename?: 'CareerPageTypeEdge', node?: { __typename?: 'CareerPageType', id: string, title?: string | null, slug: string, cover?: string | null, brandColor?: string | null, brandPageColor?: string | null, brandTableColor?: string | null, coverColor?: string | null, fontFamily?: string | null, fontColor?: string | null, description?: string | null, addressCity?: string | null, addressState?: string | null, addressStreet1?: string | null, addressStreet2?: string | null, addressCountry?: string | null, formattedAddress?: string | null, addressPostalCode?: string | null, selectedLocations?: Array<string | null> | null, galleries: { __typename?: 'CareerPageGalleryTypeConnection', edges: Array<{ __typename?: 'CareerPageGalleryTypeEdge', node?: { __typename?: 'CareerPageGalleryType', id: string, category?: string | null, uploadFile?: string | null, getUploadFileExtension?: string | null } | null } | null> } } | null } | null> } | null };

export type GetCareerPageAccessQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetCareerPageAccessQuery = { __typename?: 'Query', careerPageEditAccess?: { __typename?: 'CareerPageType', canManage?: boolean | null } | null };

export type GetCareerPageLocationsQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type GetCareerPageLocationsQuery = { __typename?: 'Query', careerPageBySlug?: { __typename?: 'CareerPageTypeConnection', edges: Array<{ __typename?: 'CareerPageTypeEdge', node?: { __typename?: 'CareerPageType', id: string, selectedLocations?: Array<string | null> | null, locations: { __typename?: 'LocationTypeConnection', edges: Array<{ __typename?: 'LocationTypeEdge', node?: { __typename?: 'LocationType', id: string, name: string, rowId?: number | null, latitude?: number | null, longitude?: number | null, formattedAddress?: string | null, tags: Array<{ __typename?: 'TagType', id: string, name: string }> } | null } | null> } } | null } | null> } | null };

export type GetCareerPagePositionsQueryVariables = Exact<{
  after?: InputMaybe<Scalars['String']>;
  location_In: Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  positionName_Icontains?: InputMaybe<Scalars['String']>;
}>;


export type GetCareerPagePositionsQuery = { __typename?: 'Query', positions?: { __typename: 'PositionTypeConnection', totalCount?: number | null, edges: Array<{ __typename?: 'PositionTypeEdge', node?: { __typename?: 'PositionType', id: string, positionName: string, paymentStatus?: EmployersPositionPaymentStatusChoices | null, hiring: boolean, createdAt: any, posted: any, baseSalaryMin?: number | null, baseSalaryMax?: number | null, baseSalaryUnitText?: string | null, slug: string, location: { __typename?: 'LocationType', name: string, image?: string | null, formattedAddress?: string | null, paymentStatus?: EmployersLocationPaymentStatusChoices | null } } | null } | null>, pageInfo: { __typename?: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasNextPage: boolean } } | null };

export type GetCareerPagesQueryVariables = Exact<{
  employerProfile: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetCareerPagesQuery = { __typename?: 'Query', employerCareerPages?: { __typename?: 'CareerPageTypeConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'CareerPageTypeEdge', node?: { __typename?: 'CareerPageType', id: string, title?: string | null, slug: string, totalPositions?: number | null, canManage?: boolean | null, createdBy?: { __typename?: 'UserType', id: string, firstName: string, lastName: string } | null, pageLocations?: Array<{ __typename?: 'LocationType', id: string, name: string, rowId?: number | null, formattedAddress?: string | null } | null> | null } | null } | null> } | null };

export type GenerateSbTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type GenerateSbTokenMutation = { __typename?: 'Mutation', generateSendbirdUserToken?: { __typename?: 'GenerteSendBirdUserToken', me?: { __typename?: 'UserType', id: string, sendbirdAccessToken?: string | null } | null } | null };

export type GetChannelsQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['String']>;
  positionId?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type GetChannelsQuery = { __typename?: 'Query', channels?: { __typename?: 'ChannelTypeConnection', edges: Array<{ __typename?: 'ChannelTypeEdge', node?: { __typename?: 'ChannelType', sendbirdChannelId: string, candidateUser?: { __typename?: 'UserType', profileImage?: string | null } | null } | null } | null> } | null };

export type GetChannelsCountQueryVariables = Exact<{
  locationId?: InputMaybe<Scalars['String']>;
  positionId?: InputMaybe<Scalars['String']>;
}>;


export type GetChannelsCountQuery = { __typename?: 'Query', channelsCount?: { __typename?: 'ChannelsCountType', unhidden?: number | null, hidden?: number | null } | null };

export type GetChannelQueryVariables = Exact<{
  sendbirdChannelId?: InputMaybe<Scalars['String']>;
}>;


export type GetChannelQuery = { __typename?: 'Query', channel?: { __typename?: 'ChannelType', id: string, sendbirdChannelId: string, lastLocation?: { __typename?: 'LocationType', id: string, name: string, image?: string | null } | null, location?: { __typename?: 'LocationType', id: string, name: string, image?: string | null } | null } | null };

export type GetChannelAndFullDetailsQueryVariables = Exact<{
  sendbirdChannelId?: InputMaybe<Scalars['String']>;
}>;


export type GetChannelAndFullDetailsQuery = { __typename?: 'Query', channel?: { __typename?: 'ChannelType', id: string, sendbirdChannelId: string, candidateUser?: { __typename?: 'UserType', id: string, rowId?: number | null, firstName: string, lastName: string, candidateProfile?: { __typename?: 'CandidateProfileType', id: string, handle?: string | null } | null } | null, location?: { __typename?: 'LocationType', id: string, name: string, image?: string | null, paymentStatus?: EmployersLocationPaymentStatusChoices | null } | null, employerUser?: { __typename?: 'UserType', id: string, firstName: string, lastName: string } | null, lastPosition?: { __typename?: 'PositionType', id: string, positionName: string, slug: string, paymentStatus?: EmployersPositionPaymentStatusChoices | null, shortUrl?: string | null } | null, lastLocation?: { __typename?: 'LocationType', id: string, name: string, image?: string | null, slug: string, paymentStatus?: EmployersLocationPaymentStatusChoices | null } | null, lastInterview?: { __typename?: 'InterviewType', id: string, uuid?: string | null, status: ApiInterviewStatusChoices } | null, lastApplication?: { __typename?: 'PositionApplicationType', id: string } | null } | null };

export type GetOrCreateSbChannelMutationVariables = Exact<{
  uuids: Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['ID']>;
  location?: InputMaybe<Scalars['ID']>;
  interview?: InputMaybe<Scalars['ID']>;
  application?: InputMaybe<Scalars['ID']>;
}>;


export type GetOrCreateSbChannelMutation = { __typename?: 'Mutation', getOrCreateSendbirdChannelWith?: { __typename?: 'GetOrCreateSendBirdChannelWith', sendbirdChannel?: string | null, me?: { __typename?: 'UserType', id: string, uuid: any, sendbirdAccessToken?: string | null, sendbirdUser?: { __typename?: 'SendBirdUserType', userId?: string | null, nickname?: string | null, profileUrl?: string | null } | null } | null } | null };

export type GetSbUsersQueryVariables = Exact<{
  uuid?: InputMaybe<Scalars['UUID']>;
  employerUuid?: InputMaybe<Scalars['UUID']>;
}>;


export type GetSbUsersQuery = { __typename?: 'Query', sendbirdUsers?: { __typename?: 'UserTypeConnection', edges: Array<{ __typename?: 'UserTypeEdge', node?: { __typename?: 'UserType', id: string, firstName: string, lastName: string, email?: string | null, positionMatches?: { __typename?: 'MatchTypeConnection', edges: Array<{ __typename?: 'MatchTypeEdge', node?: { __typename?: 'MatchType', id: string, position: { __typename?: 'PositionType', id: string, rowId?: number | null, positionName: string, paymentStatus?: EmployersPositionPaymentStatusChoices | null, location: { __typename?: 'LocationType', id: string, name: string, rowId?: number | null, paymentStatus?: EmployersLocationPaymentStatusChoices | null } } } | null } | null> } | null, sendbirdUser?: { __typename?: 'SendBirdUserType', userId?: string | null, profileUrl?: string | null, nickname?: string | null } | null } | null } | null> } | null };

export type HideOrUnhideChannelMutationVariables = Exact<{
  channelUrl: Scalars['String'];
  archive: Scalars['Boolean'];
}>;


export type HideOrUnhideChannelMutation = { __typename?: 'Mutation', mutateEmployerUserChannelHideOrUnhide?: { __typename?: 'MutateEmployerUserArchivedAt', isSuccess?: boolean | null } | null };

export type RefreshSbTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type RefreshSbTokenMutation = { __typename?: 'Mutation', refreshSendbirdUser?: { __typename?: 'RefreshSendBirdUser', me?: { __typename?: 'UserType', id: string, sendbirdAccessToken?: string | null } | null } | null };

export type MutateMergeCandidatesMutationVariables = Exact<{
  indeedEmail: Scalars['String'];
}>;


export type MutateMergeCandidatesMutation = { __typename?: 'Mutation', mergeCandidatesMutation?: { __typename?: 'MergeCandidatesMutation', authorization?: string | null, me?: { __typename?: 'UserType', id: string, email?: string | null } | null } | null };

export type ScreeningAnswerMutationVariables = Exact<{
  employerCandidateQuestionnaireId: Scalars['ID'];
  questionsAnswered: Array<InputMaybe<QuestionAnswerInputType>> | InputMaybe<QuestionAnswerInputType>;
}>;


export type ScreeningAnswerMutation = { __typename?: 'Mutation', createScreeningAnswer?: { __typename?: 'AnswerQuestionsMutation', answersDetail?: Array<{ __typename?: 'UploadUrlType', signedS3Url?: string | null, question?: { __typename?: 'ScreeningAnswerType', id: string, questionText: string, answer?: string | null } | null } | null> | null } | null };

export type EmployerCandidateQuestionnaireQueryVariables = Exact<{
  uuid?: InputMaybe<Scalars['UUID']>;
}>;


export type EmployerCandidateQuestionnaireQuery = { __typename?: 'Query', employerCandidateQuestionnaire?: { __typename?: 'EmployerCandidateQuestionnaireType', id: string, employerCandidate?: { __typename?: 'EmployerCandidateType', employerProfile: { __typename?: 'EmployerProfileType', users: { __typename?: 'UserTypeConnection', edges: Array<{ __typename?: 'UserTypeEdge', node?: { __typename?: 'UserType', id: string, firstName: string, lastName: string, profileImage?: string | null } | null } | null> } }, candidateProfile: { __typename?: 'CandidateProfileType', id: string, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string } } } | null, position?: { __typename?: 'PositionType', id: string, positionName: string, location: { __typename?: 'LocationType', id: string, name: string, formattedAddress?: string | null } } | null, screeningQuestionnaire?: { __typename?: 'ScreeningQuestionnaireType', id: string, questionnaireType?: ScreeningScreeningQuestionnaireQuestionnaireTypeChoices | null, screeningQuestion: { __typename?: 'ScreeningQuestionTypeConnection', edges: Array<{ __typename?: 'ScreeningQuestionTypeEdge', node?: { __typename?: 'ScreeningQuestionType', id: string, question: string } | null } | null> } } | null, screeningAnswer: { __typename?: 'ScreeningAnswerTypeConnection', edges: Array<{ __typename?: 'ScreeningAnswerTypeEdge', node?: { __typename?: 'ScreeningAnswerType', id: string, questionText: string, answer?: string | null, screeningQuestion?: { __typename?: 'ScreeningQuestionType', id: string } | null } | null } | null> } } | null };

export type GetAllChatCandidateQueryVariables = Exact<{
  position?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['ID']>;
}>;


export type GetAllChatCandidateQuery = { __typename?: 'Query', matches?: { __typename?: 'MatchTypeConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'MatchTypeEdge', node?: { __typename?: 'MatchType', id: string, createdAt: any, updatedAt: any, hiddenAt?: any | null, candidateStatus?: string | null, stage?: string | null, hasAppliedToPosition?: boolean | null, isFavorited?: boolean | null, candidateProfile: { __typename?: 'CandidateProfileType', id: string, personalSummary: string, yearsExperience: string, handle?: string | null, positions?: Array<string | null> | null, status?: string | null, statusEmoji?: string | null, availabilityMonday?: Array<string | null> | null, availabilityTuesday?: Array<string | null> | null, availabilityWednesday?: Array<string | null> | null, availabilityThursday?: Array<string | null> | null, availabilityFriday?: Array<string | null> | null, availabilitySaturday?: Array<string | null> | null, availabilitySunday?: Array<string | null> | null, user: { __typename?: 'UserType', id: string, uuid: any, firstName: string, lastName: string, profileImage?: string | null, email?: string | null, phone?: string | null, lastMessage?: { __typename?: 'MessageType', message?: string | null, createdAt?: string | null } | null } }, application?: { __typename?: 'PositionApplicationType', id: string, createdAt: any } | null, lastInterview?: { __typename?: 'InterviewType', id: string, status: ApiInterviewStatusChoices, scheduledFor?: any | null, location?: { __typename?: 'LocationType', id: string, name: string, formattedAddress?: string | null } | null, position?: { __typename?: 'PositionType', id: string, positionName: string } | null } | null, lastEmployerInterview?: { __typename?: 'InterviewType', id: string, status: ApiInterviewStatusChoices, scheduledFor?: any | null, location?: { __typename?: 'LocationType', id: string, name: string, formattedAddress?: string | null } | null, position?: { __typename?: 'PositionType', id: string, positionName: string } | null } | null } | null } | null> } | null };

export type GetDashboardMatchesQueryVariables = Exact<{
  position?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  applied?: InputMaybe<Scalars['Boolean']>;
  new_applications?: InputMaybe<Scalars['Boolean']>;
  new_matches?: InputMaybe<Scalars['Boolean']>;
  interviewStatus?: InputMaybe<InterviewStatusFilter>;
  sortBy?: InputMaybe<Scalars['String']>;
}>;


export type GetDashboardMatchesQuery = { __typename?: 'Query', positionById?: { __typename?: 'PositionType', id: string, rowId?: number | null, positionName: string } | null, matches?: { __typename?: 'MatchTypeConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'MatchTypeEdge', node?: { __typename?: 'MatchType', id: string, createdAt: any, updatedAt: any, hiddenAt?: any | null, candidateStatus?: string | null, hasAppliedToPosition?: boolean | null, isFavorited?: boolean | null, stage?: string | null, candidateProfile: { __typename?: 'CandidateProfileType', id: string, personalSummary: string, yearsExperience: string, handle?: string | null, positions?: Array<string | null> | null, status?: string | null, statusEmoji?: string | null, user: { __typename?: 'UserType', id: string, uuid: any, firstName: string, lastName: string, profileImage?: string | null, email?: string | null, phone?: string | null } }, lastInterview?: { __typename?: 'InterviewType', id: string, status: ApiInterviewStatusChoices, scheduledFor?: any | null, location?: { __typename?: 'LocationType', id: string, formattedAddress?: string | null } | null, position?: { __typename?: 'PositionType', id: string, positionName: string } | null } | null, lastEmployerInterview?: { __typename?: 'InterviewType', id: string, status: ApiInterviewStatusChoices, scheduledFor?: any | null, location?: { __typename?: 'LocationType', id: string, formattedAddress?: string | null } | null, position?: { __typename?: 'PositionType', id: string, positionName: string } | null } | null, application?: { __typename?: 'PositionApplicationType', id: string, createdAt: any, position: { __typename?: 'PositionType', id: string, positionName: string, positionType?: Array<string | null> | null, hiring: boolean } } | null } | null } | null> } | null };

export type GetLocationDashboardQueryVariables = Exact<{
  location: Scalars['ID'];
}>;


export type GetLocationDashboardQuery = { __typename?: 'Query', locationById?: { __typename?: 'LocationType', id: string, rowId?: number | null, name: string, paymentStatus?: EmployersLocationPaymentStatusChoices | null, slug: string, locationPhoneNumber?: string | null, image?: string | null, allPositionsCount?: number | null, hiringPositionCount?: number | null, formattedAddress?: string | null, employerProfile?: { __typename?: 'EmployerProfileType', id: string, status: EmployersEmployerProfileStatusChoices } | null, payment?: { __typename?: 'PaymentType', id: string, planName?: PaymentPaymentPlanNameChoices | null, startedOn?: any | null, subscriptionWillEndOn?: any | null, subscriptionEndedOn?: any | null } | null } | null };

export type GetNewChatCandidateQueryVariables = Exact<{
  position?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['ID']>;
}>;


export type GetNewChatCandidateQuery = { __typename?: 'Query', matches?: { __typename?: 'MatchTypeConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'MatchTypeEdge', node?: { __typename?: 'MatchType', id: string, createdAt: any, updatedAt: any, hiddenAt?: any | null, candidateStatus?: string | null, stage?: string | null, hasAppliedToPosition?: boolean | null, isFavorited?: boolean | null, candidateProfile: { __typename?: 'CandidateProfileType', id: string, personalSummary: string, yearsExperience: string, handle?: string | null, positions?: Array<string | null> | null, status?: string | null, statusEmoji?: string | null, availabilityMonday?: Array<string | null> | null, availabilityTuesday?: Array<string | null> | null, availabilityWednesday?: Array<string | null> | null, availabilityThursday?: Array<string | null> | null, availabilityFriday?: Array<string | null> | null, availabilitySaturday?: Array<string | null> | null, availabilitySunday?: Array<string | null> | null, user: { __typename?: 'UserType', id: string, uuid: any, firstName: string, lastName: string, profileImage?: string | null, email?: string | null, phone?: string | null, lastMessage?: { __typename?: 'MessageType', message?: string | null, createdAt?: string | null } | null } }, application?: { __typename?: 'PositionApplicationType', id: string, createdAt: any } | null, lastInterview?: { __typename?: 'InterviewType', id: string, status: ApiInterviewStatusChoices, scheduledFor?: any | null, location?: { __typename?: 'LocationType', id: string, name: string, formattedAddress?: string | null } | null, position?: { __typename?: 'PositionType', id: string, positionName: string } | null } | null, lastEmployerInterview?: { __typename?: 'InterviewType', id: string, status: ApiInterviewStatusChoices, scheduledFor?: any | null, location?: { __typename?: 'LocationType', id: string, name: string, formattedAddress?: string | null } | null, position?: { __typename?: 'PositionType', id: string, positionName: string } | null } | null } | null } | null> } | null };

export type GetMyDashboardPositionsQueryVariables = Exact<{
  location?: InputMaybe<Scalars['ID']>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  hiring?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetMyDashboardPositionsQuery = { __typename?: 'Query', myPositions?: { __typename?: 'PositionTypeConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'PositionTypeEdge', node?: { __typename?: 'PositionType', id: string, rowId?: number | null, slug: string, positionName: string, hiring: boolean, paymentStatus?: EmployersPositionPaymentStatusChoices | null, hiringStatus?: string | null, positionType?: Array<string | null> | null, createdAt: any, posted: any, updatedAt: any, sendNotifications: boolean, payment?: { __typename?: 'PaymentType', stripeSubscription: string } | null, location: { __typename?: 'LocationType', id: string, paymentStatus?: EmployersLocationPaymentStatusChoices | null }, dashboardCounts?: { __typename?: 'DashboardCountsType', chat?: { __typename?: 'DashboardCountType', new?: number | null, total?: number | null } | null, applicants?: { __typename?: 'DashboardCountType', new?: number | null, total?: number | null } | null, candidates?: { __typename?: 'DashboardCountType', new?: number | null, total?: number | null } | null, interviews?: { __typename?: 'InterviewCountType', pending?: { __typename?: 'DashboardCountType', new?: number | null, total?: number | null } | null, accepted?: { __typename?: 'DashboardCountType', new?: number | null, total?: number | null } | null, completed?: { __typename?: 'DashboardCountType', new?: number | null, total?: number | null } | null } | null } | null } | null } | null> } | null };

export type GetMyLocationsDashboardQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetMyLocationsDashboardQuery = { __typename?: 'Query', me?: { __typename?: 'UserType', id: string, myLocations?: { __typename?: 'LocationTypeConnection', pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'LocationTypeEdge', node?: { __typename?: 'LocationType', id: string, name: string, image?: string | null, formattedAddress?: string | null, slug: string, website?: string | null, allPositionsCount?: number | null, hiringPositionCount?: number | null, locationPhoneNumber?: string | null, payment?: { __typename?: 'PaymentType', id: string, planName?: PaymentPaymentPlanNameChoices | null, startedOn?: any | null, subscriptionWillEndOn?: any | null, subscriptionEndedOn?: any | null } | null } | null } | null> } | null } | null };

export type RequestInterviewsMutationVariables = Exact<{
  filter?: InputMaybe<RequestInterviewFilter>;
  position: Scalars['ID'];
}>;


export type RequestInterviewsMutation = { __typename?: 'Mutation', sendBatchInterviews?: { __typename?: 'RequestAllCandidatesMutation', matches?: Array<{ __typename?: 'MatchType', id: string, stage?: string | null } | null> | null, errors?: Array<{ __typename?: 'ErrorType', messages: Array<string>, field: string } | null> | null } | null };

export type CreateInterviewScheduleMutationVariables = Exact<{
  location?: InputMaybe<Scalars['String']>;
  locationPhone?: InputMaybe<Scalars['String']>;
  locationUrl?: InputMaybe<Scalars['String']>;
  durationMinutes?: InputMaybe<Scalars['Int']>;
  maxWeeksOut?: InputMaybe<Scalars['Int']>;
}>;


export type CreateInterviewScheduleMutation = { __typename?: 'Mutation', mutateInterviewSchedule?: { __typename?: 'InterviewScheduleMutationPayload', interviewSchedule?: { __typename?: 'InterviewScheduleType', id: string, location: EmployersInterviewScheduleLocationChoices, locationUrl?: string | null, locationPhone?: string | null, durationMinutes: EmployersInterviewScheduleDurationMinutesChoices, maxWeeksOut: number } | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type MutateInterviewScheduleMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  location?: InputMaybe<Scalars['String']>;
  locationPhone?: InputMaybe<Scalars['String']>;
  locationUrl?: InputMaybe<Scalars['String']>;
  durationMinutes?: InputMaybe<Scalars['Int']>;
  allowOverbooking?: InputMaybe<Scalars['Boolean']>;
  maxWeeksOut?: InputMaybe<Scalars['Int']>;
}>;


export type MutateInterviewScheduleMutation = { __typename?: 'Mutation', mutateInterviewSchedule?: { __typename?: 'InterviewScheduleMutationPayload', interviewSchedule?: { __typename?: 'InterviewScheduleType', id: string, location: EmployersInterviewScheduleLocationChoices, locationUrl?: string | null, locationPhone?: string | null, durationMinutes: EmployersInterviewScheduleDurationMinutesChoices, allowOverbooking: boolean, maxWeeksOut: number } | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type InterviewScheduleQueryVariables = Exact<{ [key: string]: never; }>;


export type InterviewScheduleQuery = { __typename?: 'Query', me?: { __typename?: 'UserType', id: string, interviewschedule?: { __typename?: 'InterviewScheduleType', id: string, location: EmployersInterviewScheduleLocationChoices, locationUrl?: string | null, locationPhone?: string | null, durationMinutes: EmployersInterviewScheduleDurationMinutesChoices, allowOverbooking: boolean, maxWeeksOut: number, interviewScheduleRanges?: Array<string | null> | null, ranges: { __typename?: 'InterviewScheduleRangeTypeConnection', edges: Array<{ __typename?: 'InterviewScheduleRangeTypeEdge', node?: { __typename?: 'InterviewScheduleRangeType', id: string, startHour?: number | null, startMinute?: number | null, endHour?: number | null, endMinute?: number | null, day: EmployersInterviewScheduleRangeDayChoices } | null } | null> } } | null } | null };

export type ScheduleInterviewMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  scheduledFor?: InputMaybe<Scalars['DateTime']>;
  messageContent?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['String']>;
  interviewType?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  meetingUrl?: InputMaybe<Scalars['String']>;
  interviewAttendees: Array<InputMaybe<InterviewAttendeeSerializerInput>> | InputMaybe<InterviewAttendeeSerializerInput>;
}>;


export type ScheduleInterviewMutation = { __typename?: 'Mutation', mutateInterview?: { __typename?: 'InterviewMutationPayload', interview?: { __typename?: 'InterviewType', id: string, uuid?: string | null, status: ApiInterviewStatusChoices, scheduledFor?: any | null, ics?: string | null } | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type ScheduleSlotsQueryVariables = Exact<{
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
  userId: Scalars['ID'];
}>;


export type ScheduleSlotsQuery = { __typename?: 'Query', scheduleSlots?: Array<{ __typename?: 'InterviewScheduleDayType', day?: any | null, slots?: Array<{ __typename?: 'InterviewScheduleSlotType', start?: any | null, available?: boolean | null } | null> | null } | null> | null };

export type EmployerScheduleInterviewMutationVariables = Exact<{
  candidate?: InputMaybe<Scalars['ID']>;
  employerProfile?: InputMaybe<Scalars['ID']>;
  position?: InputMaybe<Scalars['ID']>;
  createdBy?: InputMaybe<Scalars['ID']>;
  scheduledFor?: InputMaybe<Scalars['DateTime']>;
  interviewType?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  meetingUrl?: InputMaybe<Scalars['String']>;
  messageContent?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['String']>;
  interviewAttendees: Array<InputMaybe<InterviewAttendeeSerializerInput>> | InputMaybe<InterviewAttendeeSerializerInput>;
}>;


export type EmployerScheduleInterviewMutation = { __typename?: 'Mutation', mutateInterview?: { __typename?: 'InterviewMutationPayload', errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, interview?: { __typename?: 'InterviewType', id: string, match?: { __typename?: 'MatchType', id: string, stage?: string | null, lastInterview?: { __typename?: 'InterviewType', id: string, status: ApiInterviewStatusChoices, scheduledFor?: any | null, location?: { __typename?: 'LocationType', id: string, formattedAddress?: string | null } | null, position?: { __typename?: 'PositionType', id: string, positionName: string } | null } | null, lastEmployerInterview?: { __typename?: 'InterviewType', id: string, status: ApiInterviewStatusChoices, scheduledFor?: any | null, location?: { __typename?: 'LocationType', id: string, formattedAddress?: string | null } | null, position?: { __typename?: 'PositionType', id: string, positionName: string } | null } | null } | null, candidate?: { __typename?: 'UserType', id: string, candidateProfile?: { __typename?: 'CandidateProfileType', id: string, rowId?: number | null, handle?: string | null } | null } | null } | null } | null };

export type UserInterviewScheduleQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['ID']>;
}>;


export type UserInterviewScheduleQuery = { __typename?: 'Query', userInterviewSchedule?: { __typename?: 'InterviewScheduleType', id: string, location: EmployersInterviewScheduleLocationChoices, locationUrl?: string | null, locationPhone?: string | null, durationMinutes: EmployersInterviewScheduleDurationMinutesChoices, allowOverbooking: boolean, maxWeeksOut: number, interviewScheduleRanges?: Array<string | null> | null, ranges: { __typename?: 'InterviewScheduleRangeTypeConnection', edges: Array<{ __typename?: 'InterviewScheduleRangeTypeEdge', node?: { __typename?: 'InterviewScheduleRangeType', id: string, startHour?: number | null, startMinute?: number | null, endHour?: number | null, endMinute?: number | null, day: EmployersInterviewScheduleRangeDayChoices } | null } | null> } } | null };

export type MutateBulkMessageMutationVariables = Exact<{
  location: Scalars['ID'];
  position: Scalars['ID'];
  message: Scalars['String'];
  all?: InputMaybe<Scalars['Boolean']>;
  employerCandidates?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  locationFilters?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  positionFilters?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  stage?: InputMaybe<Scalars['ID']>;
  notificationType?: InputMaybe<Scalars['String']>;
  notificationStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;


export type MutateBulkMessageMutation = { __typename?: 'Mutation', mutateBulkMessage?: { __typename?: 'BulkMessageMutation', ok?: string | null } | null };

export type CreateMessageTemplateMutationVariables = Exact<{
  name?: InputMaybe<Scalars['String']>;
  templateType?: InputMaybe<Scalars['String']>;
  messageContent?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<Scalars['String']>;
  defaultCompensation?: InputMaybe<Scalars['Float']>;
  defaultCompensationUnits?: InputMaybe<Scalars['String']>;
  ScreeningQuestionSerializerInput?: InputMaybe<Array<InputMaybe<ScreeningQuestionSerializerInput>> | InputMaybe<ScreeningQuestionSerializerInput>>;
  action?: InputMaybe<Scalars['String']>;
}>;


export type CreateMessageTemplateMutation = { __typename?: 'Mutation', mutateEmployerMessageTemplate?: { __typename?: 'EmployerMessageTemplateMutationPayload', employerMessageTemplate?: { __typename?: 'EmployerMessageTemplateType', id: string, name?: string | null, templateType?: EmployersEmployerMessageTemplateTemplateTypeChoices | null, messageContent?: string | null, archivedAt?: any | null, category?: EmployersEmployerMessageTemplateCategoryChoices | null, defaultCompensation?: number | null, defaultCompensationUnits?: EmployersEmployerMessageTemplateDefaultCompensationUnitsChoices | null, fileUploadUrl?: string | null, action?: string | null, createdBy?: { __typename?: 'UserType', firstName: string, lastName: string } | null, screeningQuestionnaire: { __typename?: 'ScreeningQuestionnaireTypeConnection', edges: Array<{ __typename?: 'ScreeningQuestionnaireTypeEdge', node?: { __typename?: 'ScreeningQuestionnaireType', id: string, screeningQuestion: { __typename?: 'ScreeningQuestionTypeConnection', edges: Array<{ __typename?: 'ScreeningQuestionTypeEdge', node?: { __typename?: 'ScreeningQuestionType', id: string, question: string } | null } | null> } } | null } | null> } } | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type DeleteMessageTemplateFileMutationVariables = Exact<{
  messageTemplateFileId: Scalars['ID'];
}>;


export type DeleteMessageTemplateFileMutation = { __typename?: 'Mutation', deleteEmployerMessageTemplateFile?: { __typename?: 'DeleteMessageTemplateFile', deleted?: boolean | null } | null };

export type DeleteEmployerMessageTemplateMutationVariables = Exact<{
  templateId: Scalars['ID'];
}>;


export type DeleteEmployerMessageTemplateMutation = { __typename?: 'Mutation', mutateDeleteMessageTemplate?: { __typename?: 'EmployerMessageTemplateDeleteMutation', deleted?: boolean | null } | null };

export type EmployerMessageTemplateTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type EmployerMessageTemplateTypeQuery = { __typename?: 'Query', employerMessageTemplateCounts?: { __typename?: 'EmployerMessageTemplateCountType', screening?: number | null, applicants?: number | null, interview?: number | null, hired?: number | null, offer?: number | null, other?: number | null } | null };

export type GetFilteredEmployerMessageTemplatesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<EmployersEmployerMessageTemplateCategoryChoices>;
  isSimpleOnly?: InputMaybe<Scalars['Boolean']>;
  action?: InputMaybe<Scalars['String']>;
}>;


export type GetFilteredEmployerMessageTemplatesQuery = { __typename?: 'Query', employerMessageTemplates?: { __typename?: 'EmployerMessageTemplateTypeConnection', edges: Array<{ __typename?: 'EmployerMessageTemplateTypeEdge', node?: { __typename?: 'EmployerMessageTemplateType', id: string, name?: string | null, templateType?: EmployersEmployerMessageTemplateTemplateTypeChoices | null, messageContent?: string | null, archivedAt?: any | null, action?: string | null, isDefault: boolean, category?: EmployersEmployerMessageTemplateCategoryChoices | null, fileUploadUrl?: string | null, defaultCompensation?: number | null, defaultCompensationUnits?: EmployersEmployerMessageTemplateDefaultCompensationUnitsChoices | null, screeningQuestionnaire: { __typename?: 'ScreeningQuestionnaireTypeConnection', edges: Array<{ __typename?: 'ScreeningQuestionnaireTypeEdge', node?: { __typename?: 'ScreeningQuestionnaireType', id: string, createdAt: any, screeningQuestion: { __typename?: 'ScreeningQuestionTypeConnection', edges: Array<{ __typename?: 'ScreeningQuestionTypeEdge', node?: { __typename?: 'ScreeningQuestionType', id: string, question: string } | null } | null> } } | null } | null> } } | null } | null> } | null };

export type EmployerMessageTemplatesQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  category?: InputMaybe<EmployersEmployerMessageTemplateCategoryChoices>;
  action?: InputMaybe<Scalars['String']>;
}>;


export type EmployerMessageTemplatesQuery = { __typename?: 'Query', employerMessageTemplates?: { __typename?: 'EmployerMessageTemplateTypeConnection', edges: Array<{ __typename?: 'EmployerMessageTemplateTypeEdge', node?: { __typename?: 'EmployerMessageTemplateType', id: string, name?: string | null, templateType?: EmployersEmployerMessageTemplateTemplateTypeChoices | null, messageContent?: string | null, archivedAt?: any | null, action?: string | null, isDefault: boolean, category?: EmployersEmployerMessageTemplateCategoryChoices | null, fileUploadUrl?: string | null, defaultCompensation?: number | null, defaultCompensationUnits?: EmployersEmployerMessageTemplateDefaultCompensationUnitsChoices | null, createdBy?: { __typename?: 'UserType', firstName: string, lastName: string } | null, employerMessageTemplateFile: { __typename?: 'EmployerMessageTemplateFileTypeConnection', edges: Array<{ __typename?: 'EmployerMessageTemplateFileTypeEdge', node?: { __typename?: 'EmployerMessageTemplateFileType', id: string, name?: string | null, url?: string | null, attachment?: string | null, fileName?: string | null, fileType?: string | null, employerMessageTemplate: { __typename?: 'EmployerMessageTemplateType', id: string } } | null } | null> }, screeningQuestionnaire: { __typename?: 'ScreeningQuestionnaireTypeConnection', edges: Array<{ __typename?: 'ScreeningQuestionnaireTypeEdge', node?: { __typename?: 'ScreeningQuestionnaireType', id: string, createdAt: any, screeningQuestion: { __typename?: 'ScreeningQuestionTypeConnection', edges: Array<{ __typename?: 'ScreeningQuestionTypeEdge', node?: { __typename?: 'ScreeningQuestionType', id: string, question: string } | null } | null> } } | null } | null> } } | null } | null> } | null };

export type UpdateMessageTemplateMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  templateType?: InputMaybe<Scalars['String']>;
  messageContent?: InputMaybe<Scalars['String']>;
  archivedAt?: InputMaybe<Scalars['DateTime']>;
  category?: InputMaybe<Scalars['String']>;
  defaultCompensation?: InputMaybe<Scalars['Float']>;
  defaultCompensationUnits?: InputMaybe<Scalars['String']>;
  ScreeningQuestionSerializerInput?: InputMaybe<Array<InputMaybe<ScreeningQuestionSerializerInput>> | InputMaybe<ScreeningQuestionSerializerInput>>;
  action?: InputMaybe<Scalars['String']>;
}>;


export type UpdateMessageTemplateMutation = { __typename?: 'Mutation', mutateEmployerMessageTemplate?: { __typename?: 'EmployerMessageTemplateMutationPayload', employerMessageTemplate?: { __typename?: 'EmployerMessageTemplateType', id: string, name?: string | null, templateType?: EmployersEmployerMessageTemplateTemplateTypeChoices | null, messageContent?: string | null, archivedAt?: any | null, category?: EmployersEmployerMessageTemplateCategoryChoices | null, defaultCompensation?: number | null, defaultCompensationUnits?: EmployersEmployerMessageTemplateDefaultCompensationUnitsChoices | null, fileUploadUrl?: string | null, action?: string | null, isDefault: boolean, employerProfile: { __typename?: 'EmployerProfileType', id: string }, createdBy?: { __typename?: 'UserType', firstName: string, lastName: string } | null, employerMessageTemplateFile: { __typename?: 'EmployerMessageTemplateFileTypeConnection', edges: Array<{ __typename?: 'EmployerMessageTemplateFileTypeEdge', node?: { __typename?: 'EmployerMessageTemplateFileType', id: string, name?: string | null, url?: string | null, attachment?: string | null, fileName?: string | null, fileType?: string | null, employerMessageTemplate: { __typename?: 'EmployerMessageTemplateType', id: string } } | null } | null> }, screeningQuestionnaire: { __typename?: 'ScreeningQuestionnaireTypeConnection', edges: Array<{ __typename?: 'ScreeningQuestionnaireTypeEdge', node?: { __typename?: 'ScreeningQuestionnaireType', id: string, screeningQuestion: { __typename?: 'ScreeningQuestionTypeConnection', edges: Array<{ __typename?: 'ScreeningQuestionTypeEdge', node?: { __typename?: 'ScreeningQuestionType', id: string, question: string } | null } | null> } } | null } | null> } } | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type MutateMessageTemplateFileMutationVariables = Exact<{
  employerMessageTemplateId: Scalars['ID'];
  templateFiles?: InputMaybe<Array<MessageTemplateFileInput> | MessageTemplateFileInput>;
}>;


export type MutateMessageTemplateFileMutation = { __typename?: 'Mutation', mutateEmployerMessageTemplateFile?: { __typename?: 'UploadMessageTemplateFileMutation', messageTemplate?: { __typename?: 'EmployerMessageTemplateType', id: string } | null, urls?: Array<{ __typename?: 'MessageTemplateFileUrlType', presignedUrl?: string | null, link?: string | null } | null> | null } | null };

export type MutateAnswerQuestionsMutationVariables = Exact<{
  location?: InputMaybe<Scalars['ID']>;
  employerProfile?: InputMaybe<Scalars['ID']>;
  responses?: InputMaybe<Array<InputMaybe<AnswerInput>> | InputMaybe<AnswerInput>>;
}>;


export type MutateAnswerQuestionsMutation = { __typename?: 'Mutation', answerLocationQuestions?: { __typename?: 'AnswerLocationQuestions', location?: { __typename?: 'LocationType', id: string, answers: { __typename?: 'LocationAnswerTypeConnection', edges: Array<{ __typename?: 'LocationAnswerTypeEdge', node?: { __typename?: 'LocationAnswerType', id: string, displayIcon?: string | null, displayLabel?: string | null, response: string, question: { __typename?: 'QuestionType', id: string, title: string }, option?: { __typename?: 'QuestionOptionType', id: string, value: string } | null } | null } | null> } } | null } | null };

export type GetQuestionsQueryVariables = Exact<{
  category?: InputMaybe<OnboardingQuestionCategoryChoices>;
}>;


export type GetQuestionsQuery = { __typename?: 'Query', questions?: { __typename?: 'QuestionTypeConnection', edges: Array<{ __typename?: 'QuestionTypeEdge', node?: { __typename?: 'QuestionType', id: string, title: string, questionType: OnboardingQuestionQuestionTypeChoices, required: boolean, placeholder?: string | null, options?: Array<{ __typename?: 'QuestionOptionType', id: string, label: string, value: string } | null> | null } | null } | null> } | null };

export type DeletePositionMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;


export type DeletePositionMutation = { __typename?: 'Mutation', deletePosition?: { __typename?: 'DeletePositionMutationPayload', id?: string | null, message?: string | null } | null };

export type PositionCampaignsByIdQueryVariables = Exact<{
  position: Scalars['ID'];
}>;


export type PositionCampaignsByIdQuery = { __typename?: 'Query', campaignsByPosition?: Array<{ __typename?: 'JobBoardCampaignType', id: string, startedOn?: any | null, amount?: number | null, campaignWillEndOn?: any | null, active?: boolean | null } | null> | null };

export type JobDescriptionQueryVariables = Exact<{
  positionType?: InputMaybe<Scalars['String']>;
}>;


export type JobDescriptionQuery = { __typename?: 'Query', jobDescriptionForPositionType?: string | null };

export type MyPositionsQueryVariables = Exact<{
  location?: InputMaybe<Scalars['ID']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  search?: InputMaybe<Scalars['String']>;
}>;


export type MyPositionsQuery = { __typename?: 'Query', myPositions?: { __typename?: 'PositionTypeConnection', edges: Array<{ __typename?: 'PositionTypeEdge', node?: { __typename?: 'PositionType', id: string, rowId?: number | null, slug: string, positionName: string, hiring: boolean, paymentStatus?: EmployersPositionPaymentStatusChoices | null, positionType?: Array<string | null> | null, createdAt: any, indexable?: boolean | null, payment?: { __typename?: 'PaymentType', planName?: PaymentPaymentPlanNameChoices | null } | null, location: { __typename?: 'LocationType', id: string, name: string, displayName?: string | null, slug: string, formattedAddress?: string | null, paymentStatus?: EmployersLocationPaymentStatusChoices | null, payment?: { __typename?: 'PaymentType', planName?: PaymentPaymentPlanNameChoices | null } | null } } | null } | null> } | null };

export type PositionByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PositionByIdQuery = { __typename?: 'Query', positionById?: { __typename?: 'PositionType', id: string, rowId?: number | null, slug: string, positionName: string, preferredTraining?: Array<string | null> | null, positionType?: Array<string | null> | null, jobDescription?: string | null, responsibilities?: string | null, requirements?: string | null, preferredExperience?: string | null, hiring: boolean, paymentStatus?: EmployersPositionPaymentStatusChoices | null, sendNotifications: boolean, isBenefitsRequired?: boolean | null, canHaveDressCode?: boolean | null, baseSalaryMin?: number | null, baseSalaryMax?: number | null, baseSalaryUnitText?: string | null, createdAt: any, availabilityMonday?: Array<string | null> | null, availabilityTuesday?: Array<string | null> | null, availabilityWednesday?: Array<string | null> | null, availabilityThursday?: Array<string | null> | null, availabilityFriday?: Array<string | null> | null, availabilitySaturday?: Array<string | null> | null, availabilitySunday?: Array<string | null> | null, lastMatchCreation?: any | null, indeedEasyapplyOptout: boolean, location: { __typename?: 'LocationType', id: string, name: string, displayName?: string | null, slug: string, formattedAddress?: string | null, image?: string | null } } | null };

export type PositionCampaignByIdQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type PositionCampaignByIdQuery = { __typename?: 'Query', positionById?: { __typename?: 'PositionType', id: string, rowId?: number | null, slug: string, positionName: string, positionType?: Array<string | null> | null } | null };

export type MutatePositionMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  positionType?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  positionName?: InputMaybe<Scalars['String']>;
  hiring?: InputMaybe<Scalars['Boolean']>;
  preferredTraining?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  preferredExperience?: InputMaybe<Scalars['String']>;
  baseSalaryMin?: InputMaybe<Scalars['Float']>;
  baseSalaryMax?: InputMaybe<Scalars['Float']>;
  baseSalaryUnitText?: InputMaybe<Scalars['String']>;
  isBenefitsRequired?: InputMaybe<Scalars['Boolean']>;
  canHaveDressCode?: InputMaybe<Scalars['Boolean']>;
  availabilityMonday?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  availabilityTuesday?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  availabilityWednesday?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  availabilityThursday?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  availabilityFriday?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  availabilitySaturday?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  availabilitySunday?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  sendNotifications?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<Scalars['ID']>;
  jobDescription?: InputMaybe<Scalars['String']>;
  indeedEasyapplyOptout?: InputMaybe<Scalars['Boolean']>;
}>;


export type MutatePositionMutation = { __typename?: 'Mutation', mutatePosition?: { __typename?: 'PositionMutationPayload', errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null, position?: { __typename?: 'PositionType', id: string, rowId?: number | null, positionType?: Array<string | null> | null, positionName: string, hiring: boolean, paymentStatus?: EmployersPositionPaymentStatusChoices | null, preferredTraining?: Array<string | null> | null, preferredExperience?: string | null, baseSalaryMin?: number | null, baseSalaryMax?: number | null, baseSalaryUnitText?: string | null, isBenefitsRequired?: boolean | null, canHaveDressCode?: boolean | null, availabilityMonday?: Array<string | null> | null, availabilityTuesday?: Array<string | null> | null, availabilityWednesday?: Array<string | null> | null, availabilityThursday?: Array<string | null> | null, availabilityFriday?: Array<string | null> | null, availabilitySaturday?: Array<string | null> | null, availabilitySunday?: Array<string | null> | null, sendNotifications: boolean, jobDescription?: string | null, indeedEasyapplyOptout: boolean, location: { __typename?: 'LocationType', id: string, name: string, allPositionsCount?: number | null, hiringPositionCount?: number | null } } | null } | null };

export type PartialRefundCampaignMutationVariables = Exact<{
  jobBoardCampaignId: Scalars['ID'];
}>;


export type PartialRefundCampaignMutation = { __typename?: 'Mutation', refundAndEndCampaign?: { __typename?: 'RefundAndEndCampaign', jobBoardCampaign?: { __typename?: 'JobBoardCampaignType', id: string, startedOn?: any | null, amount?: number | null, campaignWillEndOn?: any | null, active?: boolean | null } | null } | null };

export type EmployerCandidateQuestionnairesQueryVariables = Exact<{
  employerCandidate?: InputMaybe<Scalars['ID']>;
  position?: InputMaybe<Scalars['ID']>;
}>;


export type EmployerCandidateQuestionnairesQuery = { __typename?: 'Query', employerCandidateQuestionnaires?: { __typename?: 'EmployerCandidateQuestionnaireTypeConnection', edges: Array<{ __typename?: 'EmployerCandidateQuestionnaireTypeEdge', node?: { __typename?: 'EmployerCandidateQuestionnaireType', id: string, submittedAt?: any | null, position?: { __typename?: 'PositionType', id: string, positionName: string, location: { __typename?: 'LocationType', id: string, name: string, formattedAddress?: string | null } } | null, screeningQuestionnaire?: { __typename?: 'ScreeningQuestionnaireType', id: string, questionnaireType?: ScreeningScreeningQuestionnaireQuestionnaireTypeChoices | null, screeningQuestion: { __typename?: 'ScreeningQuestionTypeConnection', edges: Array<{ __typename?: 'ScreeningQuestionTypeEdge', node?: { __typename?: 'ScreeningQuestionType', id: string, answers?: Array<{ __typename?: 'ScreeningAnswerType', id: string, questionText: string, answer?: string | null, screeningAnswerVideo?: string | null, updatedAt: any } | null> | null } | null } | null> } } | null } | null } | null> } | null };

export type EmployerQuestionaireQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  questionnaireType?: InputMaybe<ScreeningScreeningQuestionnaireQuestionnaireTypeChoices>;
}>;


export type EmployerQuestionaireQuery = { __typename?: 'Query', questionnaires?: { __typename?: 'ScreeningQuestionnaireTypeConnection', edges: Array<{ __typename?: 'ScreeningQuestionnaireTypeEdge', node?: { __typename?: 'ScreeningQuestionnaireType', id: string, name: string, questionnaireType?: ScreeningScreeningQuestionnaireQuestionnaireTypeChoices | null, createdAt: any, screeningQuestion: { __typename?: 'ScreeningQuestionTypeConnection', edges: Array<{ __typename?: 'ScreeningQuestionTypeEdge', node?: { __typename?: 'ScreeningQuestionType', id: string, question: string } | null } | null> } } | null } | null> } | null };

export type QuestionaireQueryVariables = Exact<{
  Id?: InputMaybe<Scalars['ID']>;
}>;


export type QuestionaireQuery = { __typename?: 'Query', questionnaire?: { __typename?: 'ScreeningQuestionnaireType', id: string, name: string, screeningQuestion: { __typename?: 'ScreeningQuestionTypeConnection', edges: Array<{ __typename?: 'ScreeningQuestionTypeEdge', node?: { __typename?: 'ScreeningQuestionType', question: string } | null } | null> } } | null };

export type MutateScreeningQuestionMutationVariables = Exact<{
  question?: InputMaybe<Scalars['String']>;
  screeningQuestionnaireId?: InputMaybe<Scalars['ID']>;
}>;


export type MutateScreeningQuestionMutation = { __typename?: 'Mutation', mutateScreeningQuestion?: { __typename?: 'CreateScreeningQuestionMutation', screeningQuestion?: { __typename?: 'ScreeningQuestionType', id: string, question: string } | null } | null };

export type MutateUpdateScreeningQuestionMutationVariables = Exact<{
  archivedAt?: InputMaybe<Scalars['DateTime']>;
  question?: InputMaybe<Scalars['String']>;
  questionId?: InputMaybe<Scalars['ID']>;
}>;


export type MutateUpdateScreeningQuestionMutation = { __typename?: 'Mutation', updateScreeningQuestion?: { __typename?: 'UpdateScreeningQuestionMutation', screeningQuestion?: { __typename?: 'ScreeningQuestionType', id: string } | null } | null };

export type GetEmployerRejectionReasonsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEmployerRejectionReasonsQuery = { __typename?: 'Query', employerRejectionReasons?: { __typename?: 'EmployerRejectionReasonTypeConnection', edges: Array<{ __typename?: 'EmployerRejectionReasonTypeEdge', node?: { __typename?: 'EmployerRejectionReasonType', id: string, name: string } | null } | null> } | null };

export type MutateEmployerRejectionReasonMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  archivedAt?: InputMaybe<Scalars['DateTime']>;
}>;


export type MutateEmployerRejectionReasonMutation = { __typename?: 'Mutation', mutateEmployerRejectionReason?: { __typename?: 'EmployerRejectionReasonMutationPayload', employerRejectionReason?: { __typename?: 'EmployerRejectionReasonType', name: string, archivedAt?: any | null, employerProfile: { __typename?: 'EmployerProfileType', id: string } } | null } | null };

export type GetEmployerRejectionReasonQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEmployerRejectionReasonQuery = { __typename?: 'Query', employerRejectionReasons?: { __typename?: 'EmployerRejectionReasonTypeConnection', edges: Array<{ __typename?: 'EmployerRejectionReasonTypeEdge', node?: { __typename?: 'EmployerRejectionReasonType', id: string, name: string, employercandidateSet: { __typename?: 'EmployerCandidateTypeConnection', totalCount?: number | null } } | null } | null> } | null };

export type MutateSendQuestionnaireMutationVariables = Exact<{
  employerCandidateId: Scalars['ID'];
  positionId: Scalars['ID'];
  questionnaireId: Scalars['ID'];
  messageContent?: InputMaybe<Scalars['String']>;
}>;


export type MutateSendQuestionnaireMutation = { __typename?: 'Mutation', sendQuestionnaire?: { __typename?: 'SendQuestionnaireMutation', id?: string | null } | null };

export type UpdateUserMutationVariables = Exact<{
  id: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  email: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  confirmPassword?: InputMaybe<Scalars['String']>;
  terms?: InputMaybe<Scalars['Boolean']>;
  timezone?: InputMaybe<Scalars['String']>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', mutateUser?: { __typename?: 'UserMutationPayload', errors?: Array<{ __typename?: 'ErrorType', messages: Array<string>, field: string } | null> | null, me?: { __typename?: 'UserType', id: string, rowId?: number | null, email?: string | null, phone?: string | null, firstName: string, lastName: string, profileImage?: string | null, unclaimed?: boolean | null, authorization?: string | null } | null } | null };

export type GetEmployerUsersQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetEmployerUsersQuery = { __typename?: 'Query', employerUsers?: { __typename?: 'EmployerProfileUserTypeConnection', edges: Array<{ __typename?: 'EmployerProfileUserTypeEdge', node?: { __typename?: 'EmployerProfileUserType', id: string, role: EmployersEmployerProfileUserRoleChoices, createdAt: any, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string, lastLogin?: any | null, email?: string | null, unclaimed?: boolean | null, timezone: string, profileImage?: string | null }, locations: { __typename?: 'LocationTypeConnection', edges: Array<{ __typename?: 'LocationTypeEdge', node?: { __typename?: 'LocationType', id: string, name: string } | null } | null> } } | null } | null> } | null };

export type InviteTeamToLocationMutationVariables = Exact<{
  location: Scalars['ID'];
  users?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  name: Scalars['String'];
}>;


export type InviteTeamToLocationMutation = { __typename?: 'Mutation', mutateLocation?: { __typename?: 'LocationMutationPayload', location?: { __typename?: 'LocationType', id: string } | null } | null };

export type RemoveEmployerUserMutationMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type RemoveEmployerUserMutationMutation = { __typename?: 'Mutation', removeEmployerUser?: { __typename?: 'RemoveEmployerUserPayload', id?: string | null } | null };

export type ResendEmployerUserInviteMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type ResendEmployerUserInviteMutation = { __typename?: 'Mutation', resendEmployerUserInvite?: { __typename?: 'ResendEmployerUserInvitePayload', id?: string | null } | null };

export type EmployerUserMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  email?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<Array<InputMaybe<Scalars['ID']>> | InputMaybe<Scalars['ID']>>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
}>;


export type EmployerUserMutation = { __typename?: 'Mutation', mutateEmployerUser?: { __typename?: 'EmployerUserMutationPayload', employerUser?: { __typename?: 'EmployerProfileUserType', id: string, role: EmployersEmployerProfileUserRoleChoices, user: { __typename?: 'UserType', id: string, firstName: string, lastName: string, lastLogin?: any | null, email?: string | null, timezone: string } } | null } | null };

export type MutateCreateEmploymentDocumentMutationVariables = Exact<{
  documentType?: InputMaybe<Scalars['String']>;
  baseSalaryValue?: InputMaybe<Scalars['Float']>;
  baseSalaryUnitText?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  position: Scalars['ID'];
  candidate: Scalars['ID'];
  startingAt?: InputMaybe<Scalars['DateTime']>;
  contactName?: InputMaybe<Scalars['String']>;
  contactPhone?: InputMaybe<Scalars['String']>;
  note?: InputMaybe<Scalars['String']>;
  messageContent?: InputMaybe<Scalars['String']>;
}>;


export type MutateCreateEmploymentDocumentMutation = { __typename?: 'Mutation', mutateEmploymentDocument?: { __typename?: 'EmploymentDocumentMutationPayload', employmentDocumentType?: { __typename?: 'EmploymentDocumentType', id: string, documentType?: EmployersEmploymentDocumentDocumentTypeChoices | null, contactName?: string | null, contactPhone?: string | null, acceptedDeclinedAt?: any | null, baseSalaryUnitText?: EmployersEmploymentDocumentBaseSalaryUnitTextChoices | null, status?: EmployersEmploymentDocumentStatusChoices | null, candidate: { __typename?: 'CandidateProfileType', id: string }, position: { __typename?: 'PositionType', id: string } } | null } | null };

export type MutateEmploymentDocumentMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Scalars['String']>;
}>;


export type MutateEmploymentDocumentMutation = { __typename?: 'Mutation', mutateEmploymentDocument?: { __typename?: 'EmploymentDocumentMutationPayload', employmentDocumentType?: { __typename?: 'EmploymentDocumentType', id: string, status?: EmployersEmploymentDocumentStatusChoices | null, candidate: { __typename?: 'CandidateProfileType', id: string } } | null } | null };

export type GetEmployerDocumentQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetEmployerDocumentQuery = { __typename?: 'Query', getEmployerDocument?: { __typename?: 'EmploymentDocumentType', id: string, documentType?: EmployersEmploymentDocumentDocumentTypeChoices | null, baseSalaryValue?: number | null, baseSalaryUnitText?: EmployersEmploymentDocumentBaseSalaryUnitTextChoices | null, status?: EmployersEmploymentDocumentStatusChoices | null, acceptedDeclinedAt?: any | null, contactName?: string | null, contactPhone?: string | null, startingAt?: any | null, note?: string | null, candidate: { __typename?: 'CandidateProfileType', id: string, user: { __typename?: 'UserType', profileImage?: string | null } }, position: { __typename?: 'PositionType', positionName: string, createdBy?: { __typename?: 'UserType', firstName: string, profileImage?: string | null } | null, location: { __typename?: 'LocationType', name: string, image?: string | null, addressStreet1: string, addressCity: string, addressState: string, addressPostalCode: string } }, employmentdocumentfileSet: { __typename?: 'EmploymentDocumentFileTypeConnection', edges: Array<{ __typename?: 'EmploymentDocumentFileTypeEdge', node?: { __typename?: 'EmploymentDocumentFileType', id: string, name?: string | null, attachment?: string | null, size?: string | null, url?: string | null } | null } | null> } } | null };

export type MutateEmploymentDocumentFileMutationVariables = Exact<{
  employmentDocumentId: Scalars['ID'];
  documentFiles?: InputMaybe<Array<InputMaybe<EmploymentDocumentFileInput>> | InputMaybe<EmploymentDocumentFileInput>>;
}>;


export type MutateEmploymentDocumentFileMutation = { __typename?: 'Mutation', uploadEmploymentDocument?: { __typename?: 'UploadEmploymentDocumentFileMutation', employmentDocument?: { __typename?: 'EmploymentDocumentType', id: string } | null, urls?: Array<{ __typename?: 'UploadedSignedUrl', fileName?: string | null, fileUrl?: string | null, signedS3Url?: string | null, link?: string | null } | null> | null } | null };

export type MutateGoogleOAuthMutationVariables = Exact<{
  authCode: Scalars['String'];
  authType: Scalars['String'];
  userGroup?: InputMaybe<Scalars['String']>;
}>;


export type MutateGoogleOAuthMutation = { __typename?: 'Mutation', googleOauth?: { __typename?: 'GoogleOAuthMutation', token?: string | null, invitedLocation?: string | null, invitedBy?: string | null, existingLocation?: string | null } | null };

export type MutateSendHelpRequestMutationVariables = Exact<{
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  employerName: Scalars['String'];
  message: Scalars['String'];
}>;


export type MutateSendHelpRequestMutation = { __typename?: 'Mutation', sendHelpRequest?: { __typename?: 'SendHelpRequestMutation', success?: boolean | null } | null };

export type DeleteIndeedTokenMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type DeleteIndeedTokenMutation = { __typename?: 'Mutation', deleteIndeedToken?: { __typename?: 'IndeedOAuthTokenDeleteMutation', ok?: boolean | null } | null };

export type DeleteIntegrationIdentifierMutationVariables = Exact<{
  integration: Scalars['String'];
}>;


export type DeleteIntegrationIdentifierMutation = { __typename?: 'Mutation', deleteIntegrationIdentifier?: { __typename?: 'IntegrationIdentifierDeleteMutation', ok?: boolean | null } | null };

export type Delete7ShiftsGuidMutationVariables = Exact<{
  id: Scalars['ID'];
}>;


export type Delete7ShiftsGuidMutation = { __typename?: 'Mutation', sevenshiftsDeleteGuid?: { __typename?: 'SevenShiftsDeleteGuidMutation', ok?: boolean | null } | null };

export type GetCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCompaniesQuery = { __typename?: 'Query', sevenshiftsCompanies?: Array<{ __typename?: 'SevenShiftsGuidType', id: string, companyName?: string | null, companyId: string, guid: string, createdAt?: any | null, updatedAt?: any | null, createdBy: { __typename?: 'UserType', firstName: string, lastName: string, email?: string | null } } | null> | null, indeedCompanies?: Array<{ __typename?: 'IndeedCompanyType', id: string, indeedCompany?: string | null, createdAt?: any | null, hasActiveCampaign?: boolean | null } | null> | null, integrationIdentifiers?: Array<{ __typename?: 'IntegrationIdentifierType', integration: string, identifier: string } | null> | null };

export type GetDepartmentsQueryVariables = Exact<{
  companyId: Scalars['Int'];
  locationId?: InputMaybe<Scalars['Int']>;
}>;


export type GetDepartmentsQuery = { __typename?: 'Query', sevenshiftsDepartments?: Array<{ __typename?: 'SevenShiftsDepartmentType', id?: number | null, name?: string | null } | null> | null };

export type GetLocationsQueryVariables = Exact<{
  companyId: Scalars['Int'];
}>;


export type GetLocationsQuery = { __typename?: 'Query', sevenshiftsLocations?: Array<{ __typename?: 'SevenShiftsLocationType', id?: number | null, name?: string | null, address?: string | null } | null> | null };

export type GetRolesQueryVariables = Exact<{
  companyId: Scalars['Int'];
  locationId?: InputMaybe<Scalars['Int']>;
  departmentId?: InputMaybe<Scalars['Int']>;
}>;


export type GetRolesQuery = { __typename?: 'Query', sevenshiftsRoles?: Array<{ __typename?: 'SevenShiftsRoleType', id?: number | null, name?: string | null, departmentId?: number | null, locationId?: number | null } | null> | null };

export type CreateIndeedTokenFromCodeMutationVariables = Exact<{
  code: Scalars['String'];
  employerId?: InputMaybe<Scalars['String']>;
}>;


export type CreateIndeedTokenFromCodeMutation = { __typename?: 'Mutation', indeedRequestOauthToken?: { __typename?: 'IndeedRequestOAuthToken', ok?: boolean | null } | null };

export type CreateUpdateIntegrationIdentifierMutationVariables = Exact<{
  integration: Scalars['String'];
  identifier: Scalars['String'];
}>;


export type CreateUpdateIntegrationIdentifierMutation = { __typename?: 'Mutation', createUpdateIntegrationIdentifier?: { __typename?: 'IntegrationIdentifierCreateUpdateMutation', integration: string, identifier: string } | null };

export type Create7ShiftsUserMutationVariables = Exact<{
  employerCandidate: Scalars['ID'];
  companyId: Scalars['Int'];
  locationId: Scalars['Int'];
  departmentId: Scalars['Int'];
  roleId?: InputMaybe<Scalars['Int']>;
  hireDate?: InputMaybe<Scalars['Date']>;
  inviteUser?: InputMaybe<Scalars['Boolean']>;
}>;


export type Create7ShiftsUserMutation = { __typename?: 'Mutation', sevenshiftsCreateUser?: { __typename?: 'SevenShiftsCreateUserMutation', sevenshiftsId?: number | null, sevenshiftsUrl?: string | null, employerCandidate?: { __typename?: 'EmployerCandidateType', id: string, sevenshiftsUrl?: string | null } | null } | null };

export type GetInterviewDetailQueryVariables = Exact<{
  uuid?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
}>;


export type GetInterviewDetailQuery = { __typename?: 'Query', interview?: { __typename?: 'InterviewType', id: string, uuid?: string | null, status: ApiInterviewStatusChoices, createdAt: any, viewedAt?: any | null, scheduledFor?: any | null, interviewType?: string | null, meetingUrl?: string | null, phoneNumber?: string | null, duration?: string | null, createdBy?: { __typename?: 'UserType', id: string, interviewschedule?: { __typename?: 'InterviewScheduleType', id: string, user: { __typename?: 'UserType', timezone: string } } | null } | null, interviewAttendees?: Array<{ __typename?: 'InterviewAttendeeType', role?: string | null, user?: { __typename?: 'UserType', id: string, timezone: string } | null } | null> | null, location?: { __typename?: 'LocationType', id: string, slug: string, rowId?: number | null, name: string, summary?: string | null, image?: string | null, formattedAddress?: string | null, tags: Array<{ __typename?: 'TagType', id: string, name: string }>, answers: { __typename?: 'LocationAnswerTypeConnection', edges: Array<{ __typename?: 'LocationAnswerTypeEdge', node?: { __typename?: 'LocationAnswerType', id: string, displayIcon?: string | null, displayLabel?: string | null } | null } | null> } } | null, position?: { __typename?: 'PositionType', id: string, rowId?: number | null, positionName: string, jobDescription?: string | null, jobDescriptionType?: string | null, positionType?: Array<string | null> | null, baseSalaryMin?: number | null, baseSalaryMax?: number | null, baseSalaryUnitText?: string | null, hasApplied?: boolean | null, posted: any } | null } | null };

export type GetInterviewScheduleQueryVariables = Exact<{
  uuid?: InputMaybe<Scalars['String']>;
  startDate: Scalars['DateTime'];
  endDate: Scalars['DateTime'];
}>;


export type GetInterviewScheduleQuery = { __typename?: 'Query', interview?: { __typename?: 'InterviewType', id: string, rowId?: number | null, status: ApiInterviewStatusChoices, scheduledFor?: any | null, ics?: string | null, uuid?: string | null, interviewType?: string | null, meetingUrl?: string | null, duration?: string | null, phoneNumber?: string | null, maxWeeksOut?: number | null, interviewScheduleSlots?: Array<{ __typename?: 'InterviewScheduleDayType', day?: any | null, slots?: Array<{ __typename?: 'InterviewScheduleSlotType', start?: any | null, available?: boolean | null } | null> | null } | null> | null, createdBy?: { __typename?: 'UserType', id: string, rowId?: number | null, uuid: any, firstName: string, profileImage?: string | null, email?: string | null } | null, location?: { __typename?: 'LocationType', id: string, rowId?: number | null, slug: string, name: string, image?: string | null, formattedAddress?: string | null } | null, position?: { __typename?: 'PositionType', id: string, rowId?: number | null, slug: string, positionName: string, positionType?: Array<string | null> | null } | null } | null };

export type GetInterviewMessagingQueryVariables = Exact<{
  location: Scalars['ID'];
  slug?: InputMaybe<Scalars['String']>;
}>;


export type GetInterviewMessagingQuery = { __typename?: 'Query', interviewMessaging?: { __typename?: 'InterviewMessagingType', id: string, rowId?: number | null, interviewRequestType: EmployersInterviewMessagingInterviewRequestTypeChoices, interviewAcceptedType: EmployersInterviewMessagingInterviewAcceptedTypeChoices, interviewRequestMessaging?: string | null, interviewAcceptedMessaging?: string | null, furtherProcessUrl?: string | null } | null, location?: { __typename?: 'LocationType', id: string, slug: string } | null };

export type MutateInterviewMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  status?: InputMaybe<Scalars['String']>;
  scheduledFor?: InputMaybe<Scalars['DateTime']>;
  setViewedAt?: InputMaybe<Scalars['Boolean']>;
  position?: InputMaybe<Scalars['ID']>;
  candidateMessage?: InputMaybe<Scalars['String']>;
  interviewAttendees?: InputMaybe<Array<InputMaybe<InterviewAttendeeSerializerInput>> | InputMaybe<InterviewAttendeeSerializerInput>>;
}>;


export type MutateInterviewMutation = { __typename?: 'Mutation', mutateInterview?: { __typename?: 'InterviewMutationPayload', interview?: { __typename?: 'InterviewType', id: string, uuid?: string | null, status: ApiInterviewStatusChoices, scheduledFor?: any | null, viewedAt?: any | null, ics?: string | null } | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type SendInterviewMutationMutationVariables = Exact<{
  candidate?: InputMaybe<Scalars['ID']>;
  employerProfile?: InputMaybe<Scalars['ID']>;
  position?: InputMaybe<Scalars['ID']>;
  createdBy?: InputMaybe<Scalars['ID']>;
  messageContent?: InputMaybe<Scalars['String']>;
  interviewAttendees: Array<InputMaybe<InterviewAttendeeSerializerInput>> | InputMaybe<InterviewAttendeeSerializerInput>;
  interviewType?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  meetingUrl?: InputMaybe<Scalars['String']>;
}>;


export type SendInterviewMutationMutation = { __typename?: 'Mutation', mutateInterview?: { __typename?: 'InterviewMutationPayload', interview?: { __typename?: 'InterviewType', id: string, match?: { __typename?: 'MatchType', id: string, stage?: string | null, lastInterview?: { __typename?: 'InterviewType', id: string, status: ApiInterviewStatusChoices, scheduledFor?: any | null, location?: { __typename?: 'LocationType', id: string, formattedAddress?: string | null } | null, position?: { __typename?: 'PositionType', id: string, positionName: string } | null } | null, lastEmployerInterview?: { __typename?: 'InterviewType', id: string, status: ApiInterviewStatusChoices, scheduledFor?: any | null, location?: { __typename?: 'LocationType', id: string, formattedAddress?: string | null } | null, position?: { __typename?: 'PositionType', id: string, positionName: string } | null } | null } | null, candidate?: { __typename?: 'UserType', id: string, candidateProfile?: { __typename?: 'CandidateProfileType', id: string, rowId?: number | null, handle?: string | null } | null } | null } | null } | null };

export type UpdateMutateInterviewMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  scheduledFor?: InputMaybe<Scalars['DateTime']>;
}>;


export type UpdateMutateInterviewMutation = { __typename?: 'Mutation', mutateInterview?: { __typename?: 'InterviewMutationPayload', interview?: { __typename?: 'InterviewType', id: string, uuid?: string | null, status: ApiInterviewStatusChoices, scheduledFor?: any | null, ics?: string | null } | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type MutatePositionApplicationMutationVariables = Exact<{
  position: Scalars['ID'];
  platform?: InputMaybe<Scalars['String']>;
  initialMessage?: InputMaybe<Scalars['String']>;
}>;


export type MutatePositionApplicationMutation = { __typename?: 'Mutation', mutatePositionApplication?: { __typename?: 'PositionApplicationMutationPayload', positionApplication?: { __typename?: 'PositionApplicationType', id: string, position: { __typename?: 'PositionType', id: string, hasApplied?: boolean | null } } | null } | null };

export type GetJobPositionQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type GetJobPositionQuery = { __typename?: 'Query', position?: { __typename?: 'PositionType', id: string, rowId?: number | null, positionName: string, paymentStatus?: EmployersPositionPaymentStatusChoices | null, jobDescription?: string | null, jobDescriptionType?: string | null, positionType?: Array<string | null> | null, availabilityMonday?: Array<string | null> | null, availabilityTuesday?: Array<string | null> | null, availabilityWednesday?: Array<string | null> | null, availabilityThursday?: Array<string | null> | null, availabilityFriday?: Array<string | null> | null, availabilitySaturday?: Array<string | null> | null, availabilitySunday?: Array<string | null> | null, preferredExperience?: string | null, responsibilities?: string | null, requirements?: string | null, baseSalaryMin?: number | null, baseSalaryMax?: number | null, baseSalaryUnitText?: string | null, createdAt: any, hasApplied?: boolean | null, posted: any, allowIndexing?: boolean | null, isNonPartner?: boolean | null, hiring: boolean, updatedAt: any, externalApplyUrl?: string | null, createdBy?: { __typename?: 'UserType', id: string, uuid: any, firstName: string, profileImage?: string | null } | null, employerProfile?: { __typename?: 'EmployerProfileType', id: string } | null, location: { __typename?: 'LocationType', id: string, rowId?: number | null, slug: string, name: string, formattedAddress?: string | null, paymentStatus?: EmployersLocationPaymentStatusChoices | null, followerCount?: number | null, summary?: string | null, image?: string | null, addressCity: string, addressPostalCode: string, tags: Array<{ __typename?: 'TagType', id: string, name: string }>, answers: { __typename?: 'LocationAnswerTypeConnection', edges: Array<{ __typename?: 'LocationAnswerTypeEdge', node?: { __typename?: 'LocationAnswerType', id: string, displayIcon?: string | null, displayLabel?: string | null } | null } | null> } } } | null };

export type GetMyApplicationsQueryVariables = Exact<{
  searchTerms?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['String']>;
}>;


export type GetMyApplicationsQuery = { __typename?: 'Query', myApplications?: { __typename?: 'PositionApplicationTypeConnection', totalCount?: number | null, pageInfo: { __typename?: 'PageInfo', endCursor?: string | null, hasNextPage: boolean }, edges: Array<{ __typename?: 'PositionApplicationTypeEdge', node?: { __typename?: 'PositionApplicationType', id: string, status: EmployersPositionApplicationStatusChoices, position: { __typename?: 'PositionType', id: string, positionName: string, slug: string, appliedAt?: string | null, location: { __typename?: 'LocationType', id: string, name: string, slug: string, image?: string | null }, createdBy?: { __typename?: 'UserType', id: string, uuid: any, profileImage?: string | null, firstName: string } | null } } | null } | null> } | null };

export type GetOtherJobPositionsByLocationQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type GetOtherJobPositionsByLocationQuery = { __typename?: 'Query', location?: { __typename?: 'LocationType', id: string, name: string, formattedAddress?: string | null, positions?: { __typename?: 'PositionTypeConnection', edges: Array<{ __typename?: 'PositionTypeEdge', node?: { __typename?: 'PositionType', id: string, rowId?: number | null, archivedAt?: any | null, slug: string, positionName: string, paymentStatus?: EmployersPositionPaymentStatusChoices | null, hiring: boolean, externalApplyUrl?: string | null, location: { __typename?: 'LocationType', name: string, paymentStatus?: EmployersLocationPaymentStatusChoices | null } } | null } | null> } | null } | null };

export type GetOtherJobPositionsQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type GetOtherJobPositionsQuery = { __typename?: 'Query', position?: { __typename?: 'PositionType', id: string, location: { __typename?: 'LocationType', id: string, name: string, formattedAddress?: string | null, positions?: { __typename?: 'PositionTypeConnection', edges: Array<{ __typename?: 'PositionTypeEdge', node?: { __typename?: 'PositionType', id: string, rowId?: number | null, slug: string, positionName: string, paymentStatus?: EmployersPositionPaymentStatusChoices | null, hiring: boolean, externalApplyUrl?: string | null, location: { __typename?: 'LocationType', name: string, paymentStatus?: EmployersLocationPaymentStatusChoices | null } } | null } | null> } | null } } | null };

export type GetFeedLocationAnswersQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type GetFeedLocationAnswersQuery = { __typename?: 'Query', location?: { __typename: 'LocationType', id: string, rowId?: number | null, slug: string, answers: { __typename?: 'LocationAnswerTypeConnection', edges: Array<{ __typename?: 'LocationAnswerTypeEdge', node?: { __typename?: 'LocationAnswerType', id: string, displayIcon?: string | null, displayLabel?: string | null, question: { __typename?: 'QuestionType', id: string, title: string }, option?: { __typename?: 'QuestionOptionType', id: string, value: string } | null } | null } | null> } } | null };

export type GetFeedLocationQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type GetFeedLocationQuery = { __typename?: 'Query', location?: { __typename: 'LocationType', id: string, rowId?: number | null, isHidden?: boolean | null, isFavorited?: boolean | null, name: string, formattedAddress?: string | null, latitude?: number | null, longitude?: number | null, image?: string | null, summary?: string | null, followerCount?: number | null, addressCity: string, slug: string, employerProfile?: { __typename?: 'EmployerProfileType', id: string, status: EmployersEmployerProfileStatusChoices } | null, tags: Array<{ __typename?: 'TagType', id: string, name: string }>, answers: { __typename?: 'LocationAnswerTypeConnection', edges: Array<{ __typename?: 'LocationAnswerTypeEdge', node?: { __typename?: 'LocationAnswerType', id: string, displayIcon?: string | null, displayLabel?: string | null } | null } | null> } } | null };

export type ToggleFavoriteLocationMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;


export type ToggleFavoriteLocationMutation = { __typename?: 'Mutation', toggleFavoriteLocation?: { __typename?: 'ToggleFavoriteLocationMutationPayload', location?: { __typename: 'LocationType', id: string, isHidden?: boolean | null, isFavorited?: boolean | null, followerCount?: number | null } | null } | null };

export type ToggleHideLocationMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']>;
}>;


export type ToggleHideLocationMutation = { __typename?: 'Mutation', toggleHideLocation?: { __typename?: 'ToggleHideFromLocationMutationPayload', location?: { __typename: 'LocationType', id: string, isHidden?: boolean | null, isFavorited?: boolean | null, followerCount?: number | null } | null } | null };

export type SearchLocationsFeedQueryVariables = Exact<{
  positionTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  after?: InputMaybe<Scalars['String']>;
  search?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  latitude?: InputMaybe<Scalars['Float']>;
  longitude?: InputMaybe<Scalars['Float']>;
  healthInsurance?: InputMaybe<Scalars['Boolean']>;
  dressCode?: InputMaybe<Scalars['Boolean']>;
  restaurantTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  following?: InputMaybe<Scalars['Boolean']>;
  featured?: InputMaybe<Scalars['String']>;
}>;


export type SearchLocationsFeedQuery = { __typename?: 'Query', locations?: { __typename?: 'LocationTypeConnection', centerLat?: number | null, centerLng?: number | null, edgeCount?: number | null, totalCount?: number | null, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, startCursor?: string | null, endCursor?: string | null }, edges: Array<{ __typename?: 'LocationTypeEdge', cursor: string, node?: { __typename: 'LocationType', id: string, rowId?: number | null, isHidden?: boolean | null, isFavorited?: boolean | null, name: string, formattedAddress?: string | null, hiringPositionCount?: number | null, followerCount?: number | null, latitude?: number | null, longitude?: number | null, image?: string | null, summary?: string | null, slug: string, hasJobMatch?: boolean | null, isHiring?: boolean | null, tags: Array<{ __typename?: 'TagType', id: string, name: string }> } | null } | null> } | null };

export type GetLocationQueryVariables = Exact<{
  id: Scalars['ID'];
}>;


export type GetLocationQuery = { __typename?: 'Query', locationById?: { __typename?: 'LocationType', id: string, rowId?: number | null, name: string, slug: string, formattedAddress?: string | null, paymentStatus?: EmployersLocationPaymentStatusChoices | null, hasPositions?: boolean | null, addressStreet1: string, addressStreet2?: string | null, addressCity: string, addressState: string, addressPostalCode: string, summary?: string | null, indeedEasyapplyOptoutDefault: boolean, answers: { __typename?: 'LocationAnswerTypeConnection', edges: Array<{ __typename?: 'LocationAnswerTypeEdge', node?: { __typename?: 'LocationAnswerType', id: string, response: string, question: { __typename?: 'QuestionType', id: string }, option?: { __typename?: 'QuestionOptionType', id: string, value: string } | null } | null } | null> } } | null };

export type GetLocationToClaimQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type GetLocationToClaimQuery = { __typename?: 'Query', location?: { __typename: 'LocationType', id: string, rowId?: number | null, slug: string, isHidden?: boolean | null, isFavorited?: boolean | null, name: string, addressStreet1: string, addressStreet2?: string | null, addressCity: string, addressState: string, addressPostalCode: string, image?: string | null, summary?: string | null, indeedEasyapplyOptoutDefault: boolean, answers: { __typename?: 'LocationAnswerTypeConnection', edges: Array<{ __typename?: 'LocationAnswerTypeEdge', node?: { __typename?: 'LocationAnswerType', id: string, response: string, question: { __typename?: 'QuestionType', id: string }, option?: { __typename?: 'QuestionOptionType', id: string, value: string } | null } | null } | null> } } | null };

export type GetMyLocationsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
}>;


export type GetMyLocationsQuery = { __typename?: 'Query', me?: { __typename: 'UserType', id: string, myLocations?: { __typename?: 'LocationTypeConnection', edges: Array<{ __typename?: 'LocationTypeEdge', node?: { __typename?: 'LocationType', id: string, rowId?: number | null, image?: string | null, name: string, displayName?: string | null, slug: string, formattedAddress?: string | null, paymentStatus?: EmployersLocationPaymentStatusChoices | null, hasPositions?: boolean | null, indeedEasyapplyOptoutDefault: boolean } | null } | null> } | null } | null };

export type MutateCreateLocationMutationVariables = Exact<{
  name: Scalars['String'];
  summary?: InputMaybe<Scalars['String']>;
  addressStreet1: Scalars['String'];
  addressStreet2?: InputMaybe<Scalars['String']>;
  addressCity: Scalars['String'];
  addressState: Scalars['String'];
  addressPostalCode: Scalars['String'];
  indeedEasyapplyOptoutDefault?: InputMaybe<Scalars['Boolean']>;
}>;


export type MutateCreateLocationMutation = { __typename?: 'Mutation', mutateLocation?: { __typename?: 'LocationMutationPayload', location?: { __typename?: 'LocationType', id: string, rowId?: number | null, name: string, summary?: string | null, addressStreet1: string, addressStreet2?: string | null, addressCity: string, addressState: string, addressPostalCode: string, slug: string, indeedEasyapplyOptoutDefault: boolean } | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type MutateUpdateLocationMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  name: Scalars['String'];
  summary?: InputMaybe<Scalars['String']>;
  addressStreet1: Scalars['String'];
  addressStreet2?: InputMaybe<Scalars['String']>;
  addressCity: Scalars['String'];
  addressState: Scalars['String'];
  addressPostalCode: Scalars['String'];
  indeedEasyapplyOptoutDefault?: InputMaybe<Scalars['Boolean']>;
}>;


export type MutateUpdateLocationMutation = { __typename?: 'Mutation', mutateLocation?: { __typename?: 'LocationMutationPayload', location?: { __typename?: 'LocationType', id: string, rowId?: number | null, name: string, summary?: string | null, addressStreet1: string, addressStreet2?: string | null, addressCity: string, addressState: string, addressPostalCode: string, slug: string, image?: string | null, indeedEasyapplyOptoutDefault: boolean } | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type MutateUpdateLocationImageMutationVariables = Exact<{
  locationId: Scalars['ID'];
  fileName: Scalars['String'];
  fileType: Scalars['String'];
}>;


export type MutateUpdateLocationImageMutation = { __typename?: 'Mutation', mutateLocationImage?: { __typename?: 'LocationImageMutationPayload', imageUploadUrl?: string | null, locationImage?: { __typename?: 'LocationImageType', id: string, location?: { __typename?: 'LocationType', id: string, rowId?: number | null, name: string, summary?: string | null, addressStreet1: string, addressStreet2?: string | null, addressCity: string, addressState: string, addressPostalCode: string, slug: string } | null } | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };

export type SearchLocationsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
}>;


export type SearchLocationsQuery = { __typename?: 'Query', locations?: { __typename?: 'LocationTypeConnection', edgeCount?: number | null, edges: Array<{ __typename?: 'LocationTypeEdge', cursor: string, node?: { __typename: 'LocationType', id: string, rowId?: number | null, slug: string, name: string, formattedAddress?: string | null, followerCount?: number | null, image?: string | null } | null } | null> } | null };

export type GetEmployerNotificationPreferenceQueryVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  employerProfileUserId?: InputMaybe<Scalars['ID']>;
}>;


export type GetEmployerNotificationPreferenceQuery = { __typename?: 'Query', employerNotificationPreference?: { __typename?: 'EmployerProfileUserNotificationPreferenceType', id: string, employerProfileUser?: { __typename?: 'EmployerProfileUserType', id: string } | null, notifications?: { __typename?: 'NotificationPreferenceSubType', dailyDigest?: { __typename?: 'NotificationPreferenceResponse', sms?: boolean | null, email?: boolean | null } | null, chatMessage?: { __typename?: 'NotificationPreferenceResponse', sms?: boolean | null, email?: boolean | null } | null, interviewResponse?: { __typename?: 'NotificationPreferenceResponse', sms?: boolean | null, email?: boolean | null } | null } | null } | null };

export type MutateEmployerNotificationPreferenceMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']>;
  dailyDigestEmail?: InputMaybe<Scalars['Boolean']>;
  chatMessageSms?: InputMaybe<Scalars['Boolean']>;
  chatMessageEmail?: InputMaybe<Scalars['Boolean']>;
  interviewResponseSms?: InputMaybe<Scalars['Boolean']>;
  interviewResponseEmail?: InputMaybe<Scalars['Boolean']>;
}>;


export type MutateEmployerNotificationPreferenceMutation = { __typename?: 'Mutation', mutateEmployerNotificationPreference?: { __typename?: 'EmployerProfileUserNotificationPreferenceMutation', id?: string | null, notifications?: { __typename?: 'NotificationPreferenceSubType', dailyDigest?: { __typename?: 'NotificationPreferenceResponse', sms?: boolean | null, email?: boolean | null } | null, chatMessage?: { __typename?: 'NotificationPreferenceResponse', sms?: boolean | null, email?: boolean | null } | null, interviewResponse?: { __typename?: 'NotificationPreferenceResponse', sms?: boolean | null, email?: boolean | null } | null } | null } | null };

export type GetPreferredMatchQueryVariables = Exact<{
  employerCandidateId: Scalars['ID'];
}>;


export type GetPreferredMatchQuery = { __typename?: 'Query', employerCandidate?: { __typename?: 'EmployerCandidateType', id: string, createdAt?: any | null, preferredMatch?: { __typename?: 'MatchType', id: string, position: { __typename?: 'PositionType', id: string, positionName: string, location: { __typename?: 'LocationType', id: string, name: string, displayName?: string | null, formattedAddress?: string | null } } } | null } | null };

export type SetPreferredMatchMutationVariables = Exact<{
  employerCandidateId: Scalars['ID'];
  positionId: Scalars['ID'];
}>;


export type SetPreferredMatchMutation = { __typename?: 'Mutation', setPreferredMatchForPosition?: { __typename?: 'SetPreferredMatchForPosition', employerCandidate?: { __typename?: 'EmployerCandidateType', id: string, preferredMatch?: { __typename?: 'MatchType', id: string, position: { __typename?: 'PositionType', id: string, positionName: string } } | null } | null, channel?: { __typename?: 'ChannelType', id: string, lastPosition?: { __typename?: 'PositionType', id: string, positionName: string } | null } | null } | null };

export type MutateClaimTokenSignInMutationVariables = Exact<{
  uid: Scalars['String'];
  claimToken: Scalars['String'];
}>;


export type MutateClaimTokenSignInMutation = { __typename?: 'Mutation', claimTokenSignInMutation?: { __typename?: 'ClaimTokenSignInMutation', authorization?: string | null, me?: { __typename?: 'UserType', id: string, rowId?: number | null, notifyViaSms: boolean, smsVerifiedAt?: any | null, notifyViaEmail: boolean, emailVerifiedAt?: any | null, email?: string | null, profileImage?: string | null, candidateProfile?: { __typename?: 'CandidateProfileType', id: string, handle?: string | null, onboardingCompletedAt?: any | null, addressPostalCode?: string | null, positions?: Array<string | null> | null } | null } | null } | null };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename?: 'Query', me?: { __typename?: 'UserType', id: string, rowId?: number | null, profileImage?: string | null, notifyViaSms: boolean, smsVerifiedAt?: any | null, notifyViaEmail: boolean, emailVerifiedAt?: any | null, email?: string | null, phone?: string | null, firstName: string, lastName: string, unclaimed?: boolean | null, sendbirdAccessToken?: string | null, uuid: any, hasSchedule?: boolean | null, timezone: string, integrations?: Array<string | null> | null, notifications?: Array<{ __typename?: 'NotificationType', uri?: string | null, message?: string | null, category?: NotificationCategoryEnum | null } | null> | null, employerProfileUser?: { __typename?: 'EmployerProfileUserType', id: string, role: EmployersEmployerProfileUserRoleChoices } | null, candidateProfile?: { __typename?: 'CandidateProfileType', id: string, handle?: string | null, onboardingCompletedAt?: any | null, addressPostalCode?: string | null, positions?: Array<string | null> | null, restaurantTypes?: Array<string | null> | null, canHaveDressCode?: boolean | null, isBenefitsRequired?: boolean | null, status?: string | null, availabilityMonday?: Array<string | null> | null, availabilityTuesday?: Array<string | null> | null, availabilityWednesday?: Array<string | null> | null, availabilityThursday?: Array<string | null> | null, availabilityFriday?: Array<string | null> | null, availabilitySaturday?: Array<string | null> | null, availabilitySunday?: Array<string | null> | null, commutePreference: string, personalSummary: string, additionalTraining?: Array<string | null> | null, employmentPreferences?: Array<string | null> | null, profileVideo?: string | null, yearsExperience: string, resume?: string | null, url?: string | null } | null, employerProfile?: { __typename?: 'EmployerProfileType', id: string, companyName?: string | null, verified: boolean, subscribed?: boolean | null, status: EmployersEmployerProfileStatusChoices, rowId?: number | null } | null } | null };

export type GetMyFeatureFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyFeatureFlagsQuery = { __typename?: 'Query', waffleFlags?: Array<{ __typename?: 'WaffleFlagType', id?: string | null, on?: boolean | null, feature?: string | null } | null> | null, me?: { __typename?: 'UserType', id: string, featureFlags?: { __typename?: 'FeatureFlagTypeConnection', edges: Array<{ __typename?: 'FeatureFlagTypeEdge', node?: { __typename?: 'FeatureFlagType', id: string, feature?: string | null, on: boolean } | null } | null> } | null } | null };

export type GetMyLastMatchCreationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyLastMatchCreationQuery = { __typename?: 'Query', me?: { __typename?: 'UserType', id: string, candidateProfile?: { __typename?: 'CandidateProfileType', id: string, lastMatchCreation?: any | null } | null } | null };

export type GetMyWorkHistoryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyWorkHistoryQuery = { __typename?: 'Query', me?: { __typename?: 'UserType', id: string, candidateProfile?: { __typename?: 'CandidateProfileType', id: string, workHistory: { __typename?: 'CandidateWorkHistoryTypeConnection', edges: Array<{ __typename?: 'CandidateWorkHistoryTypeEdge', node?: { __typename?: 'CandidateWorkHistoryType', id: string } | null } | null> } } | null } | null };

export type GetMyPhotoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyPhotoQuery = { __typename?: 'Query', me?: { __typename?: 'UserType', id: string, profileImage?: string | null } | null };

export type GetMyCandidateProfileFiltersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyCandidateProfileFiltersQuery = { __typename?: 'Query', me?: { __typename?: 'UserType', id: string, candidateProfile?: { __typename?: 'CandidateProfileType', id: string, addressPostalCode?: string | null, positions?: Array<string | null> | null, restaurantTypes?: Array<string | null> | null, canHaveDressCode?: boolean | null, isBenefitsRequired?: boolean | null } | null } | null };

export type MutateSignInInterviewRequestMutationVariables = Exact<{
  interviewToken: Scalars['String'];
  uuid: Scalars['String'];
}>;


export type MutateSignInInterviewRequestMutation = { __typename?: 'Mutation', signInInterviewMutation?: { __typename?: 'SignInInterviewMutation', authorization?: string | null } | null };

export type MutateProfileImageMutationVariables = Exact<{
  fileName: Scalars['String'];
  fileType: Scalars['String'];
}>;


export type MutateProfileImageMutation = { __typename?: 'Mutation', mutateProfileImage?: { __typename?: 'ProfileImageMutationPayload', imageUploadUrl?: string | null, profileImage?: { __typename?: 'ProfileImageType', id: string, rowId?: number | null } | null, errors?: Array<{ __typename?: 'ErrorType', field: string, messages: Array<string> } | null> | null } | null };


export const CalculatePriceDocument = gql`
    query CalculatePrice($location: ID, $paymentStatus: PaymentStatusEnum, $singleposition: Boolean) {
  calculatePrice(
    location: $location
    paymentStatus: $paymentStatus
    singleposition: $singleposition
  ) {
    monthlyPayAsYouGo {
      total
      displayPerMonth
    }
    annualPayAsYouGo {
      total
      displayPerMonth
    }
    monthlyUnlimited {
      total
      displayPerMonth
    }
    annualUnlimited {
      total
      displayPerMonth
    }
  }
}
    `;

/**
 * __useCalculatePriceQuery__
 *
 * To run a query within a React component, call `useCalculatePriceQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalculatePriceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalculatePriceQuery({
 *   variables: {
 *      location: // value for 'location'
 *      paymentStatus: // value for 'paymentStatus'
 *      singleposition: // value for 'singleposition'
 *   },
 * });
 */
export function useCalculatePriceQuery(baseOptions?: Apollo.QueryHookOptions<CalculatePriceQuery, CalculatePriceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalculatePriceQuery, CalculatePriceQueryVariables>(CalculatePriceDocument, options);
      }
export function useCalculatePriceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalculatePriceQuery, CalculatePriceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalculatePriceQuery, CalculatePriceQueryVariables>(CalculatePriceDocument, options);
        }
export type CalculatePriceQueryHookResult = ReturnType<typeof useCalculatePriceQuery>;
export type CalculatePriceLazyQueryHookResult = ReturnType<typeof useCalculatePriceLazyQuery>;
export type CalculatePriceQueryResult = Apollo.QueryResult<CalculatePriceQuery, CalculatePriceQueryVariables>;
export const CancellationReasonDocument = gql`
    mutation CancellationReason($position: ID, $location: ID!, $cancellationReasonOther: String, $hiredFohandboh: Boolean, $hiredOther: Boolean, $tooFewApplicants: Boolean, $candidatesUnresponsive: Boolean, $needsChange: Boolean, $other: Boolean) {
  mutateCancellationReason(
    input: {position: $position, location: $location, cancellationReasonOther: $cancellationReasonOther, hiredFohandboh: $hiredFohandboh, hiredOther: $hiredOther, tooFewApplicants: $tooFewApplicants, candidatesUnresponsive: $candidatesUnresponsive, needsChange: $needsChange, other: $other, partialUpdate: true}
  ) {
    cancellationReason {
      id
      cancellationReasonOther
      hiredFohandboh
      hiredOther
      tooFewApplicants
      candidatesUnresponsive
      needsChange
      other
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type CancellationReasonMutationFn = Apollo.MutationFunction<CancellationReasonMutation, CancellationReasonMutationVariables>;

/**
 * __useCancellationReasonMutation__
 *
 * To run a mutation, you first call `useCancellationReasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancellationReasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancellationReasonMutation, { data, loading, error }] = useCancellationReasonMutation({
 *   variables: {
 *      position: // value for 'position'
 *      location: // value for 'location'
 *      cancellationReasonOther: // value for 'cancellationReasonOther'
 *      hiredFohandboh: // value for 'hiredFohandboh'
 *      hiredOther: // value for 'hiredOther'
 *      tooFewApplicants: // value for 'tooFewApplicants'
 *      candidatesUnresponsive: // value for 'candidatesUnresponsive'
 *      needsChange: // value for 'needsChange'
 *      other: // value for 'other'
 *   },
 * });
 */
export function useCancellationReasonMutation(baseOptions?: Apollo.MutationHookOptions<CancellationReasonMutation, CancellationReasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancellationReasonMutation, CancellationReasonMutationVariables>(CancellationReasonDocument, options);
      }
export type CancellationReasonMutationHookResult = ReturnType<typeof useCancellationReasonMutation>;
export type CancellationReasonMutationResult = Apollo.MutationResult<CancellationReasonMutation>;
export type CancellationReasonMutationOptions = Apollo.BaseMutationOptions<CancellationReasonMutation, CancellationReasonMutationVariables>;
export const CreatePaymentIntentDocument = gql`
    mutation CreatePaymentIntent($positionId: ID!, $amount: Int!) {
  createStripePaymentIntent(amount: $amount, positionId: $positionId) {
    clientSecret
    paymentIntent
  }
}
    `;
export type CreatePaymentIntentMutationFn = Apollo.MutationFunction<CreatePaymentIntentMutation, CreatePaymentIntentMutationVariables>;

/**
 * __useCreatePaymentIntentMutation__
 *
 * To run a mutation, you first call `useCreatePaymentIntentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePaymentIntentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPaymentIntentMutation, { data, loading, error }] = useCreatePaymentIntentMutation({
 *   variables: {
 *      positionId: // value for 'positionId'
 *      amount: // value for 'amount'
 *   },
 * });
 */
export function useCreatePaymentIntentMutation(baseOptions?: Apollo.MutationHookOptions<CreatePaymentIntentMutation, CreatePaymentIntentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePaymentIntentMutation, CreatePaymentIntentMutationVariables>(CreatePaymentIntentDocument, options);
      }
export type CreatePaymentIntentMutationHookResult = ReturnType<typeof useCreatePaymentIntentMutation>;
export type CreatePaymentIntentMutationResult = Apollo.MutationResult<CreatePaymentIntentMutation>;
export type CreatePaymentIntentMutationOptions = Apollo.BaseMutationOptions<CreatePaymentIntentMutation, CreatePaymentIntentMutationVariables>;
export const DeactivateSubscriptionMutateDocument = gql`
    mutation DeactivateSubscriptionMutate($stripeSubscription: String!, $position: ID) {
  deactivateSubscription(
    stripeSubscription: $stripeSubscription
    position: $position
  ) {
    positions {
      id
      hiring
      paymentStatus
    }
    payment {
      id
      startedOn
      subscriptionWillEndOn
      subscriptionEndedOn
      subscription {
        id
        currentPeriodEnd
        displayChargeAmount
      }
    }
  }
}
    `;
export type DeactivateSubscriptionMutateMutationFn = Apollo.MutationFunction<DeactivateSubscriptionMutateMutation, DeactivateSubscriptionMutateMutationVariables>;

/**
 * __useDeactivateSubscriptionMutateMutation__
 *
 * To run a mutation, you first call `useDeactivateSubscriptionMutateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateSubscriptionMutateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateSubscriptionMutateMutation, { data, loading, error }] = useDeactivateSubscriptionMutateMutation({
 *   variables: {
 *      stripeSubscription: // value for 'stripeSubscription'
 *      position: // value for 'position'
 *   },
 * });
 */
export function useDeactivateSubscriptionMutateMutation(baseOptions?: Apollo.MutationHookOptions<DeactivateSubscriptionMutateMutation, DeactivateSubscriptionMutateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeactivateSubscriptionMutateMutation, DeactivateSubscriptionMutateMutationVariables>(DeactivateSubscriptionMutateDocument, options);
      }
export type DeactivateSubscriptionMutateMutationHookResult = ReturnType<typeof useDeactivateSubscriptionMutateMutation>;
export type DeactivateSubscriptionMutateMutationResult = Apollo.MutationResult<DeactivateSubscriptionMutateMutation>;
export type DeactivateSubscriptionMutateMutationOptions = Apollo.BaseMutationOptions<DeactivateSubscriptionMutateMutation, DeactivateSubscriptionMutateMutationVariables>;
export const GetCancelReasonsDocument = gql`
    query GetCancelReasons {
  cancellationChoices
}
    `;

/**
 * __useGetCancelReasonsQuery__
 *
 * To run a query within a React component, call `useGetCancelReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCancelReasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCancelReasonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCancelReasonsQuery(baseOptions?: Apollo.QueryHookOptions<GetCancelReasonsQuery, GetCancelReasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCancelReasonsQuery, GetCancelReasonsQueryVariables>(GetCancelReasonsDocument, options);
      }
export function useGetCancelReasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCancelReasonsQuery, GetCancelReasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCancelReasonsQuery, GetCancelReasonsQueryVariables>(GetCancelReasonsDocument, options);
        }
export type GetCancelReasonsQueryHookResult = ReturnType<typeof useGetCancelReasonsQuery>;
export type GetCancelReasonsLazyQueryHookResult = ReturnType<typeof useGetCancelReasonsLazyQuery>;
export type GetCancelReasonsQueryResult = Apollo.QueryResult<GetCancelReasonsQuery, GetCancelReasonsQueryVariables>;
export const GetCurrentPlanDocument = gql`
    query GetCurrentPlan($location: ID!) {
  locationById(id: $location) {
    id
    rowId
    paymentStatus
    employerProfile {
      id
      status
      usersCanCancel
    }
    payment {
      id
      planName
      startedOn
      subscriptionWillEndOn
      subscriptionEndedOn
      subscription {
        id
        cycle
        currentPeriodEnd
        displayChargeAmount
      }
    }
  }
}
    `;

/**
 * __useGetCurrentPlanQuery__
 *
 * To run a query within a React component, call `useGetCurrentPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCurrentPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCurrentPlanQuery({
 *   variables: {
 *      location: // value for 'location'
 *   },
 * });
 */
export function useGetCurrentPlanQuery(baseOptions: Apollo.QueryHookOptions<GetCurrentPlanQuery, GetCurrentPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCurrentPlanQuery, GetCurrentPlanQueryVariables>(GetCurrentPlanDocument, options);
      }
export function useGetCurrentPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCurrentPlanQuery, GetCurrentPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCurrentPlanQuery, GetCurrentPlanQueryVariables>(GetCurrentPlanDocument, options);
        }
export type GetCurrentPlanQueryHookResult = ReturnType<typeof useGetCurrentPlanQuery>;
export type GetCurrentPlanLazyQueryHookResult = ReturnType<typeof useGetCurrentPlanLazyQuery>;
export type GetCurrentPlanQueryResult = Apollo.QueryResult<GetCurrentPlanQuery, GetCurrentPlanQueryVariables>;
export const GetMyPositionsPlanDocument = gql`
    query GetMyPositionsPlan($location: ID) {
  myPositions(location: $location) {
    edges {
      node {
        id
        rowId
        slug
        positionName
        hiring
        positionType
        createdAt
        paymentStatus
        hiringStatus
        location {
          id
          paymentStatus
        }
        payment {
          id
          planName
          startedOn
          stripeSubscription
          stripeCustomer
          subscriptionWillEndOn
          subscriptionEndedOn
          subscription {
            id
            cycle
            currentPeriodEnd
            displayChargeAmount
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMyPositionsPlanQuery__
 *
 * To run a query within a React component, call `useGetMyPositionsPlanQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyPositionsPlanQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyPositionsPlanQuery({
 *   variables: {
 *      location: // value for 'location'
 *   },
 * });
 */
export function useGetMyPositionsPlanQuery(baseOptions?: Apollo.QueryHookOptions<GetMyPositionsPlanQuery, GetMyPositionsPlanQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyPositionsPlanQuery, GetMyPositionsPlanQueryVariables>(GetMyPositionsPlanDocument, options);
      }
export function useGetMyPositionsPlanLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyPositionsPlanQuery, GetMyPositionsPlanQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyPositionsPlanQuery, GetMyPositionsPlanQueryVariables>(GetMyPositionsPlanDocument, options);
        }
export type GetMyPositionsPlanQueryHookResult = ReturnType<typeof useGetMyPositionsPlanQuery>;
export type GetMyPositionsPlanLazyQueryHookResult = ReturnType<typeof useGetMyPositionsPlanLazyQuery>;
export type GetMyPositionsPlanQueryResult = Apollo.QueryResult<GetMyPositionsPlanQuery, GetMyPositionsPlanQueryVariables>;
export const GetPositionToPayForDocument = gql`
    query GetPositionToPayFor($id: ID!) {
  positionById(id: $id) {
    id
    slug
    rowId
    positionName
    positionType
    paymentStatus
    location {
      id
      rowId
    }
    payment {
      id
      startedOn
      subscriptionWillEndOn
      subscriptionEndedOn
      subscription {
        id
        currentPeriodEnd
        displayChargeAmount
      }
    }
  }
}
    `;

/**
 * __useGetPositionToPayForQuery__
 *
 * To run a query within a React component, call `useGetPositionToPayForQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPositionToPayForQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPositionToPayForQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPositionToPayForQuery(baseOptions: Apollo.QueryHookOptions<GetPositionToPayForQuery, GetPositionToPayForQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPositionToPayForQuery, GetPositionToPayForQueryVariables>(GetPositionToPayForDocument, options);
      }
export function useGetPositionToPayForLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPositionToPayForQuery, GetPositionToPayForQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPositionToPayForQuery, GetPositionToPayForQueryVariables>(GetPositionToPayForDocument, options);
        }
export type GetPositionToPayForQueryHookResult = ReturnType<typeof useGetPositionToPayForQuery>;
export type GetPositionToPayForLazyQueryHookResult = ReturnType<typeof useGetPositionToPayForLazyQuery>;
export type GetPositionToPayForQueryResult = Apollo.QueryResult<GetPositionToPayForQuery, GetPositionToPayForQueryVariables>;
export const ReactivateSubscriptionMutationDocument = gql`
    mutation ReactivateSubscriptionMutation($stripeSubscription: String!, $positions: [ID]) {
  reactivateSubscription(
    stripeSubscription: $stripeSubscription
    positions: $positions
  ) {
    positions {
      id
      hiring
      paymentStatus
    }
    payment {
      id
      startedOn
      subscriptionWillEndOn
      subscriptionEndedOn
      subscription {
        id
        currentPeriodEnd
        displayChargeAmount
      }
    }
  }
}
    `;
export type ReactivateSubscriptionMutationMutationFn = Apollo.MutationFunction<ReactivateSubscriptionMutationMutation, ReactivateSubscriptionMutationMutationVariables>;

/**
 * __useReactivateSubscriptionMutationMutation__
 *
 * To run a mutation, you first call `useReactivateSubscriptionMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateSubscriptionMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateSubscriptionMutationMutation, { data, loading, error }] = useReactivateSubscriptionMutationMutation({
 *   variables: {
 *      stripeSubscription: // value for 'stripeSubscription'
 *      positions: // value for 'positions'
 *   },
 * });
 */
export function useReactivateSubscriptionMutationMutation(baseOptions?: Apollo.MutationHookOptions<ReactivateSubscriptionMutationMutation, ReactivateSubscriptionMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactivateSubscriptionMutationMutation, ReactivateSubscriptionMutationMutationVariables>(ReactivateSubscriptionMutationDocument, options);
      }
export type ReactivateSubscriptionMutationMutationHookResult = ReturnType<typeof useReactivateSubscriptionMutationMutation>;
export type ReactivateSubscriptionMutationMutationResult = Apollo.MutationResult<ReactivateSubscriptionMutationMutation>;
export type ReactivateSubscriptionMutationMutationOptions = Apollo.BaseMutationOptions<ReactivateSubscriptionMutationMutation, ReactivateSubscriptionMutationMutationVariables>;
export const MutateEndCampaignDocument = gql`
    mutation MutateEndCampaign($campaignId: String!) {
  endCampaign(campaignId: $campaignId) {
    ended
  }
}
    `;
export type MutateEndCampaignMutationFn = Apollo.MutationFunction<MutateEndCampaignMutation, MutateEndCampaignMutationVariables>;

/**
 * __useMutateEndCampaignMutation__
 *
 * To run a mutation, you first call `useMutateEndCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutateEndCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateEndCampaignMutation, { data, loading, error }] = useMutateEndCampaignMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useMutateEndCampaignMutation(baseOptions?: Apollo.MutationHookOptions<MutateEndCampaignMutation, MutateEndCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutateEndCampaignMutation, MutateEndCampaignMutationVariables>(MutateEndCampaignDocument, options);
      }
export type MutateEndCampaignMutationHookResult = ReturnType<typeof useMutateEndCampaignMutation>;
export type MutateEndCampaignMutationResult = Apollo.MutationResult<MutateEndCampaignMutation>;
export type MutateEndCampaignMutationOptions = Apollo.BaseMutationOptions<MutateEndCampaignMutation, MutateEndCampaignMutationVariables>;
export const GetCampaignsDataDocument = gql`
    query GetCampaignsData($employer: ID, $position: ID, $stripeCustomer: String, $orderBy: String) {
  jobBoardCampaigns(
    employer: $employer
    position: $position
    stripeCustomer: $stripeCustomer
    orderBy: $orderBy
  ) {
    edges {
      node {
        id
        name
        platform
        amount
        stripeCustomer
        stripePaymentIntent
        startedOn
        willStartOn
        campaignEndedOn
        campaignWillEndOn
        clicks
        numApplies
        avgCpa
        spent
        active
        applicationsCount
        isDraft
        statsUpdatedAt
        status
        positions {
          edges {
            node {
              positionName
              location {
                displayName
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCampaignsDataQuery__
 *
 * To run a query within a React component, call `useGetCampaignsDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignsDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignsDataQuery({
 *   variables: {
 *      employer: // value for 'employer'
 *      position: // value for 'position'
 *      stripeCustomer: // value for 'stripeCustomer'
 *      orderBy: // value for 'orderBy'
 *   },
 * });
 */
export function useGetCampaignsDataQuery(baseOptions?: Apollo.QueryHookOptions<GetCampaignsDataQuery, GetCampaignsDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignsDataQuery, GetCampaignsDataQueryVariables>(GetCampaignsDataDocument, options);
      }
export function useGetCampaignsDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignsDataQuery, GetCampaignsDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignsDataQuery, GetCampaignsDataQueryVariables>(GetCampaignsDataDocument, options);
        }
export type GetCampaignsDataQueryHookResult = ReturnType<typeof useGetCampaignsDataQuery>;
export type GetCampaignsDataLazyQueryHookResult = ReturnType<typeof useGetCampaignsDataLazyQuery>;
export type GetCampaignsDataQueryResult = Apollo.QueryResult<GetCampaignsDataQuery, GetCampaignsDataQueryVariables>;
export const CampaignEstimationDocument = gql`
    query campaignEstimation($campaignId: ID, $startDate: Date, $endDate: Date, $budget: Float) {
  campaignEstimation(
    campaignId: $campaignId
    startDate: $startDate
    endDate: $endDate
    budget: $budget
  ) {
    message
  }
}
    `;

/**
 * __useCampaignEstimationQuery__
 *
 * To run a query within a React component, call `useCampaignEstimationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignEstimationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignEstimationQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      budget: // value for 'budget'
 *   },
 * });
 */
export function useCampaignEstimationQuery(baseOptions?: Apollo.QueryHookOptions<CampaignEstimationQuery, CampaignEstimationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignEstimationQuery, CampaignEstimationQueryVariables>(CampaignEstimationDocument, options);
      }
export function useCampaignEstimationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignEstimationQuery, CampaignEstimationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignEstimationQuery, CampaignEstimationQueryVariables>(CampaignEstimationDocument, options);
        }
export type CampaignEstimationQueryHookResult = ReturnType<typeof useCampaignEstimationQuery>;
export type CampaignEstimationLazyQueryHookResult = ReturnType<typeof useCampaignEstimationLazyQuery>;
export type CampaignEstimationQueryResult = Apollo.QueryResult<CampaignEstimationQuery, CampaignEstimationQueryVariables>;
export const CampaignPredictionDocument = gql`
    query campaignPrediction($campaignId: ID!) {
  campaignPrediction(campaignId: $campaignId) {
    budget
    clicks
    days
    currencyCode
  }
}
    `;

/**
 * __useCampaignPredictionQuery__
 *
 * To run a query within a React component, call `useCampaignPredictionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignPredictionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignPredictionQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useCampaignPredictionQuery(baseOptions: Apollo.QueryHookOptions<CampaignPredictionQuery, CampaignPredictionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignPredictionQuery, CampaignPredictionQueryVariables>(CampaignPredictionDocument, options);
      }
export function useCampaignPredictionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignPredictionQuery, CampaignPredictionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignPredictionQuery, CampaignPredictionQueryVariables>(CampaignPredictionDocument, options);
        }
export type CampaignPredictionQueryHookResult = ReturnType<typeof useCampaignPredictionQuery>;
export type CampaignPredictionLazyQueryHookResult = ReturnType<typeof useCampaignPredictionLazyQuery>;
export type CampaignPredictionQueryResult = Apollo.QueryResult<CampaignPredictionQuery, CampaignPredictionQueryVariables>;
export const CreateJobBoardCampaignDocument = gql`
    mutation createJobBoardCampaign($name: String!, $positionId: ID!, $platform: String!) {
  createJobBoardCampaign(
    name: $name
    positionId: $positionId
    platform: $platform
  ) {
    campaign {
      id
      name
      platform
    }
  }
}
    `;
export type CreateJobBoardCampaignMutationFn = Apollo.MutationFunction<CreateJobBoardCampaignMutation, CreateJobBoardCampaignMutationVariables>;

/**
 * __useCreateJobBoardCampaignMutation__
 *
 * To run a mutation, you first call `useCreateJobBoardCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateJobBoardCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createJobBoardCampaignMutation, { data, loading, error }] = useCreateJobBoardCampaignMutation({
 *   variables: {
 *      name: // value for 'name'
 *      positionId: // value for 'positionId'
 *      platform: // value for 'platform'
 *   },
 * });
 */
export function useCreateJobBoardCampaignMutation(baseOptions?: Apollo.MutationHookOptions<CreateJobBoardCampaignMutation, CreateJobBoardCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateJobBoardCampaignMutation, CreateJobBoardCampaignMutationVariables>(CreateJobBoardCampaignDocument, options);
      }
export type CreateJobBoardCampaignMutationHookResult = ReturnType<typeof useCreateJobBoardCampaignMutation>;
export type CreateJobBoardCampaignMutationResult = Apollo.MutationResult<CreateJobBoardCampaignMutation>;
export type CreateJobBoardCampaignMutationOptions = Apollo.BaseMutationOptions<CreateJobBoardCampaignMutation, CreateJobBoardCampaignMutationVariables>;
export const SoftDeleteJobBoardCampaignDocument = gql`
    mutation softDeleteJobBoardCampaign($campaignId: String!) {
  softDeleteJobBoardCampaign(campaignId: $campaignId) {
    deleted
  }
}
    `;
export type SoftDeleteJobBoardCampaignMutationFn = Apollo.MutationFunction<SoftDeleteJobBoardCampaignMutation, SoftDeleteJobBoardCampaignMutationVariables>;

/**
 * __useSoftDeleteJobBoardCampaignMutation__
 *
 * To run a mutation, you first call `useSoftDeleteJobBoardCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftDeleteJobBoardCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softDeleteJobBoardCampaignMutation, { data, loading, error }] = useSoftDeleteJobBoardCampaignMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useSoftDeleteJobBoardCampaignMutation(baseOptions?: Apollo.MutationHookOptions<SoftDeleteJobBoardCampaignMutation, SoftDeleteJobBoardCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftDeleteJobBoardCampaignMutation, SoftDeleteJobBoardCampaignMutationVariables>(SoftDeleteJobBoardCampaignDocument, options);
      }
export type SoftDeleteJobBoardCampaignMutationHookResult = ReturnType<typeof useSoftDeleteJobBoardCampaignMutation>;
export type SoftDeleteJobBoardCampaignMutationResult = Apollo.MutationResult<SoftDeleteJobBoardCampaignMutation>;
export type SoftDeleteJobBoardCampaignMutationOptions = Apollo.BaseMutationOptions<SoftDeleteJobBoardCampaignMutation, SoftDeleteJobBoardCampaignMutationVariables>;
export const GetCampaignDocument = gql`
    query getCampaign($campaignId: ID!) {
  jobBoardCampaign(campaignId: $campaignId) {
    id
    name
    platform
    stripeCustomer
    employer {
      id
    }
    amount
    spent
    clicks
    numApplies
    avgCpa
    willStartOn
    campaignWillEndOn
    startedOn
    campaignEndedOn
    isDraft
    positions {
      edges {
        node {
          id
          positionName
          rowId
          location {
            id
            displayName
            formattedAddress
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCampaignQuery__
 *
 * To run a query within a React component, call `useGetCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCampaignQuery({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useGetCampaignQuery(baseOptions: Apollo.QueryHookOptions<GetCampaignQuery, GetCampaignQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCampaignQuery, GetCampaignQueryVariables>(GetCampaignDocument, options);
      }
export function useGetCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCampaignQuery, GetCampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCampaignQuery, GetCampaignQueryVariables>(GetCampaignDocument, options);
        }
export type GetCampaignQueryHookResult = ReturnType<typeof useGetCampaignQuery>;
export type GetCampaignLazyQueryHookResult = ReturnType<typeof useGetCampaignLazyQuery>;
export type GetCampaignQueryResult = Apollo.QueryResult<GetCampaignQuery, GetCampaignQueryVariables>;
export const GetIndeedBillingStatusDocument = gql`
    query GetIndeedBillingStatus {
  getIndeedBillingStatus {
    isBillingConfirmed
  }
}
    `;

/**
 * __useGetIndeedBillingStatusQuery__
 *
 * To run a query within a React component, call `useGetIndeedBillingStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIndeedBillingStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIndeedBillingStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIndeedBillingStatusQuery(baseOptions?: Apollo.QueryHookOptions<GetIndeedBillingStatusQuery, GetIndeedBillingStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIndeedBillingStatusQuery, GetIndeedBillingStatusQueryVariables>(GetIndeedBillingStatusDocument, options);
      }
export function useGetIndeedBillingStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIndeedBillingStatusQuery, GetIndeedBillingStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIndeedBillingStatusQuery, GetIndeedBillingStatusQueryVariables>(GetIndeedBillingStatusDocument, options);
        }
export type GetIndeedBillingStatusQueryHookResult = ReturnType<typeof useGetIndeedBillingStatusQuery>;
export type GetIndeedBillingStatusLazyQueryHookResult = ReturnType<typeof useGetIndeedBillingStatusLazyQuery>;
export type GetIndeedBillingStatusQueryResult = Apollo.QueryResult<GetIndeedBillingStatusQuery, GetIndeedBillingStatusQueryVariables>;
export const MutateJobBoardCampaignDocument = gql`
    mutation mutateJobBoardCampaign($id: ID, $name: String, $positionId: String, $willStartOn: DateTime, $campaignWillEndOn: DateTime, $campaignEndedOn: DateTime, $amount: Int, $isDraft: Boolean) {
  mutateJobBoardCampaign(
    input: {id: $id, name: $name, positionId: $positionId, willStartOn: $willStartOn, campaignWillEndOn: $campaignWillEndOn, campaignEndedOn: $campaignEndedOn, amount: $amount, isDraft: $isDraft, partialUpdate: true}
  ) {
    campaignType {
      id
      name
    }
  }
}
    `;
export type MutateJobBoardCampaignMutationFn = Apollo.MutationFunction<MutateJobBoardCampaignMutation, MutateJobBoardCampaignMutationVariables>;

/**
 * __useMutateJobBoardCampaignMutation__
 *
 * To run a mutation, you first call `useMutateJobBoardCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutateJobBoardCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateJobBoardCampaignMutation, { data, loading, error }] = useMutateJobBoardCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      positionId: // value for 'positionId'
 *      willStartOn: // value for 'willStartOn'
 *      campaignWillEndOn: // value for 'campaignWillEndOn'
 *      campaignEndedOn: // value for 'campaignEndedOn'
 *      amount: // value for 'amount'
 *      isDraft: // value for 'isDraft'
 *   },
 * });
 */
export function useMutateJobBoardCampaignMutation(baseOptions?: Apollo.MutationHookOptions<MutateJobBoardCampaignMutation, MutateJobBoardCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutateJobBoardCampaignMutation, MutateJobBoardCampaignMutationVariables>(MutateJobBoardCampaignDocument, options);
      }
export type MutateJobBoardCampaignMutationHookResult = ReturnType<typeof useMutateJobBoardCampaignMutation>;
export type MutateJobBoardCampaignMutationResult = Apollo.MutationResult<MutateJobBoardCampaignMutation>;
export type MutateJobBoardCampaignMutationOptions = Apollo.BaseMutationOptions<MutateJobBoardCampaignMutation, MutateJobBoardCampaignMutationVariables>;
export const SyncCampaignDocument = gql`
    mutation syncCampaign($campaignId: String!) {
  syncCampaign(campaignId: $campaignId) {
    campaign {
      id
      name
      platform
    }
  }
}
    `;
export type SyncCampaignMutationFn = Apollo.MutationFunction<SyncCampaignMutation, SyncCampaignMutationVariables>;

/**
 * __useSyncCampaignMutation__
 *
 * To run a mutation, you first call `useSyncCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncCampaignMutation, { data, loading, error }] = useSyncCampaignMutation({
 *   variables: {
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useSyncCampaignMutation(baseOptions?: Apollo.MutationHookOptions<SyncCampaignMutation, SyncCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncCampaignMutation, SyncCampaignMutationVariables>(SyncCampaignDocument, options);
      }
export type SyncCampaignMutationHookResult = ReturnType<typeof useSyncCampaignMutation>;
export type SyncCampaignMutationResult = Apollo.MutationResult<SyncCampaignMutation>;
export type SyncCampaignMutationOptions = Apollo.BaseMutationOptions<SyncCampaignMutation, SyncCampaignMutationVariables>;
export const SyncCampaignsDocument = gql`
    mutation syncCampaigns($employerId: String!) {
  syncCampaigns(employerId: $employerId) {
    updated
  }
}
    `;
export type SyncCampaignsMutationFn = Apollo.MutationFunction<SyncCampaignsMutation, SyncCampaignsMutationVariables>;

/**
 * __useSyncCampaignsMutation__
 *
 * To run a mutation, you first call `useSyncCampaignsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncCampaignsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncCampaignsMutation, { data, loading, error }] = useSyncCampaignsMutation({
 *   variables: {
 *      employerId: // value for 'employerId'
 *   },
 * });
 */
export function useSyncCampaignsMutation(baseOptions?: Apollo.MutationHookOptions<SyncCampaignsMutation, SyncCampaignsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncCampaignsMutation, SyncCampaignsMutationVariables>(SyncCampaignsDocument, options);
      }
export type SyncCampaignsMutationHookResult = ReturnType<typeof useSyncCampaignsMutation>;
export type SyncCampaignsMutationResult = Apollo.MutationResult<SyncCampaignsMutation>;
export type SyncCampaignsMutationOptions = Apollo.BaseMutationOptions<SyncCampaignsMutation, SyncCampaignsMutationVariables>;
export const GetCandidateNameDocument = gql`
    query GetCandidateName($handle: String) {
  profile(handle: $handle) {
    id
    rowId
    handle
    lastInterview {
      id
      status
    }
    user {
      id
      firstName
      lastName
    }
  }
}
    `;

/**
 * __useGetCandidateNameQuery__
 *
 * To run a query within a React component, call `useGetCandidateNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateNameQuery({
 *   variables: {
 *      handle: // value for 'handle'
 *   },
 * });
 */
export function useGetCandidateNameQuery(baseOptions?: Apollo.QueryHookOptions<GetCandidateNameQuery, GetCandidateNameQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCandidateNameQuery, GetCandidateNameQueryVariables>(GetCandidateNameDocument, options);
      }
export function useGetCandidateNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCandidateNameQuery, GetCandidateNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCandidateNameQuery, GetCandidateNameQueryVariables>(GetCandidateNameDocument, options);
        }
export type GetCandidateNameQueryHookResult = ReturnType<typeof useGetCandidateNameQuery>;
export type GetCandidateNameLazyQueryHookResult = ReturnType<typeof useGetCandidateNameLazyQuery>;
export type GetCandidateNameQueryResult = Apollo.QueryResult<GetCandidateNameQuery, GetCandidateNameQueryVariables>;
export const GetCandidateDocument = gql`
    query GetCandidate($handle: String) {
  profile(handle: $handle) {
    id
    rowId
    user {
      id
      rowId
      uuid
      firstName
      lastName
      profileImage
      phone
      email
    }
    lastInterview {
      id
      status
      scheduledFor
      ics
      interviewType
      location {
        id
        name
      }
      position {
        id
        positionName
      }
    }
    lastPositionApplication {
      id
      createdAt
      position {
        id
        positionName
        slug
        location {
          id
          name
          formattedAddress
          image
        }
      }
    }
    resume
    resumeUploadDate
    profileVideo
    personalSummary
    yearsExperience
    handle
    positions
    canHaveDressCode
    isBenefitsRequired
    additionalTraining
    status
    availabilityMonday
    availabilityTuesday
    availabilityWednesday
    availabilityThursday
    availabilityFriday
    availabilitySaturday
    availabilitySunday
    addressPostalCode
    commutePreference
    employmentPreferences
    hasAppliedToEmployer
    endorsements {
      edges {
        node {
          id
          endorser {
            id
            firstName
          }
          employerName
          body
          createdAt
        }
      }
    }
    workHistory {
      edges {
        node {
          id
          position
          responsibilities
          employerName
          start
          end
          present
          location {
            id
            slug
            image
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCandidateQuery__
 *
 * To run a query within a React component, call `useGetCandidateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateQuery({
 *   variables: {
 *      handle: // value for 'handle'
 *   },
 * });
 */
export function useGetCandidateQuery(baseOptions?: Apollo.QueryHookOptions<GetCandidateQuery, GetCandidateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCandidateQuery, GetCandidateQueryVariables>(GetCandidateDocument, options);
      }
export function useGetCandidateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCandidateQuery, GetCandidateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCandidateQuery, GetCandidateQueryVariables>(GetCandidateDocument, options);
        }
export type GetCandidateQueryHookResult = ReturnType<typeof useGetCandidateQuery>;
export type GetCandidateLazyQueryHookResult = ReturnType<typeof useGetCandidateLazyQuery>;
export type GetCandidateQueryResult = Apollo.QueryResult<GetCandidateQuery, GetCandidateQueryVariables>;
export const GetCandidateWithApplicantsDocument = gql`
    query GetCandidateWithApplicants($handle: String) {
  profile(handle: $handle) {
    id
    rowId
    user {
      id
      rowId
      uuid
      firstName
      lastName
      profileImage
      phone
      email
    }
    lastInterview {
      id
      status
      scheduledFor
      ics
      interviewType
      phoneNumber
      meetingUrl
      interviewer {
        user {
          firstName
          lastName
          email
        }
      }
      location {
        id
        name
        displayName
        formattedAddress
      }
      position {
        id
        positionName
      }
    }
    lastPositionApplication {
      id
      platform
      platformAttribution
      createdAt
      position {
        id
        positionName
        slug
        location {
          id
          name
          formattedAddress
          displayName
          image
        }
      }
    }
    resume
    resumeUploadDate
    profileVideo
    personalSummary
    yearsExperience
    handle
    positions
    canHaveDressCode
    isBenefitsRequired
    additionalTraining
    status
    availabilityMonday
    availabilityTuesday
    availabilityWednesday
    availabilityThursday
    availabilityFriday
    availabilitySaturday
    availabilitySunday
    addressPostalCode
    commutePreference
    employmentPreferences
    hasAppliedToEmployer
    endorsements {
      edges {
        node {
          id
          endorser {
            id
            firstName
          }
          employerName
          body
          createdAt
        }
      }
    }
    workHistory {
      edges {
        node {
          id
          position
          responsibilities
          employerName
          start
          end
          present
          location {
            id
            slug
            image
          }
        }
      }
    }
    applicationsForEmployer {
      edges {
        node {
          id
          createdAt
          viewedAt
          position {
            id
            positionName
            slug
            location {
              id
              name
              displayName
              formattedAddress
              image
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCandidateWithApplicantsQuery__
 *
 * To run a query within a React component, call `useGetCandidateWithApplicantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCandidateWithApplicantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCandidateWithApplicantsQuery({
 *   variables: {
 *      handle: // value for 'handle'
 *   },
 * });
 */
export function useGetCandidateWithApplicantsQuery(baseOptions?: Apollo.QueryHookOptions<GetCandidateWithApplicantsQuery, GetCandidateWithApplicantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCandidateWithApplicantsQuery, GetCandidateWithApplicantsQueryVariables>(GetCandidateWithApplicantsDocument, options);
      }
export function useGetCandidateWithApplicantsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCandidateWithApplicantsQuery, GetCandidateWithApplicantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCandidateWithApplicantsQuery, GetCandidateWithApplicantsQueryVariables>(GetCandidateWithApplicantsDocument, options);
        }
export type GetCandidateWithApplicantsQueryHookResult = ReturnType<typeof useGetCandidateWithApplicantsQuery>;
export type GetCandidateWithApplicantsLazyQueryHookResult = ReturnType<typeof useGetCandidateWithApplicantsLazyQuery>;
export type GetCandidateWithApplicantsQueryResult = Apollo.QueryResult<GetCandidateWithApplicantsQuery, GetCandidateWithApplicantsQueryVariables>;
export const GetMatchDocument = gql`
    query GetMatch($position: ID!, $handle: String!) {
  match(position: $position, handle: $handle) {
    id
    hiddenAt
    candidateStatus
    application {
      id
      createdAt
      viewedAt
      position {
        id
        positionName
        location {
          id
          name
        }
      }
    }
    lastEmployerInterview {
      id
      status
      scheduledFor
      location {
        id
        name
        formattedAddress
      }
      position {
        id
        positionName
      }
    }
  }
}
    `;

/**
 * __useGetMatchQuery__
 *
 * To run a query within a React component, call `useGetMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMatchQuery({
 *   variables: {
 *      position: // value for 'position'
 *      handle: // value for 'handle'
 *   },
 * });
 */
export function useGetMatchQuery(baseOptions: Apollo.QueryHookOptions<GetMatchQuery, GetMatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMatchQuery, GetMatchQueryVariables>(GetMatchDocument, options);
      }
export function useGetMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMatchQuery, GetMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMatchQuery, GetMatchQueryVariables>(GetMatchDocument, options);
        }
export type GetMatchQueryHookResult = ReturnType<typeof useGetMatchQuery>;
export type GetMatchLazyQueryHookResult = ReturnType<typeof useGetMatchLazyQuery>;
export type GetMatchQueryResult = Apollo.QueryResult<GetMatchQuery, GetMatchQueryVariables>;
export const PositionApplicationDocument = gql`
    mutation PositionApplication($id: ID!, $status: String, $setViewedAt: Boolean) {
  mutatePositionApplication(
    input: {partialUpdate: true, id: $id, status: $status, setViewedAt: $setViewedAt}
  ) {
    positionApplication {
      id
      status
      viewedAt
    }
  }
}
    `;
export type PositionApplicationMutationFn = Apollo.MutationFunction<PositionApplicationMutation, PositionApplicationMutationVariables>;

/**
 * __usePositionApplicationMutation__
 *
 * To run a mutation, you first call `usePositionApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePositionApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [positionApplicationMutation, { data, loading, error }] = usePositionApplicationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      setViewedAt: // value for 'setViewedAt'
 *   },
 * });
 */
export function usePositionApplicationMutation(baseOptions?: Apollo.MutationHookOptions<PositionApplicationMutation, PositionApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PositionApplicationMutation, PositionApplicationMutationVariables>(PositionApplicationDocument, options);
      }
export type PositionApplicationMutationHookResult = ReturnType<typeof usePositionApplicationMutation>;
export type PositionApplicationMutationResult = Apollo.MutationResult<PositionApplicationMutation>;
export type PositionApplicationMutationOptions = Apollo.BaseMutationOptions<PositionApplicationMutation, PositionApplicationMutationVariables>;
export const EmployerRejectionReasonDocument = gql`
    mutation EmployerRejectionReason($employerProfile: ID, $name: String) {
  mutateEmployerRejectionReason(
    input: {employerProfile: $employerProfile, name: $name, partialUpdate: true}
  ) {
    employerRejectionReason {
      name
      employerProfile {
        id
      }
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type EmployerRejectionReasonMutationFn = Apollo.MutationFunction<EmployerRejectionReasonMutation, EmployerRejectionReasonMutationVariables>;

/**
 * __useEmployerRejectionReasonMutation__
 *
 * To run a mutation, you first call `useEmployerRejectionReasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmployerRejectionReasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [employerRejectionReasonMutation, { data, loading, error }] = useEmployerRejectionReasonMutation({
 *   variables: {
 *      employerProfile: // value for 'employerProfile'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useEmployerRejectionReasonMutation(baseOptions?: Apollo.MutationHookOptions<EmployerRejectionReasonMutation, EmployerRejectionReasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmployerRejectionReasonMutation, EmployerRejectionReasonMutationVariables>(EmployerRejectionReasonDocument, options);
      }
export type EmployerRejectionReasonMutationHookResult = ReturnType<typeof useEmployerRejectionReasonMutation>;
export type EmployerRejectionReasonMutationResult = Apollo.MutationResult<EmployerRejectionReasonMutation>;
export type EmployerRejectionReasonMutationOptions = Apollo.BaseMutationOptions<EmployerRejectionReasonMutation, EmployerRejectionReasonMutationVariables>;
export const MutateBulkMoveEmployerCandidateDocument = gql`
    mutation MutateBulkMoveEmployerCandidate($oldStage: ID, $newStage: ID!, $all: Boolean, $locations: [ID], $positions: [ID], $employerCandidateIds: [ID]!, $notificationStatuses: [String], $notificationType: String, $notificationStatusToUpdate: String) {
  bulkMoveEmployerCandidatesToStage(
    oldStage: $oldStage
    newStage: $newStage
    all: $all
    positions: $positions
    locations: $locations
    employerCandidateIds: $employerCandidateIds
    notificationStatuses: $notificationStatuses
    notificationType: $notificationType
    notificationStatusToUpdate: $notificationStatusToUpdate
  ) {
    moved
    movedCandidatesCount
    stageName
    candidateName
  }
}
    `;
export type MutateBulkMoveEmployerCandidateMutationFn = Apollo.MutationFunction<MutateBulkMoveEmployerCandidateMutation, MutateBulkMoveEmployerCandidateMutationVariables>;

/**
 * __useMutateBulkMoveEmployerCandidateMutation__
 *
 * To run a mutation, you first call `useMutateBulkMoveEmployerCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutateBulkMoveEmployerCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateBulkMoveEmployerCandidateMutation, { data, loading, error }] = useMutateBulkMoveEmployerCandidateMutation({
 *   variables: {
 *      oldStage: // value for 'oldStage'
 *      newStage: // value for 'newStage'
 *      all: // value for 'all'
 *      locations: // value for 'locations'
 *      positions: // value for 'positions'
 *      employerCandidateIds: // value for 'employerCandidateIds'
 *      notificationStatuses: // value for 'notificationStatuses'
 *      notificationType: // value for 'notificationType'
 *      notificationStatusToUpdate: // value for 'notificationStatusToUpdate'
 *   },
 * });
 */
export function useMutateBulkMoveEmployerCandidateMutation(baseOptions?: Apollo.MutationHookOptions<MutateBulkMoveEmployerCandidateMutation, MutateBulkMoveEmployerCandidateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutateBulkMoveEmployerCandidateMutation, MutateBulkMoveEmployerCandidateMutationVariables>(MutateBulkMoveEmployerCandidateDocument, options);
      }
export type MutateBulkMoveEmployerCandidateMutationHookResult = ReturnType<typeof useMutateBulkMoveEmployerCandidateMutation>;
export type MutateBulkMoveEmployerCandidateMutationResult = Apollo.MutationResult<MutateBulkMoveEmployerCandidateMutation>;
export type MutateBulkMoveEmployerCandidateMutationOptions = Apollo.BaseMutationOptions<MutateBulkMoveEmployerCandidateMutation, MutateBulkMoveEmployerCandidateMutationVariables>;
export const MatchCountQueryDocument = gql`
    query MatchCountQuery($position: ID, $search: String) {
  matchFilterCounts(position: $position, search: $search) {
    bestMatchCount
    appliedCount
    pendingCount
    acceptedCount
    declinedCount
    scheduledCount
    followerCount
    postInterviewCount
  }
}
    `;

/**
 * __useMatchCountQueryQuery__
 *
 * To run a query within a React component, call `useMatchCountQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchCountQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchCountQueryQuery({
 *   variables: {
 *      position: // value for 'position'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useMatchCountQueryQuery(baseOptions?: Apollo.QueryHookOptions<MatchCountQueryQuery, MatchCountQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchCountQueryQuery, MatchCountQueryQueryVariables>(MatchCountQueryDocument, options);
      }
export function useMatchCountQueryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchCountQueryQuery, MatchCountQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchCountQueryQuery, MatchCountQueryQueryVariables>(MatchCountQueryDocument, options);
        }
export type MatchCountQueryQueryHookResult = ReturnType<typeof useMatchCountQueryQuery>;
export type MatchCountQueryLazyQueryHookResult = ReturnType<typeof useMatchCountQueryLazyQuery>;
export type MatchCountQueryQueryResult = Apollo.QueryResult<MatchCountQueryQuery, MatchCountQueryQueryVariables>;
export const EmployerCandidateNoteDocument = gql`
    query EmployerCandidateNote($employerCandidate: ID!) {
  employerCandidateNote(employerCandidate: $employerCandidate) {
    id
    createdBy {
      id
    }
    updatedBy {
      id
    }
    text
    createdAt
    updatedAt
    archivedAt
  }
}
    `;

/**
 * __useEmployerCandidateNoteQuery__
 *
 * To run a query within a React component, call `useEmployerCandidateNoteQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployerCandidateNoteQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployerCandidateNoteQuery({
 *   variables: {
 *      employerCandidate: // value for 'employerCandidate'
 *   },
 * });
 */
export function useEmployerCandidateNoteQuery(baseOptions: Apollo.QueryHookOptions<EmployerCandidateNoteQuery, EmployerCandidateNoteQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployerCandidateNoteQuery, EmployerCandidateNoteQueryVariables>(EmployerCandidateNoteDocument, options);
      }
export function useEmployerCandidateNoteLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployerCandidateNoteQuery, EmployerCandidateNoteQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployerCandidateNoteQuery, EmployerCandidateNoteQueryVariables>(EmployerCandidateNoteDocument, options);
        }
export type EmployerCandidateNoteQueryHookResult = ReturnType<typeof useEmployerCandidateNoteQuery>;
export type EmployerCandidateNoteLazyQueryHookResult = ReturnType<typeof useEmployerCandidateNoteLazyQuery>;
export type EmployerCandidateNoteQueryResult = Apollo.QueryResult<EmployerCandidateNoteQuery, EmployerCandidateNoteQueryVariables>;
export const MutateCreateEmployerCandidateDocument = gql`
    mutation MutateCreateEmployerCandidate($employerCandidate: ID, $text: String) {
  mutateEmployerCandidateNote(
    input: {employerCandidate: $employerCandidate, text: $text}
  ) {
    employerCandidateNoteType {
      id
      createdBy {
        id
      }
      updatedBy {
        id
      }
      text
      createdAt
      updatedAt
      archivedAt
    }
  }
}
    `;
export type MutateCreateEmployerCandidateMutationFn = Apollo.MutationFunction<MutateCreateEmployerCandidateMutation, MutateCreateEmployerCandidateMutationVariables>;

/**
 * __useMutateCreateEmployerCandidateMutation__
 *
 * To run a mutation, you first call `useMutateCreateEmployerCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutateCreateEmployerCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateCreateEmployerCandidateMutation, { data, loading, error }] = useMutateCreateEmployerCandidateMutation({
 *   variables: {
 *      employerCandidate: // value for 'employerCandidate'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useMutateCreateEmployerCandidateMutation(baseOptions?: Apollo.MutationHookOptions<MutateCreateEmployerCandidateMutation, MutateCreateEmployerCandidateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutateCreateEmployerCandidateMutation, MutateCreateEmployerCandidateMutationVariables>(MutateCreateEmployerCandidateDocument, options);
      }
export type MutateCreateEmployerCandidateMutationHookResult = ReturnType<typeof useMutateCreateEmployerCandidateMutation>;
export type MutateCreateEmployerCandidateMutationResult = Apollo.MutationResult<MutateCreateEmployerCandidateMutation>;
export type MutateCreateEmployerCandidateMutationOptions = Apollo.BaseMutationOptions<MutateCreateEmployerCandidateMutation, MutateCreateEmployerCandidateMutationVariables>;
export const DismissNotificationDocument = gql`
    mutation DismissNotification($id: ID) {
  dismissNotification(notification: $id) {
    notification {
      id
      dismissedAt
    }
  }
}
    `;
export type DismissNotificationMutationFn = Apollo.MutationFunction<DismissNotificationMutation, DismissNotificationMutationVariables>;

/**
 * __useDismissNotificationMutation__
 *
 * To run a mutation, you first call `useDismissNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissNotificationMutation, { data, loading, error }] = useDismissNotificationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDismissNotificationMutation(baseOptions?: Apollo.MutationHookOptions<DismissNotificationMutation, DismissNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DismissNotificationMutation, DismissNotificationMutationVariables>(DismissNotificationDocument, options);
      }
export type DismissNotificationMutationHookResult = ReturnType<typeof useDismissNotificationMutation>;
export type DismissNotificationMutationResult = Apollo.MutationResult<DismissNotificationMutation>;
export type DismissNotificationMutationOptions = Apollo.BaseMutationOptions<DismissNotificationMutation, DismissNotificationMutationVariables>;
export const EmployerCandidatesDocument = gql`
    query employerCandidates($employerCandidateId: ID, $stageId: ID, $positions: [ID], $locations: [ID], $first: Int, $after: String, $notificationType: String, $notificationStatuses: [String], $profileDetailFilters: [String], $sortBy: EmployerCandidateSortByEnum) {
  employerCandidates(
    first: $first
    after: $after
    employerCandidateId: $employerCandidateId
    stageId: $stageId
    positions: $positions
    locations: $locations
    notificationType: $notificationType
    notificationStatuses: $notificationStatuses
    profileDetailFilters: $profileDetailFilters
    sortBy: $sortBy
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
    edges {
      node {
        id
        createdAt
        updatedAt
        sevenshiftsId
        preferredMatch {
          id
          position {
            id
            positionName
            location {
              id
              name
            }
          }
        }
        candidateProfile {
          id
          handle
          positions
          user {
            id
            uuid
            firstName
            lastName
            profileImage
            email
            phone
          }
        }
        employercandidateNotifications(stage: $stageId) {
          edges {
            node {
              id
              notificationType
              dismissedAt
              rowId
              message
              status
              color
              actions
            }
          }
        }
        chatNotification {
          id
          notificationType
          dismissedAt
          rowId
          message
          status
          color
          actions
        }
        rejectionReasons(archivedAt_Isnull: true) {
          edges {
            node {
              id
              name
            }
          }
        }
        hasNote
      }
    }
  }
}
    `;

/**
 * __useEmployerCandidatesQuery__
 *
 * To run a query within a React component, call `useEmployerCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployerCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployerCandidatesQuery({
 *   variables: {
 *      employerCandidateId: // value for 'employerCandidateId'
 *      stageId: // value for 'stageId'
 *      positions: // value for 'positions'
 *      locations: // value for 'locations'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      notificationType: // value for 'notificationType'
 *      notificationStatuses: // value for 'notificationStatuses'
 *      profileDetailFilters: // value for 'profileDetailFilters'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useEmployerCandidatesQuery(baseOptions?: Apollo.QueryHookOptions<EmployerCandidatesQuery, EmployerCandidatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployerCandidatesQuery, EmployerCandidatesQueryVariables>(EmployerCandidatesDocument, options);
      }
export function useEmployerCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployerCandidatesQuery, EmployerCandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployerCandidatesQuery, EmployerCandidatesQueryVariables>(EmployerCandidatesDocument, options);
        }
export type EmployerCandidatesQueryHookResult = ReturnType<typeof useEmployerCandidatesQuery>;
export type EmployerCandidatesLazyQueryHookResult = ReturnType<typeof useEmployerCandidatesLazyQuery>;
export type EmployerCandidatesQueryResult = Apollo.QueryResult<EmployerCandidatesQuery, EmployerCandidatesQueryVariables>;
export const EmployerCandidateNotificationsDocument = gql`
    query EmployerCandidateNotifications($employerCandidateIds: [ID], $stageId: ID, $positions: [ID], $locations: [ID], $first: Int) {
  employerCandidates(
    idIn: $employerCandidateIds
    locations: $locations
    positions: $positions
    stageId: $stageId
    first: $first
  ) {
    edges {
      node {
        id
        createdAt
        updatedAt
        sevenshiftsId
        sevenshiftsUrl
        candidateProfile {
          id
          handle
          positions
          user {
            id
            uuid
            firstName
            lastName
            profileImage
            email
            phone
          }
        }
        employercandidateNotifications(stage: $stageId) {
          edges {
            node {
              id
              notificationType
              dismissedAt
              rowId
              message
              status
              color
              actions
            }
          }
        }
        rejectionReasons(archivedAt_Isnull: true) {
          edges {
            node {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useEmployerCandidateNotificationsQuery__
 *
 * To run a query within a React component, call `useEmployerCandidateNotificationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployerCandidateNotificationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployerCandidateNotificationsQuery({
 *   variables: {
 *      employerCandidateIds: // value for 'employerCandidateIds'
 *      stageId: // value for 'stageId'
 *      positions: // value for 'positions'
 *      locations: // value for 'locations'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useEmployerCandidateNotificationsQuery(baseOptions?: Apollo.QueryHookOptions<EmployerCandidateNotificationsQuery, EmployerCandidateNotificationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployerCandidateNotificationsQuery, EmployerCandidateNotificationsQueryVariables>(EmployerCandidateNotificationsDocument, options);
      }
export function useEmployerCandidateNotificationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployerCandidateNotificationsQuery, EmployerCandidateNotificationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployerCandidateNotificationsQuery, EmployerCandidateNotificationsQueryVariables>(EmployerCandidateNotificationsDocument, options);
        }
export type EmployerCandidateNotificationsQueryHookResult = ReturnType<typeof useEmployerCandidateNotificationsQuery>;
export type EmployerCandidateNotificationsLazyQueryHookResult = ReturnType<typeof useEmployerCandidateNotificationsLazyQuery>;
export type EmployerCandidateNotificationsQueryResult = Apollo.QueryResult<EmployerCandidateNotificationsQuery, EmployerCandidateNotificationsQueryVariables>;
export const EmployerStagesDocument = gql`
    query employerStages($locations: [ID], $positions: [ID], $profileDetailFilters: [String], $stageUpdatedAtLte: DateTime, $stageUpdatedAtGte: DateTime) {
  employerStages {
    edges {
      node {
        id
        name
        ordering
        stageType
        slug
        employerCandidateCount(
          positions: $positions
          locations: $locations
          profileDetailFilters: $profileDetailFilters
          stageUpdatedAtLte: $stageUpdatedAtLte
          stageUpdatedAtGte: $stageUpdatedAtGte
        )
        hasNotification(positions: $positions, locations: $locations)
        refreshNotificationCount
      }
    }
  }
}
    `;

/**
 * __useEmployerStagesQuery__
 *
 * To run a query within a React component, call `useEmployerStagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployerStagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployerStagesQuery({
 *   variables: {
 *      locations: // value for 'locations'
 *      positions: // value for 'positions'
 *      profileDetailFilters: // value for 'profileDetailFilters'
 *      stageUpdatedAtLte: // value for 'stageUpdatedAtLte'
 *      stageUpdatedAtGte: // value for 'stageUpdatedAtGte'
 *   },
 * });
 */
export function useEmployerStagesQuery(baseOptions?: Apollo.QueryHookOptions<EmployerStagesQuery, EmployerStagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployerStagesQuery, EmployerStagesQueryVariables>(EmployerStagesDocument, options);
      }
export function useEmployerStagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployerStagesQuery, EmployerStagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployerStagesQuery, EmployerStagesQueryVariables>(EmployerStagesDocument, options);
        }
export type EmployerStagesQueryHookResult = ReturnType<typeof useEmployerStagesQuery>;
export type EmployerStagesLazyQueryHookResult = ReturnType<typeof useEmployerStagesLazyQuery>;
export type EmployerStagesQueryResult = Apollo.QueryResult<EmployerStagesQuery, EmployerStagesQueryVariables>;
export const AgendaEventsDocument = gql`
    query AgendaEvents($startTime: DateTime, $endTime: DateTime, $positions: [ID], $locations: [ID]) {
  agendaEvents(
    startTime: $startTime
    endTime: $endTime
    positions: $positions
    locations: $locations
  ) {
    title
    desc
    participants
    start
    end
    locationOfInterview {
      id
      name
      formattedAddress
    }
    positionOfInterview {
      id
      positionName
    }
    interviewRequester {
      id
    }
    createdBy {
      firstName
      lastName
    }
    dateOfInterview
    interviewId
    interviewUuid
    interviewType
    meetingUrl
    phoneNumber
    employerCandidate {
      id
      candidateProfile {
        handle
        user {
          id
          firstName
          lastName
          profileImage
        }
      }
      stage {
        id
        name
      }
      preferredMatch {
        id
        position {
          id
          location {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useAgendaEventsQuery__
 *
 * To run a query within a React component, call `useAgendaEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAgendaEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAgendaEventsQuery({
 *   variables: {
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *      positions: // value for 'positions'
 *      locations: // value for 'locations'
 *   },
 * });
 */
export function useAgendaEventsQuery(baseOptions?: Apollo.QueryHookOptions<AgendaEventsQuery, AgendaEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AgendaEventsQuery, AgendaEventsQueryVariables>(AgendaEventsDocument, options);
      }
export function useAgendaEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AgendaEventsQuery, AgendaEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AgendaEventsQuery, AgendaEventsQueryVariables>(AgendaEventsDocument, options);
        }
export type AgendaEventsQueryHookResult = ReturnType<typeof useAgendaEventsQuery>;
export type AgendaEventsLazyQueryHookResult = ReturnType<typeof useAgendaEventsLazyQuery>;
export type AgendaEventsQueryResult = Apollo.QueryResult<AgendaEventsQuery, AgendaEventsQueryVariables>;
export const GetEmployerDocumentsDocument = gql`
    query getEmployerDocuments($document_type: EmployersEmploymentDocumentDocumentTypeChoices, $candidate: ID) {
  getEmployerDocuments(
    documentType_Icontains: $document_type
    candidate: $candidate
  ) {
    edges {
      node {
        id
        documentType
        baseSalaryValue
        baseSalaryUnitText
        status
        acceptedDeclinedAt
        contactName
        contactPhone
        startingAt
        note
        position {
          id
          positionName
        }
        employmentdocumentfileSet(first: 1) {
          edges {
            node {
              id
              name
              attachment
              size
              url
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetEmployerDocumentsQuery__
 *
 * To run a query within a React component, call `useGetEmployerDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployerDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployerDocumentsQuery({
 *   variables: {
 *      document_type: // value for 'document_type'
 *      candidate: // value for 'candidate'
 *   },
 * });
 */
export function useGetEmployerDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<GetEmployerDocumentsQuery, GetEmployerDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployerDocumentsQuery, GetEmployerDocumentsQueryVariables>(GetEmployerDocumentsDocument, options);
      }
export function useGetEmployerDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployerDocumentsQuery, GetEmployerDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployerDocumentsQuery, GetEmployerDocumentsQueryVariables>(GetEmployerDocumentsDocument, options);
        }
export type GetEmployerDocumentsQueryHookResult = ReturnType<typeof useGetEmployerDocumentsQuery>;
export type GetEmployerDocumentsLazyQueryHookResult = ReturnType<typeof useGetEmployerDocumentsLazyQuery>;
export type GetEmployerDocumentsQueryResult = Apollo.QueryResult<GetEmployerDocumentsQuery, GetEmployerDocumentsQueryVariables>;
export const RejectCandidatesDocument = gql`
    mutation RejectCandidates($employerCandidates: [ID], $all: Boolean, $positions: [ID], $locations: [ID], $stage: ID!, $rejectReasons: [ID]) {
  rejectCandidates(
    employerCandidates: $employerCandidates
    all: $all
    positions: $positions
    locations: $locations
    stage: $stage
    rejectReasons: $rejectReasons
  ) {
    employerCandidates {
      id
      rejectionReasons(archivedAt_Isnull: true) {
        edges {
          node {
            name
          }
        }
      }
    }
  }
}
    `;
export type RejectCandidatesMutationFn = Apollo.MutationFunction<RejectCandidatesMutation, RejectCandidatesMutationVariables>;

/**
 * __useRejectCandidatesMutation__
 *
 * To run a mutation, you first call `useRejectCandidatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectCandidatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectCandidatesMutation, { data, loading, error }] = useRejectCandidatesMutation({
 *   variables: {
 *      employerCandidates: // value for 'employerCandidates'
 *      all: // value for 'all'
 *      positions: // value for 'positions'
 *      locations: // value for 'locations'
 *      stage: // value for 'stage'
 *      rejectReasons: // value for 'rejectReasons'
 *   },
 * });
 */
export function useRejectCandidatesMutation(baseOptions?: Apollo.MutationHookOptions<RejectCandidatesMutation, RejectCandidatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RejectCandidatesMutation, RejectCandidatesMutationVariables>(RejectCandidatesDocument, options);
      }
export type RejectCandidatesMutationHookResult = ReturnType<typeof useRejectCandidatesMutation>;
export type RejectCandidatesMutationResult = Apollo.MutationResult<RejectCandidatesMutation>;
export type RejectCandidatesMutationOptions = Apollo.BaseMutationOptions<RejectCandidatesMutation, RejectCandidatesMutationVariables>;
export const SearchEmployerCandidatesDocument = gql`
    query searchEmployerCandidates($search: String!, $first: Int, $after: String) {
  searchEmployerCandidates(search: $search, first: $first, after: $after) {
    edges {
      node {
        employerCandidateId
        userId
        firstName
        lastName
        email
        positionId
        positionName
        locationId
        locationName
        stageId
        isSelectable
        isArchived
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
    `;

/**
 * __useSearchEmployerCandidatesQuery__
 *
 * To run a query within a React component, call `useSearchEmployerCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEmployerCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEmployerCandidatesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSearchEmployerCandidatesQuery(baseOptions: Apollo.QueryHookOptions<SearchEmployerCandidatesQuery, SearchEmployerCandidatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchEmployerCandidatesQuery, SearchEmployerCandidatesQueryVariables>(SearchEmployerCandidatesDocument, options);
      }
export function useSearchEmployerCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchEmployerCandidatesQuery, SearchEmployerCandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchEmployerCandidatesQuery, SearchEmployerCandidatesQueryVariables>(SearchEmployerCandidatesDocument, options);
        }
export type SearchEmployerCandidatesQueryHookResult = ReturnType<typeof useSearchEmployerCandidatesQuery>;
export type SearchEmployerCandidatesLazyQueryHookResult = ReturnType<typeof useSearchEmployerCandidatesLazyQuery>;
export type SearchEmployerCandidatesQueryResult = Apollo.QueryResult<SearchEmployerCandidatesQuery, SearchEmployerCandidatesQueryVariables>;
export const SelectedEmployerCandidatesDocument = gql`
    query SelectedEmployerCandidates($employerCandidateIds: [ID], $stageId: ID, $positions: [ID], $locations: [ID], $first: Int) {
  employerCandidates(
    idIn: $employerCandidateIds
    locations: $locations
    positions: $positions
    stageId: $stageId
    first: $first
  ) {
    edges {
      node {
        id
        candidateProfile {
          id
          handle
          user {
            id
            email
            phone
            firstName
            lastName
            profileImage
          }
          positions
          addressPostalCode
          personalSummary
          resume
        }
      }
    }
  }
}
    `;

/**
 * __useSelectedEmployerCandidatesQuery__
 *
 * To run a query within a React component, call `useSelectedEmployerCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSelectedEmployerCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSelectedEmployerCandidatesQuery({
 *   variables: {
 *      employerCandidateIds: // value for 'employerCandidateIds'
 *      stageId: // value for 'stageId'
 *      positions: // value for 'positions'
 *      locations: // value for 'locations'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useSelectedEmployerCandidatesQuery(baseOptions?: Apollo.QueryHookOptions<SelectedEmployerCandidatesQuery, SelectedEmployerCandidatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SelectedEmployerCandidatesQuery, SelectedEmployerCandidatesQueryVariables>(SelectedEmployerCandidatesDocument, options);
      }
export function useSelectedEmployerCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SelectedEmployerCandidatesQuery, SelectedEmployerCandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SelectedEmployerCandidatesQuery, SelectedEmployerCandidatesQueryVariables>(SelectedEmployerCandidatesDocument, options);
        }
export type SelectedEmployerCandidatesQueryHookResult = ReturnType<typeof useSelectedEmployerCandidatesQuery>;
export type SelectedEmployerCandidatesLazyQueryHookResult = ReturnType<typeof useSelectedEmployerCandidatesLazyQuery>;
export type SelectedEmployerCandidatesQueryResult = Apollo.QueryResult<SelectedEmployerCandidatesQuery, SelectedEmployerCandidatesQueryVariables>;
export const UnrejectCandidatesDocument = gql`
    mutation unrejectCandidates($employerCandidates: [ID]!, $locations: [ID], $positions: [ID], $all: Boolean) {
  unrejectCandidates(
    employerCandidates: $employerCandidates
    locations: $locations
    positions: $positions
    all: $all
  ) {
    toStage {
      id
    }
  }
}
    `;
export type UnrejectCandidatesMutationFn = Apollo.MutationFunction<UnrejectCandidatesMutation, UnrejectCandidatesMutationVariables>;

/**
 * __useUnrejectCandidatesMutation__
 *
 * To run a mutation, you first call `useUnrejectCandidatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnrejectCandidatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unrejectCandidatesMutation, { data, loading, error }] = useUnrejectCandidatesMutation({
 *   variables: {
 *      employerCandidates: // value for 'employerCandidates'
 *      locations: // value for 'locations'
 *      positions: // value for 'positions'
 *      all: // value for 'all'
 *   },
 * });
 */
export function useUnrejectCandidatesMutation(baseOptions?: Apollo.MutationHookOptions<UnrejectCandidatesMutation, UnrejectCandidatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnrejectCandidatesMutation, UnrejectCandidatesMutationVariables>(UnrejectCandidatesDocument, options);
      }
export type UnrejectCandidatesMutationHookResult = ReturnType<typeof useUnrejectCandidatesMutation>;
export type UnrejectCandidatesMutationResult = Apollo.MutationResult<UnrejectCandidatesMutation>;
export type UnrejectCandidatesMutationOptions = Apollo.BaseMutationOptions<UnrejectCandidatesMutation, UnrejectCandidatesMutationVariables>;
export const MutateUpdateEmployerCandidateDocument = gql`
    mutation MutateUpdateEmployerCandidate($id: ID, $text: String) {
  mutateEmployerCandidateNote(input: {id: $id, text: $text}) {
    employerCandidateNoteType {
      id
      createdBy {
        id
      }
      updatedBy {
        id
      }
      text
      createdAt
      updatedAt
      archivedAt
    }
  }
}
    `;
export type MutateUpdateEmployerCandidateMutationFn = Apollo.MutationFunction<MutateUpdateEmployerCandidateMutation, MutateUpdateEmployerCandidateMutationVariables>;

/**
 * __useMutateUpdateEmployerCandidateMutation__
 *
 * To run a mutation, you first call `useMutateUpdateEmployerCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutateUpdateEmployerCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateUpdateEmployerCandidateMutation, { data, loading, error }] = useMutateUpdateEmployerCandidateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useMutateUpdateEmployerCandidateMutation(baseOptions?: Apollo.MutationHookOptions<MutateUpdateEmployerCandidateMutation, MutateUpdateEmployerCandidateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutateUpdateEmployerCandidateMutation, MutateUpdateEmployerCandidateMutationVariables>(MutateUpdateEmployerCandidateDocument, options);
      }
export type MutateUpdateEmployerCandidateMutationHookResult = ReturnType<typeof useMutateUpdateEmployerCandidateMutation>;
export type MutateUpdateEmployerCandidateMutationResult = Apollo.MutationResult<MutateUpdateEmployerCandidateMutation>;
export type MutateUpdateEmployerCandidateMutationOptions = Apollo.BaseMutationOptions<MutateUpdateEmployerCandidateMutation, MutateUpdateEmployerCandidateMutationVariables>;
export const GetMyMatchesDocument = gql`
    query GetMyMatches($first: Int, $after: String) {
  myMatches(first: $first, after: $after) {
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
    edges {
      node {
        id
        position {
          id
          rowId
          slug
          positionName
          updatedAt
          hasApplied
          positionType
          createdAt
          baseSalaryMin
          baseSalaryMax
          baseSalaryUnitText
          isNonPartner
          externalApplyUrl
          createdBy {
            id
            profileImage
            firstName
          }
          location {
            id
            name
            slug
            image
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMyMatchesQuery__
 *
 * To run a query within a React component, call `useGetMyMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyMatchesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetMyMatchesQuery(baseOptions?: Apollo.QueryHookOptions<GetMyMatchesQuery, GetMyMatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyMatchesQuery, GetMyMatchesQueryVariables>(GetMyMatchesDocument, options);
      }
export function useGetMyMatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyMatchesQuery, GetMyMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyMatchesQuery, GetMyMatchesQueryVariables>(GetMyMatchesDocument, options);
        }
export type GetMyMatchesQueryHookResult = ReturnType<typeof useGetMyMatchesQuery>;
export type GetMyMatchesLazyQueryHookResult = ReturnType<typeof useGetMyMatchesLazyQuery>;
export type GetMyMatchesQueryResult = Apollo.QueryResult<GetMyMatchesQuery, GetMyMatchesQueryVariables>;
export const SearchInterviewPositionsDocument = gql`
    query SearchInterviewPositions($searchTerms: [String], $first: Int, $after: String, $zipCode: String, $hasApplied: Boolean, $hasInterview: Boolean, $interviewStatus: String, $canHaveDressCode: Boolean, $isBenefitsRequired: Boolean) {
  positions(
    searchTerms: $searchTerms
    first: $first
    after: $after
    zipCode: $zipCode
    hasApplied: $hasApplied
    hasInterview: $hasInterview
    interviewStatus: $interviewStatus
    canHaveDressCode: $canHaveDressCode
    isBenefitsRequired: $isBenefitsRequired
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
    edges {
      node {
        id
        rowId
        slug
        positionName
        positionType
        updatedAt
        hasApplied
        appliedAt
        baseSalaryMin
        baseSalaryMax
        baseSalaryUnitText
        myInterview {
          id
          uuid
          scheduledFor
          status
          createdAt
          interviewType
          phoneNumber
          meetingUrl
          createdBy {
            id
            uuid
            profileImage
            firstName
            hasSchedule
          }
        }
        createdBy {
          id
          profileImage
          firstName
        }
        location {
          id
          name
          slug
          image
          formattedAddress
        }
      }
    }
  }
}
    `;

/**
 * __useSearchInterviewPositionsQuery__
 *
 * To run a query within a React component, call `useSearchInterviewPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchInterviewPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchInterviewPositionsQuery({
 *   variables: {
 *      searchTerms: // value for 'searchTerms'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      zipCode: // value for 'zipCode'
 *      hasApplied: // value for 'hasApplied'
 *      hasInterview: // value for 'hasInterview'
 *      interviewStatus: // value for 'interviewStatus'
 *      canHaveDressCode: // value for 'canHaveDressCode'
 *      isBenefitsRequired: // value for 'isBenefitsRequired'
 *   },
 * });
 */
export function useSearchInterviewPositionsQuery(baseOptions?: Apollo.QueryHookOptions<SearchInterviewPositionsQuery, SearchInterviewPositionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchInterviewPositionsQuery, SearchInterviewPositionsQueryVariables>(SearchInterviewPositionsDocument, options);
      }
export function useSearchInterviewPositionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchInterviewPositionsQuery, SearchInterviewPositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchInterviewPositionsQuery, SearchInterviewPositionsQueryVariables>(SearchInterviewPositionsDocument, options);
        }
export type SearchInterviewPositionsQueryHookResult = ReturnType<typeof useSearchInterviewPositionsQuery>;
export type SearchInterviewPositionsLazyQueryHookResult = ReturnType<typeof useSearchInterviewPositionsLazyQuery>;
export type SearchInterviewPositionsQueryResult = Apollo.QueryResult<SearchInterviewPositionsQuery, SearchInterviewPositionsQueryVariables>;
export const SearchPositionsDocument = gql`
    query SearchPositions($searchTerms: [String], $first: Int, $after: String, $zipCode: String, $hasApplied: Boolean, $hasInterview: Boolean, $canHaveDressCode: Boolean, $isBenefitsRequired: Boolean, $hiring: Boolean, $showBestMatch: Boolean, $sortBy: String) {
  positions(
    searchTerms: $searchTerms
    first: $first
    after: $after
    zipCode: $zipCode
    hasApplied: $hasApplied
    hasInterview: $hasInterview
    canHaveDressCode: $canHaveDressCode
    isBenefitsRequired: $isBenefitsRequired
    hiring: $hiring
    showBestMatch: $showBestMatch
    sortBy: $sortBy
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
    edges {
      node {
        id
        slug
        positionName
        positionType
        updatedAt
        hasApplied
        appliedAt
        baseSalaryMin
        baseSalaryMax
        baseSalaryUnitText
        isNonPartner
        posted
        externalApplyUrl
        isMatch
        positionapplicationSet(first: 1) {
          edges {
            node {
              id
              status
            }
          }
        }
        createdBy {
          id
          uuid
          profileImage
          firstName
        }
        location {
          id
          name
          slug
          image
        }
      }
    }
  }
}
    `;

/**
 * __useSearchPositionsQuery__
 *
 * To run a query within a React component, call `useSearchPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchPositionsQuery({
 *   variables: {
 *      searchTerms: // value for 'searchTerms'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      zipCode: // value for 'zipCode'
 *      hasApplied: // value for 'hasApplied'
 *      hasInterview: // value for 'hasInterview'
 *      canHaveDressCode: // value for 'canHaveDressCode'
 *      isBenefitsRequired: // value for 'isBenefitsRequired'
 *      hiring: // value for 'hiring'
 *      showBestMatch: // value for 'showBestMatch'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useSearchPositionsQuery(baseOptions?: Apollo.QueryHookOptions<SearchPositionsQuery, SearchPositionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchPositionsQuery, SearchPositionsQueryVariables>(SearchPositionsDocument, options);
      }
export function useSearchPositionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchPositionsQuery, SearchPositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchPositionsQuery, SearchPositionsQueryVariables>(SearchPositionsDocument, options);
        }
export type SearchPositionsQueryHookResult = ReturnType<typeof useSearchPositionsQuery>;
export type SearchPositionsLazyQueryHookResult = ReturnType<typeof useSearchPositionsLazyQuery>;
export type SearchPositionsQueryResult = Apollo.QueryResult<SearchPositionsQuery, SearchPositionsQueryVariables>;
export const TypeAheadSearchDocument = gql`
    query TypeAheadSearch($search: String) {
  searchAhead(search: $search) {
    groups {
      group
      values {
        value
        label
      }
    }
  }
}
    `;

/**
 * __useTypeAheadSearchQuery__
 *
 * To run a query within a React component, call `useTypeAheadSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useTypeAheadSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTypeAheadSearchQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useTypeAheadSearchQuery(baseOptions?: Apollo.QueryHookOptions<TypeAheadSearchQuery, TypeAheadSearchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TypeAheadSearchQuery, TypeAheadSearchQueryVariables>(TypeAheadSearchDocument, options);
      }
export function useTypeAheadSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TypeAheadSearchQuery, TypeAheadSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TypeAheadSearchQuery, TypeAheadSearchQueryVariables>(TypeAheadSearchDocument, options);
        }
export type TypeAheadSearchQueryHookResult = ReturnType<typeof useTypeAheadSearchQuery>;
export type TypeAheadSearchLazyQueryHookResult = ReturnType<typeof useTypeAheadSearchLazyQuery>;
export type TypeAheadSearchQueryResult = Apollo.QueryResult<TypeAheadSearchQuery, TypeAheadSearchQueryVariables>;
export const SortByOptionsDocument = gql`
    query SortByOptions {
  candidateSearchSortByOptions
}
    `;

/**
 * __useSortByOptionsQuery__
 *
 * To run a query within a React component, call `useSortByOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSortByOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSortByOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSortByOptionsQuery(baseOptions?: Apollo.QueryHookOptions<SortByOptionsQuery, SortByOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SortByOptionsQuery, SortByOptionsQueryVariables>(SortByOptionsDocument, options);
      }
export function useSortByOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SortByOptionsQuery, SortByOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SortByOptionsQuery, SortByOptionsQueryVariables>(SortByOptionsDocument, options);
        }
export type SortByOptionsQueryHookResult = ReturnType<typeof useSortByOptionsQuery>;
export type SortByOptionsLazyQueryHookResult = ReturnType<typeof useSortByOptionsLazyQuery>;
export type SortByOptionsQueryResult = Apollo.QueryResult<SortByOptionsQuery, SortByOptionsQueryVariables>;
export const MutateCreateEmployerCandidatesDocument = gql`
    mutation MutateCreateEmployerCandidates($candidateHandles: [String], $positionId: ID, $moveToStageId: ID) {
  createEmployerCandidates(
    candidateHandles: $candidateHandles
    positionId: $positionId
    moveToStageId: $moveToStageId
  ) {
    created
    employerCandidates {
      id
      stage {
        id
        name
      }
      candidateProfile {
        id
        handle
      }
    }
  }
}
    `;
export type MutateCreateEmployerCandidatesMutationFn = Apollo.MutationFunction<MutateCreateEmployerCandidatesMutation, MutateCreateEmployerCandidatesMutationVariables>;

/**
 * __useMutateCreateEmployerCandidatesMutation__
 *
 * To run a mutation, you first call `useMutateCreateEmployerCandidatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutateCreateEmployerCandidatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateCreateEmployerCandidatesMutation, { data, loading, error }] = useMutateCreateEmployerCandidatesMutation({
 *   variables: {
 *      candidateHandles: // value for 'candidateHandles'
 *      positionId: // value for 'positionId'
 *      moveToStageId: // value for 'moveToStageId'
 *   },
 * });
 */
export function useMutateCreateEmployerCandidatesMutation(baseOptions?: Apollo.MutationHookOptions<MutateCreateEmployerCandidatesMutation, MutateCreateEmployerCandidatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutateCreateEmployerCandidatesMutation, MutateCreateEmployerCandidatesMutationVariables>(MutateCreateEmployerCandidatesDocument, options);
      }
export type MutateCreateEmployerCandidatesMutationHookResult = ReturnType<typeof useMutateCreateEmployerCandidatesMutation>;
export type MutateCreateEmployerCandidatesMutationResult = Apollo.MutationResult<MutateCreateEmployerCandidatesMutation>;
export type MutateCreateEmployerCandidatesMutationOptions = Apollo.BaseMutationOptions<MutateCreateEmployerCandidatesMutation, MutateCreateEmployerCandidatesMutationVariables>;
export const GetZipcodeForLatLngDocument = gql`
    query GetZipcodeForLatLng($latitude: Float!, $longitude: Float!) {
  zipcodeForCoordinates(latitude: $latitude, longitude: $longitude) {
    zipcode
  }
}
    `;

/**
 * __useGetZipcodeForLatLngQuery__
 *
 * To run a query within a React component, call `useGetZipcodeForLatLngQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetZipcodeForLatLngQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetZipcodeForLatLngQuery({
 *   variables: {
 *      latitude: // value for 'latitude'
 *      longitude: // value for 'longitude'
 *   },
 * });
 */
export function useGetZipcodeForLatLngQuery(baseOptions: Apollo.QueryHookOptions<GetZipcodeForLatLngQuery, GetZipcodeForLatLngQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetZipcodeForLatLngQuery, GetZipcodeForLatLngQueryVariables>(GetZipcodeForLatLngDocument, options);
      }
export function useGetZipcodeForLatLngLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetZipcodeForLatLngQuery, GetZipcodeForLatLngQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetZipcodeForLatLngQuery, GetZipcodeForLatLngQueryVariables>(GetZipcodeForLatLngDocument, options);
        }
export type GetZipcodeForLatLngQueryHookResult = ReturnType<typeof useGetZipcodeForLatLngQuery>;
export type GetZipcodeForLatLngLazyQueryHookResult = ReturnType<typeof useGetZipcodeForLatLngLazyQuery>;
export type GetZipcodeForLatLngQueryResult = Apollo.QueryResult<GetZipcodeForLatLngQuery, GetZipcodeForLatLngQueryVariables>;
export const MutateInviteToApplyDocument = gql`
    mutation MutateInviteToApply($candidateHandles: [String], $positionId: ID, $locationId: ID, $message: String) {
  inviteToApply(
    candidateHandles: $candidateHandles
    positionId: $positionId
    locationId: $locationId
    message: $message
  ) {
    created
  }
}
    `;
export type MutateInviteToApplyMutationFn = Apollo.MutationFunction<MutateInviteToApplyMutation, MutateInviteToApplyMutationVariables>;

/**
 * __useMutateInviteToApplyMutation__
 *
 * To run a mutation, you first call `useMutateInviteToApplyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutateInviteToApplyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateInviteToApplyMutation, { data, loading, error }] = useMutateInviteToApplyMutation({
 *   variables: {
 *      candidateHandles: // value for 'candidateHandles'
 *      positionId: // value for 'positionId'
 *      locationId: // value for 'locationId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useMutateInviteToApplyMutation(baseOptions?: Apollo.MutationHookOptions<MutateInviteToApplyMutation, MutateInviteToApplyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutateInviteToApplyMutation, MutateInviteToApplyMutationVariables>(MutateInviteToApplyDocument, options);
      }
export type MutateInviteToApplyMutationHookResult = ReturnType<typeof useMutateInviteToApplyMutation>;
export type MutateInviteToApplyMutationResult = Apollo.MutationResult<MutateInviteToApplyMutation>;
export type MutateInviteToApplyMutationOptions = Apollo.BaseMutationOptions<MutateInviteToApplyMutation, MutateInviteToApplyMutationVariables>;
export const SearchAheadNetworkDocument = gql`
    query SearchAheadNetwork($search: String) {
  searchAheadNetwork(search: $search) {
    groups {
      group
      values {
        label
        value
      }
    }
  }
}
    `;

/**
 * __useSearchAheadNetworkQuery__
 *
 * To run a query within a React component, call `useSearchAheadNetworkQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAheadNetworkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAheadNetworkQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useSearchAheadNetworkQuery(baseOptions?: Apollo.QueryHookOptions<SearchAheadNetworkQuery, SearchAheadNetworkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchAheadNetworkQuery, SearchAheadNetworkQueryVariables>(SearchAheadNetworkDocument, options);
      }
export function useSearchAheadNetworkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchAheadNetworkQuery, SearchAheadNetworkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchAheadNetworkQuery, SearchAheadNetworkQueryVariables>(SearchAheadNetworkDocument, options);
        }
export type SearchAheadNetworkQueryHookResult = ReturnType<typeof useSearchAheadNetworkQuery>;
export type SearchAheadNetworkLazyQueryHookResult = ReturnType<typeof useSearchAheadNetworkLazyQuery>;
export type SearchAheadNetworkQueryResult = Apollo.QueryResult<SearchAheadNetworkQuery, SearchAheadNetworkQueryVariables>;
export const CandidateSearchFilterGroupsDocument = gql`
    query CandidateSearchFilterGroups {
  candidateSearchFilterGroups {
    name
    operator
    filterItems
  }
}
    `;

/**
 * __useCandidateSearchFilterGroupsQuery__
 *
 * To run a query within a React component, call `useCandidateSearchFilterGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCandidateSearchFilterGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCandidateSearchFilterGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCandidateSearchFilterGroupsQuery(baseOptions?: Apollo.QueryHookOptions<CandidateSearchFilterGroupsQuery, CandidateSearchFilterGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CandidateSearchFilterGroupsQuery, CandidateSearchFilterGroupsQueryVariables>(CandidateSearchFilterGroupsDocument, options);
      }
export function useCandidateSearchFilterGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CandidateSearchFilterGroupsQuery, CandidateSearchFilterGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CandidateSearchFilterGroupsQuery, CandidateSearchFilterGroupsQueryVariables>(CandidateSearchFilterGroupsDocument, options);
        }
export type CandidateSearchFilterGroupsQueryHookResult = ReturnType<typeof useCandidateSearchFilterGroupsQuery>;
export type CandidateSearchFilterGroupsLazyQueryHookResult = ReturnType<typeof useCandidateSearchFilterGroupsLazyQuery>;
export type CandidateSearchFilterGroupsQueryResult = Apollo.QueryResult<CandidateSearchFilterGroupsQuery, CandidateSearchFilterGroupsQueryVariables>;
export const SearchFilterGroupsDocument = gql`
    query SearchFilterGroups {
  candidateSearchFilterGroups {
    name
    operator
    filterItems
  }
}
    `;

/**
 * __useSearchFilterGroupsQuery__
 *
 * To run a query within a React component, call `useSearchFilterGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchFilterGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchFilterGroupsQuery({
 *   variables: {
 *   },
 * });
 */
export function useSearchFilterGroupsQuery(baseOptions?: Apollo.QueryHookOptions<SearchFilterGroupsQuery, SearchFilterGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchFilterGroupsQuery, SearchFilterGroupsQueryVariables>(SearchFilterGroupsDocument, options);
      }
export function useSearchFilterGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchFilterGroupsQuery, SearchFilterGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchFilterGroupsQuery, SearchFilterGroupsQueryVariables>(SearchFilterGroupsDocument, options);
        }
export type SearchFilterGroupsQueryHookResult = ReturnType<typeof useSearchFilterGroupsQuery>;
export type SearchFilterGroupsLazyQueryHookResult = ReturnType<typeof useSearchFilterGroupsLazyQuery>;
export type SearchFilterGroupsQueryResult = Apollo.QueryResult<SearchFilterGroupsQuery, SearchFilterGroupsQueryVariables>;
export const SearchProfilesDocument = gql`
    query SearchProfiles($first: Int, $searchTerms: [String], $profileDetailFilters: [String], $addressPostalCode: String, $milesFromCenterZip: Int, $sortBy: CandidateSortByEnum, $after: String) {
  searchProfiles(
    first: $first
    searchTerms: $searchTerms
    profileDetailFilters: $profileDetailFilters
    addressPostalCode: $addressPostalCode
    milesFromCenterZip: $milesFromCenterZip
    sortBy: $sortBy
    after: $after
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
    edges {
      node {
        employerCandidate {
          id
        }
        id
        positions
        canHaveDressCode
        isBenefitsRequired
        employmentPreferences
        personalSummary
        profileVideo
        status
        hasResume
        hasEndorsements
        hasContactInformation
        handle
        addressPostalCode
        yearsExperience
        resume
        resumeUploadDate
        user {
          id
          uuid
          profileImage
          firstName
          lastName
        }
        workHistory(first: 1) {
          edges {
            node {
              id
              position
              location {
                id
                name
                addressCity
                addressPostalCode
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useSearchProfilesQuery__
 *
 * To run a query within a React component, call `useSearchProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchProfilesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      searchTerms: // value for 'searchTerms'
 *      profileDetailFilters: // value for 'profileDetailFilters'
 *      addressPostalCode: // value for 'addressPostalCode'
 *      milesFromCenterZip: // value for 'milesFromCenterZip'
 *      sortBy: // value for 'sortBy'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useSearchProfilesQuery(baseOptions?: Apollo.QueryHookOptions<SearchProfilesQuery, SearchProfilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchProfilesQuery, SearchProfilesQueryVariables>(SearchProfilesDocument, options);
      }
export function useSearchProfilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchProfilesQuery, SearchProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchProfilesQuery, SearchProfilesQueryVariables>(SearchProfilesDocument, options);
        }
export type SearchProfilesQueryHookResult = ReturnType<typeof useSearchProfilesQuery>;
export type SearchProfilesLazyQueryHookResult = ReturnType<typeof useSearchProfilesLazyQuery>;
export type SearchProfilesQueryResult = Apollo.QueryResult<SearchProfilesQuery, SearchProfilesQueryVariables>;
export const SearchProfilesCountDocument = gql`
    query searchProfilesCount($searchTerms: [String], $profileDetailFilters: [String], $addressPostalCode: String, $milesFromCenterZip: Int, $sortBy: CandidateSortByEnum) {
  searchProfilesCount(
    searchTerms: $searchTerms
    profileDetailFilters: $profileDetailFilters
    addressPostalCode: $addressPostalCode
    milesFromCenterZip: $milesFromCenterZip
    sortBy: $sortBy
  ) {
    count
  }
}
    `;

/**
 * __useSearchProfilesCountQuery__
 *
 * To run a query within a React component, call `useSearchProfilesCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchProfilesCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchProfilesCountQuery({
 *   variables: {
 *      searchTerms: // value for 'searchTerms'
 *      profileDetailFilters: // value for 'profileDetailFilters'
 *      addressPostalCode: // value for 'addressPostalCode'
 *      milesFromCenterZip: // value for 'milesFromCenterZip'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useSearchProfilesCountQuery(baseOptions?: Apollo.QueryHookOptions<SearchProfilesCountQuery, SearchProfilesCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchProfilesCountQuery, SearchProfilesCountQueryVariables>(SearchProfilesCountDocument, options);
      }
export function useSearchProfilesCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchProfilesCountQuery, SearchProfilesCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchProfilesCountQuery, SearchProfilesCountQueryVariables>(SearchProfilesCountDocument, options);
        }
export type SearchProfilesCountQueryHookResult = ReturnType<typeof useSearchProfilesCountQuery>;
export type SearchProfilesCountLazyQueryHookResult = ReturnType<typeof useSearchProfilesCountLazyQuery>;
export type SearchProfilesCountQueryResult = Apollo.QueryResult<SearchProfilesCountQuery, SearchProfilesCountQueryVariables>;
export const UpdateCandidateProfileImageDocument = gql`
    mutation UpdateCandidateProfileImage($id: ID!, $profileImageId: ID, $firstName: String, $lastName: String, $email: String, $phone: String, $addressPostalCode: String, $commutePreference: String) {
  mutateCandidate(
    input: {id: $id, profileImageId: $profileImageId, firstName: $firstName, lastName: $lastName, email: $email, phone: $phone, addressPostalCode: $addressPostalCode, commutePreference: $commutePreference, partialUpdate: true}
  ) {
    errors {
      field
      messages
    }
    candidateProfile {
      id
      profileVideo
      addressPostalCode
      user {
        id
        email
        phone
        firstName
        lastName
        profileImage
      }
      profileCompleteness
      incompleteSections
      commutePreference
    }
  }
}
    `;
export type UpdateCandidateProfileImageMutationFn = Apollo.MutationFunction<UpdateCandidateProfileImageMutation, UpdateCandidateProfileImageMutationVariables>;

/**
 * __useUpdateCandidateProfileImageMutation__
 *
 * To run a mutation, you first call `useUpdateCandidateProfileImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCandidateProfileImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCandidateProfileImageMutation, { data, loading, error }] = useUpdateCandidateProfileImageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      profileImageId: // value for 'profileImageId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      addressPostalCode: // value for 'addressPostalCode'
 *      commutePreference: // value for 'commutePreference'
 *   },
 * });
 */
export function useUpdateCandidateProfileImageMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCandidateProfileImageMutation, UpdateCandidateProfileImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCandidateProfileImageMutation, UpdateCandidateProfileImageMutationVariables>(UpdateCandidateProfileImageDocument, options);
      }
export type UpdateCandidateProfileImageMutationHookResult = ReturnType<typeof useUpdateCandidateProfileImageMutation>;
export type UpdateCandidateProfileImageMutationResult = Apollo.MutationResult<UpdateCandidateProfileImageMutation>;
export type UpdateCandidateProfileImageMutationOptions = Apollo.BaseMutationOptions<UpdateCandidateProfileImageMutation, UpdateCandidateProfileImageMutationVariables>;
export const UpdateCandidateDocument = gql`
    mutation UpdateCandidate($id: ID!, $firstName: String, $lastName: String, $email: String, $phone: String, $hasCompletedOnboarding: Boolean, $profileVideoId: ID, $positions: [String], $availabilityMonday: [String], $availabilityTuesday: [String], $availabilityWednesday: [String], $availabilityThursday: [String], $availabilityFriday: [String], $availabilitySaturday: [String], $availabilitySunday: [String], $personalSummary: String, $restaurantTypes: [String], $additionalTraining: [String], $yearsExperience: String, $employmentPreferences: [String], $addressPostalCode: String, $commutePreference: String, $status: String, $canHaveDressCode: Boolean, $isBenefitsRequired: Boolean) {
  mutateCandidate(
    input: {id: $id, firstName: $firstName, lastName: $lastName, email: $email, phone: $phone, hasCompletedOnboarding: $hasCompletedOnboarding, profileVideoId: $profileVideoId, positions: $positions, availabilityMonday: $availabilityMonday, availabilityTuesday: $availabilityTuesday, availabilityWednesday: $availabilityWednesday, availabilityThursday: $availabilityThursday, availabilityFriday: $availabilityFriday, availabilitySaturday: $availabilitySaturday, availabilitySunday: $availabilitySunday, personalSummary: $personalSummary, restaurantTypes: $restaurantTypes, additionalTraining: $additionalTraining, yearsExperience: $yearsExperience, employmentPreferences: $employmentPreferences, addressPostalCode: $addressPostalCode, commutePreference: $commutePreference, status: $status, canHaveDressCode: $canHaveDressCode, isBenefitsRequired: $isBenefitsRequired, partialUpdate: true}
  ) {
    errors {
      field
      messages
    }
    candidateProfile {
      id
      profileVideo
      user {
        id
        email
        phone
        firstName
        lastName
      }
      addressPostalCode
      positions
      availabilityMonday
      availabilityTuesday
      availabilityWednesday
      availabilityThursday
      availabilityFriday
      availabilitySaturday
      availabilitySunday
      personalSummary
      restaurantTypes
      additionalTraining
      yearsExperience
      employmentPreferences
      commutePreference
      onboardingCompletedAt
      isBenefitsRequired
      canHaveDressCode
      status
      profileCompleteness
      incompleteSections
      lastMatchCreation
    }
  }
}
    `;
export type UpdateCandidateMutationFn = Apollo.MutationFunction<UpdateCandidateMutation, UpdateCandidateMutationVariables>;

/**
 * __useUpdateCandidateMutation__
 *
 * To run a mutation, you first call `useUpdateCandidateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCandidateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCandidateMutation, { data, loading, error }] = useUpdateCandidateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      hasCompletedOnboarding: // value for 'hasCompletedOnboarding'
 *      profileVideoId: // value for 'profileVideoId'
 *      positions: // value for 'positions'
 *      availabilityMonday: // value for 'availabilityMonday'
 *      availabilityTuesday: // value for 'availabilityTuesday'
 *      availabilityWednesday: // value for 'availabilityWednesday'
 *      availabilityThursday: // value for 'availabilityThursday'
 *      availabilityFriday: // value for 'availabilityFriday'
 *      availabilitySaturday: // value for 'availabilitySaturday'
 *      availabilitySunday: // value for 'availabilitySunday'
 *      personalSummary: // value for 'personalSummary'
 *      restaurantTypes: // value for 'restaurantTypes'
 *      additionalTraining: // value for 'additionalTraining'
 *      yearsExperience: // value for 'yearsExperience'
 *      employmentPreferences: // value for 'employmentPreferences'
 *      addressPostalCode: // value for 'addressPostalCode'
 *      commutePreference: // value for 'commutePreference'
 *      status: // value for 'status'
 *      canHaveDressCode: // value for 'canHaveDressCode'
 *      isBenefitsRequired: // value for 'isBenefitsRequired'
 *   },
 * });
 */
export function useUpdateCandidateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCandidateMutation, UpdateCandidateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCandidateMutation, UpdateCandidateMutationVariables>(UpdateCandidateDocument, options);
      }
export type UpdateCandidateMutationHookResult = ReturnType<typeof useUpdateCandidateMutation>;
export type UpdateCandidateMutationResult = Apollo.MutationResult<UpdateCandidateMutation>;
export type UpdateCandidateMutationOptions = Apollo.BaseMutationOptions<UpdateCandidateMutation, UpdateCandidateMutationVariables>;
export const SoftDeleteCandidateUserDocument = gql`
    mutation SoftDeleteCandidateUser($userId: String!) {
  softDeleteCandidateUser(userId: $userId) {
    deleted
  }
}
    `;
export type SoftDeleteCandidateUserMutationFn = Apollo.MutationFunction<SoftDeleteCandidateUserMutation, SoftDeleteCandidateUserMutationVariables>;

/**
 * __useSoftDeleteCandidateUserMutation__
 *
 * To run a mutation, you first call `useSoftDeleteCandidateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSoftDeleteCandidateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [softDeleteCandidateUserMutation, { data, loading, error }] = useSoftDeleteCandidateUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSoftDeleteCandidateUserMutation(baseOptions?: Apollo.MutationHookOptions<SoftDeleteCandidateUserMutation, SoftDeleteCandidateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SoftDeleteCandidateUserMutation, SoftDeleteCandidateUserMutationVariables>(SoftDeleteCandidateUserDocument, options);
      }
export type SoftDeleteCandidateUserMutationHookResult = ReturnType<typeof useSoftDeleteCandidateUserMutation>;
export type SoftDeleteCandidateUserMutationResult = Apollo.MutationResult<SoftDeleteCandidateUserMutation>;
export type SoftDeleteCandidateUserMutationOptions = Apollo.BaseMutationOptions<SoftDeleteCandidateUserMutation, SoftDeleteCandidateUserMutationVariables>;
export const MutateDeleteMyResumeDocument = gql`
    mutation MutateDeleteMyResume {
  deleteMyResume {
    candidateProfile {
      id
      resume
      profileCompleteness
      incompleteSections
    }
  }
}
    `;
export type MutateDeleteMyResumeMutationFn = Apollo.MutationFunction<MutateDeleteMyResumeMutation, MutateDeleteMyResumeMutationVariables>;

/**
 * __useMutateDeleteMyResumeMutation__
 *
 * To run a mutation, you first call `useMutateDeleteMyResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutateDeleteMyResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateDeleteMyResumeMutation, { data, loading, error }] = useMutateDeleteMyResumeMutation({
 *   variables: {
 *   },
 * });
 */
export function useMutateDeleteMyResumeMutation(baseOptions?: Apollo.MutationHookOptions<MutateDeleteMyResumeMutation, MutateDeleteMyResumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutateDeleteMyResumeMutation, MutateDeleteMyResumeMutationVariables>(MutateDeleteMyResumeDocument, options);
      }
export type MutateDeleteMyResumeMutationHookResult = ReturnType<typeof useMutateDeleteMyResumeMutation>;
export type MutateDeleteMyResumeMutationResult = Apollo.MutationResult<MutateDeleteMyResumeMutation>;
export type MutateDeleteMyResumeMutationOptions = Apollo.BaseMutationOptions<MutateDeleteMyResumeMutation, MutateDeleteMyResumeMutationVariables>;
export const DeleteWorkHistoryDocument = gql`
    mutation DeleteWorkHistory($id: String) {
  deleteWorkHistory(input: {clientMutationId: $id}) {
    id
    message
  }
}
    `;
export type DeleteWorkHistoryMutationFn = Apollo.MutationFunction<DeleteWorkHistoryMutation, DeleteWorkHistoryMutationVariables>;

/**
 * __useDeleteWorkHistoryMutation__
 *
 * To run a mutation, you first call `useDeleteWorkHistoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkHistoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkHistoryMutation, { data, loading, error }] = useDeleteWorkHistoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteWorkHistoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteWorkHistoryMutation, DeleteWorkHistoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteWorkHistoryMutation, DeleteWorkHistoryMutationVariables>(DeleteWorkHistoryDocument, options);
      }
export type DeleteWorkHistoryMutationHookResult = ReturnType<typeof useDeleteWorkHistoryMutation>;
export type DeleteWorkHistoryMutationResult = Apollo.MutationResult<DeleteWorkHistoryMutation>;
export type DeleteWorkHistoryMutationOptions = Apollo.BaseMutationOptions<DeleteWorkHistoryMutation, DeleteWorkHistoryMutationVariables>;
export const GetEmployerCandidateForHandleDocument = gql`
    query GetEmployerCandidateForHandle($handle: String) {
  profile(handle: $handle) {
    id
    handle
    employerCandidate {
      id
      createdAt
      updatedAt
      sevenshiftsId
      preferredMatch {
        id
        position {
          id
          positionName
          location {
            id
            name
          }
        }
      }
      stage {
        id
        name
      }
      candidateProfile {
        id
        handle
        positions
        user {
          id
          uuid
          firstName
          lastName
          profileImage
          email
          phone
        }
      }
      chatNotification {
        id
        notificationType
        dismissedAt
        rowId
        message
        status
        color
        actions
      }
      employercandidateNotifications(first: 2) {
        edges {
          node {
            id
            notificationType
            dismissedAt
            rowId
            message
            status
            color
            actions
          }
        }
      }
      rejectionReasons(archivedAt_Isnull: true) {
        edges {
          node {
            id
            name
          }
        }
      }
      hasNote
    }
  }
}
    `;

/**
 * __useGetEmployerCandidateForHandleQuery__
 *
 * To run a query within a React component, call `useGetEmployerCandidateForHandleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployerCandidateForHandleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployerCandidateForHandleQuery({
 *   variables: {
 *      handle: // value for 'handle'
 *   },
 * });
 */
export function useGetEmployerCandidateForHandleQuery(baseOptions?: Apollo.QueryHookOptions<GetEmployerCandidateForHandleQuery, GetEmployerCandidateForHandleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployerCandidateForHandleQuery, GetEmployerCandidateForHandleQueryVariables>(GetEmployerCandidateForHandleDocument, options);
      }
export function useGetEmployerCandidateForHandleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployerCandidateForHandleQuery, GetEmployerCandidateForHandleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployerCandidateForHandleQuery, GetEmployerCandidateForHandleQueryVariables>(GetEmployerCandidateForHandleDocument, options);
        }
export type GetEmployerCandidateForHandleQueryHookResult = ReturnType<typeof useGetEmployerCandidateForHandleQuery>;
export type GetEmployerCandidateForHandleLazyQueryHookResult = ReturnType<typeof useGetEmployerCandidateForHandleLazyQuery>;
export type GetEmployerCandidateForHandleQueryResult = Apollo.QueryResult<GetEmployerCandidateForHandleQuery, GetEmployerCandidateForHandleQueryVariables>;
export const GetIsFollowingLocationsDocument = gql`
    query GetIsFollowingLocations($handle: String, $locations: [ID]) {
  profile(handle: $handle) {
    id
    isFollowingLocations(locations: $locations)
  }
}
    `;

/**
 * __useGetIsFollowingLocationsQuery__
 *
 * To run a query within a React component, call `useGetIsFollowingLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIsFollowingLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIsFollowingLocationsQuery({
 *   variables: {
 *      handle: // value for 'handle'
 *      locations: // value for 'locations'
 *   },
 * });
 */
export function useGetIsFollowingLocationsQuery(baseOptions?: Apollo.QueryHookOptions<GetIsFollowingLocationsQuery, GetIsFollowingLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIsFollowingLocationsQuery, GetIsFollowingLocationsQueryVariables>(GetIsFollowingLocationsDocument, options);
      }
export function useGetIsFollowingLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIsFollowingLocationsQuery, GetIsFollowingLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIsFollowingLocationsQuery, GetIsFollowingLocationsQueryVariables>(GetIsFollowingLocationsDocument, options);
        }
export type GetIsFollowingLocationsQueryHookResult = ReturnType<typeof useGetIsFollowingLocationsQuery>;
export type GetIsFollowingLocationsLazyQueryHookResult = ReturnType<typeof useGetIsFollowingLocationsLazyQuery>;
export type GetIsFollowingLocationsQueryResult = Apollo.QueryResult<GetIsFollowingLocationsQuery, GetIsFollowingLocationsQueryVariables>;
export const GetMyProfileCompletenessDocument = gql`
    query GetMyProfileCompleteness {
  me {
    id
    candidateProfile {
      id
      handle
      profileCompleteness
      incompleteSections
    }
  }
}
    `;

/**
 * __useGetMyProfileCompletenessQuery__
 *
 * To run a query within a React component, call `useGetMyProfileCompletenessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyProfileCompletenessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyProfileCompletenessQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyProfileCompletenessQuery(baseOptions?: Apollo.QueryHookOptions<GetMyProfileCompletenessQuery, GetMyProfileCompletenessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyProfileCompletenessQuery, GetMyProfileCompletenessQueryVariables>(GetMyProfileCompletenessDocument, options);
      }
export function useGetMyProfileCompletenessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyProfileCompletenessQuery, GetMyProfileCompletenessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyProfileCompletenessQuery, GetMyProfileCompletenessQueryVariables>(GetMyProfileCompletenessDocument, options);
        }
export type GetMyProfileCompletenessQueryHookResult = ReturnType<typeof useGetMyProfileCompletenessQuery>;
export type GetMyProfileCompletenessLazyQueryHookResult = ReturnType<typeof useGetMyProfileCompletenessLazyQuery>;
export type GetMyProfileCompletenessQueryResult = Apollo.QueryResult<GetMyProfileCompletenessQuery, GetMyProfileCompletenessQueryVariables>;
export const GetMyWorkHistoryDetailDocument = gql`
    query GetMyWorkHistoryDetail {
  me {
    id
    candidateProfile {
      id
      workHistory {
        edges {
          node {
            id
            employerName
            responsibilities
            location {
              id
              slug
              name
              formattedAddress
              image
            }
            position
            start
            end
            present
            __typename
          }
        }
        __typename
      }
    }
  }
}
    `;

/**
 * __useGetMyWorkHistoryDetailQuery__
 *
 * To run a query within a React component, call `useGetMyWorkHistoryDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyWorkHistoryDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyWorkHistoryDetailQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyWorkHistoryDetailQuery(baseOptions?: Apollo.QueryHookOptions<GetMyWorkHistoryDetailQuery, GetMyWorkHistoryDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyWorkHistoryDetailQuery, GetMyWorkHistoryDetailQueryVariables>(GetMyWorkHistoryDetailDocument, options);
      }
export function useGetMyWorkHistoryDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyWorkHistoryDetailQuery, GetMyWorkHistoryDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyWorkHistoryDetailQuery, GetMyWorkHistoryDetailQueryVariables>(GetMyWorkHistoryDetailDocument, options);
        }
export type GetMyWorkHistoryDetailQueryHookResult = ReturnType<typeof useGetMyWorkHistoryDetailQuery>;
export type GetMyWorkHistoryDetailLazyQueryHookResult = ReturnType<typeof useGetMyWorkHistoryDetailLazyQuery>;
export type GetMyWorkHistoryDetailQueryResult = Apollo.QueryResult<GetMyWorkHistoryDetailQuery, GetMyWorkHistoryDetailQueryVariables>;
export const MutateCandidateResumeDocument = gql`
    mutation MutateCandidateResume($id: ID!, $resumeFileName: String, $resumeFileType: String) {
  mutateCandidate(
    input: {id: $id, resumeFileName: $resumeFileName, resumeFileType: $resumeFileType}
  ) {
    candidateProfile {
      id
      resume
      resumeUploadDate
      profileCompleteness
      incompleteSections
    }
    resumeUploadUrl
    errors {
      field
      messages
    }
  }
}
    `;
export type MutateCandidateResumeMutationFn = Apollo.MutationFunction<MutateCandidateResumeMutation, MutateCandidateResumeMutationVariables>;

/**
 * __useMutateCandidateResumeMutation__
 *
 * To run a mutation, you first call `useMutateCandidateResumeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutateCandidateResumeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateCandidateResumeMutation, { data, loading, error }] = useMutateCandidateResumeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      resumeFileName: // value for 'resumeFileName'
 *      resumeFileType: // value for 'resumeFileType'
 *   },
 * });
 */
export function useMutateCandidateResumeMutation(baseOptions?: Apollo.MutationHookOptions<MutateCandidateResumeMutation, MutateCandidateResumeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutateCandidateResumeMutation, MutateCandidateResumeMutationVariables>(MutateCandidateResumeDocument, options);
      }
export type MutateCandidateResumeMutationHookResult = ReturnType<typeof useMutateCandidateResumeMutation>;
export type MutateCandidateResumeMutationResult = Apollo.MutationResult<MutateCandidateResumeMutation>;
export type MutateCandidateResumeMutationOptions = Apollo.BaseMutationOptions<MutateCandidateResumeMutation, MutateCandidateResumeMutationVariables>;
export const MutateWorkHistoryDocument = gql`
    mutation MutateWorkHistory($id: ID, $employerName: String!, $location: ID, $position: String, $present: Boolean, $responsibilities: String, $start: Date, $end: Date) {
  mutateWorkHistory(
    input: {id: $id, employerName: $employerName, position: $position, present: $present, responsibilities: $responsibilities, start: $start, end: $end, location: $location, partialUpdate: true}
  ) {
    workHistory {
      id
      employerName
      responsibilities
      location {
        id
        slug
        name
        formattedAddress
        image
      }
      position
      start
      end
      present
      __typename
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type MutateWorkHistoryMutationFn = Apollo.MutationFunction<MutateWorkHistoryMutation, MutateWorkHistoryMutationVariables>;

/**
 * __useMutateWorkHistoryMutation__
 *
 * To run a mutation, you first call `useMutateWorkHistoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutateWorkHistoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateWorkHistoryMutation, { data, loading, error }] = useMutateWorkHistoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *      employerName: // value for 'employerName'
 *      location: // value for 'location'
 *      position: // value for 'position'
 *      present: // value for 'present'
 *      responsibilities: // value for 'responsibilities'
 *      start: // value for 'start'
 *      end: // value for 'end'
 *   },
 * });
 */
export function useMutateWorkHistoryMutation(baseOptions?: Apollo.MutationHookOptions<MutateWorkHistoryMutation, MutateWorkHistoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutateWorkHistoryMutation, MutateWorkHistoryMutationVariables>(MutateWorkHistoryDocument, options);
      }
export type MutateWorkHistoryMutationHookResult = ReturnType<typeof useMutateWorkHistoryMutation>;
export type MutateWorkHistoryMutationResult = Apollo.MutationResult<MutateWorkHistoryMutation>;
export type MutateWorkHistoryMutationOptions = Apollo.BaseMutationOptions<MutateWorkHistoryMutation, MutateWorkHistoryMutationVariables>;
export const CreateCareerPageDocument = gql`
    mutation createCareerPage($slug: String!, $title: String, $selectedLocations: [String]) {
  createCareerPageMutation(
    input: {slug: $slug, title: $title, selectedLocations: $selectedLocations}
  ) {
    careerPageType {
      title
      createdBy {
        id
      }
      slug
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateCareerPageMutationFn = Apollo.MutationFunction<CreateCareerPageMutation, CreateCareerPageMutationVariables>;

/**
 * __useCreateCareerPageMutation__
 *
 * To run a mutation, you first call `useCreateCareerPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCareerPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCareerPageMutation, { data, loading, error }] = useCreateCareerPageMutation({
 *   variables: {
 *      slug: // value for 'slug'
 *      title: // value for 'title'
 *      selectedLocations: // value for 'selectedLocations'
 *   },
 * });
 */
export function useCreateCareerPageMutation(baseOptions?: Apollo.MutationHookOptions<CreateCareerPageMutation, CreateCareerPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCareerPageMutation, CreateCareerPageMutationVariables>(CreateCareerPageDocument, options);
      }
export type CreateCareerPageMutationHookResult = ReturnType<typeof useCreateCareerPageMutation>;
export type CreateCareerPageMutationResult = Apollo.MutationResult<CreateCareerPageMutation>;
export type CreateCareerPageMutationOptions = Apollo.BaseMutationOptions<CreateCareerPageMutation, CreateCareerPageMutationVariables>;
export const MutateDeleteCareerPageDocument = gql`
    mutation mutateDeleteCareerPage($careerPageId: ID) {
  deleteCareerPage(careerPageId: $careerPageId) {
    deleted
  }
}
    `;
export type MutateDeleteCareerPageMutationFn = Apollo.MutationFunction<MutateDeleteCareerPageMutation, MutateDeleteCareerPageMutationVariables>;

/**
 * __useMutateDeleteCareerPageMutation__
 *
 * To run a mutation, you first call `useMutateDeleteCareerPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutateDeleteCareerPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateDeleteCareerPageMutation, { data, loading, error }] = useMutateDeleteCareerPageMutation({
 *   variables: {
 *      careerPageId: // value for 'careerPageId'
 *   },
 * });
 */
export function useMutateDeleteCareerPageMutation(baseOptions?: Apollo.MutationHookOptions<MutateDeleteCareerPageMutation, MutateDeleteCareerPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutateDeleteCareerPageMutation, MutateDeleteCareerPageMutationVariables>(MutateDeleteCareerPageDocument, options);
      }
export type MutateDeleteCareerPageMutationHookResult = ReturnType<typeof useMutateDeleteCareerPageMutation>;
export type MutateDeleteCareerPageMutationResult = Apollo.MutationResult<MutateDeleteCareerPageMutation>;
export type MutateDeleteCareerPageMutationOptions = Apollo.BaseMutationOptions<MutateDeleteCareerPageMutation, MutateDeleteCareerPageMutationVariables>;
export const GetCareerPageAnswersDisplayDocument = gql`
    query GetCareerPageAnswersDisplay($slug: String) {
  careerPageBySlug(slug: $slug) {
    edges {
      node {
        id
        answers {
          edges {
            node {
              response
              question {
                icon
              }
              option {
                displayLabel
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCareerPageAnswersDisplayQuery__
 *
 * To run a query within a React component, call `useGetCareerPageAnswersDisplayQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCareerPageAnswersDisplayQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCareerPageAnswersDisplayQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetCareerPageAnswersDisplayQuery(baseOptions?: Apollo.QueryHookOptions<GetCareerPageAnswersDisplayQuery, GetCareerPageAnswersDisplayQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCareerPageAnswersDisplayQuery, GetCareerPageAnswersDisplayQueryVariables>(GetCareerPageAnswersDisplayDocument, options);
      }
export function useGetCareerPageAnswersDisplayLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCareerPageAnswersDisplayQuery, GetCareerPageAnswersDisplayQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCareerPageAnswersDisplayQuery, GetCareerPageAnswersDisplayQueryVariables>(GetCareerPageAnswersDisplayDocument, options);
        }
export type GetCareerPageAnswersDisplayQueryHookResult = ReturnType<typeof useGetCareerPageAnswersDisplayQuery>;
export type GetCareerPageAnswersDisplayLazyQueryHookResult = ReturnType<typeof useGetCareerPageAnswersDisplayLazyQuery>;
export type GetCareerPageAnswersDisplayQueryResult = Apollo.QueryResult<GetCareerPageAnswersDisplayQuery, GetCareerPageAnswersDisplayQueryVariables>;
export const GetCareerPageAnswersDocument = gql`
    query GetCareerPageAnswers($slug: String) {
  careerPageBySlug(slug: $slug) {
    edges {
      node {
        id
        answers {
          edges {
            node {
              id
              response
              question {
                id
                title
                required
                placeholder
                category
                questionType
                icon
                options {
                  id
                  label
                  value
                  ordering
                  displayLabel
                }
              }
              option {
                id
                label
                value
                ordering
                displayLabel
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetCareerPageAnswersQuery__
 *
 * To run a query within a React component, call `useGetCareerPageAnswersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCareerPageAnswersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCareerPageAnswersQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetCareerPageAnswersQuery(baseOptions?: Apollo.QueryHookOptions<GetCareerPageAnswersQuery, GetCareerPageAnswersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCareerPageAnswersQuery, GetCareerPageAnswersQueryVariables>(GetCareerPageAnswersDocument, options);
      }
export function useGetCareerPageAnswersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCareerPageAnswersQuery, GetCareerPageAnswersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCareerPageAnswersQuery, GetCareerPageAnswersQueryVariables>(GetCareerPageAnswersDocument, options);
        }
export type GetCareerPageAnswersQueryHookResult = ReturnType<typeof useGetCareerPageAnswersQuery>;
export type GetCareerPageAnswersLazyQueryHookResult = ReturnType<typeof useGetCareerPageAnswersLazyQuery>;
export type GetCareerPageAnswersQueryResult = Apollo.QueryResult<GetCareerPageAnswersQuery, GetCareerPageAnswersQueryVariables>;
export const EditCareerPageDocument = gql`
    mutation EditCareerPage($addressCity: String, $addressPostalCode: String, $addressState: String, $addressStreet1: String, $addressStreet2: String, $brandColor: String, $brandPageColor: String, $brandTableColor: String, $coverColor: String, $description: String, $fontColor: String, $fontFamily: String, $selectedLocations: [String], $slug: String!, $title: String) {
  mutateCareerPage(
    input: {addressCity: $addressCity, addressCountry: "US", addressPostalCode: $addressPostalCode, addressState: $addressState, addressStreet1: $addressStreet1, addressStreet2: $addressStreet2, brandColor: $brandColor, brandPageColor: $brandPageColor, brandTableColor: $brandTableColor, coverColor: $coverColor, description: $description, fontColor: $fontColor, fontFamily: $fontFamily, selectedLocations: $selectedLocations, slug: $slug, title: $title}
  ) {
    coverImageUploadUrl
    errors {
      field
      messages
    }
  }
}
    `;
export type EditCareerPageMutationFn = Apollo.MutationFunction<EditCareerPageMutation, EditCareerPageMutationVariables>;

/**
 * __useEditCareerPageMutation__
 *
 * To run a mutation, you first call `useEditCareerPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCareerPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCareerPageMutation, { data, loading, error }] = useEditCareerPageMutation({
 *   variables: {
 *      addressCity: // value for 'addressCity'
 *      addressPostalCode: // value for 'addressPostalCode'
 *      addressState: // value for 'addressState'
 *      addressStreet1: // value for 'addressStreet1'
 *      addressStreet2: // value for 'addressStreet2'
 *      brandColor: // value for 'brandColor'
 *      brandPageColor: // value for 'brandPageColor'
 *      brandTableColor: // value for 'brandTableColor'
 *      coverColor: // value for 'coverColor'
 *      description: // value for 'description'
 *      fontColor: // value for 'fontColor'
 *      fontFamily: // value for 'fontFamily'
 *      selectedLocations: // value for 'selectedLocations'
 *      slug: // value for 'slug'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useEditCareerPageMutation(baseOptions?: Apollo.MutationHookOptions<EditCareerPageMutation, EditCareerPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCareerPageMutation, EditCareerPageMutationVariables>(EditCareerPageDocument, options);
      }
export type EditCareerPageMutationHookResult = ReturnType<typeof useEditCareerPageMutation>;
export type EditCareerPageMutationResult = Apollo.MutationResult<EditCareerPageMutation>;
export type EditCareerPageMutationOptions = Apollo.BaseMutationOptions<EditCareerPageMutation, EditCareerPageMutationVariables>;
export const UpdateCareerPageAnswersDocument = gql`
    mutation UpdateCareerPageAnswers($careerPage: ID!, $responses: [CareerPageAnswerInputType]!) {
  mutateCareerPageAnswer(input: {careerPage: $careerPage, responses: $responses}) {
    __typename
  }
}
    `;
export type UpdateCareerPageAnswersMutationFn = Apollo.MutationFunction<UpdateCareerPageAnswersMutation, UpdateCareerPageAnswersMutationVariables>;

/**
 * __useUpdateCareerPageAnswersMutation__
 *
 * To run a mutation, you first call `useUpdateCareerPageAnswersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCareerPageAnswersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCareerPageAnswersMutation, { data, loading, error }] = useUpdateCareerPageAnswersMutation({
 *   variables: {
 *      careerPage: // value for 'careerPage'
 *      responses: // value for 'responses'
 *   },
 * });
 */
export function useUpdateCareerPageAnswersMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCareerPageAnswersMutation, UpdateCareerPageAnswersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCareerPageAnswersMutation, UpdateCareerPageAnswersMutationVariables>(UpdateCareerPageAnswersDocument, options);
      }
export type UpdateCareerPageAnswersMutationHookResult = ReturnType<typeof useUpdateCareerPageAnswersMutation>;
export type UpdateCareerPageAnswersMutationResult = Apollo.MutationResult<UpdateCareerPageAnswersMutation>;
export type UpdateCareerPageAnswersMutationOptions = Apollo.BaseMutationOptions<UpdateCareerPageAnswersMutation, UpdateCareerPageAnswersMutationVariables>;
export const MutateCareerPageLocationChatDocument = gql`
    mutation MutateCareerPageLocationChat($locationId: ID, $message: String) {
  mutateCareerPageLocationMessage(locationId: $locationId, message: $message) {
    response
  }
}
    `;
export type MutateCareerPageLocationChatMutationFn = Apollo.MutationFunction<MutateCareerPageLocationChatMutation, MutateCareerPageLocationChatMutationVariables>;

/**
 * __useMutateCareerPageLocationChatMutation__
 *
 * To run a mutation, you first call `useMutateCareerPageLocationChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutateCareerPageLocationChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateCareerPageLocationChatMutation, { data, loading, error }] = useMutateCareerPageLocationChatMutation({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useMutateCareerPageLocationChatMutation(baseOptions?: Apollo.MutationHookOptions<MutateCareerPageLocationChatMutation, MutateCareerPageLocationChatMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutateCareerPageLocationChatMutation, MutateCareerPageLocationChatMutationVariables>(MutateCareerPageLocationChatDocument, options);
      }
export type MutateCareerPageLocationChatMutationHookResult = ReturnType<typeof useMutateCareerPageLocationChatMutation>;
export type MutateCareerPageLocationChatMutationResult = Apollo.MutationResult<MutateCareerPageLocationChatMutation>;
export type MutateCareerPageLocationChatMutationOptions = Apollo.BaseMutationOptions<MutateCareerPageLocationChatMutation, MutateCareerPageLocationChatMutationVariables>;
export const EditCareerPageWithCoverDocument = gql`
    mutation EditCareerPageWithCover($addressCity: String, $addressPostalCode: String, $addressState: String, $addressStreet1: String, $addressStreet2: String, $brandColor: String, $brandPageColor: String, $brandTableColor: String, $coverColor: String, $description: String, $fileName: String, $fileType: String, $fontColor: String, $fontFamily: String, $selectedLocations: [String], $slug: String!, $title: String) {
  mutateCareerPage(
    input: {addressCity: $addressCity, addressCountry: "US", addressPostalCode: $addressPostalCode, addressState: $addressState, addressStreet1: $addressStreet1, addressStreet2: $addressStreet2, brandColor: $brandColor, brandPageColor: $brandPageColor, brandTableColor: $brandTableColor, coverColor: $coverColor, description: $description, fileName: $fileName, fileType: $fileType, fontColor: $fontColor, fontFamily: $fontFamily, selectedLocations: $selectedLocations, slug: $slug, title: $title}
  ) {
    coverImageUploadUrl
    errors {
      field
      messages
    }
  }
}
    `;
export type EditCareerPageWithCoverMutationFn = Apollo.MutationFunction<EditCareerPageWithCoverMutation, EditCareerPageWithCoverMutationVariables>;

/**
 * __useEditCareerPageWithCoverMutation__
 *
 * To run a mutation, you first call `useEditCareerPageWithCoverMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCareerPageWithCoverMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCareerPageWithCoverMutation, { data, loading, error }] = useEditCareerPageWithCoverMutation({
 *   variables: {
 *      addressCity: // value for 'addressCity'
 *      addressPostalCode: // value for 'addressPostalCode'
 *      addressState: // value for 'addressState'
 *      addressStreet1: // value for 'addressStreet1'
 *      addressStreet2: // value for 'addressStreet2'
 *      brandColor: // value for 'brandColor'
 *      brandPageColor: // value for 'brandPageColor'
 *      brandTableColor: // value for 'brandTableColor'
 *      coverColor: // value for 'coverColor'
 *      description: // value for 'description'
 *      fileName: // value for 'fileName'
 *      fileType: // value for 'fileType'
 *      fontColor: // value for 'fontColor'
 *      fontFamily: // value for 'fontFamily'
 *      selectedLocations: // value for 'selectedLocations'
 *      slug: // value for 'slug'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useEditCareerPageWithCoverMutation(baseOptions?: Apollo.MutationHookOptions<EditCareerPageWithCoverMutation, EditCareerPageWithCoverMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCareerPageWithCoverMutation, EditCareerPageWithCoverMutationVariables>(EditCareerPageWithCoverDocument, options);
      }
export type EditCareerPageWithCoverMutationHookResult = ReturnType<typeof useEditCareerPageWithCoverMutation>;
export type EditCareerPageWithCoverMutationResult = Apollo.MutationResult<EditCareerPageWithCoverMutation>;
export type EditCareerPageWithCoverMutationOptions = Apollo.BaseMutationOptions<EditCareerPageWithCoverMutation, EditCareerPageWithCoverMutationVariables>;
export const EditCareerPageGalleryDocument = gql`
    mutation EditCareerPageGallery($careerPage: ID!, $galleries: [CareerPageGalleryCategories]!) {
  mutateCreateCareerPageGallery(
    input: {careerPage: $careerPage, galleries: $galleries}
  ) {
    urls {
      signedS3Url
      fileName
      link
    }
  }
}
    `;
export type EditCareerPageGalleryMutationFn = Apollo.MutationFunction<EditCareerPageGalleryMutation, EditCareerPageGalleryMutationVariables>;

/**
 * __useEditCareerPageGalleryMutation__
 *
 * To run a mutation, you first call `useEditCareerPageGalleryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCareerPageGalleryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCareerPageGalleryMutation, { data, loading, error }] = useEditCareerPageGalleryMutation({
 *   variables: {
 *      careerPage: // value for 'careerPage'
 *      galleries: // value for 'galleries'
 *   },
 * });
 */
export function useEditCareerPageGalleryMutation(baseOptions?: Apollo.MutationHookOptions<EditCareerPageGalleryMutation, EditCareerPageGalleryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCareerPageGalleryMutation, EditCareerPageGalleryMutationVariables>(EditCareerPageGalleryDocument, options);
      }
export type EditCareerPageGalleryMutationHookResult = ReturnType<typeof useEditCareerPageGalleryMutation>;
export type EditCareerPageGalleryMutationResult = Apollo.MutationResult<EditCareerPageGalleryMutation>;
export type EditCareerPageGalleryMutationOptions = Apollo.BaseMutationOptions<EditCareerPageGalleryMutation, EditCareerPageGalleryMutationVariables>;
export const GetCareerPageDataDocument = gql`
    query GetCareerPageData($slug: String) {
  careerPageBySlug(slug: $slug) {
    edges {
      node {
        id
        title
        slug
        cover
        brandColor
        brandPageColor
        brandTableColor
        coverColor
        fontFamily
        fontColor
        description
        addressCity
        addressState
        addressStreet1
        addressStreet2
        addressCountry
        formattedAddress
        addressPostalCode
        galleries {
          edges {
            node {
              id
              category
              uploadFile
              getUploadFileExtension
            }
          }
        }
        selectedLocations
      }
    }
  }
}
    `;

/**
 * __useGetCareerPageDataQuery__
 *
 * To run a query within a React component, call `useGetCareerPageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCareerPageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCareerPageDataQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetCareerPageDataQuery(baseOptions?: Apollo.QueryHookOptions<GetCareerPageDataQuery, GetCareerPageDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCareerPageDataQuery, GetCareerPageDataQueryVariables>(GetCareerPageDataDocument, options);
      }
export function useGetCareerPageDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCareerPageDataQuery, GetCareerPageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCareerPageDataQuery, GetCareerPageDataQueryVariables>(GetCareerPageDataDocument, options);
        }
export type GetCareerPageDataQueryHookResult = ReturnType<typeof useGetCareerPageDataQuery>;
export type GetCareerPageDataLazyQueryHookResult = ReturnType<typeof useGetCareerPageDataLazyQuery>;
export type GetCareerPageDataQueryResult = Apollo.QueryResult<GetCareerPageDataQuery, GetCareerPageDataQueryVariables>;
export const GetCareerPageAccessDocument = gql`
    query GetCareerPageAccess($id: ID!) {
  careerPageEditAccess(id: $id) {
    canManage
  }
}
    `;

/**
 * __useGetCareerPageAccessQuery__
 *
 * To run a query within a React component, call `useGetCareerPageAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCareerPageAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCareerPageAccessQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCareerPageAccessQuery(baseOptions: Apollo.QueryHookOptions<GetCareerPageAccessQuery, GetCareerPageAccessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCareerPageAccessQuery, GetCareerPageAccessQueryVariables>(GetCareerPageAccessDocument, options);
      }
export function useGetCareerPageAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCareerPageAccessQuery, GetCareerPageAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCareerPageAccessQuery, GetCareerPageAccessQueryVariables>(GetCareerPageAccessDocument, options);
        }
export type GetCareerPageAccessQueryHookResult = ReturnType<typeof useGetCareerPageAccessQuery>;
export type GetCareerPageAccessLazyQueryHookResult = ReturnType<typeof useGetCareerPageAccessLazyQuery>;
export type GetCareerPageAccessQueryResult = Apollo.QueryResult<GetCareerPageAccessQuery, GetCareerPageAccessQueryVariables>;
export const GetCareerPageLocationsDocument = gql`
    query GetCareerPageLocations($slug: String) {
  careerPageBySlug(slug: $slug) {
    edges {
      node {
        id
        locations {
          edges {
            node {
              id
              name
              rowId
              latitude
              longitude
              formattedAddress
              tags {
                id
                name
              }
            }
          }
        }
        selectedLocations
      }
    }
  }
}
    `;

/**
 * __useGetCareerPageLocationsQuery__
 *
 * To run a query within a React component, call `useGetCareerPageLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCareerPageLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCareerPageLocationsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetCareerPageLocationsQuery(baseOptions?: Apollo.QueryHookOptions<GetCareerPageLocationsQuery, GetCareerPageLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCareerPageLocationsQuery, GetCareerPageLocationsQueryVariables>(GetCareerPageLocationsDocument, options);
      }
export function useGetCareerPageLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCareerPageLocationsQuery, GetCareerPageLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCareerPageLocationsQuery, GetCareerPageLocationsQueryVariables>(GetCareerPageLocationsDocument, options);
        }
export type GetCareerPageLocationsQueryHookResult = ReturnType<typeof useGetCareerPageLocationsQuery>;
export type GetCareerPageLocationsLazyQueryHookResult = ReturnType<typeof useGetCareerPageLocationsLazyQuery>;
export type GetCareerPageLocationsQueryResult = Apollo.QueryResult<GetCareerPageLocationsQuery, GetCareerPageLocationsQueryVariables>;
export const GetCareerPagePositionsDocument = gql`
    query GetCareerPagePositions($after: String, $location_In: [ID]!, $first: Int, $positionName_Icontains: String) {
  positions(
    after: $after
    location_In: $location_In
    first: $first
    positionName_Icontains: $positionName_Icontains
    hiring: true
  ) {
    edges {
      node {
        id
        positionName
        paymentStatus
        hiring
        createdAt
        posted
        location {
          name
          image
          formattedAddress
          paymentStatus
        }
        baseSalaryMin
        baseSalaryMax
        baseSalaryUnitText
        slug
      }
    }
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasNextPage
    }
    __typename
  }
}
    `;

/**
 * __useGetCareerPagePositionsQuery__
 *
 * To run a query within a React component, call `useGetCareerPagePositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCareerPagePositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCareerPagePositionsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      location_In: // value for 'location_In'
 *      first: // value for 'first'
 *      positionName_Icontains: // value for 'positionName_Icontains'
 *   },
 * });
 */
export function useGetCareerPagePositionsQuery(baseOptions: Apollo.QueryHookOptions<GetCareerPagePositionsQuery, GetCareerPagePositionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCareerPagePositionsQuery, GetCareerPagePositionsQueryVariables>(GetCareerPagePositionsDocument, options);
      }
export function useGetCareerPagePositionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCareerPagePositionsQuery, GetCareerPagePositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCareerPagePositionsQuery, GetCareerPagePositionsQueryVariables>(GetCareerPagePositionsDocument, options);
        }
export type GetCareerPagePositionsQueryHookResult = ReturnType<typeof useGetCareerPagePositionsQuery>;
export type GetCareerPagePositionsLazyQueryHookResult = ReturnType<typeof useGetCareerPagePositionsLazyQuery>;
export type GetCareerPagePositionsQueryResult = Apollo.QueryResult<GetCareerPagePositionsQuery, GetCareerPagePositionsQueryVariables>;
export const GetCareerPagesDocument = gql`
    query GetCareerPages($employerProfile: ID!, $first: Int, $after: String) {
  employerCareerPages(
    employerProfile: $employerProfile
    first: $first
    after: $after
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
    edges {
      node {
        id
        title
        slug
        createdBy {
          id
          firstName
          lastName
        }
        pageLocations {
          id
          name
          rowId
          formattedAddress
        }
        totalPositions
        canManage
      }
    }
  }
}
    `;

/**
 * __useGetCareerPagesQuery__
 *
 * To run a query within a React component, call `useGetCareerPagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCareerPagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCareerPagesQuery({
 *   variables: {
 *      employerProfile: // value for 'employerProfile'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetCareerPagesQuery(baseOptions: Apollo.QueryHookOptions<GetCareerPagesQuery, GetCareerPagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCareerPagesQuery, GetCareerPagesQueryVariables>(GetCareerPagesDocument, options);
      }
export function useGetCareerPagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCareerPagesQuery, GetCareerPagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCareerPagesQuery, GetCareerPagesQueryVariables>(GetCareerPagesDocument, options);
        }
export type GetCareerPagesQueryHookResult = ReturnType<typeof useGetCareerPagesQuery>;
export type GetCareerPagesLazyQueryHookResult = ReturnType<typeof useGetCareerPagesLazyQuery>;
export type GetCareerPagesQueryResult = Apollo.QueryResult<GetCareerPagesQuery, GetCareerPagesQueryVariables>;
export const GenerateSbTokenDocument = gql`
    mutation GenerateSBToken {
  generateSendbirdUserToken {
    me {
      id
      sendbirdAccessToken
    }
  }
}
    `;
export type GenerateSbTokenMutationFn = Apollo.MutationFunction<GenerateSbTokenMutation, GenerateSbTokenMutationVariables>;

/**
 * __useGenerateSbTokenMutation__
 *
 * To run a mutation, you first call `useGenerateSbTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSbTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSbTokenMutation, { data, loading, error }] = useGenerateSbTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useGenerateSbTokenMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSbTokenMutation, GenerateSbTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSbTokenMutation, GenerateSbTokenMutationVariables>(GenerateSbTokenDocument, options);
      }
export type GenerateSbTokenMutationHookResult = ReturnType<typeof useGenerateSbTokenMutation>;
export type GenerateSbTokenMutationResult = Apollo.MutationResult<GenerateSbTokenMutation>;
export type GenerateSbTokenMutationOptions = Apollo.BaseMutationOptions<GenerateSbTokenMutation, GenerateSbTokenMutationVariables>;
export const GetChannelsDocument = gql`
    query GetChannels($locationId: String, $positionId: String, $filters: [String]) {
  channels(locationId: $locationId, positionId: $positionId, filters: $filters) {
    edges {
      node {
        sendbirdChannelId
        candidateUser {
          profileImage
        }
      }
    }
  }
}
    `;

/**
 * __useGetChannelsQuery__
 *
 * To run a query within a React component, call `useGetChannelsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelsQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      positionId: // value for 'positionId'
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useGetChannelsQuery(baseOptions?: Apollo.QueryHookOptions<GetChannelsQuery, GetChannelsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelsQuery, GetChannelsQueryVariables>(GetChannelsDocument, options);
      }
export function useGetChannelsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelsQuery, GetChannelsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelsQuery, GetChannelsQueryVariables>(GetChannelsDocument, options);
        }
export type GetChannelsQueryHookResult = ReturnType<typeof useGetChannelsQuery>;
export type GetChannelsLazyQueryHookResult = ReturnType<typeof useGetChannelsLazyQuery>;
export type GetChannelsQueryResult = Apollo.QueryResult<GetChannelsQuery, GetChannelsQueryVariables>;
export const GetChannelsCountDocument = gql`
    query GetChannelsCount($locationId: String, $positionId: String) {
  channelsCount(locationId: $locationId, positionId: $positionId) {
    unhidden
    hidden
  }
}
    `;

/**
 * __useGetChannelsCountQuery__
 *
 * To run a query within a React component, call `useGetChannelsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelsCountQuery({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      positionId: // value for 'positionId'
 *   },
 * });
 */
export function useGetChannelsCountQuery(baseOptions?: Apollo.QueryHookOptions<GetChannelsCountQuery, GetChannelsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelsCountQuery, GetChannelsCountQueryVariables>(GetChannelsCountDocument, options);
      }
export function useGetChannelsCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelsCountQuery, GetChannelsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelsCountQuery, GetChannelsCountQueryVariables>(GetChannelsCountDocument, options);
        }
export type GetChannelsCountQueryHookResult = ReturnType<typeof useGetChannelsCountQuery>;
export type GetChannelsCountLazyQueryHookResult = ReturnType<typeof useGetChannelsCountLazyQuery>;
export type GetChannelsCountQueryResult = Apollo.QueryResult<GetChannelsCountQuery, GetChannelsCountQueryVariables>;
export const GetChannelDocument = gql`
    query GetChannel($sendbirdChannelId: String) {
  channel(sendbirdChannelId: $sendbirdChannelId) {
    id
    sendbirdChannelId
    lastLocation {
      id
      name
      image
    }
    location {
      id
      name
      image
    }
  }
}
    `;

/**
 * __useGetChannelQuery__
 *
 * To run a query within a React component, call `useGetChannelQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelQuery({
 *   variables: {
 *      sendbirdChannelId: // value for 'sendbirdChannelId'
 *   },
 * });
 */
export function useGetChannelQuery(baseOptions?: Apollo.QueryHookOptions<GetChannelQuery, GetChannelQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelQuery, GetChannelQueryVariables>(GetChannelDocument, options);
      }
export function useGetChannelLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelQuery, GetChannelQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelQuery, GetChannelQueryVariables>(GetChannelDocument, options);
        }
export type GetChannelQueryHookResult = ReturnType<typeof useGetChannelQuery>;
export type GetChannelLazyQueryHookResult = ReturnType<typeof useGetChannelLazyQuery>;
export type GetChannelQueryResult = Apollo.QueryResult<GetChannelQuery, GetChannelQueryVariables>;
export const GetChannelAndFullDetailsDocument = gql`
    query GetChannelAndFullDetails($sendbirdChannelId: String) {
  channel(sendbirdChannelId: $sendbirdChannelId) {
    id
    sendbirdChannelId
    candidateUser {
      id
      rowId
      firstName
      lastName
      candidateProfile {
        id
        handle
      }
    }
    location {
      id
      name
      image
      paymentStatus
    }
    employerUser {
      id
      firstName
      lastName
    }
    lastPosition {
      id
      positionName
      slug
      paymentStatus
      shortUrl
    }
    lastLocation {
      id
      name
      image
      slug
      paymentStatus
    }
    lastInterview {
      id
      uuid
      status
    }
    lastApplication {
      id
    }
  }
}
    `;

/**
 * __useGetChannelAndFullDetailsQuery__
 *
 * To run a query within a React component, call `useGetChannelAndFullDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelAndFullDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelAndFullDetailsQuery({
 *   variables: {
 *      sendbirdChannelId: // value for 'sendbirdChannelId'
 *   },
 * });
 */
export function useGetChannelAndFullDetailsQuery(baseOptions?: Apollo.QueryHookOptions<GetChannelAndFullDetailsQuery, GetChannelAndFullDetailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelAndFullDetailsQuery, GetChannelAndFullDetailsQueryVariables>(GetChannelAndFullDetailsDocument, options);
      }
export function useGetChannelAndFullDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelAndFullDetailsQuery, GetChannelAndFullDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelAndFullDetailsQuery, GetChannelAndFullDetailsQueryVariables>(GetChannelAndFullDetailsDocument, options);
        }
export type GetChannelAndFullDetailsQueryHookResult = ReturnType<typeof useGetChannelAndFullDetailsQuery>;
export type GetChannelAndFullDetailsLazyQueryHookResult = ReturnType<typeof useGetChannelAndFullDetailsLazyQuery>;
export type GetChannelAndFullDetailsQueryResult = Apollo.QueryResult<GetChannelAndFullDetailsQuery, GetChannelAndFullDetailsQueryVariables>;
export const GetOrCreateSbChannelDocument = gql`
    mutation GetOrCreateSBChannel($uuids: [String]!, $position: ID, $location: ID, $interview: ID, $application: ID) {
  getOrCreateSendbirdChannelWith(
    userUuids: $uuids
    position: $position
    location: $location
    interview: $interview
    application: $application
  ) {
    sendbirdChannel
    me {
      id
      uuid
      sendbirdAccessToken
      sendbirdUser {
        userId
        nickname
        profileUrl
      }
    }
  }
}
    `;
export type GetOrCreateSbChannelMutationFn = Apollo.MutationFunction<GetOrCreateSbChannelMutation, GetOrCreateSbChannelMutationVariables>;

/**
 * __useGetOrCreateSbChannelMutation__
 *
 * To run a mutation, you first call `useGetOrCreateSbChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGetOrCreateSbChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [getOrCreateSbChannelMutation, { data, loading, error }] = useGetOrCreateSbChannelMutation({
 *   variables: {
 *      uuids: // value for 'uuids'
 *      position: // value for 'position'
 *      location: // value for 'location'
 *      interview: // value for 'interview'
 *      application: // value for 'application'
 *   },
 * });
 */
export function useGetOrCreateSbChannelMutation(baseOptions?: Apollo.MutationHookOptions<GetOrCreateSbChannelMutation, GetOrCreateSbChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GetOrCreateSbChannelMutation, GetOrCreateSbChannelMutationVariables>(GetOrCreateSbChannelDocument, options);
      }
export type GetOrCreateSbChannelMutationHookResult = ReturnType<typeof useGetOrCreateSbChannelMutation>;
export type GetOrCreateSbChannelMutationResult = Apollo.MutationResult<GetOrCreateSbChannelMutation>;
export type GetOrCreateSbChannelMutationOptions = Apollo.BaseMutationOptions<GetOrCreateSbChannelMutation, GetOrCreateSbChannelMutationVariables>;
export const GetSbUsersDocument = gql`
    query GetSBUsers($uuid: UUID, $employerUuid: UUID) {
  sendbirdUsers(uuid: $uuid) {
    edges {
      node {
        id
        firstName
        lastName
        email
        positionMatches(employerUuid: $employerUuid) {
          edges {
            node {
              id
              position {
                id
                rowId
                positionName
                paymentStatus
                location {
                  id
                  name
                  rowId
                  paymentStatus
                }
              }
            }
          }
        }
        sendbirdUser {
          userId
          profileUrl
          nickname
        }
      }
    }
  }
}
    `;

/**
 * __useGetSbUsersQuery__
 *
 * To run a query within a React component, call `useGetSbUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSbUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSbUsersQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      employerUuid: // value for 'employerUuid'
 *   },
 * });
 */
export function useGetSbUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetSbUsersQuery, GetSbUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSbUsersQuery, GetSbUsersQueryVariables>(GetSbUsersDocument, options);
      }
export function useGetSbUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSbUsersQuery, GetSbUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSbUsersQuery, GetSbUsersQueryVariables>(GetSbUsersDocument, options);
        }
export type GetSbUsersQueryHookResult = ReturnType<typeof useGetSbUsersQuery>;
export type GetSbUsersLazyQueryHookResult = ReturnType<typeof useGetSbUsersLazyQuery>;
export type GetSbUsersQueryResult = Apollo.QueryResult<GetSbUsersQuery, GetSbUsersQueryVariables>;
export const HideOrUnhideChannelDocument = gql`
    mutation HideOrUnhideChannel($channelUrl: String!, $archive: Boolean!) {
  mutateEmployerUserChannelHideOrUnhide(
    channelUrl: $channelUrl
    archive: $archive
  ) {
    isSuccess
  }
}
    `;
export type HideOrUnhideChannelMutationFn = Apollo.MutationFunction<HideOrUnhideChannelMutation, HideOrUnhideChannelMutationVariables>;

/**
 * __useHideOrUnhideChannelMutation__
 *
 * To run a mutation, you first call `useHideOrUnhideChannelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHideOrUnhideChannelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hideOrUnhideChannelMutation, { data, loading, error }] = useHideOrUnhideChannelMutation({
 *   variables: {
 *      channelUrl: // value for 'channelUrl'
 *      archive: // value for 'archive'
 *   },
 * });
 */
export function useHideOrUnhideChannelMutation(baseOptions?: Apollo.MutationHookOptions<HideOrUnhideChannelMutation, HideOrUnhideChannelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<HideOrUnhideChannelMutation, HideOrUnhideChannelMutationVariables>(HideOrUnhideChannelDocument, options);
      }
export type HideOrUnhideChannelMutationHookResult = ReturnType<typeof useHideOrUnhideChannelMutation>;
export type HideOrUnhideChannelMutationResult = Apollo.MutationResult<HideOrUnhideChannelMutation>;
export type HideOrUnhideChannelMutationOptions = Apollo.BaseMutationOptions<HideOrUnhideChannelMutation, HideOrUnhideChannelMutationVariables>;
export const RefreshSbTokenDocument = gql`
    mutation RefreshSBToken {
  refreshSendbirdUser {
    me {
      id
      sendbirdAccessToken
    }
  }
}
    `;
export type RefreshSbTokenMutationFn = Apollo.MutationFunction<RefreshSbTokenMutation, RefreshSbTokenMutationVariables>;

/**
 * __useRefreshSbTokenMutation__
 *
 * To run a mutation, you first call `useRefreshSbTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshSbTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshSbTokenMutation, { data, loading, error }] = useRefreshSbTokenMutation({
 *   variables: {
 *   },
 * });
 */
export function useRefreshSbTokenMutation(baseOptions?: Apollo.MutationHookOptions<RefreshSbTokenMutation, RefreshSbTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshSbTokenMutation, RefreshSbTokenMutationVariables>(RefreshSbTokenDocument, options);
      }
export type RefreshSbTokenMutationHookResult = ReturnType<typeof useRefreshSbTokenMutation>;
export type RefreshSbTokenMutationResult = Apollo.MutationResult<RefreshSbTokenMutation>;
export type RefreshSbTokenMutationOptions = Apollo.BaseMutationOptions<RefreshSbTokenMutation, RefreshSbTokenMutationVariables>;
export const MutateMergeCandidatesDocument = gql`
    mutation MutateMergeCandidates($indeedEmail: String!) {
  mergeCandidatesMutation(indeedEmail: $indeedEmail) {
    me {
      id
      email
    }
    authorization
  }
}
    `;
export type MutateMergeCandidatesMutationFn = Apollo.MutationFunction<MutateMergeCandidatesMutation, MutateMergeCandidatesMutationVariables>;

/**
 * __useMutateMergeCandidatesMutation__
 *
 * To run a mutation, you first call `useMutateMergeCandidatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutateMergeCandidatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateMergeCandidatesMutation, { data, loading, error }] = useMutateMergeCandidatesMutation({
 *   variables: {
 *      indeedEmail: // value for 'indeedEmail'
 *   },
 * });
 */
export function useMutateMergeCandidatesMutation(baseOptions?: Apollo.MutationHookOptions<MutateMergeCandidatesMutation, MutateMergeCandidatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutateMergeCandidatesMutation, MutateMergeCandidatesMutationVariables>(MutateMergeCandidatesDocument, options);
      }
export type MutateMergeCandidatesMutationHookResult = ReturnType<typeof useMutateMergeCandidatesMutation>;
export type MutateMergeCandidatesMutationResult = Apollo.MutationResult<MutateMergeCandidatesMutation>;
export type MutateMergeCandidatesMutationOptions = Apollo.BaseMutationOptions<MutateMergeCandidatesMutation, MutateMergeCandidatesMutationVariables>;
export const ScreeningAnswerDocument = gql`
    mutation ScreeningAnswer($employerCandidateQuestionnaireId: ID!, $questionsAnswered: [QuestionAnswerInputType]!) {
  createScreeningAnswer(
    input: {employerCandidateQuestionnaireId: $employerCandidateQuestionnaireId, questionsAnswered: $questionsAnswered}
  ) {
    answersDetail {
      signedS3Url
      question {
        id
        questionText
        answer
      }
    }
  }
}
    `;
export type ScreeningAnswerMutationFn = Apollo.MutationFunction<ScreeningAnswerMutation, ScreeningAnswerMutationVariables>;

/**
 * __useScreeningAnswerMutation__
 *
 * To run a mutation, you first call `useScreeningAnswerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScreeningAnswerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [screeningAnswerMutation, { data, loading, error }] = useScreeningAnswerMutation({
 *   variables: {
 *      employerCandidateQuestionnaireId: // value for 'employerCandidateQuestionnaireId'
 *      questionsAnswered: // value for 'questionsAnswered'
 *   },
 * });
 */
export function useScreeningAnswerMutation(baseOptions?: Apollo.MutationHookOptions<ScreeningAnswerMutation, ScreeningAnswerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScreeningAnswerMutation, ScreeningAnswerMutationVariables>(ScreeningAnswerDocument, options);
      }
export type ScreeningAnswerMutationHookResult = ReturnType<typeof useScreeningAnswerMutation>;
export type ScreeningAnswerMutationResult = Apollo.MutationResult<ScreeningAnswerMutation>;
export type ScreeningAnswerMutationOptions = Apollo.BaseMutationOptions<ScreeningAnswerMutation, ScreeningAnswerMutationVariables>;
export const EmployerCandidateQuestionnaireDocument = gql`
    query EmployerCandidateQuestionnaire($uuid: UUID) {
  employerCandidateQuestionnaire(uuid: $uuid) {
    id
    employerCandidate {
      employerProfile {
        users {
          edges {
            node {
              id
              firstName
              lastName
              profileImage
            }
          }
        }
      }
      candidateProfile {
        id
        user {
          id
          firstName
          lastName
        }
      }
    }
    position {
      id
      positionName
      location {
        id
        name
        formattedAddress
      }
    }
    screeningQuestionnaire {
      id
      questionnaireType
      screeningQuestion {
        edges {
          node {
            id
            question
          }
        }
      }
    }
    screeningAnswer {
      edges {
        node {
          id
          questionText
          answer
          screeningQuestion {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useEmployerCandidateQuestionnaireQuery__
 *
 * To run a query within a React component, call `useEmployerCandidateQuestionnaireQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployerCandidateQuestionnaireQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployerCandidateQuestionnaireQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useEmployerCandidateQuestionnaireQuery(baseOptions?: Apollo.QueryHookOptions<EmployerCandidateQuestionnaireQuery, EmployerCandidateQuestionnaireQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployerCandidateQuestionnaireQuery, EmployerCandidateQuestionnaireQueryVariables>(EmployerCandidateQuestionnaireDocument, options);
      }
export function useEmployerCandidateQuestionnaireLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployerCandidateQuestionnaireQuery, EmployerCandidateQuestionnaireQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployerCandidateQuestionnaireQuery, EmployerCandidateQuestionnaireQueryVariables>(EmployerCandidateQuestionnaireDocument, options);
        }
export type EmployerCandidateQuestionnaireQueryHookResult = ReturnType<typeof useEmployerCandidateQuestionnaireQuery>;
export type EmployerCandidateQuestionnaireLazyQueryHookResult = ReturnType<typeof useEmployerCandidateQuestionnaireLazyQuery>;
export type EmployerCandidateQuestionnaireQueryResult = Apollo.QueryResult<EmployerCandidateQuestionnaireQuery, EmployerCandidateQuestionnaireQueryVariables>;
export const GetAllChatCandidateDocument = gql`
    query GetAllChatCandidate($position: ID, $first: Int, $after: String, $locationId: ID) {
  matches(
    position: $position
    first: $first
    after: $after
    sendbird: true
    newChats: false
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        createdAt
        updatedAt
        hiddenAt
        candidateStatus
        stage
        candidateProfile {
          id
          personalSummary
          yearsExperience
          handle
          positions
          status
          statusEmoji
          availabilityMonday
          availabilityTuesday
          availabilityWednesday
          availabilityThursday
          availabilityFriday
          availabilitySaturday
          availabilitySunday
          user {
            id
            uuid
            firstName
            lastName
            profileImage
            email
            phone
            lastMessage(locationId: $locationId) {
              message
              createdAt
            }
          }
        }
        hasAppliedToPosition
        isFavorited
        application {
          id
          createdAt
        }
        lastInterview {
          id
          status
          scheduledFor
          location {
            id
            name
            formattedAddress
          }
          position {
            id
            positionName
          }
        }
        lastEmployerInterview {
          id
          status
          scheduledFor
          location {
            id
            name
            formattedAddress
          }
          position {
            id
            positionName
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetAllChatCandidateQuery__
 *
 * To run a query within a React component, call `useGetAllChatCandidateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllChatCandidateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllChatCandidateQuery({
 *   variables: {
 *      position: // value for 'position'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetAllChatCandidateQuery(baseOptions?: Apollo.QueryHookOptions<GetAllChatCandidateQuery, GetAllChatCandidateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllChatCandidateQuery, GetAllChatCandidateQueryVariables>(GetAllChatCandidateDocument, options);
      }
export function useGetAllChatCandidateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllChatCandidateQuery, GetAllChatCandidateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllChatCandidateQuery, GetAllChatCandidateQueryVariables>(GetAllChatCandidateDocument, options);
        }
export type GetAllChatCandidateQueryHookResult = ReturnType<typeof useGetAllChatCandidateQuery>;
export type GetAllChatCandidateLazyQueryHookResult = ReturnType<typeof useGetAllChatCandidateLazyQuery>;
export type GetAllChatCandidateQueryResult = Apollo.QueryResult<GetAllChatCandidateQuery, GetAllChatCandidateQueryVariables>;
export const GetDashboardMatchesDocument = gql`
    query GetDashboardMatches($position: ID, $id: ID!, $first: Int, $after: String, $applied: Boolean, $new_applications: Boolean, $new_matches: Boolean, $interviewStatus: InterviewStatusFilter, $sortBy: String) {
  positionById(id: $id) {
    id
    rowId
    positionName
  }
  matches(
    position: $position
    first: $first
    after: $after
    applied: $applied
    newApplications: $new_applications
    newMatches: $new_matches
    interviewStatus: $interviewStatus
    sort: $sortBy
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        createdAt
        updatedAt
        hiddenAt
        candidateStatus
        candidateProfile {
          id
          personalSummary
          yearsExperience
          handle
          positions
          status
          statusEmoji
          personalSummary
          user {
            id
            uuid
            firstName
            lastName
            profileImage
            email
            phone
          }
        }
        hasAppliedToPosition
        isFavorited
        stage
        lastInterview {
          id
          status
          scheduledFor
          location {
            id
            formattedAddress
          }
          position {
            id
            positionName
          }
        }
        lastEmployerInterview {
          id
          status
          scheduledFor
          location {
            id
            formattedAddress
          }
          position {
            id
            positionName
          }
        }
        application {
          id
          createdAt
          position {
            id
            positionName
            positionType
            hiring
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetDashboardMatchesQuery__
 *
 * To run a query within a React component, call `useGetDashboardMatchesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDashboardMatchesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDashboardMatchesQuery({
 *   variables: {
 *      position: // value for 'position'
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      applied: // value for 'applied'
 *      new_applications: // value for 'new_applications'
 *      new_matches: // value for 'new_matches'
 *      interviewStatus: // value for 'interviewStatus'
 *      sortBy: // value for 'sortBy'
 *   },
 * });
 */
export function useGetDashboardMatchesQuery(baseOptions: Apollo.QueryHookOptions<GetDashboardMatchesQuery, GetDashboardMatchesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDashboardMatchesQuery, GetDashboardMatchesQueryVariables>(GetDashboardMatchesDocument, options);
      }
export function useGetDashboardMatchesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDashboardMatchesQuery, GetDashboardMatchesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDashboardMatchesQuery, GetDashboardMatchesQueryVariables>(GetDashboardMatchesDocument, options);
        }
export type GetDashboardMatchesQueryHookResult = ReturnType<typeof useGetDashboardMatchesQuery>;
export type GetDashboardMatchesLazyQueryHookResult = ReturnType<typeof useGetDashboardMatchesLazyQuery>;
export type GetDashboardMatchesQueryResult = Apollo.QueryResult<GetDashboardMatchesQuery, GetDashboardMatchesQueryVariables>;
export const GetLocationDashboardDocument = gql`
    query GetLocationDashboard($location: ID!) {
  locationById(id: $location) {
    id
    rowId
    name
    paymentStatus
    slug
    locationPhoneNumber
    image
    allPositionsCount
    hiringPositionCount
    employerProfile {
      id
      status
    }
    formattedAddress
    payment {
      id
      planName
      startedOn
      subscriptionWillEndOn
      subscriptionEndedOn
    }
  }
}
    `;

/**
 * __useGetLocationDashboardQuery__
 *
 * To run a query within a React component, call `useGetLocationDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationDashboardQuery({
 *   variables: {
 *      location: // value for 'location'
 *   },
 * });
 */
export function useGetLocationDashboardQuery(baseOptions: Apollo.QueryHookOptions<GetLocationDashboardQuery, GetLocationDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationDashboardQuery, GetLocationDashboardQueryVariables>(GetLocationDashboardDocument, options);
      }
export function useGetLocationDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationDashboardQuery, GetLocationDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationDashboardQuery, GetLocationDashboardQueryVariables>(GetLocationDashboardDocument, options);
        }
export type GetLocationDashboardQueryHookResult = ReturnType<typeof useGetLocationDashboardQuery>;
export type GetLocationDashboardLazyQueryHookResult = ReturnType<typeof useGetLocationDashboardLazyQuery>;
export type GetLocationDashboardQueryResult = Apollo.QueryResult<GetLocationDashboardQuery, GetLocationDashboardQueryVariables>;
export const GetNewChatCandidateDocument = gql`
    query GetNewChatCandidate($position: ID, $first: Int, $after: String, $locationId: ID) {
  matches(
    position: $position
    first: $first
    after: $after
    sendbird: true
    newChats: true
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        createdAt
        updatedAt
        hiddenAt
        candidateStatus
        stage
        candidateProfile {
          id
          personalSummary
          yearsExperience
          handle
          positions
          status
          statusEmoji
          availabilityMonday
          availabilityTuesday
          availabilityWednesday
          availabilityThursday
          availabilityFriday
          availabilitySaturday
          availabilitySunday
          user {
            id
            uuid
            firstName
            lastName
            profileImage
            email
            phone
            lastMessage(locationId: $locationId) {
              message
              createdAt
            }
          }
        }
        hasAppliedToPosition
        isFavorited
        application {
          id
          createdAt
        }
        lastInterview {
          id
          status
          scheduledFor
          location {
            id
            name
            formattedAddress
          }
          position {
            id
            positionName
          }
        }
        lastEmployerInterview {
          id
          status
          scheduledFor
          location {
            id
            name
            formattedAddress
          }
          position {
            id
            positionName
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetNewChatCandidateQuery__
 *
 * To run a query within a React component, call `useGetNewChatCandidateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNewChatCandidateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNewChatCandidateQuery({
 *   variables: {
 *      position: // value for 'position'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetNewChatCandidateQuery(baseOptions?: Apollo.QueryHookOptions<GetNewChatCandidateQuery, GetNewChatCandidateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetNewChatCandidateQuery, GetNewChatCandidateQueryVariables>(GetNewChatCandidateDocument, options);
      }
export function useGetNewChatCandidateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetNewChatCandidateQuery, GetNewChatCandidateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetNewChatCandidateQuery, GetNewChatCandidateQueryVariables>(GetNewChatCandidateDocument, options);
        }
export type GetNewChatCandidateQueryHookResult = ReturnType<typeof useGetNewChatCandidateQuery>;
export type GetNewChatCandidateLazyQueryHookResult = ReturnType<typeof useGetNewChatCandidateLazyQuery>;
export type GetNewChatCandidateQueryResult = Apollo.QueryResult<GetNewChatCandidateQuery, GetNewChatCandidateQueryVariables>;
export const GetMyDashboardPositionsDocument = gql`
    query GetMyDashboardPositions($location: ID, $first: Int, $after: String, $search: String, $hiring: Boolean) {
  myPositions(
    location: $location
    first: $first
    after: $after
    positionName_Icontains: $search
    hiring: $hiring
  ) {
    pageInfo {
      endCursor
      hasNextPage
    }
    edges {
      node {
        id
        rowId
        slug
        positionName
        hiring
        paymentStatus
        payment {
          stripeSubscription
        }
        hiringStatus
        location {
          id
          paymentStatus
        }
        positionType
        createdAt
        posted
        updatedAt
        sendNotifications
        dashboardCounts {
          chat {
            new
            total
          }
          applicants {
            new
            total
          }
          candidates {
            new
            total
          }
          interviews {
            pending {
              new
              total
            }
            accepted {
              new
              total
            }
            completed {
              new
              total
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMyDashboardPositionsQuery__
 *
 * To run a query within a React component, call `useGetMyDashboardPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyDashboardPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyDashboardPositionsQuery({
 *   variables: {
 *      location: // value for 'location'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      hiring: // value for 'hiring'
 *   },
 * });
 */
export function useGetMyDashboardPositionsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyDashboardPositionsQuery, GetMyDashboardPositionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyDashboardPositionsQuery, GetMyDashboardPositionsQueryVariables>(GetMyDashboardPositionsDocument, options);
      }
export function useGetMyDashboardPositionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyDashboardPositionsQuery, GetMyDashboardPositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyDashboardPositionsQuery, GetMyDashboardPositionsQueryVariables>(GetMyDashboardPositionsDocument, options);
        }
export type GetMyDashboardPositionsQueryHookResult = ReturnType<typeof useGetMyDashboardPositionsQuery>;
export type GetMyDashboardPositionsLazyQueryHookResult = ReturnType<typeof useGetMyDashboardPositionsLazyQuery>;
export type GetMyDashboardPositionsQueryResult = Apollo.QueryResult<GetMyDashboardPositionsQuery, GetMyDashboardPositionsQueryVariables>;
export const GetMyLocationsDashboardDocument = gql`
    query GetMyLocationsDashboard($first: Int, $after: String, $search: String) {
  me {
    id
    myLocations(first: $first, after: $after, search: $search) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          id
          name
          image
          formattedAddress
          slug
          website
          allPositionsCount
          hiringPositionCount
          locationPhoneNumber
          payment {
            id
            planName
            startedOn
            subscriptionWillEndOn
            subscriptionEndedOn
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMyLocationsDashboardQuery__
 *
 * To run a query within a React component, call `useGetMyLocationsDashboardQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyLocationsDashboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyLocationsDashboardQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetMyLocationsDashboardQuery(baseOptions?: Apollo.QueryHookOptions<GetMyLocationsDashboardQuery, GetMyLocationsDashboardQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyLocationsDashboardQuery, GetMyLocationsDashboardQueryVariables>(GetMyLocationsDashboardDocument, options);
      }
export function useGetMyLocationsDashboardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyLocationsDashboardQuery, GetMyLocationsDashboardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyLocationsDashboardQuery, GetMyLocationsDashboardQueryVariables>(GetMyLocationsDashboardDocument, options);
        }
export type GetMyLocationsDashboardQueryHookResult = ReturnType<typeof useGetMyLocationsDashboardQuery>;
export type GetMyLocationsDashboardLazyQueryHookResult = ReturnType<typeof useGetMyLocationsDashboardLazyQuery>;
export type GetMyLocationsDashboardQueryResult = Apollo.QueryResult<GetMyLocationsDashboardQuery, GetMyLocationsDashboardQueryVariables>;
export const RequestInterviewsDocument = gql`
    mutation requestInterviews($filter: RequestInterviewFilter, $position: ID!) {
  sendBatchInterviews(filter: $filter, positionId: $position) {
    matches {
      id
      stage
    }
    errors {
      messages
      field
    }
  }
}
    `;
export type RequestInterviewsMutationFn = Apollo.MutationFunction<RequestInterviewsMutation, RequestInterviewsMutationVariables>;

/**
 * __useRequestInterviewsMutation__
 *
 * To run a mutation, you first call `useRequestInterviewsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestInterviewsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestInterviewsMutation, { data, loading, error }] = useRequestInterviewsMutation({
 *   variables: {
 *      filter: // value for 'filter'
 *      position: // value for 'position'
 *   },
 * });
 */
export function useRequestInterviewsMutation(baseOptions?: Apollo.MutationHookOptions<RequestInterviewsMutation, RequestInterviewsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestInterviewsMutation, RequestInterviewsMutationVariables>(RequestInterviewsDocument, options);
      }
export type RequestInterviewsMutationHookResult = ReturnType<typeof useRequestInterviewsMutation>;
export type RequestInterviewsMutationResult = Apollo.MutationResult<RequestInterviewsMutation>;
export type RequestInterviewsMutationOptions = Apollo.BaseMutationOptions<RequestInterviewsMutation, RequestInterviewsMutationVariables>;
export const CreateInterviewScheduleDocument = gql`
    mutation CreateInterviewSchedule($location: String, $locationPhone: String, $locationUrl: String, $durationMinutes: Int, $maxWeeksOut: Int) {
  mutateInterviewSchedule(
    input: {location: $location, locationUrl: $locationUrl, locationPhone: $locationPhone, durationMinutes: $durationMinutes, maxWeeksOut: $maxWeeksOut}
  ) {
    interviewSchedule {
      id
      location
      locationUrl
      locationPhone
      durationMinutes
      maxWeeksOut
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateInterviewScheduleMutationFn = Apollo.MutationFunction<CreateInterviewScheduleMutation, CreateInterviewScheduleMutationVariables>;

/**
 * __useCreateInterviewScheduleMutation__
 *
 * To run a mutation, you first call `useCreateInterviewScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateInterviewScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createInterviewScheduleMutation, { data, loading, error }] = useCreateInterviewScheduleMutation({
 *   variables: {
 *      location: // value for 'location'
 *      locationPhone: // value for 'locationPhone'
 *      locationUrl: // value for 'locationUrl'
 *      durationMinutes: // value for 'durationMinutes'
 *      maxWeeksOut: // value for 'maxWeeksOut'
 *   },
 * });
 */
export function useCreateInterviewScheduleMutation(baseOptions?: Apollo.MutationHookOptions<CreateInterviewScheduleMutation, CreateInterviewScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateInterviewScheduleMutation, CreateInterviewScheduleMutationVariables>(CreateInterviewScheduleDocument, options);
      }
export type CreateInterviewScheduleMutationHookResult = ReturnType<typeof useCreateInterviewScheduleMutation>;
export type CreateInterviewScheduleMutationResult = Apollo.MutationResult<CreateInterviewScheduleMutation>;
export type CreateInterviewScheduleMutationOptions = Apollo.BaseMutationOptions<CreateInterviewScheduleMutation, CreateInterviewScheduleMutationVariables>;
export const MutateInterviewScheduleDocument = gql`
    mutation MutateInterviewSchedule($id: ID, $location: String, $locationPhone: String, $locationUrl: String, $durationMinutes: Int, $allowOverbooking: Boolean, $maxWeeksOut: Int) {
  mutateInterviewSchedule(
    input: {id: $id, location: $location, locationUrl: $locationUrl, locationPhone: $locationPhone, durationMinutes: $durationMinutes, allowOverbooking: $allowOverbooking, maxWeeksOut: $maxWeeksOut, partialUpdate: true}
  ) {
    interviewSchedule {
      id
      location
      locationUrl
      locationPhone
      durationMinutes
      allowOverbooking
      maxWeeksOut
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type MutateInterviewScheduleMutationFn = Apollo.MutationFunction<MutateInterviewScheduleMutation, MutateInterviewScheduleMutationVariables>;

/**
 * __useMutateInterviewScheduleMutation__
 *
 * To run a mutation, you first call `useMutateInterviewScheduleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutateInterviewScheduleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateInterviewScheduleMutation, { data, loading, error }] = useMutateInterviewScheduleMutation({
 *   variables: {
 *      id: // value for 'id'
 *      location: // value for 'location'
 *      locationPhone: // value for 'locationPhone'
 *      locationUrl: // value for 'locationUrl'
 *      durationMinutes: // value for 'durationMinutes'
 *      allowOverbooking: // value for 'allowOverbooking'
 *      maxWeeksOut: // value for 'maxWeeksOut'
 *   },
 * });
 */
export function useMutateInterviewScheduleMutation(baseOptions?: Apollo.MutationHookOptions<MutateInterviewScheduleMutation, MutateInterviewScheduleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutateInterviewScheduleMutation, MutateInterviewScheduleMutationVariables>(MutateInterviewScheduleDocument, options);
      }
export type MutateInterviewScheduleMutationHookResult = ReturnType<typeof useMutateInterviewScheduleMutation>;
export type MutateInterviewScheduleMutationResult = Apollo.MutationResult<MutateInterviewScheduleMutation>;
export type MutateInterviewScheduleMutationOptions = Apollo.BaseMutationOptions<MutateInterviewScheduleMutation, MutateInterviewScheduleMutationVariables>;
export const InterviewScheduleDocument = gql`
    query InterviewSchedule {
  me {
    id
    interviewschedule {
      id
      location
      locationUrl
      locationPhone
      durationMinutes
      allowOverbooking
      maxWeeksOut
      ranges {
        edges {
          node {
            id
            startHour
            startMinute
            endHour
            endMinute
            day
          }
        }
      }
      interviewScheduleRanges
    }
  }
}
    `;

/**
 * __useInterviewScheduleQuery__
 *
 * To run a query within a React component, call `useInterviewScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useInterviewScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInterviewScheduleQuery({
 *   variables: {
 *   },
 * });
 */
export function useInterviewScheduleQuery(baseOptions?: Apollo.QueryHookOptions<InterviewScheduleQuery, InterviewScheduleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<InterviewScheduleQuery, InterviewScheduleQueryVariables>(InterviewScheduleDocument, options);
      }
export function useInterviewScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<InterviewScheduleQuery, InterviewScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<InterviewScheduleQuery, InterviewScheduleQueryVariables>(InterviewScheduleDocument, options);
        }
export type InterviewScheduleQueryHookResult = ReturnType<typeof useInterviewScheduleQuery>;
export type InterviewScheduleLazyQueryHookResult = ReturnType<typeof useInterviewScheduleLazyQuery>;
export type InterviewScheduleQueryResult = Apollo.QueryResult<InterviewScheduleQuery, InterviewScheduleQueryVariables>;
export const ScheduleInterviewDocument = gql`
    mutation ScheduleInterview($id: ID, $scheduledFor: DateTime, $messageContent: String, $duration: String, $interviewType: String, $phoneNumber: String, $meetingUrl: String, $interviewAttendees: [InterviewAttendeeSerializerInput]!) {
  mutateInterview(
    input: {id: $id, status: "scheduled", scheduledFor: $scheduledFor, partialUpdate: true, duration: $duration, interviewType: $interviewType, phoneNumber: $phoneNumber, meetingUrl: $meetingUrl, messageContent: $messageContent, interviewAttendees: $interviewAttendees}
  ) {
    interview {
      id
      uuid
      status
      scheduledFor
      ics
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type ScheduleInterviewMutationFn = Apollo.MutationFunction<ScheduleInterviewMutation, ScheduleInterviewMutationVariables>;

/**
 * __useScheduleInterviewMutation__
 *
 * To run a mutation, you first call `useScheduleInterviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleInterviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleInterviewMutation, { data, loading, error }] = useScheduleInterviewMutation({
 *   variables: {
 *      id: // value for 'id'
 *      scheduledFor: // value for 'scheduledFor'
 *      messageContent: // value for 'messageContent'
 *      duration: // value for 'duration'
 *      interviewType: // value for 'interviewType'
 *      phoneNumber: // value for 'phoneNumber'
 *      meetingUrl: // value for 'meetingUrl'
 *      interviewAttendees: // value for 'interviewAttendees'
 *   },
 * });
 */
export function useScheduleInterviewMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleInterviewMutation, ScheduleInterviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleInterviewMutation, ScheduleInterviewMutationVariables>(ScheduleInterviewDocument, options);
      }
export type ScheduleInterviewMutationHookResult = ReturnType<typeof useScheduleInterviewMutation>;
export type ScheduleInterviewMutationResult = Apollo.MutationResult<ScheduleInterviewMutation>;
export type ScheduleInterviewMutationOptions = Apollo.BaseMutationOptions<ScheduleInterviewMutation, ScheduleInterviewMutationVariables>;
export const ScheduleSlotsDocument = gql`
    query ScheduleSlots($startDate: DateTime!, $endDate: DateTime!, $userId: ID!) {
  scheduleSlots(startDate: $startDate, endDate: $endDate, userId: $userId) {
    day
    slots {
      start
      available
    }
  }
}
    `;

/**
 * __useScheduleSlotsQuery__
 *
 * To run a query within a React component, call `useScheduleSlotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScheduleSlotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScheduleSlotsQuery({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useScheduleSlotsQuery(baseOptions: Apollo.QueryHookOptions<ScheduleSlotsQuery, ScheduleSlotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScheduleSlotsQuery, ScheduleSlotsQueryVariables>(ScheduleSlotsDocument, options);
      }
export function useScheduleSlotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScheduleSlotsQuery, ScheduleSlotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScheduleSlotsQuery, ScheduleSlotsQueryVariables>(ScheduleSlotsDocument, options);
        }
export type ScheduleSlotsQueryHookResult = ReturnType<typeof useScheduleSlotsQuery>;
export type ScheduleSlotsLazyQueryHookResult = ReturnType<typeof useScheduleSlotsLazyQuery>;
export type ScheduleSlotsQueryResult = Apollo.QueryResult<ScheduleSlotsQuery, ScheduleSlotsQueryVariables>;
export const EmployerScheduleInterviewDocument = gql`
    mutation EmployerScheduleInterview($candidate: ID, $employerProfile: ID, $position: ID, $createdBy: ID, $scheduledFor: DateTime, $interviewType: String, $phoneNumber: String, $meetingUrl: String, $messageContent: String, $duration: String, $interviewAttendees: [InterviewAttendeeSerializerInput]!) {
  mutateInterview(
    input: {candidate: $candidate, employerProfile: $employerProfile, createdBy: $createdBy, position: $position, status: "scheduled", scheduledFor: $scheduledFor, interviewType: $interviewType, phoneNumber: $phoneNumber, meetingUrl: $meetingUrl, messageContent: $messageContent, interviewAttendees: $interviewAttendees, duration: $duration}
  ) {
    errors {
      field
      messages
    }
    interview {
      id
      match {
        id
        stage
        lastInterview {
          id
          status
          scheduledFor
          location {
            id
            formattedAddress
          }
          position {
            id
            positionName
          }
        }
        lastEmployerInterview {
          id
          status
          scheduledFor
          location {
            id
            formattedAddress
          }
          position {
            id
            positionName
          }
        }
      }
      candidate {
        id
        candidateProfile {
          id
          rowId
          handle
        }
      }
    }
  }
}
    `;
export type EmployerScheduleInterviewMutationFn = Apollo.MutationFunction<EmployerScheduleInterviewMutation, EmployerScheduleInterviewMutationVariables>;

/**
 * __useEmployerScheduleInterviewMutation__
 *
 * To run a mutation, you first call `useEmployerScheduleInterviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmployerScheduleInterviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [employerScheduleInterviewMutation, { data, loading, error }] = useEmployerScheduleInterviewMutation({
 *   variables: {
 *      candidate: // value for 'candidate'
 *      employerProfile: // value for 'employerProfile'
 *      position: // value for 'position'
 *      createdBy: // value for 'createdBy'
 *      scheduledFor: // value for 'scheduledFor'
 *      interviewType: // value for 'interviewType'
 *      phoneNumber: // value for 'phoneNumber'
 *      meetingUrl: // value for 'meetingUrl'
 *      messageContent: // value for 'messageContent'
 *      duration: // value for 'duration'
 *      interviewAttendees: // value for 'interviewAttendees'
 *   },
 * });
 */
export function useEmployerScheduleInterviewMutation(baseOptions?: Apollo.MutationHookOptions<EmployerScheduleInterviewMutation, EmployerScheduleInterviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmployerScheduleInterviewMutation, EmployerScheduleInterviewMutationVariables>(EmployerScheduleInterviewDocument, options);
      }
export type EmployerScheduleInterviewMutationHookResult = ReturnType<typeof useEmployerScheduleInterviewMutation>;
export type EmployerScheduleInterviewMutationResult = Apollo.MutationResult<EmployerScheduleInterviewMutation>;
export type EmployerScheduleInterviewMutationOptions = Apollo.BaseMutationOptions<EmployerScheduleInterviewMutation, EmployerScheduleInterviewMutationVariables>;
export const UserInterviewScheduleDocument = gql`
    query UserInterviewSchedule($userId: ID) {
  userInterviewSchedule(userId: $userId) {
    id
    location
    locationUrl
    locationPhone
    durationMinutes
    allowOverbooking
    maxWeeksOut
    ranges {
      edges {
        node {
          id
          startHour
          startMinute
          endHour
          endMinute
          day
        }
      }
    }
    interviewScheduleRanges
  }
}
    `;

/**
 * __useUserInterviewScheduleQuery__
 *
 * To run a query within a React component, call `useUserInterviewScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserInterviewScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserInterviewScheduleQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserInterviewScheduleQuery(baseOptions?: Apollo.QueryHookOptions<UserInterviewScheduleQuery, UserInterviewScheduleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserInterviewScheduleQuery, UserInterviewScheduleQueryVariables>(UserInterviewScheduleDocument, options);
      }
export function useUserInterviewScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserInterviewScheduleQuery, UserInterviewScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserInterviewScheduleQuery, UserInterviewScheduleQueryVariables>(UserInterviewScheduleDocument, options);
        }
export type UserInterviewScheduleQueryHookResult = ReturnType<typeof useUserInterviewScheduleQuery>;
export type UserInterviewScheduleLazyQueryHookResult = ReturnType<typeof useUserInterviewScheduleLazyQuery>;
export type UserInterviewScheduleQueryResult = Apollo.QueryResult<UserInterviewScheduleQuery, UserInterviewScheduleQueryVariables>;
export const MutateBulkMessageDocument = gql`
    mutation MutateBulkMessage($location: ID!, $position: ID!, $message: String!, $all: Boolean, $employerCandidates: [ID], $locationFilters: [ID], $positionFilters: [ID], $stage: ID, $notificationType: String, $notificationStatuses: [String]) {
  mutateBulkMessage(
    location: $location
    position: $position
    message: $message
    all: $all
    employerCandidates: $employerCandidates
    locationFilters: $locationFilters
    positionFilters: $positionFilters
    stage: $stage
    notificationType: $notificationType
    notificationStatuses: $notificationStatuses
  ) {
    ok
  }
}
    `;
export type MutateBulkMessageMutationFn = Apollo.MutationFunction<MutateBulkMessageMutation, MutateBulkMessageMutationVariables>;

/**
 * __useMutateBulkMessageMutation__
 *
 * To run a mutation, you first call `useMutateBulkMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutateBulkMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateBulkMessageMutation, { data, loading, error }] = useMutateBulkMessageMutation({
 *   variables: {
 *      location: // value for 'location'
 *      position: // value for 'position'
 *      message: // value for 'message'
 *      all: // value for 'all'
 *      employerCandidates: // value for 'employerCandidates'
 *      locationFilters: // value for 'locationFilters'
 *      positionFilters: // value for 'positionFilters'
 *      stage: // value for 'stage'
 *      notificationType: // value for 'notificationType'
 *      notificationStatuses: // value for 'notificationStatuses'
 *   },
 * });
 */
export function useMutateBulkMessageMutation(baseOptions?: Apollo.MutationHookOptions<MutateBulkMessageMutation, MutateBulkMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutateBulkMessageMutation, MutateBulkMessageMutationVariables>(MutateBulkMessageDocument, options);
      }
export type MutateBulkMessageMutationHookResult = ReturnType<typeof useMutateBulkMessageMutation>;
export type MutateBulkMessageMutationResult = Apollo.MutationResult<MutateBulkMessageMutation>;
export type MutateBulkMessageMutationOptions = Apollo.BaseMutationOptions<MutateBulkMessageMutation, MutateBulkMessageMutationVariables>;
export const CreateMessageTemplateDocument = gql`
    mutation CreateMessageTemplate($name: String, $templateType: String, $messageContent: String, $category: String, $defaultCompensation: Float, $defaultCompensationUnits: String, $ScreeningQuestionSerializerInput: [ScreeningQuestionSerializerInput], $action: String) {
  mutateEmployerMessageTemplate(
    input: {name: $name, templateType: $templateType, messageContent: $messageContent, category: $category, defaultCompensation: $defaultCompensation, defaultCompensationUnits: $defaultCompensationUnits, screeningQuestionList: $ScreeningQuestionSerializerInput, action: $action}
  ) {
    employerMessageTemplate {
      id
      name
      createdBy {
        firstName
        lastName
      }
      templateType
      messageContent
      archivedAt
      category
      defaultCompensation
      defaultCompensationUnits
      fileUploadUrl
      action
      screeningQuestionnaire {
        edges {
          node {
            id
            screeningQuestion {
              edges {
                node {
                  id
                  question
                }
              }
            }
          }
        }
      }
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type CreateMessageTemplateMutationFn = Apollo.MutationFunction<CreateMessageTemplateMutation, CreateMessageTemplateMutationVariables>;

/**
 * __useCreateMessageTemplateMutation__
 *
 * To run a mutation, you first call `useCreateMessageTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMessageTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMessageTemplateMutation, { data, loading, error }] = useCreateMessageTemplateMutation({
 *   variables: {
 *      name: // value for 'name'
 *      templateType: // value for 'templateType'
 *      messageContent: // value for 'messageContent'
 *      category: // value for 'category'
 *      defaultCompensation: // value for 'defaultCompensation'
 *      defaultCompensationUnits: // value for 'defaultCompensationUnits'
 *      ScreeningQuestionSerializerInput: // value for 'ScreeningQuestionSerializerInput'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useCreateMessageTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateMessageTemplateMutation, CreateMessageTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMessageTemplateMutation, CreateMessageTemplateMutationVariables>(CreateMessageTemplateDocument, options);
      }
export type CreateMessageTemplateMutationHookResult = ReturnType<typeof useCreateMessageTemplateMutation>;
export type CreateMessageTemplateMutationResult = Apollo.MutationResult<CreateMessageTemplateMutation>;
export type CreateMessageTemplateMutationOptions = Apollo.BaseMutationOptions<CreateMessageTemplateMutation, CreateMessageTemplateMutationVariables>;
export const DeleteMessageTemplateFileDocument = gql`
    mutation DeleteMessageTemplateFile($messageTemplateFileId: ID!) {
  deleteEmployerMessageTemplateFile(messageTemplateFileId: $messageTemplateFileId) {
    deleted
  }
}
    `;
export type DeleteMessageTemplateFileMutationFn = Apollo.MutationFunction<DeleteMessageTemplateFileMutation, DeleteMessageTemplateFileMutationVariables>;

/**
 * __useDeleteMessageTemplateFileMutation__
 *
 * To run a mutation, you first call `useDeleteMessageTemplateFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMessageTemplateFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMessageTemplateFileMutation, { data, loading, error }] = useDeleteMessageTemplateFileMutation({
 *   variables: {
 *      messageTemplateFileId: // value for 'messageTemplateFileId'
 *   },
 * });
 */
export function useDeleteMessageTemplateFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMessageTemplateFileMutation, DeleteMessageTemplateFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMessageTemplateFileMutation, DeleteMessageTemplateFileMutationVariables>(DeleteMessageTemplateFileDocument, options);
      }
export type DeleteMessageTemplateFileMutationHookResult = ReturnType<typeof useDeleteMessageTemplateFileMutation>;
export type DeleteMessageTemplateFileMutationResult = Apollo.MutationResult<DeleteMessageTemplateFileMutation>;
export type DeleteMessageTemplateFileMutationOptions = Apollo.BaseMutationOptions<DeleteMessageTemplateFileMutation, DeleteMessageTemplateFileMutationVariables>;
export const DeleteEmployerMessageTemplateDocument = gql`
    mutation DeleteEmployerMessageTemplate($templateId: ID!) {
  mutateDeleteMessageTemplate(templateId: $templateId) {
    deleted
  }
}
    `;
export type DeleteEmployerMessageTemplateMutationFn = Apollo.MutationFunction<DeleteEmployerMessageTemplateMutation, DeleteEmployerMessageTemplateMutationVariables>;

/**
 * __useDeleteEmployerMessageTemplateMutation__
 *
 * To run a mutation, you first call `useDeleteEmployerMessageTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmployerMessageTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmployerMessageTemplateMutation, { data, loading, error }] = useDeleteEmployerMessageTemplateMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *   },
 * });
 */
export function useDeleteEmployerMessageTemplateMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmployerMessageTemplateMutation, DeleteEmployerMessageTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmployerMessageTemplateMutation, DeleteEmployerMessageTemplateMutationVariables>(DeleteEmployerMessageTemplateDocument, options);
      }
export type DeleteEmployerMessageTemplateMutationHookResult = ReturnType<typeof useDeleteEmployerMessageTemplateMutation>;
export type DeleteEmployerMessageTemplateMutationResult = Apollo.MutationResult<DeleteEmployerMessageTemplateMutation>;
export type DeleteEmployerMessageTemplateMutationOptions = Apollo.BaseMutationOptions<DeleteEmployerMessageTemplateMutation, DeleteEmployerMessageTemplateMutationVariables>;
export const EmployerMessageTemplateTypeDocument = gql`
    query EmployerMessageTemplateType {
  employerMessageTemplateCounts {
    screening
    applicants
    interview
    hired
    offer
    other
  }
}
    `;

/**
 * __useEmployerMessageTemplateTypeQuery__
 *
 * To run a query within a React component, call `useEmployerMessageTemplateTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployerMessageTemplateTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployerMessageTemplateTypeQuery({
 *   variables: {
 *   },
 * });
 */
export function useEmployerMessageTemplateTypeQuery(baseOptions?: Apollo.QueryHookOptions<EmployerMessageTemplateTypeQuery, EmployerMessageTemplateTypeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployerMessageTemplateTypeQuery, EmployerMessageTemplateTypeQueryVariables>(EmployerMessageTemplateTypeDocument, options);
      }
export function useEmployerMessageTemplateTypeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployerMessageTemplateTypeQuery, EmployerMessageTemplateTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployerMessageTemplateTypeQuery, EmployerMessageTemplateTypeQueryVariables>(EmployerMessageTemplateTypeDocument, options);
        }
export type EmployerMessageTemplateTypeQueryHookResult = ReturnType<typeof useEmployerMessageTemplateTypeQuery>;
export type EmployerMessageTemplateTypeLazyQueryHookResult = ReturnType<typeof useEmployerMessageTemplateTypeLazyQuery>;
export type EmployerMessageTemplateTypeQueryResult = Apollo.QueryResult<EmployerMessageTemplateTypeQuery, EmployerMessageTemplateTypeQueryVariables>;
export const GetFilteredEmployerMessageTemplatesDocument = gql`
    query GetFilteredEmployerMessageTemplates($search: String, $category: EmployersEmployerMessageTemplateCategoryChoices, $isSimpleOnly: Boolean, $action: String) {
  employerMessageTemplates(
    name_Icontains: $search
    category_Icontains: $category
    action_Iexact: $action
    isSimpleOnly: $isSimpleOnly
  ) {
    edges {
      node {
        id
        name
        templateType
        messageContent
        archivedAt
        action
        isDefault
        category
        templateType
        fileUploadUrl
        defaultCompensation
        defaultCompensationUnits
        screeningQuestionnaire {
          edges {
            node {
              id
              createdAt
              screeningQuestion {
                edges {
                  node {
                    id
                    question
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetFilteredEmployerMessageTemplatesQuery__
 *
 * To run a query within a React component, call `useGetFilteredEmployerMessageTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFilteredEmployerMessageTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFilteredEmployerMessageTemplatesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      category: // value for 'category'
 *      isSimpleOnly: // value for 'isSimpleOnly'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useGetFilteredEmployerMessageTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetFilteredEmployerMessageTemplatesQuery, GetFilteredEmployerMessageTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFilteredEmployerMessageTemplatesQuery, GetFilteredEmployerMessageTemplatesQueryVariables>(GetFilteredEmployerMessageTemplatesDocument, options);
      }
export function useGetFilteredEmployerMessageTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFilteredEmployerMessageTemplatesQuery, GetFilteredEmployerMessageTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFilteredEmployerMessageTemplatesQuery, GetFilteredEmployerMessageTemplatesQueryVariables>(GetFilteredEmployerMessageTemplatesDocument, options);
        }
export type GetFilteredEmployerMessageTemplatesQueryHookResult = ReturnType<typeof useGetFilteredEmployerMessageTemplatesQuery>;
export type GetFilteredEmployerMessageTemplatesLazyQueryHookResult = ReturnType<typeof useGetFilteredEmployerMessageTemplatesLazyQuery>;
export type GetFilteredEmployerMessageTemplatesQueryResult = Apollo.QueryResult<GetFilteredEmployerMessageTemplatesQuery, GetFilteredEmployerMessageTemplatesQueryVariables>;
export const EmployerMessageTemplatesDocument = gql`
    query EmployerMessageTemplates($search: String, $category: EmployersEmployerMessageTemplateCategoryChoices, $action: String) {
  employerMessageTemplates(
    name_Icontains: $search
    category_Icontains: $category
    action_Iexact: $action
  ) {
    edges {
      node {
        id
        name
        createdBy {
          firstName
          lastName
        }
        templateType
        messageContent
        archivedAt
        action
        employerMessageTemplateFile {
          edges {
            node {
              id
              name
              url
              attachment
              fileName
              fileType
              employerMessageTemplate {
                id
              }
            }
          }
        }
        isDefault
        category
        templateType
        fileUploadUrl
        defaultCompensation
        defaultCompensationUnits
        screeningQuestionnaire {
          edges {
            node {
              id
              createdAt
              screeningQuestion {
                edges {
                  node {
                    id
                    question
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useEmployerMessageTemplatesQuery__
 *
 * To run a query within a React component, call `useEmployerMessageTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployerMessageTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployerMessageTemplatesQuery({
 *   variables: {
 *      search: // value for 'search'
 *      category: // value for 'category'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useEmployerMessageTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<EmployerMessageTemplatesQuery, EmployerMessageTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployerMessageTemplatesQuery, EmployerMessageTemplatesQueryVariables>(EmployerMessageTemplatesDocument, options);
      }
export function useEmployerMessageTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployerMessageTemplatesQuery, EmployerMessageTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployerMessageTemplatesQuery, EmployerMessageTemplatesQueryVariables>(EmployerMessageTemplatesDocument, options);
        }
export type EmployerMessageTemplatesQueryHookResult = ReturnType<typeof useEmployerMessageTemplatesQuery>;
export type EmployerMessageTemplatesLazyQueryHookResult = ReturnType<typeof useEmployerMessageTemplatesLazyQuery>;
export type EmployerMessageTemplatesQueryResult = Apollo.QueryResult<EmployerMessageTemplatesQuery, EmployerMessageTemplatesQueryVariables>;
export const UpdateMessageTemplateDocument = gql`
    mutation UpdateMessageTemplate($id: ID, $name: String, $templateType: String, $messageContent: String, $archivedAt: DateTime, $category: String, $defaultCompensation: Float, $defaultCompensationUnits: String, $ScreeningQuestionSerializerInput: [ScreeningQuestionSerializerInput], $action: String) {
  mutateEmployerMessageTemplate(
    input: {id: $id, name: $name, templateType: $templateType, messageContent: $messageContent, archivedAt: $archivedAt, partialUpdate: true, category: $category, defaultCompensation: $defaultCompensation, defaultCompensationUnits: $defaultCompensationUnits, screeningQuestionList: $ScreeningQuestionSerializerInput, action: $action}
  ) {
    employerMessageTemplate {
      id
      employerProfile {
        id
      }
      createdBy {
        firstName
        lastName
      }
      name
      templateType
      messageContent
      archivedAt
      category
      defaultCompensation
      defaultCompensationUnits
      fileUploadUrl
      action
      isDefault
      employerMessageTemplateFile {
        edges {
          node {
            id
            name
            url
            attachment
            fileName
            fileType
            employerMessageTemplate {
              id
            }
          }
        }
      }
      screeningQuestionnaire {
        edges {
          node {
            id
            screeningQuestion {
              edges {
                node {
                  id
                  question
                }
              }
            }
          }
        }
      }
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateMessageTemplateMutationFn = Apollo.MutationFunction<UpdateMessageTemplateMutation, UpdateMessageTemplateMutationVariables>;

/**
 * __useUpdateMessageTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateMessageTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMessageTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMessageTemplateMutation, { data, loading, error }] = useUpdateMessageTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      templateType: // value for 'templateType'
 *      messageContent: // value for 'messageContent'
 *      archivedAt: // value for 'archivedAt'
 *      category: // value for 'category'
 *      defaultCompensation: // value for 'defaultCompensation'
 *      defaultCompensationUnits: // value for 'defaultCompensationUnits'
 *      ScreeningQuestionSerializerInput: // value for 'ScreeningQuestionSerializerInput'
 *      action: // value for 'action'
 *   },
 * });
 */
export function useUpdateMessageTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMessageTemplateMutation, UpdateMessageTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMessageTemplateMutation, UpdateMessageTemplateMutationVariables>(UpdateMessageTemplateDocument, options);
      }
export type UpdateMessageTemplateMutationHookResult = ReturnType<typeof useUpdateMessageTemplateMutation>;
export type UpdateMessageTemplateMutationResult = Apollo.MutationResult<UpdateMessageTemplateMutation>;
export type UpdateMessageTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateMessageTemplateMutation, UpdateMessageTemplateMutationVariables>;
export const MutateMessageTemplateFileDocument = gql`
    mutation MutateMessageTemplateFile($employerMessageTemplateId: ID!, $templateFiles: [MessageTemplateFileInput!]) {
  mutateEmployerMessageTemplateFile(
    employerMessageTemplateId: $employerMessageTemplateId
    templateFiles: $templateFiles
  ) {
    messageTemplate {
      id
    }
    urls {
      presignedUrl
      link
    }
  }
}
    `;
export type MutateMessageTemplateFileMutationFn = Apollo.MutationFunction<MutateMessageTemplateFileMutation, MutateMessageTemplateFileMutationVariables>;

/**
 * __useMutateMessageTemplateFileMutation__
 *
 * To run a mutation, you first call `useMutateMessageTemplateFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutateMessageTemplateFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateMessageTemplateFileMutation, { data, loading, error }] = useMutateMessageTemplateFileMutation({
 *   variables: {
 *      employerMessageTemplateId: // value for 'employerMessageTemplateId'
 *      templateFiles: // value for 'templateFiles'
 *   },
 * });
 */
export function useMutateMessageTemplateFileMutation(baseOptions?: Apollo.MutationHookOptions<MutateMessageTemplateFileMutation, MutateMessageTemplateFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutateMessageTemplateFileMutation, MutateMessageTemplateFileMutationVariables>(MutateMessageTemplateFileDocument, options);
      }
export type MutateMessageTemplateFileMutationHookResult = ReturnType<typeof useMutateMessageTemplateFileMutation>;
export type MutateMessageTemplateFileMutationResult = Apollo.MutationResult<MutateMessageTemplateFileMutation>;
export type MutateMessageTemplateFileMutationOptions = Apollo.BaseMutationOptions<MutateMessageTemplateFileMutation, MutateMessageTemplateFileMutationVariables>;
export const MutateAnswerQuestionsDocument = gql`
    mutation MutateAnswerQuestions($location: ID, $employerProfile: ID, $responses: [AnswerInput]) {
  answerLocationQuestions(
    input: {location: $location, employerProfile: $employerProfile, responses: $responses}
  ) {
    location {
      id
      answers {
        edges {
          node {
            id
            displayIcon
            displayLabel
            response
            question {
              id
              title
            }
            option {
              id
              value
            }
          }
        }
      }
    }
  }
}
    `;
export type MutateAnswerQuestionsMutationFn = Apollo.MutationFunction<MutateAnswerQuestionsMutation, MutateAnswerQuestionsMutationVariables>;

/**
 * __useMutateAnswerQuestionsMutation__
 *
 * To run a mutation, you first call `useMutateAnswerQuestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutateAnswerQuestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateAnswerQuestionsMutation, { data, loading, error }] = useMutateAnswerQuestionsMutation({
 *   variables: {
 *      location: // value for 'location'
 *      employerProfile: // value for 'employerProfile'
 *      responses: // value for 'responses'
 *   },
 * });
 */
export function useMutateAnswerQuestionsMutation(baseOptions?: Apollo.MutationHookOptions<MutateAnswerQuestionsMutation, MutateAnswerQuestionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutateAnswerQuestionsMutation, MutateAnswerQuestionsMutationVariables>(MutateAnswerQuestionsDocument, options);
      }
export type MutateAnswerQuestionsMutationHookResult = ReturnType<typeof useMutateAnswerQuestionsMutation>;
export type MutateAnswerQuestionsMutationResult = Apollo.MutationResult<MutateAnswerQuestionsMutation>;
export type MutateAnswerQuestionsMutationOptions = Apollo.BaseMutationOptions<MutateAnswerQuestionsMutation, MutateAnswerQuestionsMutationVariables>;
export const GetQuestionsDocument = gql`
    query GetQuestions($category: OnboardingQuestionCategoryChoices) {
  questions(category: $category) {
    edges {
      node {
        id
        title
        questionType
        required
        placeholder
        options {
          id
          label
          value
        }
      }
    }
  }
}
    `;

/**
 * __useGetQuestionsQuery__
 *
 * To run a query within a React component, call `useGetQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuestionsQuery({
 *   variables: {
 *      category: // value for 'category'
 *   },
 * });
 */
export function useGetQuestionsQuery(baseOptions?: Apollo.QueryHookOptions<GetQuestionsQuery, GetQuestionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetQuestionsQuery, GetQuestionsQueryVariables>(GetQuestionsDocument, options);
      }
export function useGetQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetQuestionsQuery, GetQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetQuestionsQuery, GetQuestionsQueryVariables>(GetQuestionsDocument, options);
        }
export type GetQuestionsQueryHookResult = ReturnType<typeof useGetQuestionsQuery>;
export type GetQuestionsLazyQueryHookResult = ReturnType<typeof useGetQuestionsLazyQuery>;
export type GetQuestionsQueryResult = Apollo.QueryResult<GetQuestionsQuery, GetQuestionsQueryVariables>;
export const DeletePositionDocument = gql`
    mutation DeletePosition($id: String) {
  deletePosition(input: {clientMutationId: $id}) {
    id
    message
  }
}
    `;
export type DeletePositionMutationFn = Apollo.MutationFunction<DeletePositionMutation, DeletePositionMutationVariables>;

/**
 * __useDeletePositionMutation__
 *
 * To run a mutation, you first call `useDeletePositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePositionMutation, { data, loading, error }] = useDeletePositionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeletePositionMutation(baseOptions?: Apollo.MutationHookOptions<DeletePositionMutation, DeletePositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeletePositionMutation, DeletePositionMutationVariables>(DeletePositionDocument, options);
      }
export type DeletePositionMutationHookResult = ReturnType<typeof useDeletePositionMutation>;
export type DeletePositionMutationResult = Apollo.MutationResult<DeletePositionMutation>;
export type DeletePositionMutationOptions = Apollo.BaseMutationOptions<DeletePositionMutation, DeletePositionMutationVariables>;
export const PositionCampaignsByIdDocument = gql`
    query PositionCampaignsById($position: ID!) {
  campaignsByPosition(position: $position) {
    id
    startedOn
    amount
    campaignWillEndOn
    active
  }
}
    `;

/**
 * __usePositionCampaignsByIdQuery__
 *
 * To run a query within a React component, call `usePositionCampaignsByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePositionCampaignsByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePositionCampaignsByIdQuery({
 *   variables: {
 *      position: // value for 'position'
 *   },
 * });
 */
export function usePositionCampaignsByIdQuery(baseOptions: Apollo.QueryHookOptions<PositionCampaignsByIdQuery, PositionCampaignsByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PositionCampaignsByIdQuery, PositionCampaignsByIdQueryVariables>(PositionCampaignsByIdDocument, options);
      }
export function usePositionCampaignsByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PositionCampaignsByIdQuery, PositionCampaignsByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PositionCampaignsByIdQuery, PositionCampaignsByIdQueryVariables>(PositionCampaignsByIdDocument, options);
        }
export type PositionCampaignsByIdQueryHookResult = ReturnType<typeof usePositionCampaignsByIdQuery>;
export type PositionCampaignsByIdLazyQueryHookResult = ReturnType<typeof usePositionCampaignsByIdLazyQuery>;
export type PositionCampaignsByIdQueryResult = Apollo.QueryResult<PositionCampaignsByIdQuery, PositionCampaignsByIdQueryVariables>;
export const JobDescriptionDocument = gql`
    query JobDescription($positionType: String) {
  jobDescriptionForPositionType(positionType: $positionType)
}
    `;

/**
 * __useJobDescriptionQuery__
 *
 * To run a query within a React component, call `useJobDescriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useJobDescriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useJobDescriptionQuery({
 *   variables: {
 *      positionType: // value for 'positionType'
 *   },
 * });
 */
export function useJobDescriptionQuery(baseOptions?: Apollo.QueryHookOptions<JobDescriptionQuery, JobDescriptionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<JobDescriptionQuery, JobDescriptionQueryVariables>(JobDescriptionDocument, options);
      }
export function useJobDescriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<JobDescriptionQuery, JobDescriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<JobDescriptionQuery, JobDescriptionQueryVariables>(JobDescriptionDocument, options);
        }
export type JobDescriptionQueryHookResult = ReturnType<typeof useJobDescriptionQuery>;
export type JobDescriptionLazyQueryHookResult = ReturnType<typeof useJobDescriptionLazyQuery>;
export type JobDescriptionQueryResult = Apollo.QueryResult<JobDescriptionQuery, JobDescriptionQueryVariables>;
export const MyPositionsDocument = gql`
    query MyPositions($location: ID, $locations: [ID], $search: String) {
  myPositions(
    location: $location
    locations: $locations
    positionName_Icontains: $search
  ) {
    edges {
      node {
        id
        rowId
        slug
        positionName
        hiring
        paymentStatus
        positionType
        createdAt
        indexable
        payment {
          planName
        }
        location {
          id
          name
          displayName
          slug
          formattedAddress
          paymentStatus
          payment {
            planName
          }
        }
      }
    }
  }
}
    `;

/**
 * __useMyPositionsQuery__
 *
 * To run a query within a React component, call `useMyPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMyPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMyPositionsQuery({
 *   variables: {
 *      location: // value for 'location'
 *      locations: // value for 'locations'
 *      search: // value for 'search'
 *   },
 * });
 */
export function useMyPositionsQuery(baseOptions?: Apollo.QueryHookOptions<MyPositionsQuery, MyPositionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MyPositionsQuery, MyPositionsQueryVariables>(MyPositionsDocument, options);
      }
export function useMyPositionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MyPositionsQuery, MyPositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MyPositionsQuery, MyPositionsQueryVariables>(MyPositionsDocument, options);
        }
export type MyPositionsQueryHookResult = ReturnType<typeof useMyPositionsQuery>;
export type MyPositionsLazyQueryHookResult = ReturnType<typeof useMyPositionsLazyQuery>;
export type MyPositionsQueryResult = Apollo.QueryResult<MyPositionsQuery, MyPositionsQueryVariables>;
export const PositionByIdDocument = gql`
    query PositionById($id: ID!) {
  positionById(id: $id) {
    id
    rowId
    slug
    positionName
    preferredTraining
    positionType
    jobDescription
    responsibilities
    requirements
    preferredExperience
    hiring
    paymentStatus
    sendNotifications
    isBenefitsRequired
    canHaveDressCode
    baseSalaryMin
    baseSalaryMax
    baseSalaryUnitText
    createdAt
    availabilityMonday
    availabilityTuesday
    availabilityWednesday
    availabilityThursday
    availabilityFriday
    availabilitySaturday
    availabilitySunday
    lastMatchCreation
    jobDescription
    indeedEasyapplyOptout
    location {
      id
      name
      displayName
      slug
      formattedAddress
      image
    }
  }
}
    `;

/**
 * __usePositionByIdQuery__
 *
 * To run a query within a React component, call `usePositionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePositionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePositionByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePositionByIdQuery(baseOptions: Apollo.QueryHookOptions<PositionByIdQuery, PositionByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PositionByIdQuery, PositionByIdQueryVariables>(PositionByIdDocument, options);
      }
export function usePositionByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PositionByIdQuery, PositionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PositionByIdQuery, PositionByIdQueryVariables>(PositionByIdDocument, options);
        }
export type PositionByIdQueryHookResult = ReturnType<typeof usePositionByIdQuery>;
export type PositionByIdLazyQueryHookResult = ReturnType<typeof usePositionByIdLazyQuery>;
export type PositionByIdQueryResult = Apollo.QueryResult<PositionByIdQuery, PositionByIdQueryVariables>;
export const PositionCampaignByIdDocument = gql`
    query PositionCampaignById($id: ID!) {
  positionById(id: $id) {
    id
    rowId
    slug
    positionName
    positionType
  }
}
    `;

/**
 * __usePositionCampaignByIdQuery__
 *
 * To run a query within a React component, call `usePositionCampaignByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `usePositionCampaignByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePositionCampaignByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePositionCampaignByIdQuery(baseOptions: Apollo.QueryHookOptions<PositionCampaignByIdQuery, PositionCampaignByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PositionCampaignByIdQuery, PositionCampaignByIdQueryVariables>(PositionCampaignByIdDocument, options);
      }
export function usePositionCampaignByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PositionCampaignByIdQuery, PositionCampaignByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PositionCampaignByIdQuery, PositionCampaignByIdQueryVariables>(PositionCampaignByIdDocument, options);
        }
export type PositionCampaignByIdQueryHookResult = ReturnType<typeof usePositionCampaignByIdQuery>;
export type PositionCampaignByIdLazyQueryHookResult = ReturnType<typeof usePositionCampaignByIdLazyQuery>;
export type PositionCampaignByIdQueryResult = Apollo.QueryResult<PositionCampaignByIdQuery, PositionCampaignByIdQueryVariables>;
export const MutatePositionDocument = gql`
    mutation MutatePosition($id: ID, $positionType: [String], $positionName: String, $hiring: Boolean, $preferredTraining: [String], $preferredExperience: String, $baseSalaryMin: Float, $baseSalaryMax: Float, $baseSalaryUnitText: String, $isBenefitsRequired: Boolean, $canHaveDressCode: Boolean, $availabilityMonday: [String], $availabilityTuesday: [String], $availabilityWednesday: [String], $availabilityThursday: [String], $availabilityFriday: [String], $availabilitySaturday: [String], $availabilitySunday: [String], $sendNotifications: Boolean, $location: ID, $jobDescription: String, $indeedEasyapplyOptout: Boolean) {
  mutatePosition(
    input: {partialUpdate: true, id: $id, positionType: $positionType, positionName: $positionName, hiring: $hiring, preferredTraining: $preferredTraining, preferredExperience: $preferredExperience, baseSalaryMin: $baseSalaryMin, baseSalaryMax: $baseSalaryMax, baseSalaryUnitText: $baseSalaryUnitText, isBenefitsRequired: $isBenefitsRequired, canHaveDressCode: $canHaveDressCode, availabilityMonday: $availabilityMonday, availabilityTuesday: $availabilityTuesday, availabilityWednesday: $availabilityWednesday, availabilityThursday: $availabilityThursday, availabilityFriday: $availabilityFriday, availabilitySaturday: $availabilitySaturday, availabilitySunday: $availabilitySunday, sendNotifications: $sendNotifications, location: $location, jobDescription: $jobDescription, indeedEasyapplyOptout: $indeedEasyapplyOptout}
  ) {
    errors {
      field
      messages
    }
    position {
      id
      rowId
      positionType
      positionName
      hiring
      paymentStatus
      preferredTraining
      preferredExperience
      baseSalaryMin
      baseSalaryMax
      baseSalaryUnitText
      isBenefitsRequired
      canHaveDressCode
      availabilityMonday
      availabilityTuesday
      availabilityWednesday
      availabilityThursday
      availabilityFriday
      availabilitySaturday
      availabilitySunday
      sendNotifications
      jobDescription
      indeedEasyapplyOptout
      location {
        id
        name
        allPositionsCount
        hiringPositionCount
      }
    }
  }
}
    `;
export type MutatePositionMutationFn = Apollo.MutationFunction<MutatePositionMutation, MutatePositionMutationVariables>;

/**
 * __useMutatePositionMutation__
 *
 * To run a mutation, you first call `useMutatePositionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutatePositionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutatePositionMutation, { data, loading, error }] = useMutatePositionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      positionType: // value for 'positionType'
 *      positionName: // value for 'positionName'
 *      hiring: // value for 'hiring'
 *      preferredTraining: // value for 'preferredTraining'
 *      preferredExperience: // value for 'preferredExperience'
 *      baseSalaryMin: // value for 'baseSalaryMin'
 *      baseSalaryMax: // value for 'baseSalaryMax'
 *      baseSalaryUnitText: // value for 'baseSalaryUnitText'
 *      isBenefitsRequired: // value for 'isBenefitsRequired'
 *      canHaveDressCode: // value for 'canHaveDressCode'
 *      availabilityMonday: // value for 'availabilityMonday'
 *      availabilityTuesday: // value for 'availabilityTuesday'
 *      availabilityWednesday: // value for 'availabilityWednesday'
 *      availabilityThursday: // value for 'availabilityThursday'
 *      availabilityFriday: // value for 'availabilityFriday'
 *      availabilitySaturday: // value for 'availabilitySaturday'
 *      availabilitySunday: // value for 'availabilitySunday'
 *      sendNotifications: // value for 'sendNotifications'
 *      location: // value for 'location'
 *      jobDescription: // value for 'jobDescription'
 *      indeedEasyapplyOptout: // value for 'indeedEasyapplyOptout'
 *   },
 * });
 */
export function useMutatePositionMutation(baseOptions?: Apollo.MutationHookOptions<MutatePositionMutation, MutatePositionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutatePositionMutation, MutatePositionMutationVariables>(MutatePositionDocument, options);
      }
export type MutatePositionMutationHookResult = ReturnType<typeof useMutatePositionMutation>;
export type MutatePositionMutationResult = Apollo.MutationResult<MutatePositionMutation>;
export type MutatePositionMutationOptions = Apollo.BaseMutationOptions<MutatePositionMutation, MutatePositionMutationVariables>;
export const PartialRefundCampaignDocument = gql`
    mutation PartialRefundCampaign($jobBoardCampaignId: ID!) {
  refundAndEndCampaign(jobBoardCampaignId: $jobBoardCampaignId) {
    jobBoardCampaign {
      id
      startedOn
      amount
      campaignWillEndOn
      active
    }
  }
}
    `;
export type PartialRefundCampaignMutationFn = Apollo.MutationFunction<PartialRefundCampaignMutation, PartialRefundCampaignMutationVariables>;

/**
 * __usePartialRefundCampaignMutation__
 *
 * To run a mutation, you first call `usePartialRefundCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePartialRefundCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [partialRefundCampaignMutation, { data, loading, error }] = usePartialRefundCampaignMutation({
 *   variables: {
 *      jobBoardCampaignId: // value for 'jobBoardCampaignId'
 *   },
 * });
 */
export function usePartialRefundCampaignMutation(baseOptions?: Apollo.MutationHookOptions<PartialRefundCampaignMutation, PartialRefundCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PartialRefundCampaignMutation, PartialRefundCampaignMutationVariables>(PartialRefundCampaignDocument, options);
      }
export type PartialRefundCampaignMutationHookResult = ReturnType<typeof usePartialRefundCampaignMutation>;
export type PartialRefundCampaignMutationResult = Apollo.MutationResult<PartialRefundCampaignMutation>;
export type PartialRefundCampaignMutationOptions = Apollo.BaseMutationOptions<PartialRefundCampaignMutation, PartialRefundCampaignMutationVariables>;
export const EmployerCandidateQuestionnairesDocument = gql`
    query EmployerCandidateQuestionnaires($employerCandidate: ID, $position: ID) {
  employerCandidateQuestionnaires(
    employerCandidate: $employerCandidate
    position: $position
  ) {
    edges {
      node {
        id
        submittedAt
        position {
          id
          positionName
          location {
            id
            name
            formattedAddress
          }
        }
        screeningQuestionnaire {
          id
          questionnaireType
          screeningQuestion {
            edges {
              node {
                id
                answers {
                  id
                  questionText
                  answer
                  screeningAnswerVideo
                  updatedAt
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useEmployerCandidateQuestionnairesQuery__
 *
 * To run a query within a React component, call `useEmployerCandidateQuestionnairesQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployerCandidateQuestionnairesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployerCandidateQuestionnairesQuery({
 *   variables: {
 *      employerCandidate: // value for 'employerCandidate'
 *      position: // value for 'position'
 *   },
 * });
 */
export function useEmployerCandidateQuestionnairesQuery(baseOptions?: Apollo.QueryHookOptions<EmployerCandidateQuestionnairesQuery, EmployerCandidateQuestionnairesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployerCandidateQuestionnairesQuery, EmployerCandidateQuestionnairesQueryVariables>(EmployerCandidateQuestionnairesDocument, options);
      }
export function useEmployerCandidateQuestionnairesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployerCandidateQuestionnairesQuery, EmployerCandidateQuestionnairesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployerCandidateQuestionnairesQuery, EmployerCandidateQuestionnairesQueryVariables>(EmployerCandidateQuestionnairesDocument, options);
        }
export type EmployerCandidateQuestionnairesQueryHookResult = ReturnType<typeof useEmployerCandidateQuestionnairesQuery>;
export type EmployerCandidateQuestionnairesLazyQueryHookResult = ReturnType<typeof useEmployerCandidateQuestionnairesLazyQuery>;
export type EmployerCandidateQuestionnairesQueryResult = Apollo.QueryResult<EmployerCandidateQuestionnairesQuery, EmployerCandidateQuestionnairesQueryVariables>;
export const EmployerQuestionaireDocument = gql`
    query EmployerQuestionaire($search: String, $questionnaireType: ScreeningScreeningQuestionnaireQuestionnaireTypeChoices) {
  questionnaires(name_Icontains: $search, questionnaireType: $questionnaireType) {
    edges {
      node {
        id
        name
        questionnaireType
        createdAt
        screeningQuestion {
          edges {
            node {
              id
              question
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useEmployerQuestionaireQuery__
 *
 * To run a query within a React component, call `useEmployerQuestionaireQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployerQuestionaireQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployerQuestionaireQuery({
 *   variables: {
 *      search: // value for 'search'
 *      questionnaireType: // value for 'questionnaireType'
 *   },
 * });
 */
export function useEmployerQuestionaireQuery(baseOptions?: Apollo.QueryHookOptions<EmployerQuestionaireQuery, EmployerQuestionaireQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployerQuestionaireQuery, EmployerQuestionaireQueryVariables>(EmployerQuestionaireDocument, options);
      }
export function useEmployerQuestionaireLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployerQuestionaireQuery, EmployerQuestionaireQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployerQuestionaireQuery, EmployerQuestionaireQueryVariables>(EmployerQuestionaireDocument, options);
        }
export type EmployerQuestionaireQueryHookResult = ReturnType<typeof useEmployerQuestionaireQuery>;
export type EmployerQuestionaireLazyQueryHookResult = ReturnType<typeof useEmployerQuestionaireLazyQuery>;
export type EmployerQuestionaireQueryResult = Apollo.QueryResult<EmployerQuestionaireQuery, EmployerQuestionaireQueryVariables>;
export const QuestionaireDocument = gql`
    query Questionaire($Id: ID) {
  questionnaire(screeningQuestionnaireId: $Id) {
    id
    name
    screeningQuestion {
      edges {
        node {
          question
        }
      }
    }
  }
}
    `;

/**
 * __useQuestionaireQuery__
 *
 * To run a query within a React component, call `useQuestionaireQuery` and pass it any options that fit your needs.
 * When your component renders, `useQuestionaireQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQuestionaireQuery({
 *   variables: {
 *      Id: // value for 'Id'
 *   },
 * });
 */
export function useQuestionaireQuery(baseOptions?: Apollo.QueryHookOptions<QuestionaireQuery, QuestionaireQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QuestionaireQuery, QuestionaireQueryVariables>(QuestionaireDocument, options);
      }
export function useQuestionaireLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QuestionaireQuery, QuestionaireQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QuestionaireQuery, QuestionaireQueryVariables>(QuestionaireDocument, options);
        }
export type QuestionaireQueryHookResult = ReturnType<typeof useQuestionaireQuery>;
export type QuestionaireLazyQueryHookResult = ReturnType<typeof useQuestionaireLazyQuery>;
export type QuestionaireQueryResult = Apollo.QueryResult<QuestionaireQuery, QuestionaireQueryVariables>;
export const MutateScreeningQuestionDocument = gql`
    mutation mutateScreeningQuestion($question: String, $screeningQuestionnaireId: ID) {
  mutateScreeningQuestion(
    question: $question
    screeningQuestionnaireId: $screeningQuestionnaireId
  ) {
    screeningQuestion {
      id
      question
    }
  }
}
    `;
export type MutateScreeningQuestionMutationFn = Apollo.MutationFunction<MutateScreeningQuestionMutation, MutateScreeningQuestionMutationVariables>;

/**
 * __useMutateScreeningQuestionMutation__
 *
 * To run a mutation, you first call `useMutateScreeningQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutateScreeningQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateScreeningQuestionMutation, { data, loading, error }] = useMutateScreeningQuestionMutation({
 *   variables: {
 *      question: // value for 'question'
 *      screeningQuestionnaireId: // value for 'screeningQuestionnaireId'
 *   },
 * });
 */
export function useMutateScreeningQuestionMutation(baseOptions?: Apollo.MutationHookOptions<MutateScreeningQuestionMutation, MutateScreeningQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutateScreeningQuestionMutation, MutateScreeningQuestionMutationVariables>(MutateScreeningQuestionDocument, options);
      }
export type MutateScreeningQuestionMutationHookResult = ReturnType<typeof useMutateScreeningQuestionMutation>;
export type MutateScreeningQuestionMutationResult = Apollo.MutationResult<MutateScreeningQuestionMutation>;
export type MutateScreeningQuestionMutationOptions = Apollo.BaseMutationOptions<MutateScreeningQuestionMutation, MutateScreeningQuestionMutationVariables>;
export const MutateUpdateScreeningQuestionDocument = gql`
    mutation MutateUpdateScreeningQuestion($archivedAt: DateTime, $question: String, $questionId: ID) {
  updateScreeningQuestion(
    archivedAt: $archivedAt
    question: $question
    screeningQuestionId: $questionId
  ) {
    screeningQuestion {
      id
    }
  }
}
    `;
export type MutateUpdateScreeningQuestionMutationFn = Apollo.MutationFunction<MutateUpdateScreeningQuestionMutation, MutateUpdateScreeningQuestionMutationVariables>;

/**
 * __useMutateUpdateScreeningQuestionMutation__
 *
 * To run a mutation, you first call `useMutateUpdateScreeningQuestionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutateUpdateScreeningQuestionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateUpdateScreeningQuestionMutation, { data, loading, error }] = useMutateUpdateScreeningQuestionMutation({
 *   variables: {
 *      archivedAt: // value for 'archivedAt'
 *      question: // value for 'question'
 *      questionId: // value for 'questionId'
 *   },
 * });
 */
export function useMutateUpdateScreeningQuestionMutation(baseOptions?: Apollo.MutationHookOptions<MutateUpdateScreeningQuestionMutation, MutateUpdateScreeningQuestionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutateUpdateScreeningQuestionMutation, MutateUpdateScreeningQuestionMutationVariables>(MutateUpdateScreeningQuestionDocument, options);
      }
export type MutateUpdateScreeningQuestionMutationHookResult = ReturnType<typeof useMutateUpdateScreeningQuestionMutation>;
export type MutateUpdateScreeningQuestionMutationResult = Apollo.MutationResult<MutateUpdateScreeningQuestionMutation>;
export type MutateUpdateScreeningQuestionMutationOptions = Apollo.BaseMutationOptions<MutateUpdateScreeningQuestionMutation, MutateUpdateScreeningQuestionMutationVariables>;
export const GetEmployerRejectionReasonsDocument = gql`
    query GetEmployerRejectionReasons {
  employerRejectionReasons {
    edges {
      node {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetEmployerRejectionReasonsQuery__
 *
 * To run a query within a React component, call `useGetEmployerRejectionReasonsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployerRejectionReasonsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployerRejectionReasonsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEmployerRejectionReasonsQuery(baseOptions?: Apollo.QueryHookOptions<GetEmployerRejectionReasonsQuery, GetEmployerRejectionReasonsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployerRejectionReasonsQuery, GetEmployerRejectionReasonsQueryVariables>(GetEmployerRejectionReasonsDocument, options);
      }
export function useGetEmployerRejectionReasonsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployerRejectionReasonsQuery, GetEmployerRejectionReasonsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployerRejectionReasonsQuery, GetEmployerRejectionReasonsQueryVariables>(GetEmployerRejectionReasonsDocument, options);
        }
export type GetEmployerRejectionReasonsQueryHookResult = ReturnType<typeof useGetEmployerRejectionReasonsQuery>;
export type GetEmployerRejectionReasonsLazyQueryHookResult = ReturnType<typeof useGetEmployerRejectionReasonsLazyQuery>;
export type GetEmployerRejectionReasonsQueryResult = Apollo.QueryResult<GetEmployerRejectionReasonsQuery, GetEmployerRejectionReasonsQueryVariables>;
export const MutateEmployerRejectionReasonDocument = gql`
    mutation MutateEmployerRejectionReason($id: ID, $name: String, $archivedAt: DateTime) {
  mutateEmployerRejectionReason(
    input: {id: $id, name: $name, archivedAt: $archivedAt, partialUpdate: true}
  ) {
    employerRejectionReason {
      name
      archivedAt
      employerProfile {
        id
      }
    }
  }
}
    `;
export type MutateEmployerRejectionReasonMutationFn = Apollo.MutationFunction<MutateEmployerRejectionReasonMutation, MutateEmployerRejectionReasonMutationVariables>;

/**
 * __useMutateEmployerRejectionReasonMutation__
 *
 * To run a mutation, you first call `useMutateEmployerRejectionReasonMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutateEmployerRejectionReasonMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateEmployerRejectionReasonMutation, { data, loading, error }] = useMutateEmployerRejectionReasonMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      archivedAt: // value for 'archivedAt'
 *   },
 * });
 */
export function useMutateEmployerRejectionReasonMutation(baseOptions?: Apollo.MutationHookOptions<MutateEmployerRejectionReasonMutation, MutateEmployerRejectionReasonMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutateEmployerRejectionReasonMutation, MutateEmployerRejectionReasonMutationVariables>(MutateEmployerRejectionReasonDocument, options);
      }
export type MutateEmployerRejectionReasonMutationHookResult = ReturnType<typeof useMutateEmployerRejectionReasonMutation>;
export type MutateEmployerRejectionReasonMutationResult = Apollo.MutationResult<MutateEmployerRejectionReasonMutation>;
export type MutateEmployerRejectionReasonMutationOptions = Apollo.BaseMutationOptions<MutateEmployerRejectionReasonMutation, MutateEmployerRejectionReasonMutationVariables>;
export const GetEmployerRejectionReasonDocument = gql`
    query GetEmployerRejectionReason {
  employerRejectionReasons {
    edges {
      node {
        id
        name
        employercandidateSet {
          totalCount
        }
      }
    }
  }
}
    `;

/**
 * __useGetEmployerRejectionReasonQuery__
 *
 * To run a query within a React component, call `useGetEmployerRejectionReasonQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployerRejectionReasonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployerRejectionReasonQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEmployerRejectionReasonQuery(baseOptions?: Apollo.QueryHookOptions<GetEmployerRejectionReasonQuery, GetEmployerRejectionReasonQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployerRejectionReasonQuery, GetEmployerRejectionReasonQueryVariables>(GetEmployerRejectionReasonDocument, options);
      }
export function useGetEmployerRejectionReasonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployerRejectionReasonQuery, GetEmployerRejectionReasonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployerRejectionReasonQuery, GetEmployerRejectionReasonQueryVariables>(GetEmployerRejectionReasonDocument, options);
        }
export type GetEmployerRejectionReasonQueryHookResult = ReturnType<typeof useGetEmployerRejectionReasonQuery>;
export type GetEmployerRejectionReasonLazyQueryHookResult = ReturnType<typeof useGetEmployerRejectionReasonLazyQuery>;
export type GetEmployerRejectionReasonQueryResult = Apollo.QueryResult<GetEmployerRejectionReasonQuery, GetEmployerRejectionReasonQueryVariables>;
export const MutateSendQuestionnaireDocument = gql`
    mutation MutateSendQuestionnaire($employerCandidateId: ID!, $positionId: ID!, $questionnaireId: ID!, $messageContent: String) {
  sendQuestionnaire(
    employerCandidate: $employerCandidateId
    position: $positionId
    screeningQuestionnaire: $questionnaireId
    messageContent: $messageContent
  ) {
    id
  }
}
    `;
export type MutateSendQuestionnaireMutationFn = Apollo.MutationFunction<MutateSendQuestionnaireMutation, MutateSendQuestionnaireMutationVariables>;

/**
 * __useMutateSendQuestionnaireMutation__
 *
 * To run a mutation, you first call `useMutateSendQuestionnaireMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutateSendQuestionnaireMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateSendQuestionnaireMutation, { data, loading, error }] = useMutateSendQuestionnaireMutation({
 *   variables: {
 *      employerCandidateId: // value for 'employerCandidateId'
 *      positionId: // value for 'positionId'
 *      questionnaireId: // value for 'questionnaireId'
 *      messageContent: // value for 'messageContent'
 *   },
 * });
 */
export function useMutateSendQuestionnaireMutation(baseOptions?: Apollo.MutationHookOptions<MutateSendQuestionnaireMutation, MutateSendQuestionnaireMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutateSendQuestionnaireMutation, MutateSendQuestionnaireMutationVariables>(MutateSendQuestionnaireDocument, options);
      }
export type MutateSendQuestionnaireMutationHookResult = ReturnType<typeof useMutateSendQuestionnaireMutation>;
export type MutateSendQuestionnaireMutationResult = Apollo.MutationResult<MutateSendQuestionnaireMutation>;
export type MutateSendQuestionnaireMutationOptions = Apollo.BaseMutationOptions<MutateSendQuestionnaireMutation, MutateSendQuestionnaireMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($id: ID!, $firstName: String!, $lastName: String!, $email: String!, $phone: String, $password: String, $confirmPassword: String, $terms: Boolean, $timezone: String) {
  mutateUser(
    input: {id: $id, firstName: $firstName, lastName: $lastName, email: $email, password: $password, confirmPassword: $confirmPassword, phone: $phone, terms: $terms, timezone: $timezone, partialUpdate: true}
  ) {
    errors {
      messages
      field
    }
    me {
      id
      rowId
      email
      phone
      firstName
      lastName
      profileImage
      unclaimed
      authorization
    }
  }
}
    `;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      email: // value for 'email'
 *      phone: // value for 'phone'
 *      password: // value for 'password'
 *      confirmPassword: // value for 'confirmPassword'
 *      terms: // value for 'terms'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const GetEmployerUsersDocument = gql`
    query GetEmployerUsers($search: String) {
  employerUsers(search: $search) {
    edges {
      node {
        id
        role
        createdAt
        user {
          id
          firstName
          lastName
          lastLogin
          email
          unclaimed
          timezone
          profileImage
        }
        locations {
          edges {
            node {
              id
              name
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetEmployerUsersQuery__
 *
 * To run a query within a React component, call `useGetEmployerUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployerUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployerUsersQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetEmployerUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetEmployerUsersQuery, GetEmployerUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployerUsersQuery, GetEmployerUsersQueryVariables>(GetEmployerUsersDocument, options);
      }
export function useGetEmployerUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployerUsersQuery, GetEmployerUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployerUsersQuery, GetEmployerUsersQueryVariables>(GetEmployerUsersDocument, options);
        }
export type GetEmployerUsersQueryHookResult = ReturnType<typeof useGetEmployerUsersQuery>;
export type GetEmployerUsersLazyQueryHookResult = ReturnType<typeof useGetEmployerUsersLazyQuery>;
export type GetEmployerUsersQueryResult = Apollo.QueryResult<GetEmployerUsersQuery, GetEmployerUsersQueryVariables>;
export const InviteTeamToLocationDocument = gql`
    mutation inviteTeamToLocation($location: ID!, $users: [String], $name: String!) {
  mutateLocation(input: {id: $location, users: $users, name: $name}) {
    location {
      id
    }
  }
}
    `;
export type InviteTeamToLocationMutationFn = Apollo.MutationFunction<InviteTeamToLocationMutation, InviteTeamToLocationMutationVariables>;

/**
 * __useInviteTeamToLocationMutation__
 *
 * To run a mutation, you first call `useInviteTeamToLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInviteTeamToLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [inviteTeamToLocationMutation, { data, loading, error }] = useInviteTeamToLocationMutation({
 *   variables: {
 *      location: // value for 'location'
 *      users: // value for 'users'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useInviteTeamToLocationMutation(baseOptions?: Apollo.MutationHookOptions<InviteTeamToLocationMutation, InviteTeamToLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InviteTeamToLocationMutation, InviteTeamToLocationMutationVariables>(InviteTeamToLocationDocument, options);
      }
export type InviteTeamToLocationMutationHookResult = ReturnType<typeof useInviteTeamToLocationMutation>;
export type InviteTeamToLocationMutationResult = Apollo.MutationResult<InviteTeamToLocationMutation>;
export type InviteTeamToLocationMutationOptions = Apollo.BaseMutationOptions<InviteTeamToLocationMutation, InviteTeamToLocationMutationVariables>;
export const RemoveEmployerUserMutationDocument = gql`
    mutation RemoveEmployerUserMutation($id: ID!) {
  removeEmployerUser(input: {id: $id}) {
    id
  }
}
    `;
export type RemoveEmployerUserMutationMutationFn = Apollo.MutationFunction<RemoveEmployerUserMutationMutation, RemoveEmployerUserMutationMutationVariables>;

/**
 * __useRemoveEmployerUserMutationMutation__
 *
 * To run a mutation, you first call `useRemoveEmployerUserMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEmployerUserMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEmployerUserMutationMutation, { data, loading, error }] = useRemoveEmployerUserMutationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveEmployerUserMutationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEmployerUserMutationMutation, RemoveEmployerUserMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEmployerUserMutationMutation, RemoveEmployerUserMutationMutationVariables>(RemoveEmployerUserMutationDocument, options);
      }
export type RemoveEmployerUserMutationMutationHookResult = ReturnType<typeof useRemoveEmployerUserMutationMutation>;
export type RemoveEmployerUserMutationMutationResult = Apollo.MutationResult<RemoveEmployerUserMutationMutation>;
export type RemoveEmployerUserMutationMutationOptions = Apollo.BaseMutationOptions<RemoveEmployerUserMutationMutation, RemoveEmployerUserMutationMutationVariables>;
export const ResendEmployerUserInviteDocument = gql`
    mutation ResendEmployerUserInvite($id: ID!) {
  resendEmployerUserInvite(input: {id: $id}) {
    id
  }
}
    `;
export type ResendEmployerUserInviteMutationFn = Apollo.MutationFunction<ResendEmployerUserInviteMutation, ResendEmployerUserInviteMutationVariables>;

/**
 * __useResendEmployerUserInviteMutation__
 *
 * To run a mutation, you first call `useResendEmployerUserInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendEmployerUserInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendEmployerUserInviteMutation, { data, loading, error }] = useResendEmployerUserInviteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useResendEmployerUserInviteMutation(baseOptions?: Apollo.MutationHookOptions<ResendEmployerUserInviteMutation, ResendEmployerUserInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendEmployerUserInviteMutation, ResendEmployerUserInviteMutationVariables>(ResendEmployerUserInviteDocument, options);
      }
export type ResendEmployerUserInviteMutationHookResult = ReturnType<typeof useResendEmployerUserInviteMutation>;
export type ResendEmployerUserInviteMutationResult = Apollo.MutationResult<ResendEmployerUserInviteMutation>;
export type ResendEmployerUserInviteMutationOptions = Apollo.BaseMutationOptions<ResendEmployerUserInviteMutation, ResendEmployerUserInviteMutationVariables>;
export const EmployerUserDocument = gql`
    mutation EmployerUser($id: ID, $email: String, $role: String, $locations: [ID], $firstName: String, $lastName: String, $timezone: String) {
  mutateEmployerUser(
    input: {id: $id, email: $email, role: $role, locations: $locations, firstName: $firstName, lastName: $lastName, timezone: $timezone}
  ) {
    employerUser {
      id
      role
      user {
        id
        firstName
        lastName
        lastLogin
        email
        timezone
      }
    }
  }
}
    `;
export type EmployerUserMutationFn = Apollo.MutationFunction<EmployerUserMutation, EmployerUserMutationVariables>;

/**
 * __useEmployerUserMutation__
 *
 * To run a mutation, you first call `useEmployerUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmployerUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [employerUserMutation, { data, loading, error }] = useEmployerUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      email: // value for 'email'
 *      role: // value for 'role'
 *      locations: // value for 'locations'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useEmployerUserMutation(baseOptions?: Apollo.MutationHookOptions<EmployerUserMutation, EmployerUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EmployerUserMutation, EmployerUserMutationVariables>(EmployerUserDocument, options);
      }
export type EmployerUserMutationHookResult = ReturnType<typeof useEmployerUserMutation>;
export type EmployerUserMutationResult = Apollo.MutationResult<EmployerUserMutation>;
export type EmployerUserMutationOptions = Apollo.BaseMutationOptions<EmployerUserMutation, EmployerUserMutationVariables>;
export const MutateCreateEmploymentDocumentDocument = gql`
    mutation MutateCreateEmploymentDocument($documentType: String, $baseSalaryValue: Float, $baseSalaryUnitText: String, $status: String, $position: ID!, $candidate: ID!, $startingAt: DateTime, $contactName: String, $contactPhone: String, $note: String, $messageContent: String) {
  mutateEmploymentDocument(
    input: {documentType: $documentType, baseSalaryValue: $baseSalaryValue, baseSalaryUnitText: $baseSalaryUnitText, status: $status, position: $position, candidate: $candidate, startingAt: $startingAt, contactName: $contactName, contactPhone: $contactPhone, note: $note, messageContent: $messageContent}
  ) {
    employmentDocumentType {
      id
      candidate {
        id
      }
      position {
        id
      }
      documentType
      contactName
      contactPhone
      acceptedDeclinedAt
      baseSalaryUnitText
      status
    }
  }
}
    `;
export type MutateCreateEmploymentDocumentMutationFn = Apollo.MutationFunction<MutateCreateEmploymentDocumentMutation, MutateCreateEmploymentDocumentMutationVariables>;

/**
 * __useMutateCreateEmploymentDocumentMutation__
 *
 * To run a mutation, you first call `useMutateCreateEmploymentDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutateCreateEmploymentDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateCreateEmploymentDocumentMutation, { data, loading, error }] = useMutateCreateEmploymentDocumentMutation({
 *   variables: {
 *      documentType: // value for 'documentType'
 *      baseSalaryValue: // value for 'baseSalaryValue'
 *      baseSalaryUnitText: // value for 'baseSalaryUnitText'
 *      status: // value for 'status'
 *      position: // value for 'position'
 *      candidate: // value for 'candidate'
 *      startingAt: // value for 'startingAt'
 *      contactName: // value for 'contactName'
 *      contactPhone: // value for 'contactPhone'
 *      note: // value for 'note'
 *      messageContent: // value for 'messageContent'
 *   },
 * });
 */
export function useMutateCreateEmploymentDocumentMutation(baseOptions?: Apollo.MutationHookOptions<MutateCreateEmploymentDocumentMutation, MutateCreateEmploymentDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutateCreateEmploymentDocumentMutation, MutateCreateEmploymentDocumentMutationVariables>(MutateCreateEmploymentDocumentDocument, options);
      }
export type MutateCreateEmploymentDocumentMutationHookResult = ReturnType<typeof useMutateCreateEmploymentDocumentMutation>;
export type MutateCreateEmploymentDocumentMutationResult = Apollo.MutationResult<MutateCreateEmploymentDocumentMutation>;
export type MutateCreateEmploymentDocumentMutationOptions = Apollo.BaseMutationOptions<MutateCreateEmploymentDocumentMutation, MutateCreateEmploymentDocumentMutationVariables>;
export const MutateEmploymentDocumentDocument = gql`
    mutation MutateEmploymentDocument($id: ID, $status: String) {
  mutateEmploymentDocument(input: {id: $id, status: $status}) {
    employmentDocumentType {
      id
      candidate {
        id
      }
      status
    }
  }
}
    `;
export type MutateEmploymentDocumentMutationFn = Apollo.MutationFunction<MutateEmploymentDocumentMutation, MutateEmploymentDocumentMutationVariables>;

/**
 * __useMutateEmploymentDocumentMutation__
 *
 * To run a mutation, you first call `useMutateEmploymentDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutateEmploymentDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateEmploymentDocumentMutation, { data, loading, error }] = useMutateEmploymentDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useMutateEmploymentDocumentMutation(baseOptions?: Apollo.MutationHookOptions<MutateEmploymentDocumentMutation, MutateEmploymentDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutateEmploymentDocumentMutation, MutateEmploymentDocumentMutationVariables>(MutateEmploymentDocumentDocument, options);
      }
export type MutateEmploymentDocumentMutationHookResult = ReturnType<typeof useMutateEmploymentDocumentMutation>;
export type MutateEmploymentDocumentMutationResult = Apollo.MutationResult<MutateEmploymentDocumentMutation>;
export type MutateEmploymentDocumentMutationOptions = Apollo.BaseMutationOptions<MutateEmploymentDocumentMutation, MutateEmploymentDocumentMutationVariables>;
export const GetEmployerDocumentDocument = gql`
    query GetEmployerDocument($id: ID!) {
  getEmployerDocument(id: $id) {
    id
    documentType
    baseSalaryValue
    baseSalaryUnitText
    status
    acceptedDeclinedAt
    contactName
    contactPhone
    startingAt
    note
    candidate {
      id
      user {
        profileImage
      }
    }
    position {
      positionName
      createdBy {
        firstName
        profileImage
      }
      location {
        name
        image
        addressStreet1
        addressCity
        addressState
        addressPostalCode
      }
    }
    employmentdocumentfileSet {
      edges {
        node {
          id
          name
          attachment
          size
          url
        }
      }
    }
  }
}
    `;

/**
 * __useGetEmployerDocumentQuery__
 *
 * To run a query within a React component, call `useGetEmployerDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployerDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployerDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEmployerDocumentQuery(baseOptions: Apollo.QueryHookOptions<GetEmployerDocumentQuery, GetEmployerDocumentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployerDocumentQuery, GetEmployerDocumentQueryVariables>(GetEmployerDocumentDocument, options);
      }
export function useGetEmployerDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployerDocumentQuery, GetEmployerDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployerDocumentQuery, GetEmployerDocumentQueryVariables>(GetEmployerDocumentDocument, options);
        }
export type GetEmployerDocumentQueryHookResult = ReturnType<typeof useGetEmployerDocumentQuery>;
export type GetEmployerDocumentLazyQueryHookResult = ReturnType<typeof useGetEmployerDocumentLazyQuery>;
export type GetEmployerDocumentQueryResult = Apollo.QueryResult<GetEmployerDocumentQuery, GetEmployerDocumentQueryVariables>;
export const MutateEmploymentDocumentFileDocument = gql`
    mutation MutateEmploymentDocumentFile($employmentDocumentId: ID!, $documentFiles: [EmploymentDocumentFileInput]) {
  uploadEmploymentDocument(
    employmentDocumentId: $employmentDocumentId
    documentFiles: $documentFiles
  ) {
    employmentDocument {
      id
    }
    urls {
      fileName
      fileUrl
      signedS3Url
      link
    }
  }
}
    `;
export type MutateEmploymentDocumentFileMutationFn = Apollo.MutationFunction<MutateEmploymentDocumentFileMutation, MutateEmploymentDocumentFileMutationVariables>;

/**
 * __useMutateEmploymentDocumentFileMutation__
 *
 * To run a mutation, you first call `useMutateEmploymentDocumentFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutateEmploymentDocumentFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateEmploymentDocumentFileMutation, { data, loading, error }] = useMutateEmploymentDocumentFileMutation({
 *   variables: {
 *      employmentDocumentId: // value for 'employmentDocumentId'
 *      documentFiles: // value for 'documentFiles'
 *   },
 * });
 */
export function useMutateEmploymentDocumentFileMutation(baseOptions?: Apollo.MutationHookOptions<MutateEmploymentDocumentFileMutation, MutateEmploymentDocumentFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutateEmploymentDocumentFileMutation, MutateEmploymentDocumentFileMutationVariables>(MutateEmploymentDocumentFileDocument, options);
      }
export type MutateEmploymentDocumentFileMutationHookResult = ReturnType<typeof useMutateEmploymentDocumentFileMutation>;
export type MutateEmploymentDocumentFileMutationResult = Apollo.MutationResult<MutateEmploymentDocumentFileMutation>;
export type MutateEmploymentDocumentFileMutationOptions = Apollo.BaseMutationOptions<MutateEmploymentDocumentFileMutation, MutateEmploymentDocumentFileMutationVariables>;
export const MutateGoogleOAuthDocument = gql`
    mutation MutateGoogleOAuth($authCode: String!, $authType: String!, $userGroup: String) {
  googleOauth(authCode: $authCode, authType: $authType, userGroup: $userGroup) {
    token
    invitedLocation
    invitedBy
    existingLocation
  }
}
    `;
export type MutateGoogleOAuthMutationFn = Apollo.MutationFunction<MutateGoogleOAuthMutation, MutateGoogleOAuthMutationVariables>;

/**
 * __useMutateGoogleOAuthMutation__
 *
 * To run a mutation, you first call `useMutateGoogleOAuthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutateGoogleOAuthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateGoogleOAuthMutation, { data, loading, error }] = useMutateGoogleOAuthMutation({
 *   variables: {
 *      authCode: // value for 'authCode'
 *      authType: // value for 'authType'
 *      userGroup: // value for 'userGroup'
 *   },
 * });
 */
export function useMutateGoogleOAuthMutation(baseOptions?: Apollo.MutationHookOptions<MutateGoogleOAuthMutation, MutateGoogleOAuthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutateGoogleOAuthMutation, MutateGoogleOAuthMutationVariables>(MutateGoogleOAuthDocument, options);
      }
export type MutateGoogleOAuthMutationHookResult = ReturnType<typeof useMutateGoogleOAuthMutation>;
export type MutateGoogleOAuthMutationResult = Apollo.MutationResult<MutateGoogleOAuthMutation>;
export type MutateGoogleOAuthMutationOptions = Apollo.BaseMutationOptions<MutateGoogleOAuthMutation, MutateGoogleOAuthMutationVariables>;
export const MutateSendHelpRequestDocument = gql`
    mutation MutateSendHelpRequest($email: String!, $firstName: String!, $lastName: String!, $employerName: String!, $message: String!) {
  sendHelpRequest(
    email: $email
    firstName: $firstName
    lastName: $lastName
    employerName: $employerName
    message: $message
  ) {
    success
  }
}
    `;
export type MutateSendHelpRequestMutationFn = Apollo.MutationFunction<MutateSendHelpRequestMutation, MutateSendHelpRequestMutationVariables>;

/**
 * __useMutateSendHelpRequestMutation__
 *
 * To run a mutation, you first call `useMutateSendHelpRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutateSendHelpRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateSendHelpRequestMutation, { data, loading, error }] = useMutateSendHelpRequestMutation({
 *   variables: {
 *      email: // value for 'email'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      employerName: // value for 'employerName'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useMutateSendHelpRequestMutation(baseOptions?: Apollo.MutationHookOptions<MutateSendHelpRequestMutation, MutateSendHelpRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutateSendHelpRequestMutation, MutateSendHelpRequestMutationVariables>(MutateSendHelpRequestDocument, options);
      }
export type MutateSendHelpRequestMutationHookResult = ReturnType<typeof useMutateSendHelpRequestMutation>;
export type MutateSendHelpRequestMutationResult = Apollo.MutationResult<MutateSendHelpRequestMutation>;
export type MutateSendHelpRequestMutationOptions = Apollo.BaseMutationOptions<MutateSendHelpRequestMutation, MutateSendHelpRequestMutationVariables>;
export const DeleteIndeedTokenDocument = gql`
    mutation DeleteIndeedToken($id: ID!) {
  deleteIndeedToken(id: $id) {
    ok
  }
}
    `;
export type DeleteIndeedTokenMutationFn = Apollo.MutationFunction<DeleteIndeedTokenMutation, DeleteIndeedTokenMutationVariables>;

/**
 * __useDeleteIndeedTokenMutation__
 *
 * To run a mutation, you first call `useDeleteIndeedTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIndeedTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIndeedTokenMutation, { data, loading, error }] = useDeleteIndeedTokenMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteIndeedTokenMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIndeedTokenMutation, DeleteIndeedTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIndeedTokenMutation, DeleteIndeedTokenMutationVariables>(DeleteIndeedTokenDocument, options);
      }
export type DeleteIndeedTokenMutationHookResult = ReturnType<typeof useDeleteIndeedTokenMutation>;
export type DeleteIndeedTokenMutationResult = Apollo.MutationResult<DeleteIndeedTokenMutation>;
export type DeleteIndeedTokenMutationOptions = Apollo.BaseMutationOptions<DeleteIndeedTokenMutation, DeleteIndeedTokenMutationVariables>;
export const DeleteIntegrationIdentifierDocument = gql`
    mutation DeleteIntegrationIdentifier($integration: String!) {
  deleteIntegrationIdentifier(integration: $integration) {
    ok
  }
}
    `;
export type DeleteIntegrationIdentifierMutationFn = Apollo.MutationFunction<DeleteIntegrationIdentifierMutation, DeleteIntegrationIdentifierMutationVariables>;

/**
 * __useDeleteIntegrationIdentifierMutation__
 *
 * To run a mutation, you first call `useDeleteIntegrationIdentifierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteIntegrationIdentifierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteIntegrationIdentifierMutation, { data, loading, error }] = useDeleteIntegrationIdentifierMutation({
 *   variables: {
 *      integration: // value for 'integration'
 *   },
 * });
 */
export function useDeleteIntegrationIdentifierMutation(baseOptions?: Apollo.MutationHookOptions<DeleteIntegrationIdentifierMutation, DeleteIntegrationIdentifierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteIntegrationIdentifierMutation, DeleteIntegrationIdentifierMutationVariables>(DeleteIntegrationIdentifierDocument, options);
      }
export type DeleteIntegrationIdentifierMutationHookResult = ReturnType<typeof useDeleteIntegrationIdentifierMutation>;
export type DeleteIntegrationIdentifierMutationResult = Apollo.MutationResult<DeleteIntegrationIdentifierMutation>;
export type DeleteIntegrationIdentifierMutationOptions = Apollo.BaseMutationOptions<DeleteIntegrationIdentifierMutation, DeleteIntegrationIdentifierMutationVariables>;
export const Delete7ShiftsGuidDocument = gql`
    mutation Delete7ShiftsGuid($id: ID!) {
  sevenshiftsDeleteGuid(id: $id) {
    ok
  }
}
    `;
export type Delete7ShiftsGuidMutationFn = Apollo.MutationFunction<Delete7ShiftsGuidMutation, Delete7ShiftsGuidMutationVariables>;

/**
 * __useDelete7ShiftsGuidMutation__
 *
 * To run a mutation, you first call `useDelete7ShiftsGuidMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDelete7ShiftsGuidMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [delete7ShiftsGuidMutation, { data, loading, error }] = useDelete7ShiftsGuidMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDelete7ShiftsGuidMutation(baseOptions?: Apollo.MutationHookOptions<Delete7ShiftsGuidMutation, Delete7ShiftsGuidMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Delete7ShiftsGuidMutation, Delete7ShiftsGuidMutationVariables>(Delete7ShiftsGuidDocument, options);
      }
export type Delete7ShiftsGuidMutationHookResult = ReturnType<typeof useDelete7ShiftsGuidMutation>;
export type Delete7ShiftsGuidMutationResult = Apollo.MutationResult<Delete7ShiftsGuidMutation>;
export type Delete7ShiftsGuidMutationOptions = Apollo.BaseMutationOptions<Delete7ShiftsGuidMutation, Delete7ShiftsGuidMutationVariables>;
export const GetCompaniesDocument = gql`
    query GetCompanies {
  sevenshiftsCompanies {
    id
    companyName
    companyId
    guid
    createdAt
    updatedAt
    createdBy {
      firstName
      lastName
      email
    }
  }
  indeedCompanies {
    id
    indeedCompany
    createdAt
    hasActiveCampaign
  }
  integrationIdentifiers {
    integration
    identifier
  }
}
    `;

/**
 * __useGetCompaniesQuery__
 *
 * To run a query within a React component, call `useGetCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<GetCompaniesQuery, GetCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCompaniesQuery, GetCompaniesQueryVariables>(GetCompaniesDocument, options);
      }
export function useGetCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCompaniesQuery, GetCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCompaniesQuery, GetCompaniesQueryVariables>(GetCompaniesDocument, options);
        }
export type GetCompaniesQueryHookResult = ReturnType<typeof useGetCompaniesQuery>;
export type GetCompaniesLazyQueryHookResult = ReturnType<typeof useGetCompaniesLazyQuery>;
export type GetCompaniesQueryResult = Apollo.QueryResult<GetCompaniesQuery, GetCompaniesQueryVariables>;
export const GetDepartmentsDocument = gql`
    query GetDepartments($companyId: Int!, $locationId: Int) {
  sevenshiftsDepartments(companyId: $companyId, locationId: $locationId) {
    id
    name
  }
}
    `;

/**
 * __useGetDepartmentsQuery__
 *
 * To run a query within a React component, call `useGetDepartmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDepartmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDepartmentsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      locationId: // value for 'locationId'
 *   },
 * });
 */
export function useGetDepartmentsQuery(baseOptions: Apollo.QueryHookOptions<GetDepartmentsQuery, GetDepartmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDepartmentsQuery, GetDepartmentsQueryVariables>(GetDepartmentsDocument, options);
      }
export function useGetDepartmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDepartmentsQuery, GetDepartmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDepartmentsQuery, GetDepartmentsQueryVariables>(GetDepartmentsDocument, options);
        }
export type GetDepartmentsQueryHookResult = ReturnType<typeof useGetDepartmentsQuery>;
export type GetDepartmentsLazyQueryHookResult = ReturnType<typeof useGetDepartmentsLazyQuery>;
export type GetDepartmentsQueryResult = Apollo.QueryResult<GetDepartmentsQuery, GetDepartmentsQueryVariables>;
export const GetLocationsDocument = gql`
    query GetLocations($companyId: Int!) {
  sevenshiftsLocations(companyId: $companyId) {
    id
    name
    address
  }
}
    `;

/**
 * __useGetLocationsQuery__
 *
 * To run a query within a React component, call `useGetLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetLocationsQuery(baseOptions: Apollo.QueryHookOptions<GetLocationsQuery, GetLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationsQuery, GetLocationsQueryVariables>(GetLocationsDocument, options);
      }
export function useGetLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationsQuery, GetLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationsQuery, GetLocationsQueryVariables>(GetLocationsDocument, options);
        }
export type GetLocationsQueryHookResult = ReturnType<typeof useGetLocationsQuery>;
export type GetLocationsLazyQueryHookResult = ReturnType<typeof useGetLocationsLazyQuery>;
export type GetLocationsQueryResult = Apollo.QueryResult<GetLocationsQuery, GetLocationsQueryVariables>;
export const GetRolesDocument = gql`
    query GetRoles($companyId: Int!, $locationId: Int, $departmentId: Int) {
  sevenshiftsRoles(
    companyId: $companyId
    locationId: $locationId
    departmentId: $departmentId
  ) {
    id
    name
    departmentId
    locationId
  }
}
    `;

/**
 * __useGetRolesQuery__
 *
 * To run a query within a React component, call `useGetRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRolesQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      locationId: // value for 'locationId'
 *      departmentId: // value for 'departmentId'
 *   },
 * });
 */
export function useGetRolesQuery(baseOptions: Apollo.QueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
      }
export function useGetRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetRolesQuery, GetRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetRolesQuery, GetRolesQueryVariables>(GetRolesDocument, options);
        }
export type GetRolesQueryHookResult = ReturnType<typeof useGetRolesQuery>;
export type GetRolesLazyQueryHookResult = ReturnType<typeof useGetRolesLazyQuery>;
export type GetRolesQueryResult = Apollo.QueryResult<GetRolesQuery, GetRolesQueryVariables>;
export const CreateIndeedTokenFromCodeDocument = gql`
    mutation CreateIndeedTokenFromCode($code: String!, $employerId: String) {
  indeedRequestOauthToken(code: $code, employerId: $employerId) {
    ok
  }
}
    `;
export type CreateIndeedTokenFromCodeMutationFn = Apollo.MutationFunction<CreateIndeedTokenFromCodeMutation, CreateIndeedTokenFromCodeMutationVariables>;

/**
 * __useCreateIndeedTokenFromCodeMutation__
 *
 * To run a mutation, you first call `useCreateIndeedTokenFromCodeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIndeedTokenFromCodeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIndeedTokenFromCodeMutation, { data, loading, error }] = useCreateIndeedTokenFromCodeMutation({
 *   variables: {
 *      code: // value for 'code'
 *      employerId: // value for 'employerId'
 *   },
 * });
 */
export function useCreateIndeedTokenFromCodeMutation(baseOptions?: Apollo.MutationHookOptions<CreateIndeedTokenFromCodeMutation, CreateIndeedTokenFromCodeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIndeedTokenFromCodeMutation, CreateIndeedTokenFromCodeMutationVariables>(CreateIndeedTokenFromCodeDocument, options);
      }
export type CreateIndeedTokenFromCodeMutationHookResult = ReturnType<typeof useCreateIndeedTokenFromCodeMutation>;
export type CreateIndeedTokenFromCodeMutationResult = Apollo.MutationResult<CreateIndeedTokenFromCodeMutation>;
export type CreateIndeedTokenFromCodeMutationOptions = Apollo.BaseMutationOptions<CreateIndeedTokenFromCodeMutation, CreateIndeedTokenFromCodeMutationVariables>;
export const CreateUpdateIntegrationIdentifierDocument = gql`
    mutation CreateUpdateIntegrationIdentifier($integration: String!, $identifier: String!) {
  createUpdateIntegrationIdentifier(
    integration: $integration
    identifier: $identifier
  ) {
    integration
    identifier
  }
}
    `;
export type CreateUpdateIntegrationIdentifierMutationFn = Apollo.MutationFunction<CreateUpdateIntegrationIdentifierMutation, CreateUpdateIntegrationIdentifierMutationVariables>;

/**
 * __useCreateUpdateIntegrationIdentifierMutation__
 *
 * To run a mutation, you first call `useCreateUpdateIntegrationIdentifierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateUpdateIntegrationIdentifierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createUpdateIntegrationIdentifierMutation, { data, loading, error }] = useCreateUpdateIntegrationIdentifierMutation({
 *   variables: {
 *      integration: // value for 'integration'
 *      identifier: // value for 'identifier'
 *   },
 * });
 */
export function useCreateUpdateIntegrationIdentifierMutation(baseOptions?: Apollo.MutationHookOptions<CreateUpdateIntegrationIdentifierMutation, CreateUpdateIntegrationIdentifierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateUpdateIntegrationIdentifierMutation, CreateUpdateIntegrationIdentifierMutationVariables>(CreateUpdateIntegrationIdentifierDocument, options);
      }
export type CreateUpdateIntegrationIdentifierMutationHookResult = ReturnType<typeof useCreateUpdateIntegrationIdentifierMutation>;
export type CreateUpdateIntegrationIdentifierMutationResult = Apollo.MutationResult<CreateUpdateIntegrationIdentifierMutation>;
export type CreateUpdateIntegrationIdentifierMutationOptions = Apollo.BaseMutationOptions<CreateUpdateIntegrationIdentifierMutation, CreateUpdateIntegrationIdentifierMutationVariables>;
export const Create7ShiftsUserDocument = gql`
    mutation Create7ShiftsUser($employerCandidate: ID!, $companyId: Int!, $locationId: Int!, $departmentId: Int!, $roleId: Int, $hireDate: Date, $inviteUser: Boolean) {
  sevenshiftsCreateUser(
    employerCandidate: $employerCandidate
    companyId: $companyId
    locationId: $locationId
    departmentId: $departmentId
    roleId: $roleId
    hireDate: $hireDate
    inviteUser: $inviteUser
  ) {
    sevenshiftsId
    sevenshiftsUrl
    employerCandidate {
      id
      sevenshiftsUrl
    }
  }
}
    `;
export type Create7ShiftsUserMutationFn = Apollo.MutationFunction<Create7ShiftsUserMutation, Create7ShiftsUserMutationVariables>;

/**
 * __useCreate7ShiftsUserMutation__
 *
 * To run a mutation, you first call `useCreate7ShiftsUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreate7ShiftsUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [create7ShiftsUserMutation, { data, loading, error }] = useCreate7ShiftsUserMutation({
 *   variables: {
 *      employerCandidate: // value for 'employerCandidate'
 *      companyId: // value for 'companyId'
 *      locationId: // value for 'locationId'
 *      departmentId: // value for 'departmentId'
 *      roleId: // value for 'roleId'
 *      hireDate: // value for 'hireDate'
 *      inviteUser: // value for 'inviteUser'
 *   },
 * });
 */
export function useCreate7ShiftsUserMutation(baseOptions?: Apollo.MutationHookOptions<Create7ShiftsUserMutation, Create7ShiftsUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<Create7ShiftsUserMutation, Create7ShiftsUserMutationVariables>(Create7ShiftsUserDocument, options);
      }
export type Create7ShiftsUserMutationHookResult = ReturnType<typeof useCreate7ShiftsUserMutation>;
export type Create7ShiftsUserMutationResult = Apollo.MutationResult<Create7ShiftsUserMutation>;
export type Create7ShiftsUserMutationOptions = Apollo.BaseMutationOptions<Create7ShiftsUserMutation, Create7ShiftsUserMutationVariables>;
export const GetInterviewDetailDocument = gql`
    query GetInterviewDetail($uuid: String, $token: String, $id: String) {
  interview(uuid: $uuid, token: $token, id: $id) {
    id
    uuid
    status
    createdAt
    viewedAt
    scheduledFor
    interviewType
    meetingUrl
    phoneNumber
    duration
    createdBy {
      id
      interviewschedule {
        id
        user {
          timezone
        }
      }
    }
    interviewAttendees {
      role
      user {
        id
        timezone
      }
    }
    location {
      id
      slug
      rowId
      name
      summary
      image
      formattedAddress
      tags {
        id
        name
      }
      answers {
        edges {
          node {
            id
            displayIcon
            displayLabel
          }
        }
      }
    }
    position {
      id
      rowId
      positionName
      jobDescription
      jobDescriptionType
      positionType
      baseSalaryMin
      baseSalaryMax
      baseSalaryUnitText
      hasApplied
      posted
    }
  }
}
    `;

/**
 * __useGetInterviewDetailQuery__
 *
 * To run a query within a React component, call `useGetInterviewDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInterviewDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInterviewDetailQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      token: // value for 'token'
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetInterviewDetailQuery(baseOptions?: Apollo.QueryHookOptions<GetInterviewDetailQuery, GetInterviewDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInterviewDetailQuery, GetInterviewDetailQueryVariables>(GetInterviewDetailDocument, options);
      }
export function useGetInterviewDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInterviewDetailQuery, GetInterviewDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInterviewDetailQuery, GetInterviewDetailQueryVariables>(GetInterviewDetailDocument, options);
        }
export type GetInterviewDetailQueryHookResult = ReturnType<typeof useGetInterviewDetailQuery>;
export type GetInterviewDetailLazyQueryHookResult = ReturnType<typeof useGetInterviewDetailLazyQuery>;
export type GetInterviewDetailQueryResult = Apollo.QueryResult<GetInterviewDetailQuery, GetInterviewDetailQueryVariables>;
export const GetInterviewScheduleDocument = gql`
    query GetInterviewSchedule($uuid: String, $startDate: DateTime!, $endDate: DateTime!) {
  interview(uuid: $uuid) {
    id
    rowId
    status
    scheduledFor
    ics
    uuid
    interviewType
    meetingUrl
    duration
    phoneNumber
    maxWeeksOut
    interviewScheduleSlots(startDate: $startDate, endDate: $endDate) {
      day
      slots {
        start
        available
      }
    }
    createdBy {
      id
      rowId
      uuid
      firstName
      profileImage
      email
    }
    location {
      id
      rowId
      slug
      name
      image
      formattedAddress
    }
    position {
      id
      rowId
      slug
      positionName
      positionType
    }
  }
}
    `;

/**
 * __useGetInterviewScheduleQuery__
 *
 * To run a query within a React component, call `useGetInterviewScheduleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInterviewScheduleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInterviewScheduleQuery({
 *   variables: {
 *      uuid: // value for 'uuid'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *   },
 * });
 */
export function useGetInterviewScheduleQuery(baseOptions: Apollo.QueryHookOptions<GetInterviewScheduleQuery, GetInterviewScheduleQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInterviewScheduleQuery, GetInterviewScheduleQueryVariables>(GetInterviewScheduleDocument, options);
      }
export function useGetInterviewScheduleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInterviewScheduleQuery, GetInterviewScheduleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInterviewScheduleQuery, GetInterviewScheduleQueryVariables>(GetInterviewScheduleDocument, options);
        }
export type GetInterviewScheduleQueryHookResult = ReturnType<typeof useGetInterviewScheduleQuery>;
export type GetInterviewScheduleLazyQueryHookResult = ReturnType<typeof useGetInterviewScheduleLazyQuery>;
export type GetInterviewScheduleQueryResult = Apollo.QueryResult<GetInterviewScheduleQuery, GetInterviewScheduleQueryVariables>;
export const GetInterviewMessagingDocument = gql`
    query GetInterviewMessaging($location: ID!, $slug: String) {
  interviewMessaging(location: $location) {
    id
    rowId
    interviewRequestType
    interviewAcceptedType
    interviewRequestMessaging
    interviewAcceptedMessaging
    furtherProcessUrl
  }
  location(slug: $slug) {
    id
    slug
  }
}
    `;

/**
 * __useGetInterviewMessagingQuery__
 *
 * To run a query within a React component, call `useGetInterviewMessagingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInterviewMessagingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInterviewMessagingQuery({
 *   variables: {
 *      location: // value for 'location'
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetInterviewMessagingQuery(baseOptions: Apollo.QueryHookOptions<GetInterviewMessagingQuery, GetInterviewMessagingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInterviewMessagingQuery, GetInterviewMessagingQueryVariables>(GetInterviewMessagingDocument, options);
      }
export function useGetInterviewMessagingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInterviewMessagingQuery, GetInterviewMessagingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInterviewMessagingQuery, GetInterviewMessagingQueryVariables>(GetInterviewMessagingDocument, options);
        }
export type GetInterviewMessagingQueryHookResult = ReturnType<typeof useGetInterviewMessagingQuery>;
export type GetInterviewMessagingLazyQueryHookResult = ReturnType<typeof useGetInterviewMessagingLazyQuery>;
export type GetInterviewMessagingQueryResult = Apollo.QueryResult<GetInterviewMessagingQuery, GetInterviewMessagingQueryVariables>;
export const MutateInterviewDocument = gql`
    mutation MutateInterview($id: ID, $status: String, $scheduledFor: DateTime, $setViewedAt: Boolean, $position: ID, $candidateMessage: String, $interviewAttendees: [InterviewAttendeeSerializerInput]) {
  mutateInterview(
    input: {id: $id, status: $status, scheduledFor: $scheduledFor, position: $position, setViewedAt: $setViewedAt, partialUpdate: true, candidateMessage: $candidateMessage, interviewAttendees: $interviewAttendees}
  ) {
    interview {
      id
      uuid
      status
      scheduledFor
      viewedAt
      ics
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type MutateInterviewMutationFn = Apollo.MutationFunction<MutateInterviewMutation, MutateInterviewMutationVariables>;

/**
 * __useMutateInterviewMutation__
 *
 * To run a mutation, you first call `useMutateInterviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutateInterviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateInterviewMutation, { data, loading, error }] = useMutateInterviewMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *      scheduledFor: // value for 'scheduledFor'
 *      setViewedAt: // value for 'setViewedAt'
 *      position: // value for 'position'
 *      candidateMessage: // value for 'candidateMessage'
 *      interviewAttendees: // value for 'interviewAttendees'
 *   },
 * });
 */
export function useMutateInterviewMutation(baseOptions?: Apollo.MutationHookOptions<MutateInterviewMutation, MutateInterviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutateInterviewMutation, MutateInterviewMutationVariables>(MutateInterviewDocument, options);
      }
export type MutateInterviewMutationHookResult = ReturnType<typeof useMutateInterviewMutation>;
export type MutateInterviewMutationResult = Apollo.MutationResult<MutateInterviewMutation>;
export type MutateInterviewMutationOptions = Apollo.BaseMutationOptions<MutateInterviewMutation, MutateInterviewMutationVariables>;
export const SendInterviewMutationDocument = gql`
    mutation SendInterviewMutation($candidate: ID, $employerProfile: ID, $position: ID, $createdBy: ID, $messageContent: String, $interviewAttendees: [InterviewAttendeeSerializerInput]!, $interviewType: String, $phoneNumber: String, $meetingUrl: String) {
  mutateInterview(
    input: {candidate: $candidate, employerProfile: $employerProfile, createdBy: $createdBy, position: $position, messageContent: $messageContent, interviewAttendees: $interviewAttendees, interviewType: $interviewType, phoneNumber: $phoneNumber, meetingUrl: $meetingUrl}
  ) {
    interview {
      id
      match {
        id
        stage
        lastInterview {
          id
          status
          scheduledFor
          location {
            id
            formattedAddress
          }
          position {
            id
            positionName
          }
        }
        lastEmployerInterview {
          id
          status
          scheduledFor
          location {
            id
            formattedAddress
          }
          position {
            id
            positionName
          }
        }
      }
      candidate {
        id
        candidateProfile {
          id
          rowId
          handle
        }
      }
    }
  }
}
    `;
export type SendInterviewMutationMutationFn = Apollo.MutationFunction<SendInterviewMutationMutation, SendInterviewMutationMutationVariables>;

/**
 * __useSendInterviewMutationMutation__
 *
 * To run a mutation, you first call `useSendInterviewMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendInterviewMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendInterviewMutationMutation, { data, loading, error }] = useSendInterviewMutationMutation({
 *   variables: {
 *      candidate: // value for 'candidate'
 *      employerProfile: // value for 'employerProfile'
 *      position: // value for 'position'
 *      createdBy: // value for 'createdBy'
 *      messageContent: // value for 'messageContent'
 *      interviewAttendees: // value for 'interviewAttendees'
 *      interviewType: // value for 'interviewType'
 *      phoneNumber: // value for 'phoneNumber'
 *      meetingUrl: // value for 'meetingUrl'
 *   },
 * });
 */
export function useSendInterviewMutationMutation(baseOptions?: Apollo.MutationHookOptions<SendInterviewMutationMutation, SendInterviewMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendInterviewMutationMutation, SendInterviewMutationMutationVariables>(SendInterviewMutationDocument, options);
      }
export type SendInterviewMutationMutationHookResult = ReturnType<typeof useSendInterviewMutationMutation>;
export type SendInterviewMutationMutationResult = Apollo.MutationResult<SendInterviewMutationMutation>;
export type SendInterviewMutationMutationOptions = Apollo.BaseMutationOptions<SendInterviewMutationMutation, SendInterviewMutationMutationVariables>;
export const UpdateMutateInterviewDocument = gql`
    mutation UpdateMutateInterview($id: ID, $scheduledFor: DateTime) {
  mutateInterview(
    input: {id: $id, status: "scheduled", scheduledFor: $scheduledFor, partialUpdate: true}
  ) {
    interview {
      id
      uuid
      status
      scheduledFor
      ics
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type UpdateMutateInterviewMutationFn = Apollo.MutationFunction<UpdateMutateInterviewMutation, UpdateMutateInterviewMutationVariables>;

/**
 * __useUpdateMutateInterviewMutation__
 *
 * To run a mutation, you first call `useUpdateMutateInterviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMutateInterviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMutateInterviewMutation, { data, loading, error }] = useUpdateMutateInterviewMutation({
 *   variables: {
 *      id: // value for 'id'
 *      scheduledFor: // value for 'scheduledFor'
 *   },
 * });
 */
export function useUpdateMutateInterviewMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMutateInterviewMutation, UpdateMutateInterviewMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMutateInterviewMutation, UpdateMutateInterviewMutationVariables>(UpdateMutateInterviewDocument, options);
      }
export type UpdateMutateInterviewMutationHookResult = ReturnType<typeof useUpdateMutateInterviewMutation>;
export type UpdateMutateInterviewMutationResult = Apollo.MutationResult<UpdateMutateInterviewMutation>;
export type UpdateMutateInterviewMutationOptions = Apollo.BaseMutationOptions<UpdateMutateInterviewMutation, UpdateMutateInterviewMutationVariables>;
export const MutatePositionApplicationDocument = gql`
    mutation MutatePositionApplication($position: ID!, $platform: String, $initialMessage: String) {
  mutatePositionApplication(
    input: {position: $position, platform: $platform, initialMessage: $initialMessage}
  ) {
    positionApplication {
      id
      position {
        id
        hasApplied
      }
    }
  }
}
    `;
export type MutatePositionApplicationMutationFn = Apollo.MutationFunction<MutatePositionApplicationMutation, MutatePositionApplicationMutationVariables>;

/**
 * __useMutatePositionApplicationMutation__
 *
 * To run a mutation, you first call `useMutatePositionApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutatePositionApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutatePositionApplicationMutation, { data, loading, error }] = useMutatePositionApplicationMutation({
 *   variables: {
 *      position: // value for 'position'
 *      platform: // value for 'platform'
 *      initialMessage: // value for 'initialMessage'
 *   },
 * });
 */
export function useMutatePositionApplicationMutation(baseOptions?: Apollo.MutationHookOptions<MutatePositionApplicationMutation, MutatePositionApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutatePositionApplicationMutation, MutatePositionApplicationMutationVariables>(MutatePositionApplicationDocument, options);
      }
export type MutatePositionApplicationMutationHookResult = ReturnType<typeof useMutatePositionApplicationMutation>;
export type MutatePositionApplicationMutationResult = Apollo.MutationResult<MutatePositionApplicationMutation>;
export type MutatePositionApplicationMutationOptions = Apollo.BaseMutationOptions<MutatePositionApplicationMutation, MutatePositionApplicationMutationVariables>;
export const GetJobPositionDocument = gql`
    query GetJobPosition($slug: String) {
  position(slug: $slug) {
    id
    rowId
    positionName
    paymentStatus
    jobDescription
    jobDescriptionType
    positionType
    availabilityMonday
    availabilityTuesday
    availabilityWednesday
    availabilityThursday
    availabilityFriday
    availabilitySaturday
    availabilitySunday
    preferredExperience
    responsibilities
    requirements
    baseSalaryMin
    baseSalaryMax
    baseSalaryUnitText
    createdAt
    hasApplied
    posted
    allowIndexing
    isNonPartner
    hiring
    updatedAt
    externalApplyUrl
    createdBy {
      id
      uuid
      firstName
      profileImage
    }
    employerProfile {
      id
    }
    location {
      id
      rowId
      slug
      name
      formattedAddress
      paymentStatus
      followerCount
      summary
      image
      addressCity
      addressPostalCode
      tags {
        id
        name
      }
      answers {
        edges {
          node {
            id
            displayIcon
            displayLabel
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetJobPositionQuery__
 *
 * To run a query within a React component, call `useGetJobPositionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetJobPositionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetJobPositionQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetJobPositionQuery(baseOptions?: Apollo.QueryHookOptions<GetJobPositionQuery, GetJobPositionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetJobPositionQuery, GetJobPositionQueryVariables>(GetJobPositionDocument, options);
      }
export function useGetJobPositionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetJobPositionQuery, GetJobPositionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetJobPositionQuery, GetJobPositionQueryVariables>(GetJobPositionDocument, options);
        }
export type GetJobPositionQueryHookResult = ReturnType<typeof useGetJobPositionQuery>;
export type GetJobPositionLazyQueryHookResult = ReturnType<typeof useGetJobPositionLazyQuery>;
export type GetJobPositionQueryResult = Apollo.QueryResult<GetJobPositionQuery, GetJobPositionQueryVariables>;
export const GetMyApplicationsDocument = gql`
    query GetMyApplications($searchTerms: [String], $first: Int, $after: String) {
  myApplications(searchTerms: $searchTerms, first: $first, after: $after) {
    pageInfo {
      endCursor
      hasNextPage
    }
    totalCount
    edges {
      node {
        id
        status
        position {
          id
          positionName
          slug
          appliedAt
          location {
            id
            name
            slug
            image
          }
          createdBy {
            id
            uuid
            profileImage
            firstName
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMyApplicationsQuery__
 *
 * To run a query within a React component, call `useGetMyApplicationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyApplicationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyApplicationsQuery({
 *   variables: {
 *      searchTerms: // value for 'searchTerms'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useGetMyApplicationsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyApplicationsQuery, GetMyApplicationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyApplicationsQuery, GetMyApplicationsQueryVariables>(GetMyApplicationsDocument, options);
      }
export function useGetMyApplicationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyApplicationsQuery, GetMyApplicationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyApplicationsQuery, GetMyApplicationsQueryVariables>(GetMyApplicationsDocument, options);
        }
export type GetMyApplicationsQueryHookResult = ReturnType<typeof useGetMyApplicationsQuery>;
export type GetMyApplicationsLazyQueryHookResult = ReturnType<typeof useGetMyApplicationsLazyQuery>;
export type GetMyApplicationsQueryResult = Apollo.QueryResult<GetMyApplicationsQuery, GetMyApplicationsQueryVariables>;
export const GetOtherJobPositionsByLocationDocument = gql`
    query GetOtherJobPositionsByLocation($slug: String) {
  location(slug: $slug) {
    id
    name
    formattedAddress
    positions(hiring: true, archivedAt_Isnull: true) {
      edges {
        node {
          id
          rowId
          archivedAt
          slug
          positionName
          paymentStatus
          hiring
          externalApplyUrl
          location {
            name
            paymentStatus
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetOtherJobPositionsByLocationQuery__
 *
 * To run a query within a React component, call `useGetOtherJobPositionsByLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOtherJobPositionsByLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOtherJobPositionsByLocationQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetOtherJobPositionsByLocationQuery(baseOptions?: Apollo.QueryHookOptions<GetOtherJobPositionsByLocationQuery, GetOtherJobPositionsByLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOtherJobPositionsByLocationQuery, GetOtherJobPositionsByLocationQueryVariables>(GetOtherJobPositionsByLocationDocument, options);
      }
export function useGetOtherJobPositionsByLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOtherJobPositionsByLocationQuery, GetOtherJobPositionsByLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOtherJobPositionsByLocationQuery, GetOtherJobPositionsByLocationQueryVariables>(GetOtherJobPositionsByLocationDocument, options);
        }
export type GetOtherJobPositionsByLocationQueryHookResult = ReturnType<typeof useGetOtherJobPositionsByLocationQuery>;
export type GetOtherJobPositionsByLocationLazyQueryHookResult = ReturnType<typeof useGetOtherJobPositionsByLocationLazyQuery>;
export type GetOtherJobPositionsByLocationQueryResult = Apollo.QueryResult<GetOtherJobPositionsByLocationQuery, GetOtherJobPositionsByLocationQueryVariables>;
export const GetOtherJobPositionsDocument = gql`
    query GetOtherJobPositions($slug: String) {
  position(slug: $slug) {
    id
    location {
      id
      name
      formattedAddress
      positions(hiring: true, archivedAt_Isnull: true) {
        edges {
          node {
            id
            rowId
            slug
            positionName
            paymentStatus
            hiring
            externalApplyUrl
            location {
              name
              paymentStatus
            }
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetOtherJobPositionsQuery__
 *
 * To run a query within a React component, call `useGetOtherJobPositionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOtherJobPositionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOtherJobPositionsQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetOtherJobPositionsQuery(baseOptions?: Apollo.QueryHookOptions<GetOtherJobPositionsQuery, GetOtherJobPositionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOtherJobPositionsQuery, GetOtherJobPositionsQueryVariables>(GetOtherJobPositionsDocument, options);
      }
export function useGetOtherJobPositionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOtherJobPositionsQuery, GetOtherJobPositionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOtherJobPositionsQuery, GetOtherJobPositionsQueryVariables>(GetOtherJobPositionsDocument, options);
        }
export type GetOtherJobPositionsQueryHookResult = ReturnType<typeof useGetOtherJobPositionsQuery>;
export type GetOtherJobPositionsLazyQueryHookResult = ReturnType<typeof useGetOtherJobPositionsLazyQuery>;
export type GetOtherJobPositionsQueryResult = Apollo.QueryResult<GetOtherJobPositionsQuery, GetOtherJobPositionsQueryVariables>;
export const GetFeedLocationAnswersDocument = gql`
    query GetFeedLocationAnswers($slug: String) {
  location(slug: $slug) {
    id
    rowId
    slug
    answers {
      edges {
        node {
          id
          displayIcon
          displayLabel
          question {
            id
            title
          }
          option {
            id
            value
          }
        }
      }
    }
    __typename
  }
}
    `;

/**
 * __useGetFeedLocationAnswersQuery__
 *
 * To run a query within a React component, call `useGetFeedLocationAnswersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedLocationAnswersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedLocationAnswersQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetFeedLocationAnswersQuery(baseOptions?: Apollo.QueryHookOptions<GetFeedLocationAnswersQuery, GetFeedLocationAnswersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeedLocationAnswersQuery, GetFeedLocationAnswersQueryVariables>(GetFeedLocationAnswersDocument, options);
      }
export function useGetFeedLocationAnswersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeedLocationAnswersQuery, GetFeedLocationAnswersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeedLocationAnswersQuery, GetFeedLocationAnswersQueryVariables>(GetFeedLocationAnswersDocument, options);
        }
export type GetFeedLocationAnswersQueryHookResult = ReturnType<typeof useGetFeedLocationAnswersQuery>;
export type GetFeedLocationAnswersLazyQueryHookResult = ReturnType<typeof useGetFeedLocationAnswersLazyQuery>;
export type GetFeedLocationAnswersQueryResult = Apollo.QueryResult<GetFeedLocationAnswersQuery, GetFeedLocationAnswersQueryVariables>;
export const GetFeedLocationDocument = gql`
    query GetFeedLocation($slug: String) {
  location(slug: $slug) {
    id
    rowId
    isHidden
    isFavorited
    name
    formattedAddress
    latitude
    longitude
    image
    summary
    followerCount
    addressCity
    slug
    employerProfile {
      id
      status
    }
    tags {
      id
      name
    }
    answers {
      edges {
        node {
          id
          displayIcon
          displayLabel
        }
      }
    }
    __typename
  }
}
    `;

/**
 * __useGetFeedLocationQuery__
 *
 * To run a query within a React component, call `useGetFeedLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedLocationQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetFeedLocationQuery(baseOptions?: Apollo.QueryHookOptions<GetFeedLocationQuery, GetFeedLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeedLocationQuery, GetFeedLocationQueryVariables>(GetFeedLocationDocument, options);
      }
export function useGetFeedLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeedLocationQuery, GetFeedLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeedLocationQuery, GetFeedLocationQueryVariables>(GetFeedLocationDocument, options);
        }
export type GetFeedLocationQueryHookResult = ReturnType<typeof useGetFeedLocationQuery>;
export type GetFeedLocationLazyQueryHookResult = ReturnType<typeof useGetFeedLocationLazyQuery>;
export type GetFeedLocationQueryResult = Apollo.QueryResult<GetFeedLocationQuery, GetFeedLocationQueryVariables>;
export const ToggleFavoriteLocationDocument = gql`
    mutation ToggleFavoriteLocation($id: String) {
  toggleFavoriteLocation(input: {clientMutationId: $id}) {
    location {
      id
      isHidden
      isFavorited
      followerCount
      __typename
    }
  }
}
    `;
export type ToggleFavoriteLocationMutationFn = Apollo.MutationFunction<ToggleFavoriteLocationMutation, ToggleFavoriteLocationMutationVariables>;

/**
 * __useToggleFavoriteLocationMutation__
 *
 * To run a mutation, you first call `useToggleFavoriteLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleFavoriteLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleFavoriteLocationMutation, { data, loading, error }] = useToggleFavoriteLocationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleFavoriteLocationMutation(baseOptions?: Apollo.MutationHookOptions<ToggleFavoriteLocationMutation, ToggleFavoriteLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleFavoriteLocationMutation, ToggleFavoriteLocationMutationVariables>(ToggleFavoriteLocationDocument, options);
      }
export type ToggleFavoriteLocationMutationHookResult = ReturnType<typeof useToggleFavoriteLocationMutation>;
export type ToggleFavoriteLocationMutationResult = Apollo.MutationResult<ToggleFavoriteLocationMutation>;
export type ToggleFavoriteLocationMutationOptions = Apollo.BaseMutationOptions<ToggleFavoriteLocationMutation, ToggleFavoriteLocationMutationVariables>;
export const ToggleHideLocationDocument = gql`
    mutation ToggleHideLocation($id: String) {
  toggleHideLocation(input: {clientMutationId: $id}) {
    location {
      id
      isHidden
      isFavorited
      followerCount
      __typename
    }
  }
}
    `;
export type ToggleHideLocationMutationFn = Apollo.MutationFunction<ToggleHideLocationMutation, ToggleHideLocationMutationVariables>;

/**
 * __useToggleHideLocationMutation__
 *
 * To run a mutation, you first call `useToggleHideLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useToggleHideLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [toggleHideLocationMutation, { data, loading, error }] = useToggleHideLocationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useToggleHideLocationMutation(baseOptions?: Apollo.MutationHookOptions<ToggleHideLocationMutation, ToggleHideLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ToggleHideLocationMutation, ToggleHideLocationMutationVariables>(ToggleHideLocationDocument, options);
      }
export type ToggleHideLocationMutationHookResult = ReturnType<typeof useToggleHideLocationMutation>;
export type ToggleHideLocationMutationResult = Apollo.MutationResult<ToggleHideLocationMutation>;
export type ToggleHideLocationMutationOptions = Apollo.BaseMutationOptions<ToggleHideLocationMutation, ToggleHideLocationMutationVariables>;
export const SearchLocationsFeedDocument = gql`
    query SearchLocationsFeed($positionTypes: [String], $after: String, $search: String, $zipCode: String, $first: Int, $latitude: Float, $longitude: Float, $healthInsurance: Boolean, $dressCode: Boolean, $restaurantTypes: [String], $following: Boolean, $featured: String) {
  locations(
    positionTypes: $positionTypes
    first: $first
    after: $after
    search: $search
    zipCode: $zipCode
    latitude: $latitude
    longitude: $longitude
    healthInsurance: $healthInsurance
    dressCode: $dressCode
    restaurantTypes: $restaurantTypes
    following: $following
    featured: $featured
  ) {
    centerLat
    centerLng
    edgeCount
    totalCount
    pageInfo {
      hasNextPage
      startCursor
      endCursor
      __typename
    }
    edges {
      cursor
      node {
        id
        rowId
        isHidden
        isFavorited
        name
        formattedAddress
        hiringPositionCount
        followerCount
        latitude
        longitude
        image
        summary
        slug
        hasJobMatch
        isHiring
        tags {
          id
          name
        }
        __typename
      }
    }
  }
}
    `;

/**
 * __useSearchLocationsFeedQuery__
 *
 * To run a query within a React component, call `useSearchLocationsFeedQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchLocationsFeedQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchLocationsFeedQuery({
 *   variables: {
 *      positionTypes: // value for 'positionTypes'
 *      after: // value for 'after'
 *      search: // value for 'search'
 *      zipCode: // value for 'zipCode'
 *      first: // value for 'first'
 *      latitude: // value for 'latitude'
 *      longitude: // value for 'longitude'
 *      healthInsurance: // value for 'healthInsurance'
 *      dressCode: // value for 'dressCode'
 *      restaurantTypes: // value for 'restaurantTypes'
 *      following: // value for 'following'
 *      featured: // value for 'featured'
 *   },
 * });
 */
export function useSearchLocationsFeedQuery(baseOptions?: Apollo.QueryHookOptions<SearchLocationsFeedQuery, SearchLocationsFeedQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchLocationsFeedQuery, SearchLocationsFeedQueryVariables>(SearchLocationsFeedDocument, options);
      }
export function useSearchLocationsFeedLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchLocationsFeedQuery, SearchLocationsFeedQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchLocationsFeedQuery, SearchLocationsFeedQueryVariables>(SearchLocationsFeedDocument, options);
        }
export type SearchLocationsFeedQueryHookResult = ReturnType<typeof useSearchLocationsFeedQuery>;
export type SearchLocationsFeedLazyQueryHookResult = ReturnType<typeof useSearchLocationsFeedLazyQuery>;
export type SearchLocationsFeedQueryResult = Apollo.QueryResult<SearchLocationsFeedQuery, SearchLocationsFeedQueryVariables>;
export const GetLocationDocument = gql`
    query GetLocation($id: ID!) {
  locationById(id: $id) {
    id
    rowId
    name
    slug
    formattedAddress
    paymentStatus
    hasPositions
    addressStreet1
    addressStreet2
    addressCity
    addressState
    addressPostalCode
    summary
    indeedEasyapplyOptoutDefault
    answers {
      edges {
        node {
          id
          question {
            id
          }
          response
          option {
            id
            value
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetLocationQuery__
 *
 * To run a query within a React component, call `useGetLocationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetLocationQuery(baseOptions: Apollo.QueryHookOptions<GetLocationQuery, GetLocationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationQuery, GetLocationQueryVariables>(GetLocationDocument, options);
      }
export function useGetLocationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationQuery, GetLocationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationQuery, GetLocationQueryVariables>(GetLocationDocument, options);
        }
export type GetLocationQueryHookResult = ReturnType<typeof useGetLocationQuery>;
export type GetLocationLazyQueryHookResult = ReturnType<typeof useGetLocationLazyQuery>;
export type GetLocationQueryResult = Apollo.QueryResult<GetLocationQuery, GetLocationQueryVariables>;
export const GetLocationToClaimDocument = gql`
    query GetLocationToClaim($slug: String) {
  location(slug: $slug) {
    id
    rowId
    slug
    isHidden
    isFavorited
    name
    addressStreet1
    addressStreet2
    addressCity
    addressState
    addressPostalCode
    image
    summary
    indeedEasyapplyOptoutDefault
    answers {
      edges {
        node {
          id
          question {
            id
          }
          response
          option {
            id
            value
          }
        }
      }
    }
    __typename
  }
}
    `;

/**
 * __useGetLocationToClaimQuery__
 *
 * To run a query within a React component, call `useGetLocationToClaimQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLocationToClaimQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLocationToClaimQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useGetLocationToClaimQuery(baseOptions?: Apollo.QueryHookOptions<GetLocationToClaimQuery, GetLocationToClaimQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLocationToClaimQuery, GetLocationToClaimQueryVariables>(GetLocationToClaimDocument, options);
      }
export function useGetLocationToClaimLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLocationToClaimQuery, GetLocationToClaimQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLocationToClaimQuery, GetLocationToClaimQueryVariables>(GetLocationToClaimDocument, options);
        }
export type GetLocationToClaimQueryHookResult = ReturnType<typeof useGetLocationToClaimQuery>;
export type GetLocationToClaimLazyQueryHookResult = ReturnType<typeof useGetLocationToClaimLazyQuery>;
export type GetLocationToClaimQueryResult = Apollo.QueryResult<GetLocationToClaimQuery, GetLocationToClaimQueryVariables>;
export const GetMyLocationsDocument = gql`
    query GetMyLocations($search: String) {
  me {
    id
    myLocations(search: $search) {
      edges {
        node {
          id
          rowId
          image
          name
          displayName
          slug
          formattedAddress
          paymentStatus
          hasPositions
          indeedEasyapplyOptoutDefault
        }
      }
    }
    __typename
  }
}
    `;

/**
 * __useGetMyLocationsQuery__
 *
 * To run a query within a React component, call `useGetMyLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyLocationsQuery({
 *   variables: {
 *      search: // value for 'search'
 *   },
 * });
 */
export function useGetMyLocationsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyLocationsQuery, GetMyLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyLocationsQuery, GetMyLocationsQueryVariables>(GetMyLocationsDocument, options);
      }
export function useGetMyLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyLocationsQuery, GetMyLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyLocationsQuery, GetMyLocationsQueryVariables>(GetMyLocationsDocument, options);
        }
export type GetMyLocationsQueryHookResult = ReturnType<typeof useGetMyLocationsQuery>;
export type GetMyLocationsLazyQueryHookResult = ReturnType<typeof useGetMyLocationsLazyQuery>;
export type GetMyLocationsQueryResult = Apollo.QueryResult<GetMyLocationsQuery, GetMyLocationsQueryVariables>;
export const MutateCreateLocationDocument = gql`
    mutation MutateCreateLocation($name: String!, $summary: String, $addressStreet1: String!, $addressStreet2: String, $addressCity: String!, $addressState: String!, $addressPostalCode: String!, $indeedEasyapplyOptoutDefault: Boolean) {
  mutateLocation(
    input: {name: $name, summary: $summary, addressStreet1: $addressStreet1, addressStreet2: $addressStreet2, addressCity: $addressCity, addressState: $addressState, addressPostalCode: $addressPostalCode, indeedEasyapplyOptoutDefault: $indeedEasyapplyOptoutDefault}
  ) {
    location {
      id
      rowId
      name
      summary
      addressStreet1
      addressStreet2
      addressCity
      addressState
      addressPostalCode
      slug
      indeedEasyapplyOptoutDefault
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type MutateCreateLocationMutationFn = Apollo.MutationFunction<MutateCreateLocationMutation, MutateCreateLocationMutationVariables>;

/**
 * __useMutateCreateLocationMutation__
 *
 * To run a mutation, you first call `useMutateCreateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutateCreateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateCreateLocationMutation, { data, loading, error }] = useMutateCreateLocationMutation({
 *   variables: {
 *      name: // value for 'name'
 *      summary: // value for 'summary'
 *      addressStreet1: // value for 'addressStreet1'
 *      addressStreet2: // value for 'addressStreet2'
 *      addressCity: // value for 'addressCity'
 *      addressState: // value for 'addressState'
 *      addressPostalCode: // value for 'addressPostalCode'
 *      indeedEasyapplyOptoutDefault: // value for 'indeedEasyapplyOptoutDefault'
 *   },
 * });
 */
export function useMutateCreateLocationMutation(baseOptions?: Apollo.MutationHookOptions<MutateCreateLocationMutation, MutateCreateLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutateCreateLocationMutation, MutateCreateLocationMutationVariables>(MutateCreateLocationDocument, options);
      }
export type MutateCreateLocationMutationHookResult = ReturnType<typeof useMutateCreateLocationMutation>;
export type MutateCreateLocationMutationResult = Apollo.MutationResult<MutateCreateLocationMutation>;
export type MutateCreateLocationMutationOptions = Apollo.BaseMutationOptions<MutateCreateLocationMutation, MutateCreateLocationMutationVariables>;
export const MutateUpdateLocationDocument = gql`
    mutation MutateUpdateLocation($id: ID, $name: String!, $summary: String, $addressStreet1: String!, $addressStreet2: String, $addressCity: String!, $addressState: String!, $addressPostalCode: String!, $indeedEasyapplyOptoutDefault: Boolean) {
  mutateLocation(
    input: {id: $id, name: $name, summary: $summary, addressStreet1: $addressStreet1, addressStreet2: $addressStreet2, addressCity: $addressCity, addressState: $addressState, addressPostalCode: $addressPostalCode, indeedEasyapplyOptoutDefault: $indeedEasyapplyOptoutDefault}
  ) {
    location {
      id
      rowId
      name
      summary
      addressStreet1
      addressStreet2
      addressCity
      addressState
      addressPostalCode
      slug
      image
      indeedEasyapplyOptoutDefault
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type MutateUpdateLocationMutationFn = Apollo.MutationFunction<MutateUpdateLocationMutation, MutateUpdateLocationMutationVariables>;

/**
 * __useMutateUpdateLocationMutation__
 *
 * To run a mutation, you first call `useMutateUpdateLocationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutateUpdateLocationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateUpdateLocationMutation, { data, loading, error }] = useMutateUpdateLocationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      summary: // value for 'summary'
 *      addressStreet1: // value for 'addressStreet1'
 *      addressStreet2: // value for 'addressStreet2'
 *      addressCity: // value for 'addressCity'
 *      addressState: // value for 'addressState'
 *      addressPostalCode: // value for 'addressPostalCode'
 *      indeedEasyapplyOptoutDefault: // value for 'indeedEasyapplyOptoutDefault'
 *   },
 * });
 */
export function useMutateUpdateLocationMutation(baseOptions?: Apollo.MutationHookOptions<MutateUpdateLocationMutation, MutateUpdateLocationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutateUpdateLocationMutation, MutateUpdateLocationMutationVariables>(MutateUpdateLocationDocument, options);
      }
export type MutateUpdateLocationMutationHookResult = ReturnType<typeof useMutateUpdateLocationMutation>;
export type MutateUpdateLocationMutationResult = Apollo.MutationResult<MutateUpdateLocationMutation>;
export type MutateUpdateLocationMutationOptions = Apollo.BaseMutationOptions<MutateUpdateLocationMutation, MutateUpdateLocationMutationVariables>;
export const MutateUpdateLocationImageDocument = gql`
    mutation MutateUpdateLocationImage($locationId: ID!, $fileName: String!, $fileType: String!) {
  mutateLocationImage(
    input: {location: $locationId, fileName: $fileName, fileType: $fileType}
  ) {
    imageUploadUrl
    locationImage {
      id
      location {
        id
        rowId
        name
        summary
        addressStreet1
        addressStreet2
        addressCity
        addressState
        addressPostalCode
        slug
      }
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type MutateUpdateLocationImageMutationFn = Apollo.MutationFunction<MutateUpdateLocationImageMutation, MutateUpdateLocationImageMutationVariables>;

/**
 * __useMutateUpdateLocationImageMutation__
 *
 * To run a mutation, you first call `useMutateUpdateLocationImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutateUpdateLocationImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateUpdateLocationImageMutation, { data, loading, error }] = useMutateUpdateLocationImageMutation({
 *   variables: {
 *      locationId: // value for 'locationId'
 *      fileName: // value for 'fileName'
 *      fileType: // value for 'fileType'
 *   },
 * });
 */
export function useMutateUpdateLocationImageMutation(baseOptions?: Apollo.MutationHookOptions<MutateUpdateLocationImageMutation, MutateUpdateLocationImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutateUpdateLocationImageMutation, MutateUpdateLocationImageMutationVariables>(MutateUpdateLocationImageDocument, options);
      }
export type MutateUpdateLocationImageMutationHookResult = ReturnType<typeof useMutateUpdateLocationImageMutation>;
export type MutateUpdateLocationImageMutationResult = Apollo.MutationResult<MutateUpdateLocationImageMutation>;
export type MutateUpdateLocationImageMutationOptions = Apollo.BaseMutationOptions<MutateUpdateLocationImageMutation, MutateUpdateLocationImageMutationVariables>;
export const SearchLocationsDocument = gql`
    query SearchLocations($search: String, $first: Int) {
  locations(first: $first, search: $search, featured: "any", claimed: false) {
    edgeCount
    edges {
      cursor
      node {
        id
        rowId
        slug
        name
        formattedAddress
        followerCount
        image
        __typename
      }
    }
  }
}
    `;

/**
 * __useSearchLocationsQuery__
 *
 * To run a query within a React component, call `useSearchLocationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchLocationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchLocationsQuery({
 *   variables: {
 *      search: // value for 'search'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useSearchLocationsQuery(baseOptions?: Apollo.QueryHookOptions<SearchLocationsQuery, SearchLocationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchLocationsQuery, SearchLocationsQueryVariables>(SearchLocationsDocument, options);
      }
export function useSearchLocationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchLocationsQuery, SearchLocationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchLocationsQuery, SearchLocationsQueryVariables>(SearchLocationsDocument, options);
        }
export type SearchLocationsQueryHookResult = ReturnType<typeof useSearchLocationsQuery>;
export type SearchLocationsLazyQueryHookResult = ReturnType<typeof useSearchLocationsLazyQuery>;
export type SearchLocationsQueryResult = Apollo.QueryResult<SearchLocationsQuery, SearchLocationsQueryVariables>;
export const GetEmployerNotificationPreferenceDocument = gql`
    query GetEmployerNotificationPreference($id: ID, $employerProfileUserId: ID) {
  employerNotificationPreference(
    id: $id
    employerProfileUserId: $employerProfileUserId
  ) {
    id
    employerProfileUser {
      id
    }
    notifications {
      dailyDigest {
        sms
        email
      }
      chatMessage {
        sms
        email
      }
      interviewResponse {
        sms
        email
      }
    }
  }
}
    `;

/**
 * __useGetEmployerNotificationPreferenceQuery__
 *
 * To run a query within a React component, call `useGetEmployerNotificationPreferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmployerNotificationPreferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmployerNotificationPreferenceQuery({
 *   variables: {
 *      id: // value for 'id'
 *      employerProfileUserId: // value for 'employerProfileUserId'
 *   },
 * });
 */
export function useGetEmployerNotificationPreferenceQuery(baseOptions?: Apollo.QueryHookOptions<GetEmployerNotificationPreferenceQuery, GetEmployerNotificationPreferenceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmployerNotificationPreferenceQuery, GetEmployerNotificationPreferenceQueryVariables>(GetEmployerNotificationPreferenceDocument, options);
      }
export function useGetEmployerNotificationPreferenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmployerNotificationPreferenceQuery, GetEmployerNotificationPreferenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmployerNotificationPreferenceQuery, GetEmployerNotificationPreferenceQueryVariables>(GetEmployerNotificationPreferenceDocument, options);
        }
export type GetEmployerNotificationPreferenceQueryHookResult = ReturnType<typeof useGetEmployerNotificationPreferenceQuery>;
export type GetEmployerNotificationPreferenceLazyQueryHookResult = ReturnType<typeof useGetEmployerNotificationPreferenceLazyQuery>;
export type GetEmployerNotificationPreferenceQueryResult = Apollo.QueryResult<GetEmployerNotificationPreferenceQuery, GetEmployerNotificationPreferenceQueryVariables>;
export const MutateEmployerNotificationPreferenceDocument = gql`
    mutation MutateEmployerNotificationPreference($id: ID, $dailyDigestEmail: Boolean, $chatMessageSms: Boolean, $chatMessageEmail: Boolean, $interviewResponseSms: Boolean, $interviewResponseEmail: Boolean) {
  mutateEmployerNotificationPreference(
    id: $id
    dailyDigestEmail: $dailyDigestEmail
    chatMessageSms: $chatMessageSms
    chatMessageEmail: $chatMessageEmail
    interviewResponseSms: $interviewResponseSms
    interviewResponseEmail: $interviewResponseEmail
  ) {
    id
    notifications {
      dailyDigest {
        sms
        email
      }
      chatMessage {
        sms
        email
      }
      interviewResponse {
        sms
        email
      }
    }
  }
}
    `;
export type MutateEmployerNotificationPreferenceMutationFn = Apollo.MutationFunction<MutateEmployerNotificationPreferenceMutation, MutateEmployerNotificationPreferenceMutationVariables>;

/**
 * __useMutateEmployerNotificationPreferenceMutation__
 *
 * To run a mutation, you first call `useMutateEmployerNotificationPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutateEmployerNotificationPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateEmployerNotificationPreferenceMutation, { data, loading, error }] = useMutateEmployerNotificationPreferenceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      dailyDigestEmail: // value for 'dailyDigestEmail'
 *      chatMessageSms: // value for 'chatMessageSms'
 *      chatMessageEmail: // value for 'chatMessageEmail'
 *      interviewResponseSms: // value for 'interviewResponseSms'
 *      interviewResponseEmail: // value for 'interviewResponseEmail'
 *   },
 * });
 */
export function useMutateEmployerNotificationPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<MutateEmployerNotificationPreferenceMutation, MutateEmployerNotificationPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutateEmployerNotificationPreferenceMutation, MutateEmployerNotificationPreferenceMutationVariables>(MutateEmployerNotificationPreferenceDocument, options);
      }
export type MutateEmployerNotificationPreferenceMutationHookResult = ReturnType<typeof useMutateEmployerNotificationPreferenceMutation>;
export type MutateEmployerNotificationPreferenceMutationResult = Apollo.MutationResult<MutateEmployerNotificationPreferenceMutation>;
export type MutateEmployerNotificationPreferenceMutationOptions = Apollo.BaseMutationOptions<MutateEmployerNotificationPreferenceMutation, MutateEmployerNotificationPreferenceMutationVariables>;
export const GetPreferredMatchDocument = gql`
    query GetPreferredMatch($employerCandidateId: ID!) {
  employerCandidate(id: $employerCandidateId) {
    id
    createdAt
    preferredMatch {
      id
      position {
        id
        positionName
        location {
          id
          name
          displayName
          formattedAddress
        }
      }
    }
  }
}
    `;

/**
 * __useGetPreferredMatchQuery__
 *
 * To run a query within a React component, call `useGetPreferredMatchQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPreferredMatchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPreferredMatchQuery({
 *   variables: {
 *      employerCandidateId: // value for 'employerCandidateId'
 *   },
 * });
 */
export function useGetPreferredMatchQuery(baseOptions: Apollo.QueryHookOptions<GetPreferredMatchQuery, GetPreferredMatchQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPreferredMatchQuery, GetPreferredMatchQueryVariables>(GetPreferredMatchDocument, options);
      }
export function useGetPreferredMatchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPreferredMatchQuery, GetPreferredMatchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPreferredMatchQuery, GetPreferredMatchQueryVariables>(GetPreferredMatchDocument, options);
        }
export type GetPreferredMatchQueryHookResult = ReturnType<typeof useGetPreferredMatchQuery>;
export type GetPreferredMatchLazyQueryHookResult = ReturnType<typeof useGetPreferredMatchLazyQuery>;
export type GetPreferredMatchQueryResult = Apollo.QueryResult<GetPreferredMatchQuery, GetPreferredMatchQueryVariables>;
export const SetPreferredMatchDocument = gql`
    mutation SetPreferredMatch($employerCandidateId: ID!, $positionId: ID!) {
  setPreferredMatchForPosition(
    employerCandidateId: $employerCandidateId
    positionId: $positionId
  ) {
    employerCandidate {
      id
      preferredMatch {
        id
        position {
          id
          positionName
        }
      }
    }
    channel {
      id
      lastPosition {
        id
        positionName
      }
    }
  }
}
    `;
export type SetPreferredMatchMutationFn = Apollo.MutationFunction<SetPreferredMatchMutation, SetPreferredMatchMutationVariables>;

/**
 * __useSetPreferredMatchMutation__
 *
 * To run a mutation, you first call `useSetPreferredMatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetPreferredMatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setPreferredMatchMutation, { data, loading, error }] = useSetPreferredMatchMutation({
 *   variables: {
 *      employerCandidateId: // value for 'employerCandidateId'
 *      positionId: // value for 'positionId'
 *   },
 * });
 */
export function useSetPreferredMatchMutation(baseOptions?: Apollo.MutationHookOptions<SetPreferredMatchMutation, SetPreferredMatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetPreferredMatchMutation, SetPreferredMatchMutationVariables>(SetPreferredMatchDocument, options);
      }
export type SetPreferredMatchMutationHookResult = ReturnType<typeof useSetPreferredMatchMutation>;
export type SetPreferredMatchMutationResult = Apollo.MutationResult<SetPreferredMatchMutation>;
export type SetPreferredMatchMutationOptions = Apollo.BaseMutationOptions<SetPreferredMatchMutation, SetPreferredMatchMutationVariables>;
export const MutateClaimTokenSignInDocument = gql`
    mutation MutateClaimTokenSignIn($uid: String!, $claimToken: String!) {
  claimTokenSignInMutation(uid: $uid, claimToken: $claimToken) {
    authorization
    me {
      id
      rowId
      notifyViaSms
      smsVerifiedAt
      notifyViaEmail
      emailVerifiedAt
      email
      profileImage
      candidateProfile {
        id
        handle
        onboardingCompletedAt
        addressPostalCode
        positions
      }
    }
  }
}
    `;
export type MutateClaimTokenSignInMutationFn = Apollo.MutationFunction<MutateClaimTokenSignInMutation, MutateClaimTokenSignInMutationVariables>;

/**
 * __useMutateClaimTokenSignInMutation__
 *
 * To run a mutation, you first call `useMutateClaimTokenSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutateClaimTokenSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateClaimTokenSignInMutation, { data, loading, error }] = useMutateClaimTokenSignInMutation({
 *   variables: {
 *      uid: // value for 'uid'
 *      claimToken: // value for 'claimToken'
 *   },
 * });
 */
export function useMutateClaimTokenSignInMutation(baseOptions?: Apollo.MutationHookOptions<MutateClaimTokenSignInMutation, MutateClaimTokenSignInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutateClaimTokenSignInMutation, MutateClaimTokenSignInMutationVariables>(MutateClaimTokenSignInDocument, options);
      }
export type MutateClaimTokenSignInMutationHookResult = ReturnType<typeof useMutateClaimTokenSignInMutation>;
export type MutateClaimTokenSignInMutationResult = Apollo.MutationResult<MutateClaimTokenSignInMutation>;
export type MutateClaimTokenSignInMutationOptions = Apollo.BaseMutationOptions<MutateClaimTokenSignInMutation, MutateClaimTokenSignInMutationVariables>;
export const GetMeDocument = gql`
    query GetMe {
  me {
    id
    rowId
    profileImage
    notifyViaSms
    smsVerifiedAt
    notifyViaEmail
    emailVerifiedAt
    email
    phone
    firstName
    lastName
    unclaimed
    sendbirdAccessToken
    uuid
    hasSchedule
    timezone
    notifications {
      uri
      message
      category
    }
    employerProfileUser {
      id
      role
    }
    candidateProfile {
      id
      handle
      onboardingCompletedAt
      addressPostalCode
      positions
      restaurantTypes
      canHaveDressCode
      isBenefitsRequired
      status
      availabilityMonday
      availabilityTuesday
      availabilityWednesday
      availabilityThursday
      availabilityFriday
      availabilitySaturday
      availabilitySunday
      commutePreference
      personalSummary
      additionalTraining
      employmentPreferences
      profileVideo
      yearsExperience
      resume
      url
    }
    employerProfile {
      id
      companyName
      verified
      subscribed
      status
      rowId
    }
    integrations
  }
}
    `;

/**
 * __useGetMeQuery__
 *
 * To run a query within a React component, call `useGetMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMeQuery(baseOptions?: Apollo.QueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
      }
export function useGetMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMeQuery, GetMeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMeQuery, GetMeQueryVariables>(GetMeDocument, options);
        }
export type GetMeQueryHookResult = ReturnType<typeof useGetMeQuery>;
export type GetMeLazyQueryHookResult = ReturnType<typeof useGetMeLazyQuery>;
export type GetMeQueryResult = Apollo.QueryResult<GetMeQuery, GetMeQueryVariables>;
export const GetMyFeatureFlagsDocument = gql`
    query GetMyFeatureFlags {
  waffleFlags {
    id
    on
    feature
  }
  me {
    id
    featureFlags(on: true) {
      edges {
        node {
          id
          feature
          on
        }
      }
    }
  }
}
    `;

/**
 * __useGetMyFeatureFlagsQuery__
 *
 * To run a query within a React component, call `useGetMyFeatureFlagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyFeatureFlagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyFeatureFlagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyFeatureFlagsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyFeatureFlagsQuery, GetMyFeatureFlagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyFeatureFlagsQuery, GetMyFeatureFlagsQueryVariables>(GetMyFeatureFlagsDocument, options);
      }
export function useGetMyFeatureFlagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyFeatureFlagsQuery, GetMyFeatureFlagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyFeatureFlagsQuery, GetMyFeatureFlagsQueryVariables>(GetMyFeatureFlagsDocument, options);
        }
export type GetMyFeatureFlagsQueryHookResult = ReturnType<typeof useGetMyFeatureFlagsQuery>;
export type GetMyFeatureFlagsLazyQueryHookResult = ReturnType<typeof useGetMyFeatureFlagsLazyQuery>;
export type GetMyFeatureFlagsQueryResult = Apollo.QueryResult<GetMyFeatureFlagsQuery, GetMyFeatureFlagsQueryVariables>;
export const GetMyLastMatchCreationDocument = gql`
    query GetMyLastMatchCreation {
  me {
    id
    candidateProfile {
      id
      lastMatchCreation
    }
  }
}
    `;

/**
 * __useGetMyLastMatchCreationQuery__
 *
 * To run a query within a React component, call `useGetMyLastMatchCreationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyLastMatchCreationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyLastMatchCreationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyLastMatchCreationQuery(baseOptions?: Apollo.QueryHookOptions<GetMyLastMatchCreationQuery, GetMyLastMatchCreationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyLastMatchCreationQuery, GetMyLastMatchCreationQueryVariables>(GetMyLastMatchCreationDocument, options);
      }
export function useGetMyLastMatchCreationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyLastMatchCreationQuery, GetMyLastMatchCreationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyLastMatchCreationQuery, GetMyLastMatchCreationQueryVariables>(GetMyLastMatchCreationDocument, options);
        }
export type GetMyLastMatchCreationQueryHookResult = ReturnType<typeof useGetMyLastMatchCreationQuery>;
export type GetMyLastMatchCreationLazyQueryHookResult = ReturnType<typeof useGetMyLastMatchCreationLazyQuery>;
export type GetMyLastMatchCreationQueryResult = Apollo.QueryResult<GetMyLastMatchCreationQuery, GetMyLastMatchCreationQueryVariables>;
export const GetMyWorkHistoryDocument = gql`
    query GetMyWorkHistory {
  me {
    id
    candidateProfile {
      id
      workHistory {
        edges {
          node {
            id
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetMyWorkHistoryQuery__
 *
 * To run a query within a React component, call `useGetMyWorkHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyWorkHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyWorkHistoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyWorkHistoryQuery(baseOptions?: Apollo.QueryHookOptions<GetMyWorkHistoryQuery, GetMyWorkHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyWorkHistoryQuery, GetMyWorkHistoryQueryVariables>(GetMyWorkHistoryDocument, options);
      }
export function useGetMyWorkHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyWorkHistoryQuery, GetMyWorkHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyWorkHistoryQuery, GetMyWorkHistoryQueryVariables>(GetMyWorkHistoryDocument, options);
        }
export type GetMyWorkHistoryQueryHookResult = ReturnType<typeof useGetMyWorkHistoryQuery>;
export type GetMyWorkHistoryLazyQueryHookResult = ReturnType<typeof useGetMyWorkHistoryLazyQuery>;
export type GetMyWorkHistoryQueryResult = Apollo.QueryResult<GetMyWorkHistoryQuery, GetMyWorkHistoryQueryVariables>;
export const GetMyPhotoDocument = gql`
    query GetMyPhoto {
  me {
    id
    profileImage
  }
}
    `;

/**
 * __useGetMyPhotoQuery__
 *
 * To run a query within a React component, call `useGetMyPhotoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyPhotoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyPhotoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyPhotoQuery(baseOptions?: Apollo.QueryHookOptions<GetMyPhotoQuery, GetMyPhotoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyPhotoQuery, GetMyPhotoQueryVariables>(GetMyPhotoDocument, options);
      }
export function useGetMyPhotoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyPhotoQuery, GetMyPhotoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyPhotoQuery, GetMyPhotoQueryVariables>(GetMyPhotoDocument, options);
        }
export type GetMyPhotoQueryHookResult = ReturnType<typeof useGetMyPhotoQuery>;
export type GetMyPhotoLazyQueryHookResult = ReturnType<typeof useGetMyPhotoLazyQuery>;
export type GetMyPhotoQueryResult = Apollo.QueryResult<GetMyPhotoQuery, GetMyPhotoQueryVariables>;
export const GetMyCandidateProfileFiltersDocument = gql`
    query GetMyCandidateProfileFilters {
  me {
    id
    candidateProfile {
      id
      addressPostalCode
      positions
      restaurantTypes
      canHaveDressCode
      isBenefitsRequired
    }
  }
}
    `;

/**
 * __useGetMyCandidateProfileFiltersQuery__
 *
 * To run a query within a React component, call `useGetMyCandidateProfileFiltersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyCandidateProfileFiltersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyCandidateProfileFiltersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyCandidateProfileFiltersQuery(baseOptions?: Apollo.QueryHookOptions<GetMyCandidateProfileFiltersQuery, GetMyCandidateProfileFiltersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyCandidateProfileFiltersQuery, GetMyCandidateProfileFiltersQueryVariables>(GetMyCandidateProfileFiltersDocument, options);
      }
export function useGetMyCandidateProfileFiltersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyCandidateProfileFiltersQuery, GetMyCandidateProfileFiltersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyCandidateProfileFiltersQuery, GetMyCandidateProfileFiltersQueryVariables>(GetMyCandidateProfileFiltersDocument, options);
        }
export type GetMyCandidateProfileFiltersQueryHookResult = ReturnType<typeof useGetMyCandidateProfileFiltersQuery>;
export type GetMyCandidateProfileFiltersLazyQueryHookResult = ReturnType<typeof useGetMyCandidateProfileFiltersLazyQuery>;
export type GetMyCandidateProfileFiltersQueryResult = Apollo.QueryResult<GetMyCandidateProfileFiltersQuery, GetMyCandidateProfileFiltersQueryVariables>;
export const MutateSignInInterviewRequestDocument = gql`
    mutation MutateSignInInterviewRequest($interviewToken: String!, $uuid: String!) {
  signInInterviewMutation(interviewToken: $interviewToken, uuid: $uuid) {
    authorization
  }
}
    `;
export type MutateSignInInterviewRequestMutationFn = Apollo.MutationFunction<MutateSignInInterviewRequestMutation, MutateSignInInterviewRequestMutationVariables>;

/**
 * __useMutateSignInInterviewRequestMutation__
 *
 * To run a mutation, you first call `useMutateSignInInterviewRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutateSignInInterviewRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateSignInInterviewRequestMutation, { data, loading, error }] = useMutateSignInInterviewRequestMutation({
 *   variables: {
 *      interviewToken: // value for 'interviewToken'
 *      uuid: // value for 'uuid'
 *   },
 * });
 */
export function useMutateSignInInterviewRequestMutation(baseOptions?: Apollo.MutationHookOptions<MutateSignInInterviewRequestMutation, MutateSignInInterviewRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutateSignInInterviewRequestMutation, MutateSignInInterviewRequestMutationVariables>(MutateSignInInterviewRequestDocument, options);
      }
export type MutateSignInInterviewRequestMutationHookResult = ReturnType<typeof useMutateSignInInterviewRequestMutation>;
export type MutateSignInInterviewRequestMutationResult = Apollo.MutationResult<MutateSignInInterviewRequestMutation>;
export type MutateSignInInterviewRequestMutationOptions = Apollo.BaseMutationOptions<MutateSignInInterviewRequestMutation, MutateSignInInterviewRequestMutationVariables>;
export const MutateProfileImageDocument = gql`
    mutation MutateProfileImage($fileName: String!, $fileType: String!) {
  mutateProfileImage(input: {fileName: $fileName, fileType: $fileType}) {
    imageUploadUrl
    profileImage {
      id
      rowId
    }
    errors {
      field
      messages
    }
  }
}
    `;
export type MutateProfileImageMutationFn = Apollo.MutationFunction<MutateProfileImageMutation, MutateProfileImageMutationVariables>;

/**
 * __useMutateProfileImageMutation__
 *
 * To run a mutation, you first call `useMutateProfileImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMutateProfileImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mutateProfileImageMutation, { data, loading, error }] = useMutateProfileImageMutation({
 *   variables: {
 *      fileName: // value for 'fileName'
 *      fileType: // value for 'fileType'
 *   },
 * });
 */
export function useMutateProfileImageMutation(baseOptions?: Apollo.MutationHookOptions<MutateProfileImageMutation, MutateProfileImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MutateProfileImageMutation, MutateProfileImageMutationVariables>(MutateProfileImageDocument, options);
      }
export type MutateProfileImageMutationHookResult = ReturnType<typeof useMutateProfileImageMutation>;
export type MutateProfileImageMutationResult = Apollo.MutationResult<MutateProfileImageMutation>;
export type MutateProfileImageMutationOptions = Apollo.BaseMutationOptions<MutateProfileImageMutation, MutateProfileImageMutationVariables>;